// import { rootUrl_Micro } from './api-url';
import { get } from 'jquery';
import { environment } from 'src/environments/environment';

export const rootUrl = environment.rootUrl;
export const rootUrlReport = environment.rootUrlReport;
export const rootUrlAuthen = localStorage.getItem("urlAuth");
export const rootUrl_Micro = localStorage.getItem("url");
export const rootUrlDefault = environment.urlDefault;
export const apiUrl = {
    oauth: {
        getCookie: rootUrlReport + 'GetEncryptionKey',
    },
    // Các danh mục dùng chung
    danhMuc: {
        dmDonVi: rootUrl_Micro + 'danh-muc/don-vi', // Đơn vị lọc theo tỉnh, huyện, xã
        dmPhongBan: rootUrl_Micro + 'danh-muc/phong-ban',
        nhomQuyen: rootUrl_Micro + 'danh-muc/nhom-quyen',
        chucDanh: rootUrl_Micro + 'danh-muc/chuc-danh',
        quanHeVoiCH: rootUrl_Micro + 'danh-muc/quan-he', // Quan hệ với chủ hộ
        danToc: rootUrl_Micro + 'danh-muc/dan-toc', // Danh mục dân tộc
        tinhTrangNhaO: rootUrl_Micro + 'danh-muc/tinh-trang-nha-o', // Danh mục tình trạng nhà ở
        loaiHoXi: rootUrl_Micro + 'danh-muc/loai-ho-xi', // Danh mục loại hố xí
        loaiDien: rootUrl_Micro + 'danh-muc/loai-dien', // Loại điện
        soHuuNhaO: rootUrl_Micro + 'danh-muc/hinh-thuc-so-huu-nha', // Hình thức sở hữu nhà ở
        nuocSinhHoat: rootUrl_Micro + 'danh-muc/nuoc-sinh-hoat', // Nước sinh hoạt
        phanLoaiHoNgheo: rootUrl_Micro + 'danh-muc/phan-loai-ho-ngheo', // Phân loại hộ nghèo
        chiTietHoNgheo: rootUrl_Micro + 'danh-muc/chi-tiet-ho-ngheo?loaiHo=', // Chi tiết hộ nghèo
        danhMucDoiTuong: rootUrl_Micro + 'danh-muc/doi-tuong', // Danh mục đối tượng
        tinhTrangViecLam: rootUrl_Micro + 'danh-muc/tinh-trang-viec-lam',
        doiTuongChinhSach: rootUrl_Micro + 'danh-muc/doi-tuong-chinh-sach',
        tinhTrangHonNhan: rootUrl_Micro + 'danh-muc/tinh-trang-hon-nhan',
        capHoc: rootUrl_Micro + 'danh-muc/cap-hoc',
        loaiTheBHYT: rootUrl_Micro + 'danh-muc/loai-the-bhyt',
        lyDoKhongKCB: rootUrl_Micro + 'danh-muc/ly-do-khong-kcb',
        trinhDoHocVan: rootUrl_Micro + 'danh-muc/trinh-do-hoc-van',
        dsMucDoKhuyetTat: rootUrl_Micro + 'danh-muc/muc-do-khuyet-tat',
        danhMucTrinhDo: rootUrl_Micro + 'danh-muc/trinh-do',
        danhMucTinhTrangHocTap: rootUrl_Micro + 'danh-muc/tinh-trang-hoc-tap',
        danhMucHoatDong: rootUrl_Micro + 'danh-muc/ma-hoat-dong', // idLoaiDoiTuong=1
        danhMucLoaiDoiTuong: rootUrl_Micro + 'danh-muc/loai-doi-tuong',
        doiTuongThuocCS: rootUrl_Micro + 'danh-muc/doi-tuong-thuoc-chinh-sach',
        danhMucChucDanh: rootUrl_Micro + 'danh-muc/chuc-danh',
        timKiemDanToc: rootUrl_Micro + 'danh-muc/dan-toc/tim-kiem',
        themMoiDanToc: rootUrl_Micro + 'danh-muc/dan-toc/them-moi',
        capNhatDanToc: rootUrl_Micro + 'danh-muc/dan-toc/cap-nhat',
        xoaDanToc: rootUrl_Micro + 'danh-muc/dan-toc/xoa',
        khoiPhucDanToc: rootUrl_Micro + 'danh-muc/dan-toc/khoi-phuc',
        timKiemDonVi: rootUrl_Micro + 'danh-muc/don-vi/tim-kiem',
        themMoiDonVi: rootUrl_Micro + 'danh-muc/don-vi/them-moi',
        capNhatDonVi: rootUrl_Micro + 'danh-muc/don-vi/cap-nhat',
        danhMucCapDonVi: rootUrl_Micro + 'danh-muc/cap-bac-don-vi/lay-cap-bac-don-vi',
        themMoiCapDonVi: rootUrl_Micro + 'danh-muc/cap-bac-don-vi/them-moi',
        timKiemPhongBan: rootUrl_Micro + 'danh-muc/phong-ban/tim-kiem-phong-ban',
        themMoiPhongBan: rootUrl_Micro + 'danh-muc/phong-ban/them-moi',
        capNhatPhongBan: rootUrl_Micro + 'danh-muc/phong-ban/cap-nhat',
        xoaDonVi: rootUrl_Micro + 'danh-muc/don-vi/xoa',
        xoaPhongBan: rootUrl_Micro + 'danh-muc/phong-ban/xoa',
        menu: rootUrl_Micro + 'danh-muc/phan-quyen-menu',
        notification: rootUrl_Micro + 'danh-muc/notification',
        systemConfig: rootUrl_Micro + 'danh-muc/system-config',
        timkiemQuanHe: rootUrl_Micro + 'danh-muc/quan-he/tim-kiem-quan-he',
        themQuanHe: rootUrl_Micro + 'danh-muc/quan-he/them-quan-he',
        capNhatQuanHe: rootUrl_Micro + 'danh-muc/quan-he/cap-nhat-quan-he',
        xoaQuanHe: rootUrl_Micro + 'danh-muc/quan-he/xoa-quan-he',
        timkiemKhuVuc: rootUrl_Micro + 'danh-muc/khu-vuc/tim-kiem-khu-vuc',
        themKhuVuc: rootUrl_Micro + 'danh-muc/khu-vuc/them-khu-vuc',
        capNhatKhuVuc: rootUrl_Micro + 'danh-muc/khu-vuc/cap-nhat-khu-vuc',
        xoaKhuVuc: rootUrl_Micro + 'danh-muc/khu-vuc/xoa-khu-vuc',
        getAllKhuVuc: rootUrl_Micro + 'danh-muc/khu-vuc/get-all-khu-vuc',
        timkiemVungKt: rootUrl_Micro + 'danh-muc/vung-kinh-te/tim-kiem-vung-kinh-te',
        themVungKt: rootUrl_Micro + 'danh-muc/vung-kinh-te/them-vung-kinh-te',
        capNhatVungKt: rootUrl_Micro + 'danh-muc/vung-kinh-te/cap-nhat-vung-kinh-te',
        xoaVungKt: rootUrl_Micro + 'danh-muc/vung-kinh-te/xoa-vung-kinh-te',
        getAllVungKt: rootUrl_Micro + 'danh-muc/vung-kinh-te/get-all-vung-kinh-te',
        timkiemLuongTt: rootUrl_Micro + 'danh-muc/luong-toi-thieu-vung/tim-kiem-luong-toi-thieu-vung',
        themLuongTt: rootUrl_Micro + 'danh-muc/luong-toi-thieu-vung/them-luong-toi-thieu-vung',
        capNhatLuongTt: rootUrl_Micro + 'danh-muc/luong-toi-thieu-vung/cap-nhat-luong-toi-thieu-vung',
        xoaLuongTt: rootUrl_Micro + 'danh-muc/luong-toi-thieu-vung/xoa-luong-toi-thieu-vung',
        getAllLuongTt: rootUrl_Micro + 'danh-muc/luong-toi-thieu-vung/get-all-luong-toi-thieu-vung',
        getAllTrinhDoVanHoa: rootUrl_Micro + 'danh-muc/trinh-do-van-hoa/get-all-trinh-do-van-hoa',
        getAllDoiTuongBTXH: rootUrl_Micro + 'danh-muc/doi-tuong-tcxh-hang-thang/get-all-doi-tuong-tcxh-hang-thang',
        getAllLoaiViecLam: rootUrl_Micro + 'danh-muc/loai-viec-lam/get-all-loai-viec-lam',
        getAllViecLamCongAnLuong: rootUrl_Micro + 'danh-muc/lam-cong-an-luong/get-all-lam-cong-an-luong',
        getAllTrangThaiQuyTrinhChuyenHo: rootUrl_Micro + 'bao-tro-xa-hoi/v2/danh-muc/get-all-trang-thai-chuyen-ho',
        getAllCoSoDaoTao: rootUrl_Micro + "danh-muc/co-so-dao-tao/get-all",
        timkiemChanNuoi: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/tim-kiem-danh-muc-vat-nuoi',
        themChanNuoi: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-danh-muc-vat-nuoi',
        capNhatChanNuoi: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-danh-muc-vat-nuoi',
        xoaChanNuoi: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-danh-muc-vat-nuoi',
        //trong trot
        timkiemTrongTrot: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/tim-kiem-danh-muc-cay-trong',
        themTrongTrot: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-danh-muc-cay-trong',
        capNhatTrongTrot: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-danh-muc-cay-trong',
        xoaTrongTrot: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-danh-muc-cay-trong',
        getAllLoaiCayTrong: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/get-all-danh-muc-loai-cay-trong',
        //nganh nghe
        timkiemNganhNghe: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/tim-kiem-danh-muc-nganh-nghe',
        themNganhNghe: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-danh-muc-nganh-nghe',
        capNhatNganhNghe: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-danh-muc-nganh-nghe',
        xoaNganhNghe: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-danh-muc-nganh-nghe',
        getAllNhomNganhNghe: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/get-all-danh-muc-loai-nganh-nghe',
        //KHAC
        timkiemKhac: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/tim-kiem-danh-muc-khac',
        themKhac: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-danh-muc-khac',
        capNhatKhac: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-danh-muc-khac',
        xoaKhac: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-danh-muc-khac',
        //MUC XAC DINH
        getMucXacDinh: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/danh-sach-muc-xac-dinh',
        capNhatMucXacDinh: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-danh-muc-muc-xac-dinh',
        themMucXacDinh: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-danh-muc-muc-xac-dinh',
        //ho gia dinh,
        nguonThu: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-trung-binh/get-all-nguon-thu',
        loaiDoiTuong: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-trung-binh/get-all-phan-loai-doi-tuong',
        getAllTrangThaiQuyTrinh: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-trung-binh/get-all-trang-thai',
        KIEM_DINH:{
          //ho gia dinh,
          nguonThu: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/get-all-nguon-thu',
          loaiDoiTuong: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/get-all-phan-loai-doi-tuong',
          getAllTrangThaiQuyTrinh: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/get-all-trang-thai',
        },
        SYS_LOG: {
          nhatKyHeThong: rootUrl_Micro + "danh-muc/logs",
          taiNhatKyHeThong: rootUrl_Micro + "danh-muc/logs/download",
          getStackTraceDetail: rootUrl_Micro + "danh-muc/logs/error"
        },
        getAllTrinhDoLanhDao: rootUrl_Micro + "tre-em/danh-muc/get-all-trinh-do-nu-can-bo-chu-chot"
    },

    // API người dùng
    nguoiDung: {
        listUser: rootUrl_Micro + 'nguoi-dung/v2/danh-sach-nguoi-dung',
        userDetail: 'nguoi-dung/v2/thong-tin-chi-tiet',
        deleteUser: rootUrl_Micro + 'nguoi-dung/v2/xoa',
        recoverUser: rootUrl_Micro + 'nguoi-dung/v2/khoi-phuc',
        registryUrl: rootUrl_Micro + 'nguoi-dung/v2/dang-ky',
        editInfoUrl: rootUrl_Micro + 'nguoi-dung/v2/sua-tai-khoan',
        updateUserUrl: rootUrl_Micro + 'nguoi-dung/v2/sua-tai-khoan',
        detailUserUrl: rootUrl_Micro + 'nguoi-dung/v2/findByUsername',
        checkingPasswordExpireUrl: rootUrl_Micro + 'nguoi-dung/v2/kiem-tra-thoi-han-mat-khau',
        resetPw: rootUrl_Micro + 'nguoi-dung/v2/doi-mat-khau',
        xoaNguoiDung: rootUrl_Micro + 'nguoi-dung/v2/xoa-khoi-he-thong',
        listLog: rootUrl_Micro + 'nguoi-dung/v2/nhat-ky-truy-cap',
        listHanhDong: rootUrl_Micro + 'danh-muc/hanh-dong',
        xuatDanhSachNguoiDung: rootUrl_Micro + 'nguoi-dung/v2/xuat-danh-sach-nguoi-dung-v2',
        xuatExcelNhatKyTruyCap: rootUrl_Micro + 'nguoi-dung/v2/xuat-excel-nhat-ky-truy-cap',
        updateUserInfo: rootUrl_Micro + 'nguoi-dung/v2/sua-thong-tin-ca-nhan',
        updatePasswordUser: rootUrl_Micro + 'nguoi-dung/v2/doi-mat-khau-ca-nhan',
        // expireToken: rootUrl_Micro + 'oauth/revoke-token',
        addExpireToken: rootUrl_Micro + 'oauth/add-expire-token',
        resetPass: rootUrl_Micro + 'nguoi-dung/v2/reset-mat-khau',
        dongYDieuKhoan: rootUrl_Micro + 'nguoi-dung/v2/dong-y-dieu-khoan',
        SYS_LOG: {
          nhatKyHeThong: rootUrl_Micro + "nguoi-dung/v2/logs",
          taiNhatKyHeThong: rootUrl_Micro + "nguoi-dung/v2/logs/download",
          getStackTraceDetail: rootUrl_Micro + "nguoi-dung/v2/logs/error"
        },
        registryUrlNguoiDan: rootUrl_Micro + 'nguoi-dung/v2/dang-ky-nguoi-dan',
        capNhatTaiKhoanQLVB: rootUrl_Micro + 'nguoi-dung/v2/cap-nhat-tai-khoan-qlvb'
    },

    //VLG Danh mục API
    danhMucAPI: {
        dmAPI: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/danh-sach-api',
        capNhatAPI: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/them-api',
        xoaAPI: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/xoa-api',
        dmParams: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/danh-sach-param-api',
        capNhatParams: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/them-param-api',
        xoaParams: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/xoa-api',
    },

    LDVL: {
      TNLD:{
        getTNLDNguoiLDKhongHopDongHuyenXa: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong/tai-nan-lao-dong-khong-hdld-huyen-xa',
        getTNLDNguoiLDKhongHopDongTinh: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong/tai-nan-lao-dong-khong-hdld-tinh',
        deleteTNLDNguoiLDKhongHopDong: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong/delete-tai-nan-lao-dong-khong-hdld',
        updateTNLDNguoiLDKhongHopDong: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong/update-trang-thai-tai-nan-lao-dong-khong-hdld',
        getDMNgheNghiep: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong/lay-danh-sach-nganh-nghe',
        getDSTrangThai3Cap: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong/lay-danh-sach-trang-thai-3-cap',
        getTNLDNguoiLDKhongHopDongChiTiet: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong/lay-tnld-nguoi-lao-dong-khong-hdld-chi-tiet',
        insertTNLDNguoiLDKhongHopDongChiTiet: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong/them-tnld-nguoi-khong-hdld',
        updateTNLDNguoiLDKhongHopDongChiTiet: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong/cap-nhat-tnld-nguoi-khong-hdld',
        inbaocaoTNLDNguoiLDKhongHDLD: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao/tai-nan-ld-nguoi-ld-khong-hdld',
        getDMNgheNghiepTongHop: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong/lay-danh-sach-nganh-nghe-tong-hop',
        getTrangThai2Cap: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong/lay-danh-sach-trang-thai-2-cap",
        getDMYeuToGayChanThuong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong/lay-danh-muc-yeu-to-gay-chan-thuong",
        getDMNguyenNhanChiTiet: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong/lay-danh-muc-nguyen-nhan-chi-tiet",
        getDMNganhKinhTe: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong/lay-danh-sach-nganh-nghe-kinh-te",
        getDSCoSo: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong/lay-danh-sach-co-so",
        getDSLoaiHinhCoSo: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong/lay-danh-sach-loai-hinh-co-so",
        getDSLinhVuc: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong/lay-danh-sach-linh-vuc",
        getThongTinDoanhNghiep: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong/lay-thong-tin-doanh-nghiep",
        getTongHopTinhHinhTNLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong/lay-thong-tin-tong-hop-tinh-hinh-tnld",
        getTongHopThietHaiTNLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong/lay-thong-tin-tong-hop-thiet-hai-tnld",
        themTongHopTinhHinhLaoDongCapCoSo: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong/them-thong-tin-tong-hop-tinh-hinh-tnld",
        getQuanLyTongHopTinhHinhTNLDCapCoSo: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong/lay-thong-tin-quan-ly-tong-hop-tinh-hinh-tnld-cap-co-so",
        updateQuanLyTongHopTinhHinhTNLDCapCoSo: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong/cap-nhat-trang-thai-tong-hop-tinh-hinh-tnld",
        deleteQuanLyTongHopTinhHinhTNLDCapCoSo: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong/xoa-quan-ly-tong-hop-tinh-hinh-tnld",
        getChiTietQuanLyTongHopTinhHinhTNLDCapCoSo: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong/lay-chi-tiet-tong-hop-tinh-hinh-tnld-cap-co-so",
        capNhatTongHopTinhHinhLaoDongCapCoSo: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong/cap-nhat-quan-ly-tong-hop-tinh-hinh-tnld",
        getTongHopTinhHinhQuanLyTNLDCapCoSo: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong/lay-quan-ly-tong-hop-tinh-hinh-tnld-cap-co-so",
        getQuanLyTinhHinhLaoDongCapCoSo: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong/lay-thong-tin-quan-ly-tong-hop-tinh-hinh-tnld-cap-co-so-tong-hop",
        getTNLDTongHopChitiet: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong/lay-thong-tin-chi-tiet-quan-ly-tinh-hinh-tnld-cap-co-so",
        themQuanLyTongHopTinhHinhLaoDongCapCoSo: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong/them-thong-tin-quan-ly-tong-hop-tinh-hinh-tnld",
        inbaocaoTNLDTuNguoiSDLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao/tai-nan-ld-tu-nguoi-su-dung-lao-dong",
        getTongHopQuanLyTinhHinhTNLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong/lay-thong-tin-quan-ly-tong-hop-tinh-hinh-tnld",
        getQuanLyTongHopThietHaiTNLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong/lay-thong-tin-quan-ly-tong-hop-thiet-hai-tnld",
        getBCTongHopTinhHinhTNLDCapCoSo: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao/tai-nan-lao-dong-doanh-nghiep",
        xoaQuanLyTongHopTinhHinhLaoDongCapCoSo: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong/xoa-thong-tin-quan-ly-tong-hop-tinh-hinh-tnld",
        capNhatQuanLyTongHopTinhHinhLaoDongCapCoSo: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong/cap-nhat-thong-tin-quan-ly-tong-hop-tinh-hinh-tnld",
        getTNLDQuanLyTongHopChitiet: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong/lay-chi-tiet-quan-ly-tong-hop-tinh-hinh-tnld-cap-co-so",
        deleteQuanLyTongHopTinhHinhTNLDCapCoSoTongHop: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong/xoa-quan-ly-tong-hop-tinh-hinh-tnld-tong-hop",
      },
        danhMuc: {
        timKiemLoaiHopDong: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/danh-muc/loai-hop-dong/danh-sach',
        themMoiLoaiHopDong: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/danh-muc/loai-hop-dong/them-moi',
        capNhatLoaiHopDong: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/danh-muc/loai-hop-dong/cap-nhat',
        xoaLoaiHopDong: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/danh-muc/loai-hop-dong/xoa',
        timKiemTrinhDoChuyenMon: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/danh-muc/bang-cap/danh-sach',
        themMoiTrinhDoChuyenMon: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/danh-muc/bang-cap/them-moi',
        capNhatTrinhDoChuyenMon: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/danh-muc/bang-cap/cap-nhat',
        xoaTrinhDoChuyenMon: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/danh-muc/bang-cap/xoa',
        danhSachNganhNghe: rootUrl_Micro + 'san-viec-lam/danh-muc/nganh-nghe/danh-sach',
        danhMucQuyMoCongTy: rootUrl_Micro + 'san-viec-lam/danh-muc/qui-mo-cong-ty',
        chauLuc: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/danh-muc/chau-luc/all',
        danToc: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/dan-toc/all',
        loaiHinhHoatDong: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/loai-hinh-hoat-dong/all',
        loaiHinhKinhTe: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/loai-hinh-kinh-te/all',
        lyDoKTGHDKD: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/ly-do-ktghdkt/all',
        moiQH: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/quan-he/all',
        nhomNganhKT: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/nhom-nganh-kt/all',
        trinhDoCM: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/trinh-do-chuyen-mon-kt/all',
        trinhDoGDDT: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/trinh-do-gdpt/all',
        quyenSo: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/so-ghi-chep-cung/getQuyenSo',
        linhVucGDDT: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/linh-vuc-gddt/all',
        quocTich: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/quoc-tich/all',
        loaiBienDong: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/loai-bien-dong/all',
        tinhTrangHoatDong: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/tinh-trang-hoat-dong-kt/getTinhTrangHoatDong',
        khuVuc: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/khu-vuc/getAll",
        loaiDoiTuong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/loai-doi-tuong/getAll",
        loaiLamViec: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/loai-viec-lam/getAll",
        danhSachTrinhDo: rootUrl_Micro + 'san-viec-lam/danh-muc/trinh-do',
        danhMucNgonNgu: rootUrl_Micro + 'san-viec-lam/danh-muc/ngon-ngu',
        danhMucMucLuongToiDa: rootUrl_Micro + 'san-viec-lam/danh-muc/muc-luong-toi-da',
        danhMucMucLuongToiThieu: rootUrl_Micro + 'san-viec-lam/danh-muc/muc-luong-toi-thieu',
        danhMucQuocTich: rootUrl_Micro + 'san-viec-lam/danh-muc/quoc-tich',
        danhMucCapDoCongViec: rootUrl_Micro + 'san-viec-lam/danh-muc/cap-do-cong-viec',
        danhMucLoaiCongViec: rootUrl_Micro + 'san-viec-lam/danh-muc/loai-cong-viec',
        // danhMucLinhVucGDDT: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/linh-vuc-gddt/all",
        LinhVucGDDT_ADD_EDIT_DELETE: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/linh-vuc-gddt",
        // danhMucLoaiBienDong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/loai-bien-dong/all",
        loaiBienDong_ADD_EDIT_DELETE: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/loai-bien-dong",
        loaiHinhHoatDong_ADD_EDIT_DELETE: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/loai-hinh-hoat-dong",
        loaiDoiTuong_ADD_EDIT_DELETE: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/loai-doi-tuong",
        lyDoKHDKT_ADD_UPDATE_DELETE: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/ly-do-ktghdkt",
        loaiHinhKT_ADD_UPDATE_DELETE: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/loai-hinh-kinh-te",
        // loaiViecLam: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/loai-viec-lam/getAll",
        loaiViecLam_ADD_UPDATE_DELETE: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/loai-viec-lam",
        trinhDoCMKT_ADD_UPDATE_DELETE: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/trinh-do-chuyen-mon-kt",
        tinhTrangHoatDongKT_ADD_UPDATE_DELETE: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/tinh-trang-hoat-dong-kt",
        nhomNganhKT_ADD_UPDATE_DELETE: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/nhom-nganh-kt",
        trinhDoGDDT_ADD_UPDATE_DELETE: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/trinh-do-gdpt",
        doiTuongUuTien: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/doi-tuong-uu-tien/getAll",
        quyMoLaoDong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/quy-mo-lao-dong/getAll",
        viTheCongViec: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/vi-the-cong-viec/getAll",
        khuCongNghiepKCX: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/khu-cong-nghiep/getKhuCNByTinh",
        getThuocLinhVuc: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/nhom-nganh-kt/linh-vuc",
        thoiGianThatNghiep: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/thoi-gian-that-nghiep/getAll",
        dieuKiemSearch: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/dieu-kien-search/getAll",
        getAllMaCongViec: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/cong-viec-dang-lam/getAll",
        // loại tiền lương
        loaiTienLuong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/danh-muc/tien-luong/danh-sach",
        loaiTienLuong_ADD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/danh-muc/tien-luong/them-moi",
        loaiTienLuong_UPDATE: rootUrl_Micro + "quan-ly-san-viec-lam/v2/danh-muc/tien-luong/cap-nhat",
        loaiTienLuong_DELETE: rootUrl_Micro + "quan-ly-san-viec-lam/v2/danh-muc/tien-luong/xoa",
        //Chấn Thương
        timKiemChanThuong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/dm-cac-chan-thuong/tim-kiem-dm-cac-chan-thuong",
        loaiChanThuong_ADD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/dm-cac-chan-thuong/them-dm-cac-chan-thuong",
        loaiChanThuong_UPDATE: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/dm-cac-chan-thuong/cap-nhat-dm-cac-chan-thuong",
        loaiChanThuong_DELETE: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/dm-cac-chan-thuong/xoa-dm-cac-chan-thuong",

        // Danh mục kinh tế / hành chính sự nghiệp
        timKiemKTHCSN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/dm-kt-hcsn/tim-kiem-dm-kt-hcsn",
        themMoiKTHCSN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/dm-kt-hcsn/them-dm-kt-hcsn",
        capNhatKTHCSN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/dm-kt-hcsn/cap-nhat-dm-kt-hcsn",
        xoaKTHCSN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/dm-kt-hcsn/xoa-dm-kt-hcsn",

        // Danh mục quốc tịch
        timKiemQuocTich: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/dm-quoc-tich/tim-kiem-dm-quoc-tich",
        themMoiQuocTich: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/dm-quoc-tich/them-dm-quoc-tich",
        capNhatQuocTich: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/dm-quoc-tich/cap-nhat-dm-quoc-tich",
        xoaQuocTich: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/dm-quoc-tich/xoa-dm-quoc-tich",

        // Danh mục quốc tịch
        timKiemYTDH: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/dm-yeu-to-co-hai-trong-moi-truong-lao-dong/tim-kiem-dm-yeu-to-co-hai-trong-moi-truong-lao-dong",
        themMoiYTDH: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/dm-yeu-to-co-hai-trong-moi-truong-lao-dong/them-dm-yeu-to-co-hai-trong-moi-truong-lao-dong",
        capNhatYTDH: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/dm-yeu-to-co-hai-trong-moi-truong-lao-dong/cap-nhat-dm-yeu-to-co-hai-trong-moi-truong-lao-dong",
        xoaYTDH: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/dm-yeu-to-co-hai-trong-moi-truong-lao-dong/xoa-dm-yeu-to-co-hai-trong-moi-truong-lao-dong",
        getDSYTDH: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/dm-yeu-to-co-hai-trong-moi-truong-lao-dong/lay-danh-sach-dm-yeu-to-co-hai-trong-moi-truong-lao-dong",

        // chức danh
        getAllChucDanh: rootUrl_Micro + "quan-ly-san-viec-lam/v2/danh-muc/nganh-chuc-danh/get-all",
        getAllNgach: rootUrl_Micro + "quan-ly-san-viec-lam/v2/danh-muc/dich-vu-viec-lam/ngach-cap-chuc-danh/get-all",
        getAllViTri: rootUrl_Micro + "quan-ly-san-viec-lam/v2/danh-muc/dich-vu-viec-lam/loai-vi-tri-viec-lam/get-all",
        getAllLinhVuc: rootUrl_Micro + "sldtbxh/quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/linh-vuc-gddt/all",

        getDmDichVuVieclam: rootUrl_Micro + "quan-ly-san-viec-lam/v2/danh-muc/dich-vu-viec-lam/vi-tri-viec-lam",
        getDmDichVuViecLamDetail: rootUrl_Micro + "quan-ly-san-viec-lam/v2/danh-muc/dich-vu-viec-lam/vi-tri-viec-lam/get-detail",
        getHinhThucNhuCauLamViecVayVon: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/dm-hinh-thuc-nhu-cau-lam-viec-vay-von/getAll',
        getAllNganhNgheDT: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/dm-nghanh-nghe-dt/getAll',

        getAllDonViTienTe: rootUrl_Micro + 'san-viec-lam/danh-muc/tien-te',
        danhMucTheTuKhoa: rootUrl_Micro + 'san-viec-lam/danh-muc/the',
        danhSachCongTy: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/tuyen-dung/cong-ty/get-all',
        danhMucDonViXKLD: rootUrl_Micro + "matuy/bao-cao-stg/dm-donvi-xkld",
        kyBaoCao: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/get-danh-muc-quy',
        getAllDanhMucMayMoc: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dm-may-moc/getAll',
        

        //quản lý doanh nghiệp - danh mục
        dmDungChung_ViecLam: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-tin-co-so-hgi/get-danh-muc-dung-chung',
        //end qldn - danh mục
        },
        //quản lý doanh nghiệp cho thuê lại lđ - chức năng - HGI - SRS17_18
        QLdoanhNghiepChoThueLaiLD:{
          dsDoanhNghiep: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-tin-co-so-thue-lai-lao-dong-hgi/get',
          themDoanhNghiep: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-tin-co-so-thue-lai-lao-dong-hgi/insert',
          suaDoanhNghiep: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-tin-co-so-thue-lai-lao-dong-hgi/update',
          layIDFileGPKD: rootUrl_Micro + 'file/cung-cau-lao-dong/thong-tin-co-so/upload-gpkd',
          downFileGPKD: rootUrl_Micro + 'file/cung-cau-lao-dong/thong-tin-co-so/download',
          xoaDoanhNghiep: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-tin-co-so-thue-lai-lao-dong-hgi/delete',
          layGPKD: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-tin-co-so-hgi/get-giay-phep-kinh-doanh',
          downFileDanhSach: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-tin-co-so-thue-lai-lao-dong-hgi/xuat-danh-sach',
        },
        //end quản lý doanh nghiệp cho thuê lại lđ - chức năng - HGI - SRS17_18
        //quản lý doanh nghiệp - chức năng - HGI - SRS15_16
        QLdoanhNghiep:{
          dsDoanhNghiep: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-tin-co-so-hgi/get',
          themDoanhNghiep: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-tin-co-so-hgi/insert',
          dsDoanhNghiepLogin: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-tin-co-so-hgi/get-login',
          capNhatDoanhNghiep: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-tin-co-so-hgi/update',
          layIDFileGPKD: rootUrl_Micro + 'file/cung-cau-lao-dong/thong-tin-co-so/upload-gpkd',
          downFileGPKD: rootUrl_Micro + 'file/cung-cau-lao-dong/thong-tin-co-so/download',
          xoaDoanhNghiep: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-tin-co-so-hgi/delete',
          downloadTemplateImport: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-tin-co-so-hgi/download-template-import',
          importDoanhNghiep: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-tin-co-so-hgi/import-doanh-nghiep',
          theMoiTaiKhoanDN: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-tin-co-so-hgi/them-moi-tai-khoan-dn',
          themMoiTaiKhoanDNChoThueLaiLĐ: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-tin-co-so-hgi/them-moi-tai-khoan-dn-thue-lai',
          capNhatTaiKhoanDN: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-tin-co-so-hgi/cap-nhat-tai-khoan-dn',
          xoaTaiKhoanDoanhNghiep: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-tin-co-so-hgi/delete-tk-dn',
          khoaTaiKhoanDoanhNghiep: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-tin-co-so-hgi/khoa-tk-dn',
          resetTaiKhoanDoanhNghiep: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-tin-co-so-hgi/reset-tk-dn',
          xuatDanhSach: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-tin-co-so-hgi/xuat-danh-sach',
          danhMucNganhNgheKinhTe: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-tin-co-so-hgi/danh-muc-nganh-nghe-kinh-te',
          danhMucKTHanhChinhSuNghiep: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-tin-co-so-hgi/danh-muc-kinh-te-hanh-chinh-su-nghiep',
          getFullThongTinCoSoById: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-tin-co-so-hgi',
        },
        //end quản lý doanh nghiệp - chức năng - HGI - SRS15_16
        //sổ thống kê TNLĐ - HGI - SRS47
        soThongKeTNLD:{
          dmDungChung: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/so-thong-ke-tnld-hgi/get-danh-muc-dung-chung',
          dmNgheNghiep: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/so-thong-ke-tnld-hgi/get-dm-nganh-nghe',
          dsTaiNanLD: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/so-thong-ke-tnld-hgi/get',
          xuatBaoCao: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/so-thong-ke-tnld-hgi/xuat-bao-cao-so-thong-ke-tnld',
          xoaSoThongKe: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/so-thong-ke-tnld-hgi/delete',
          themSoThongKe: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/so-thong-ke-tnld-hgi/insert',
          suaSoThongKe: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/so-thong-ke-tnld-hgi/update',
          dsCoSo: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/so-thong-ke-tnld-hgi/get-list-co-so',
          dmNganhNgheKinhTe: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/so-thong-ke-tnld-hgi/get-dm-nganh-nghe-kinh-te',
        },
        //end sổ thống kê TNLĐ - HGI - SRS47
        //chỉ tiêu giải quyết việc làm - chức năng - HGI - SRS30
        chiTieuGQVL_HGI:{
          dsChiTieu: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/chi-tieu-giai-quyet-viec-lam-hgi/get',
          themChiTieu: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/chi-tieu-giai-quyet-viec-lam-hgi/insert',
          suaChiTieu: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/chi-tieu-giai-quyet-viec-lam-hgi/update',
          xoaChiTieu: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/chi-tieu-giai-quyet-viec-lam-hgi/delete',
          //lấy chỉ tiêu -- api dsChiTieu thêm /<id>
        },
        //end chỉ tiêu giải quyết việc làm - chức năng - HGI - SRS30
        congTy: {
        timKiemCongTy: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cong-ty/danh-sach-phan-trang',
        xoaCongTy: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cong-ty/xoa',
        pheDuyetCongTy: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cong-ty/cap-nhat-phe-duyet?maCongTy=',
        khoaTaiKhoanCongTy: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cong-ty/cap-nhat-trang-thai-khoa?maCongTy=',
        timKiemTinTuyenDung: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/tuyen-dung/tin-tuyen-dung/tim-kiem',
        pheDuyetTinTuyenDung: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/tuyen-dung/tin-tuyen-dung/duyet?maBaiDang=',
        xoaTinTuyenDung: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/tuyen-dung/tin-tuyen-dung/xoa?maBaiDang=',
        chiTietCongTy: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cong-ty/thong-tin-chi-tiet',
        chiTietTinTuyenDung: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cong-ty/chi-tiet-tin-tuyen-dung',
        dangTin: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/tuyen-dung/dang-tin-tuyen-dung',
        capNhatThongTinCongTy: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cong-ty/cap-nhat-thong-tin-chung',
        dangTinTuc: {
          getDanhSach: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/tin-tuc/danh-sach-tin-tuc',
          themMoiTin: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/tin-tuc/dang-tin-tuc',
          capNhatTin: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/tin-tuc/cap-nhat-tin',
          xoaTin: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/tin-tuc/xoa-tin-tuc',
          uploadFile: rootUrl_Micro + 'file/svl/tin-tuc/uploadeFile',
          downloadFile: rootUrl_Micro + 'file/svl/tin-tuc/downloadFile',
          getChiTiet: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/tin-tuc/chi-tiet-tin-tuc',
          getBanner: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/tin-tuc/banner'
        }
        },
        ungVien: {
        timKiemTaiKhoanUngVien: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/ung-vien/tai-khoan-ung-vien/tim-kiem',
        pheDuyetTaiKhoanUngVien: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/ung-vien/tai-khoan-ung-vien/duyet',
        xoaTaiKhoanUngVien: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/ung-vien/tai-khoan-ung-vien/xoa?tenDangNhap=',
        khoaTaiKhoanUngVien: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/ung-vien/tai-khoan-ung-vien/khoa-mo?tenDangNhap=',
        timKiemHoSoUngVien: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/ung-vien/ho-so-ung-vien/tim-kiem',
        pheDuyetHoSoUngVien: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/ung-vien/ho-so-ung-vien/duyet?idHoSo=',
        chiTietUngVien: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/ung-vien/lay-thong-tin-ung-vien',
        chiTietHoSo: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/ung-vien/chi-tiet-ho-so-ung-vien',
        resetPass: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/reset-mat-khau'
        },
        hoGiaDinh: {
        getList: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/ho-gia-dinh/all/filter',
        getListTK: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/ho-gia-dinh/all/search',
        ADD_UPDATE_DELETE: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/ho-gia-dinh',
        MAHO: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/ho-gia-dinh/get'
        },
        soGhiChepCung: {
        getList: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/so-ghi-chep-cung/all',
        getListTK: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/so-ghi-chep-cung/get/search',
        getTheoID: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/so-ghi-chep-cung/get',
        ADD_UPDATE_DELETE: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/so-ghi-chep-cung'
        },
        TTNguoiGhi: {
        getList: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-tin-nguoi-ghi/getTTNguoiGhi',
        ADD_UPDATE_DELETE: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-tin-nguoi-ghi',
        },
        cungBanDau: {
        getList: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/cung-lao-dong/getCungTheoHuyenXaThonV2',
        getListTheoQuyenSo: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/cung-lao-dong/getHoTheoSoV2',
        ADD_UPDATE_DELETE: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/cung-lao-dong',
        getHoTheoSoCungBD: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/cung-lao-dong/getHoTheoSoCungBDV2',
        getCungLDBienDongTheoHuyenXaThon: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/cung-lao-dong/getCungLDBienDongTheoHuyenXaThonV2',
        getCungTheoLoaiBienDong: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/cung-lao-dong/getCungTheoLoaiBienDongV2',

        ID_CUNG_LAO_DONG: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/cung-lao-dong/getThanhVien',
        getCungTheoHo: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/cung-lao-dong/getCungTheoHo',

        exportThanhVienBTE: rootUrl_Micro + 'file/cung-cau-lao-dong/import-thanh-vien/downloadTemplate/349a17b5-9bb7-4e9b-87cd-c6c4458e487c',
        exportThanhVien: rootUrl_Micro + 'file/cung-cau-lao-dong/import-thanh-vien/downloadTemplate/90e88290-24ef-11ed-a026-0050568863c2',
        importThanhVien: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/import-thanh-vien',
        cungBienDong: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/cung-lao-dong/cung_bd_v2',

        getAllDanhSachThanhVien: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/cung-lao-dong/getAllDanhSachThanhVien",
        getThanhVienBienDong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/cung-lao-dong/getThanhVienBienDong",
        //  minhvn.bte - 12/07/2022
        getAllDanhSachThanhVienBTE: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/cung-lao-dong/getAllDanhSachThanhVienBTE",
        getDanhSachCungLDChoNguoiDan: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/cung-lao-dong/getDanhSachCungLDChoNguoiDan",
        getThanhVienBienDongBTE: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/cung-lao-dong/getThanhVienBienDongBTE",
        //  minhvn.bte - 12/07/2022

        getAllDanhSachLDCMUBanDau: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/cung-lao-dong/getAllDanhSachLDCMUBanDau",
        getAllDanhSachLDCMUBienDong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/cung-lao-dong/getAllDanhSachLDCMUBienDong",
        exportTemplateCMU: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/export-template',
        importThanhVienCMU: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/importThanhVienCMU',
        },
        thanhVien: {
        getThanhVienID: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thanh-vien/get',
        getThanhVienNguoiDanID: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thanh-vien/get-nguoi-dan',
        ADD_UPDATE_DELETE: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thanh-vien',
        ADD_THANH_VIEN: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/them-thanh-vien',
        GET_ThanhVien_idCung: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/cung-lao-dong/getThanhVien',
        RECOVERY_DELETE: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thanh-vien/recovery',
        getThanhVienBTXH: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thanh_vien_theo_ho/getTheoHo',
        getThanhVienBTXHid: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thanh_vien_theo_ho',
        THEM_THANHVIEN_BTE: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/them-thanh-vien-bte',
        getByCCCD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thanh-vien/get-by-cccd",
        ADD_THANH_VIEN_CMU: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/them-thanh-vien-cmu',
        getThanhVienBanDauID: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thanh-vien/get-ban-dau',
        deleteThanhVienBienDongCmu: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thanh-vien/xoa-thanh-vien-bien-dong',
        dashboardLDVLViecLam : rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thanh-vien/dashboard-vieclam",
        ADD_UPDATE_BAN_DAU_CMU: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thanh-vien/updateBanDau',
        dasboardLDVL_HGI: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thanh-vien/dashboard-cung-cau",
        dasboardLDVL_HGI_CoViecLam: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thanh-vien/dashboard-co-viec-lam",
        dasboardLDVL_HGI_ThatNghiep: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thanh-vien/dashboard-that-nghiep",
        },
        soGhiChepCau: {
        getAllSoGhiChepCau: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/so-ghi-chep-cau/getAllSoGhiChepCau",
        getList: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/so-ghi-chep-cau/all',
        getListTK: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/so-ghi-chep-cau/get/search',
        getTheoID: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/so-ghi-chep-cau/get',
        ADD_UPDATE_DELETE: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/so-ghi-chep-cau',
        },
        toChuc: {
        getList: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/to-chuc/all/filter',
        getListTK: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/to-chuc/all/search',
        getTheoID: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/to-chuc/get',
        ADD_UPDATE_DELETE: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/to-chuc',
        getToChucByMaTinh: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/to-chuc/getToChucByMaTinh",
        getToChucByMaTinh_PhanTrang: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/to-chuc/getToChucByMaTinhPhanTrang",
        },
        cauBanDau: {
        getTTNguoiGhi: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-tin-nguoi-ghi/getTTNguoiGhi",
        // getTTNguoiGhiTheoSoGhiChepcau: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-tin-nguoi-ghi/getTTNguoiGhiTheoSoGhiChepcau",
        getCauLDTheoToChuc: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/cau-lao-dong/getCauLDTheoToChuc",
        getCauLDTheoHuyenXa: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/cau-lao-dong/getCauLDTheoHuyenXa",
        getCauLDTheoNguoiGhiSo: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/cau-lao-dong/getCauLDTheoNguoiGhiSo",
        getCauLDTheoQuyenSo: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/cau-lao-dong/getCauLDTheoQuyenSo",
        ADD_UPDATE_DELETE: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/cau-lao-dong",
        getTTLaoDong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-tin-lao-dong/getTTLaoDongV2",
        UPDATE_TTLaoDong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-tin-lao-dong/v2",
        getCauLDBDTheoHuyenXa: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/cau-lao-dong/getCauLDBDTheoHuyenXa",
        getCauLDBDTheoNguoiGhiSo: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/cau-lao-dong/getCauLDBDTheoNguoiGhiSo",
        getCauLDBDtheoQuyenSo: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/cau-lao-dong/getCauLDBDtheoQuyenSo",
        getTraCuuNhanhCauLD: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/cau-lao-dong/getTraCuuNhanhCauLD',

        getDanhSachToChuc: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/cau-lao-dong/getDanhSachToChuc",
        getDanhSachToChucBienDong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/cau-lao-dong/getDanhSachToChucBienDong",

        importCau: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/import-cau-lao-dong',
        checkImportCau: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/import-cau-lao-dong/check-file-import-cau-ld',
        exportCau: rootUrl_Micro + 'file/cung-cau-lao-dong/import-thanh-vien/downloadTemplate/e0bb1727-bc7f-4f5f-a4c2-efa3c35127e8',
        // minhvn.bte - IT5ASXH-6262 - 15/09/2022
        exportCauBTE: rootUrl_Micro + 'file/cung-cau-lao-dong/import-thanh-vien/downloadTemplate/ef1af1c6-33e6-11ed-a026-0050568863c2',
        // End minhvn.bte - IT5ASXH-6262 - 15/09/2022

        },
        traCuuNhanh: {
        getTraCuuNhanhCungLD: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/cung-lao-dong/getTraCuuNhanhCungLD',
        },

        TNLD_TONG_HOP: {
          getDMNgheNghiep: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong-tong-hop/lay-danh-sach-nganh-nghe',
          getDSTrangThai3Cap: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong-tong-hop/lay-danh-sach-trang-thai-3-cap',
          getTNLDNguoiLDKhongHopDongChiTiet: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong-tong-hop/lay-tnld-nguoi-lao-dong-khong-hdld-chi-tiet',
          getTNLDNguoiLDKhongHopDongTongHop: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong-tong-hop/tai-nan-lao-dong-khong-hdld-tong-hop',
          getTNLDNguoiLDKhongHopDongTongHopChiTiet: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong-tong-hop/lay-tnld-nguoi-lao-dong-khong-hdld-tong-hop-chi-tiet',
          insertTNLDNguoiLDKhongHopDongTongHop: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong-tong-hop/them-tnld-nguoi-khong-hdld-tong-hop',
          upsertTNLDNguoiLDKhongHopDongTongHop: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong-tong-hop/cap-nhat-tnld-nguoi-khong-hdld-tong-hop',
          deleteTNLDNguoiLDKhongHopDongTongHop: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong-tong-hop/xoa-tnld-nguoi-khong-hdld-tong-hop',
          inbaocaoTNLDNguoiLDKhongHDLDTongHop: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao/tai-nan-ld-nguoi-ld-khong-hdld-tong-hop'
        },
        giaiQuyetViecLam: {
            getGiaQuyetViecLam: rootUrl_Micro + "quan-ly-san-viec-lam/v2/get-giai-quyet-viec-lam",
            getGQVLID: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/giai-quyet-viec-lam/get",
            ADD_GQVL: rootUrl_Micro + "quan-ly-san-viec-lam/v2/them-giai-quyet-viec-lam",
            UPDATE_GQVL: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cap-nhat-giai-quyet-viec-lam",
            DELETE_GQVL: rootUrl_Micro + "quan-ly-san-viec-lam/v2/xoa-giai-quyet-viec-lam",
            getDoiTuong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/van-ban/search-thanh-vien",
            //CMU
            getMa: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/giai-quyet-viec-lam/getText",
            themMoiGQVLCMU: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/giai-quyet-viec-lam",
            capNhatGQVLCMU: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/giai-quyet-viec-lam",
            getGQVLCMU: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/giai-quyet-viec-lam/getGiaQuyetViecLam",
            getDoiTuongGQVLCMU: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/giai-quyet-viec-lam/search-thanh-vien",

            exportMauGQVL: rootUrl_Micro + 'file/cung-cau-lao-dong/import-thanh-vien/downloadTemplate/1beadc68-5d1b-11ee-924d-0050568863c2',
            checkImportQGVL: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/giai-quyet-viec-lam/check-file-import-gqvl',
            importGQVL: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/giai-quyet-viec-lam/import_gqvl',

            baoCaoGQVLThangXa: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao-tong-hop-giai-quyet-viec-lam-theo-thang',
            baoCaoGQVLQuyXa: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao-tong-hop-giai-quyet-viec-lam-theo-quy'

        },
        phongVanOnline: {
        // getRoom: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/meeting-room/getRoom',
        getRoom: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/meeting-room/getRoomV2',
        meetingRoom: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/meeting-room',
        getRoomID: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/meeting-room/get',
        getDSPheDuyet: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/meeting-room/getDSPheDuyet",
        getDSDaDuyet: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/meeting-room/getDSDaDuyet",
        pheDuyet: rootUrl_Micro + "sldtbxh/quan-ly-san-viec-lam/v2/cung-cau-lao-dong/meeting-room/phe-duyet",
        dongPhong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/meeting-room/dong_phong",
        },
        chiTieuGQVL: {
        getChiTieuGQVL: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/chi-tieu-giai-quyet-viec-lam/search",
        getChiTieuID: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/chi-tieu-giai-quyet-viec-lam/get",
        ADD_UPDATE_DELETE: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/chi-tieu-giai-quyet-viec-lam",
        getChiTieuGQVLCMU: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/chi-tieu-giai-quyet-viec-lam/tiem-kiem-chi-tieu-cap_huyen",
        ADD_CMU: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/chi-tieu-giai-quyet-viec-lam/them-chi-tieu-gqvl-cmu",
        getChiTieuGQVLCMU_CAP_XA: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/chi-tieu-giai-quyet-viec-lam/tiem-kiem-chi-tieu",


        },
        baoCao: {
            soGhiChepCung: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao-so-ghi-chep-cung/trangbia",
            soGhiChepTrangBiaPDF: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao-so-ghi-chep-cung/xuat-bc-trang-bia",
            soGhiChepTTCoBan: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao-so-ghi-chep-cung/xuat-bc-tt-co-ban",
            soGhiChepBangKe: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao-so-ghi-chep-cung/xuat-bc-bang-ke",

            soGhiChepCau: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao-so-ghi-chep-cau/xuat-bc-cau-ld",
            soGhiChepCauTrangBiaPDF: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao-so-ghi-chep-cau/xuat-bc-trang-bia-cauld",
            soGhiChepCauTTCoBan: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao-so-ghi-chep-cau/xuat-bc-tt-co-ban",
            soGhiChepCauBangKe: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao-so-ghi-chep-cau/xuat-bc-bang-ke",

            baoCaoCapXa: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao-ttld-cap-xa/xuatBCTTLDCapXa",
            cungCapXa: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao-ttld-cap-xa/xuat-bc-mau01",
            cungCapXaVeThongTinLaoDongDTP: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao-ttld-cap-xa/xuat-bc-mau01-dtp",
            cungCapXaVeThongTinLaoDongDTPExcel: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao-ttld-cap-xa/xuat-bc-mau01-dtp-excel",
            chiTietCungCapXa: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/v2/bao-cao-ttld-cap-xa/xuat-bc-chiTietCung",
            getBCToChuc: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao-mau-02-tt-cau-lao-dong",
            getBCThanhVien: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao-mau-01-tt-cung-lao-dong",
            getBCTongHopCungCau: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao-tong-hop-cung-cau-ld",
            getBCTongHopCungCauXuatFile: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao-tong-hop-cung-cau-xuat-file",
            getBCTongHopCungCauDTP: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao-tong-hop-cung-cau-ld/dtp",
            getBCTongHopCungCauMau2STG: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao-tong-hop-cung-cau-ld/bc1",
            getBCTongHopCungCauMau3STG: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao-tong-hop-cung-cau-ld/bc2",
            getBCTongHopCungCauMau4STG: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao-tong-hop-cung-cau-ld/bc3",

            getBCTienDoDieuTraTTLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tien-do-dieu-tra-ttld",
            getBCTienDoDieuTraTTLD_Cung: rootUrl_Micro + "get-data/lao-dong-viec-lam/bao-cao-ttld-cap-xa/bc-tien-do-dieu-tra",
            getBCTienDoDieuTraTTLD_Cau: rootUrl_Micro + "get-data/lao-dong-viec-lam/bao-cao-ttld-cap-xa/bc-tien-do-dieu-tra-cau-ld",
            getBCTienDoDieuTraTTLD_Cung_BTE: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao-ttld-cap-xa/bc-tien-do-dieu-tra-temp-bte",
            getBCTienDoDieuTraTTLD_Cau_BTE: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao-tong-hop-cung-cau-ld/bc-tien-do-dieu-tra-cau-ld-temp-bte",

            baoCaoTongHopBieuMau1: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao/bieu-mau-1",
            baoCaoTongHopBieuMau2: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao/bieu-mau-2",
            baoCaoTongHopBieuMau3: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao/bieu-mau-3",
            baoCaoTongHopBieuMau4: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao/bieu-mau-4",
            baoCaoTongHopBieuMau5: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao/bieu-mau-5",
            xuatBaoCao: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao/download",
            exportThanhVien: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/export/thanh-vien",
            exportThanhVienBTE: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/export/thanh-vien-bte",
            exportToChuc: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/export/to-chuc-bte",
            exportToChucProvinces: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/export/to-chuc",
            exportBCDanSoTu10: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bieu-mau/dan-so-tu-10-tuoi-tro-len",
            exportBCLaoDongCoViecLamTu15: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bieu-mau/lao-dong-co-viec-lam-tu-15-tuoi-chia-theo-linh-vuc-kt",
            exportBCLucLuongLaoDongTu15: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bieu-mau/lao-dong-tu-15-tuoi-tro-len",
            exportBCKhongThamGiaHDKT: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bieu-mau/lao-dong-khong-tham-gia-hoat-dong-kinh-te",
            exportBCLaoDongCoViecLamTrongDoTuoi: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bieu-mau/lao-dong-co-viec-lam-trong-do-tuoi",
            exportBCLaoDongCoViecLamTheoKhuVucKT: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bieu-mau/lao-dong-co-viec-lam-theo-khu-vuc-kinh-te",
            exportBaoCaoLaoDongQuaDaoTao: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bieu-mau/lao-dong-qua-dao-tao",
            exportTienDo_Cung: rootUrl_Micro + "get-data/lao-dong-viec-lam/v2/bao-cao-ttld-cap-xa/bc-tien-do-cungld",
            exportTienDo_Cau: rootUrl_Micro + "get-data/lao-dong-viec-lam/v2/bao-cao-ttld-cap-xa/bc-tien-do-cauld",
            excelMau03: rootUrl_Micro + "quan-ly-san-viec-lam/v2/mau-so-03-bte",
            exportBCLaoDongTrongDoTuoi: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bieu-mau/lao-dong-trong-do-tuoi-lao-dong-dtp",

            // =================== Cac mau BC LDVL STG ===================
            baoCaoDS15T_01_STG: rootUrl_Micro + 'matuy/v2/bao-cao-stg/dan-so-tren-15t-01a',
            baoCaoDS15T_01b_STG: rootUrl_Micro + 'matuy/v2/bao-cao-stg/dan-so-tren-15t-01b',
            baoCaoDS15T_02_STG: rootUrl_Micro + 'matuy/v2/bao-cao-stg/dan-so-tren-15t-02',
            baoCaoDS15T_03_STG: rootUrl_Micro + 'matuy/v2/bao-cao-stg/dan-so-tren-15t-03',
            baoCaoDS15T_04_STG: rootUrl_Micro + 'matuy/v2/bao-cao-stg/dan-so-tren-15t-04',
            baoCaoDS15T_05_STG: rootUrl_Micro + 'matuy/v2/bao-cao-stg/dan-so-tren-15t-05',
            baoCaoDS15T_06_STG: rootUrl_Micro + 'matuy/bao-cao-stg/dan-so-tren-15t-06',

            baoCaoDSKoTGHDKT_01_STG: rootUrl_Micro + 'matuy/v2/bao-cao-stg/dan-so-ko-hdkt-tren-15t-01',
            baoCaoDSKoTGHDKT_02_STG: rootUrl_Micro + 'matuy/v2/bao-cao-stg/dan-so-ko-hdkt-tren-15t-02',
            baoCaoDSKoTGHDKT_03_STG: rootUrl_Micro + 'matuy/v2/bao-cao-stg/dan-so-ko-hdkt-tren-15t-03',
            baoCaoDSKoTGHDKT_04_STG: rootUrl_Micro + 'matuy/v2/bao-cao-stg/dan-so-ko-hdkt-tren-15t-04',
            baoCaoDSKoTGHDKT_05_STG: rootUrl_Micro + 'matuy/v2/bao-cao-stg/dan-so-ko-hdkt-tren-15t-05',

            baoCaoLDCoVL_01_STG: rootUrl_Micro + 'matuy/v2/bao-cao-stg/ld-co-viec-lam-trong-tuoi-ld-01',
            baoCaoLDCoVL_02_STG: rootUrl_Micro + 'matuy/v2/bao-cao-stg/ld-co-viec-lam-trong-tuoi-ld-02',
            baoCaoLDCoVL_03_STG: rootUrl_Micro + 'matuy/v2/bao-cao-stg/ld-co-viec-lam-trong-tuoi-ld-03',
            baoCaoLDCoVL_04_STG: rootUrl_Micro + 'matuy/v2/bao-cao-stg/ld-co-viec-lam-trong-tuoi-ld-04',
            baoCaoLDCoVL_05_STG: rootUrl_Micro + 'matuy/v2/bao-cao-stg/ld-co-viec-lam-trong-tuoi-ld-05',
            baoCaoLDCoVL_13_STG: rootUrl_Micro + 'matuy/bao-cao-stg/chua-cai-dat',
            baoCaoLDCoVL_29_STG: rootUrl_Micro + 'matuy/bao-cao-stg/chua-cai-dat',

            baoCaoLDTrongTuoiLD_01_STG: rootUrl_Micro + 'matuy/v2/bao-cao-stg/ld-trong-tuoi-ld-01',
            baoCaoLDTrongTuoiLD_02_STG: rootUrl_Micro + 'matuy/v2/bao-cao-stg/ld-trong-tuoi-ld-02',
            baoCaoLDTrongTuoiLD_03_STG: rootUrl_Micro + 'matuy/v2/bao-cao-stg/ld-trong-tuoi-ld-03',
            baoCaoLDTrongTuoiLD_04_STG: rootUrl_Micro + 'matuy/v2/bao-cao-stg/ld-trong-tuoi-ld-04',
            baoCaoLDTrongTuoiLD_05_STG: rootUrl_Micro + 'matuy/v2/bao-cao-stg/ld-trong-tuoi-ld-05',
            baoCaoLDTrongTuoiLD_06_STG: rootUrl_Micro + 'matuy/v2/bao-cao-stg/ld-trong-tuoi-ld-06',
            baoCaoLDTrongTuoiLD_07_STG: rootUrl_Micro + 'matuy/v2/bao-cao-stg/ld-trong-tuoi-ld-07',
            baoCaoLDTrongTuoiLD_08_STG: rootUrl_Micro + 'matuy/v2/bao-cao-stg/ld-trong-tuoi-ld-08',
            baoCaoLDTrongTuoiLD_09_STG: rootUrl_Micro + 'matuy/v2/bao-cao-stg/ld-trong-tuoi-ld-09',
            baoCaoLDTrongTuoiLD_10_STG: rootUrl_Micro + 'matuy/bao-cao-stg/ld-trong-tuoi-ld-10',

            baoCaoTTCungLD_STG: rootUrl_Micro + 'matuy/v2/bao-cao-stg/bao-cao-cung-lao-dong',
            baoCaoDSLDDcTaoVL: rootUrl_Micro + 'matuy/v2/bao-cao-stg/danh-sach-lao-dong-duoc-tao-viec-lam',
            baoCaoCTGQVLVXKLD_Chung_STG: rootUrl_Micro + 'matuy/v2/bao-cao-stg/kq-thuc-hien-chi-tieu-xkld-chung',
            baoCaoCTGQVLVXKLD_XKLDChiaTheoTT_STG: rootUrl_Micro + 'matuy/v2/bao-cao-stg/kq-thuc-hien-chi-tieu-xkld-theo-thi-truong',
            baoCaoKQGQVLVXKLD_ToanTinh_STG: rootUrl_Micro + 'matuy/bao-cao-stg/chua-cai-dat',
            thongKeLDTaiDiaPhuong: rootUrl_Micro + 'matuy/v2/bao-cao-stg/ThongKeLDTaiDiaPhuong',
            bcTNLDChetNguoi: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao-atvsld-stg/bao-cao-nhanh-tnld-nang-phu-luc-4",
            bcTNLDTrenDiaBanTinh: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao-atvsld-stg/bao-cao-tong-hop-6-thang",
            bcTNLDKhongTheoHD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao-atvsld-stg/bao-cao-tnld-khong-theo-hdld",
            bcCucThongKe: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bieu-mau-bao-cao-tai-cuc-thong-ke",
            getBCDanhSachDoanhNghiep: rootUrl_Micro + "quan-ly-san-viec-lam/v2/san-viec-lam/bao-cao/danh-sach-doanh-nghiep",
            getBCTongHopDoanhNghiep: rootUrl_Micro + "quan-ly-san-viec-lam/v2/san-viec-lam/bao-cao/tong-hop-doanh-nghiep",
            getBCDanhSachLaoDong: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/san-viec-lam/bao-cao/danh-sach-lao-dong',
            giayPhepLaoDong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao-mau-03/giayPhepLaoDong",
            mauBCLaoDongTheoTrinhDoCMU: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bieu-mau/lao-dong-theo-trinh-do-cmu",
            tongHopThongTinCungLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao/tong-hop-thong-tin-cung",
            mauBCLaoDongTheoTinhTrangViecLamCMU: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bieu-mau/lao-dong-theo-tinh-trang-viec-lam-cmu",
            mauBCLaoDongTheoTrinhDoChuyenMonCMU: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bieu-mau/lao-dong-theo-trinh-do-chuyen-mon-cmu",
            getBCThanhVien_CMU: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao-mau-01-tt-cung-lao-dong/cmu",
            templateDangTinTuyenDung: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cong-ty/tai-mau-excel-tin-tuyen-dung",
            mauBCLaoDongTheoTrinhDoChuyenMonChiTietCMU: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bieu-mau/lao-dong-theo-trinh-do-chuyen-mon-cmu-chi-tiet",
        },
        chiTieuGQVL_STG: {
            getChiTieuGQVL: rootUrl_Micro + "matuy/ldvl-thongtu11/v2/giai-quyet-viec-lam-stg/danh-sach-chi-tieu",
            getChiTieuID: rootUrl_Micro + "matuy/ldvl-thongtu11/v2/giai-quyet-viec-lam-stg/chi-tiet-chi-tieu",
            addChiTieu: rootUrl_Micro + "matuy/ldvl-thongtu11/giai-quyet-viec-lam-stg/them-chi-tieu",
            editChiTieu: rootUrl_Micro + "matuy/ldvl-thongtu11/v2/giai-quyet-viec-lam-stg/cap-nhat-chi-tieu",
            delete_restoreChiTieuID: rootUrl_Micro + "matuy/ldvl-thongtu11/v2/giai-quyet-viec-lam-stg/xoa-khoi-phuc-chi-tieu",
        },
        atvsld: {
            getList: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/an-toan-ve-sinh-lao-dong",
            getByToChuc: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/an-toan-ve-sinh-lao-dong/getByToChuc",
            add_edit_delete: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/an-toan-ve-sinh-lao-dong",
            upload_image: rootUrl_Micro + "file/cung-cau-lao-dong/upload-image",
            load_image: rootUrl_Micro + "file/cung-cau-lao-dong/downloadFile",
            getATVSLDTheoHuyenXa: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/an-toan-ve-sinh-lao-dong/getATVSLDTheoHuyenXa",
            tuChoi: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/an-toan-ve-sinh-lao-dong/tu-choi",
            pheDuyet: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/an-toan-ve-sinh-lao-dong/phe-duyet",
            xuatBaoCao: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/an-toan-ve-sinh-lao-dong/bc-atvsld",
            bienBanKiemTra: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bien-ban-kiem-tra/getAll",
            getDSDoanhNghiepDaKT: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bien-ban-kiem-tra/getDSDoanhNghiepDaKT",
            ADD_EDIT: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bien-ban-kiem-tra",
            getAllDonViDuocKT: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bien-ban-kiem-tra/getAllDonViDuocKT",
            getAllDoanKT: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bien-ban-kiem-tra/getAllDoanKT",
            ADD_EDIT_DELETE_DKT: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bien-ban-kiem-tra/doan-kt",
            ADD_EDIT_DELETE_DVDKT: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bien-ban-kiem-tra/don-vi-duoc-kt",
            xuatBienBanATVSLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bien-ban-kiem-tra/xuat-bc-bien-ban",
        },
        nguoiNNLVTaiVN: {
            //Dang ky nhu cau su dung lao dong
            trinhDoChuyenMon: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/chuyen-mon-dao-tao/getAll",
            hinhThucLamViec: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/hinh-thuc-lam-viec/getAll",
            ngheCongViec: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/nghe-cong-viec/getAll",
            giaypheplaodong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/danh-muc/loai-giay-phep/all",
            trinhDo: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/trinh-do/getAll",
            getByToChucNNNLVTVN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dang-ki-nhu-cau-su-dung-ld/getByHuyenXaStatus",
            uploadFileNNNLDTVN: rootUrl_Micro + "file/cung-cau-lao-dong/dang-ki-nhu-cau-su-dung-ld/upload-image",
            getByIdNhuCauSuDungLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/vi-tri-cong-viec-dang-ki/getByIdNhuCauSuDungLD",
            uploadFile: rootUrl_Micro + "file/cung-cau-lao-dong/dang-ki-nhu-cau-su-dung-ld/upload-image",
            deleteFile: rootUrl_Micro + "file/cung-cau-lao-dong/dang-ki-nhu-cau-su-dung-ld/deleteFile",
            ADD_EDIT_DELETE_dangKyNhuCau: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dang-ki-nhu-cau-su-dung-ld",
            xoaFile: rootUrl_Micro + "file/cung-cau-lao-dong/dang-ki-nhu-cau-su-dung-ld/deleteFile",
            pheDuyet: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dang-ki-nhu-cau-su-dung-ld/gui-phe-duyet",
            listViTriCV: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/vi-tri-cong-viec-dang-ki/getByIdNhuCauSuDungLD",
            viTriCV_ADD_EDIT_DELETE: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/vi-tri-cong-viec-dang-ki",
            getAllViTri: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/vi-tri-cong-viec/getAllViTriCongViec",
            capPhep: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dang-ki-nhu-cau-su-dung-ld/cap-phep",
            xuLy: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dang-ki-nhu-cau-su-dung-ld/submit",
            daTiepNhan: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dang-ki-nhu-cau-su-dung-ld/phe-duyet-ho-so",
            tuChoi: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dang-ki-nhu-cau-su-dung-ld/tu-choi",
            xuatBaoCaoDKNhuCau: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dang-ki-nhu-cau-su-dung-ld/xuat-bc-cap-phep",
            // getTTNLLVTVN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/danh-sach-cap-giay-phep-lao-dong",
            getTTNLLVTVN_BTE: rootUrl_Micro + "quan-ly-san-viec-lam/v2/danh-sach-cap-giay-phep-lao-dong-bte",
            addNewM03: rootUrl_Micro + "quan-ly-san-viec-lam/v2/them-cap-giay-phep-lao-dong",
            updateM03: rootUrl_Micro + "quan-ly-san-viec-lam/v2/sua-cap-giay-phep-lao-dong",
            deleteM03: rootUrl_Micro + "quan-ly-san-viec-lam/v2/xoa-cap-giay-phep-lao-dong",
            xuatM03: rootUrl_Micro + "quan-ly-san-viec-lam/v2/mau-so-03",

            getTTNLLVTVN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/danh-sach-cap-giay-phep-lao-dong-stg",
            xuatDS_TTNLLVTVN_STG: rootUrl_Micro + "quan-ly-san-viec-lam/v2/xuat-danh-sach-cap-giay-phep-lao-dong-stg",
            getImportTemplate_TTNLLVTVN_STG: rootUrl_Micro + "file/cung-cau-lao-dong/import-thanh-vien/downloadTemplate/de97f1c8-60cf-11ed-a026-0050568863c2",
            getFileDSToChuc_TTNLLVTVN_STG: rootUrl_Micro + "quan-ly-san-viec-lam/v2/xuat-ds-to-chuc",
            importDS_TTNLLVTVN_STG: rootUrl_Micro + "quan-ly-san-viec-lam/v2/import-ds_cap_phep-ld",
            getTTNLLVTVN_STG: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cap-giay-phep-lao-dong-stg/danh-sach",
            addNewM03_STG: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cap-giay-phep-lao-dong-stg/cap-moi",
            updateM03_STG: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cap-giay-phep-lao-dong-stg/cap-nhat",
            xuatM03_STG: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cap-giay-phep-lao-dong-stg/in-mau-03",
            giaHanM03_STG: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cap-giay-phep-lao-dong-stg/gia-han",
            capLaiM03_STG: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cap-giay-phep-lao-dong-stg/cap-lai",
            koCapM03_STG: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cap-giay-phep-lao-dong-stg/khong-cap-gpld",
            deleteM03_STG: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cap-giay-phep-lao-dong-stg/xoa-khoi-phuc",
            thuHoiM03_STG: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cap-giay-phep-lao-dong-stg/thu-hoi",
            xuatDSCPLD_STG: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cap-giay-phep-lao-dong-stg/xuat-ds_cap_phep-ld",
            xuatBCTHLDNN_STG: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cap-giay-phep-lao-dong-stg/bc-tinh-hinh-ld-nuoc-ngoai",
            findTTNLVTVN_STG: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cap-giay-phep-lao-dong-stg/thong-tin-giay-phep-lao_dong",

            getTTNLLVTVN_GNBV_STG: rootUrl_Micro + "quan-ly-san-viec-lam/v2/stg/danh-sach-cap-giay-phep-lao-dong",
            getListTinhTrangGiaoNop: rootUrl_Micro + "quan-ly-san-viec-lam/v2/stg/danh-sach-tinh-trang-giao-nop",
            giaoNopTTLDNuocNgoai: rootUrl_Micro + "quan-ly-san-viec-lam/v2/stg/giao-nop-tt-lao-dong-nuoc-ngoai",
            addNewM03_GNBV_STG: rootUrl_Micro + "quan-ly-san-viec-lam/v2/stg/them-cap-giay-phep-lao-dong",
            updateM03_GNBV_STG: rootUrl_Micro + "quan-ly-san-viec-lam/v2/stg/sua-cap-giay-phep-lao-dong",
            detailM03_GNBV_STG: rootUrl_Micro + "quan-ly-san-viec-lam/v2/stg/chi-tiet-tt-lao-dong-nuoc-ngoai",
            tkM03_vitri_GNBV_STG: rootUrl_Micro + "quan-ly-san-viec-lam/v2/stg/tk-tt-ld-nuoc-ngoai-theo-vi-tri",

            //Cap phep
            upLoadImgeCapPhep: rootUrl_Micro + "file/cung-cau-lao-dong/dang-ki-cap-giay-phep-ld/upload-image-dk-cap-phep-ld",
            xoaFileCapPhep: rootUrl_Micro + "file/cung-cau-lao-dong/dang-ki-cap-giay-phep-ld/deleteFile",
            deleteAllFileCapPhep: rootUrl_Micro + "file/cung-cau-lao-dong/dang-ki-cap-giay-phep-ld/deleteAllFile",
            getByMaTB: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dang-ki-nhu-cau-su-dung-ld/getMaTBByToChuc",
            getAllByStatus: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dang-ki-cap-phep-lao-dong/getAllByStatus",
            capPhep_ADD_EDIT_DELETE: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dang-ki-cap-phep-lao-dong",
            daTiepNhanCapPhep: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dang-ki-cap-phep-lao-dong/submit",
            tuChoiCapPhep: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dang-ki-cap-phep-lao-dong/tu-choi",
            xuLyCapPhep: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dang-ki-cap-phep-lao-dong/phe-duyet-ho-so",
            capPhepCapPhep: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dang-ki-cap-phep-lao-dong/cap-phep",
            xuatBaoCaoCapPhep: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao-mau-03",

            //Thay doi nhu cau su dung
            getListThayDoiYeuCau: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thay-doi-dk-nhu-cau-su-dung-ld/getByHuyenXaStatus',
            thayDoiYeuCau_ADD_EDIT_DELETE: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thay-doi-dk-nhu-cau-su-dung-ld',
            tuChoiThayDoiYeuCau: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thay-doi-dk-nhu-cau-su-dung-ld/tu-choi',
            tiepNhanThayDoiYeuCau: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thay-doi-dk-nhu-cau-su-dung-ld/submit',
            xuLyThayDoiYeuCau: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thay-doi-dk-nhu-cau-su-dung-ld/phe-duyet-ho-so',
            capPhepThayDoiYeuCau: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thay-doi-dk-nhu-cau-su-dung-ld/cap-phep',
            xuatBaoCaoCapPhepThaydoiYeuCau: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thay-doi-dk-nhu-cau-su-dung-ld/xuat-bc-cap-phep',
            viTriCVThayDoi_ADD_EDIT: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/vi-tri-cong-viec-thay-doi-nhu-cau',
            getViTriCVThayDoiYeuCau: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/vi-tri-cong-viec-thay-doi-nhu-cau/getByIdNhuCauSuDungLD',
            uploadAnhThayDoi: rootUrl_Micro + 'file/cung-cau-lao-dong/dang-ki-thay-doi-nhu-cau-su-dung-ld/upload-image',
            xuatBaoCaoThayDoi: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thay-doi-dk-nhu-cau-su-dung-ld/xuat-bc-cap-phep',
            getViTriCVOld: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dang-ki-nhu-cau-su-dung-ld/getByMaTB',
            xoaFileThayDoi: rootUrl_Micro + 'file/cung-cau-lao-dong/dang-ki-thay-doi-nhu-cau-su-dung-ld/deleteFile',

            //Cap phep lai
            upLoadImgeCapPhepLai: rootUrl_Micro + "file/cung-cau-lao-dong/dang-ki-cap-lai-giay-phep-ld/upload-image-dk-cap-lai-giay-phep-ld",
            xoaFileCapPhepLai: rootUrl_Micro + "file/cung-cau-lao-dong/dang-ki-cap-lai-giay-phep-ld/deleteFile",
            deleteAllFileCapPhepLai: rootUrl_Micro + "file/cung-cau-lao-dong/dang-ki-cap-giay-phep-ld/deleteAllFile",
            getAllByStatusLai: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dang-ki-cap-lai-giay-phep-lao-dong/getAllByStatus",
            capPhepLai_ADD_EDIT_DELETE: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dang-ki-cap-lai-giay-phep-lao-dong",
            daTiepNhanCapPhepLai: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dang-ki-cap-lai-giay-phep-lao-dong/submit",
            tuChoiCapPhepLai: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dang-ki-cap-lai-giay-phep-lao-dong/tu-choi",
            xuLyCapPhepLai: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dang-ki-cap-lai-giay-phep-lao-dong/phe-duyet-ho-so",
            capPhepCapPhepLai: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dang-ki-cap-lai-giay-phep-lao-dong/cap-phep",
            getAllLyDoCapLai: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/ly-do-cap-lai-giay-phep-ld/getAll',
            baoCaoCapPhepLai: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao-mau-03/dkCapLai",

            //Quan ly giay phep
            getDSCoSo: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/gpld-nguoi-nuoc-ngoai/danh-sach-co-so",
            getDSGiayPhepLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/gpld-nguoi-nuoc-ngoai/danh-sach-giay-phep",
            capGiayPhepLD:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/gpld-nguoi-nuoc-ngoai/them-thong-tin-nguoi-ld-nuoc-ngoai",
            getThongTinChiTietNguoiLD:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/gpld-nguoi-nuoc-ngoai/chi-tiet-nguoi-ld-nuoc-ngoai",
            getDSGiayPhepTheoIDNguoiLDPhanTrang:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/gpld-nguoi-nuoc-ngoai/danh-sach-giay-phep-by-id-nguoi-ld",
            capLaiGiayPhepLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/gpld-nguoi-nuoc-ngoai/cap-lai-giay-phep-cho-nguoi-ld-nuoc-ngoai",
            getChiTietGiayPhepById: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/gpld-nguoi-nuoc-ngoai/lay-chi-tiet-giay-phep-by-id",
            thuHoiGiayPhepById:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/gpld-nguoi-nuoc-ngoai/thu-hoi-giay-phep-by-id",
            xoaGiayPhepLaoDong:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/gpld-nguoi-nuoc-ngoai/xoa-giay-phep-by-id",
            uploadFileGiayPhep: rootUrl_Micro + "file/cung-cau-lao-dong/giay-phep-lao-dong/upload-gpld",
            getDSGiayPhepSapHetHan: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/gpld-nguoi-nuoc-ngoai/danh-sach-giay-phep-sap-het-han",
            xoaThongTinNguoiLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/gpld-nguoi-nuoc-ngoai/xoa-thong-tin-nguoi-lao-dong-by-id",
            xuatGiayPhep: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao/xuat-file-giay-phep-ld-nguoi-ld-nuoc-ngoai",
            downloadFileGiayPhep: rootUrl_Micro + "file/cung-cau-lao-dong/giay-phep-lao-dong/download",
            getFileGiayPhep: rootUrl_Micro + "file/cung-cau-lao-dong/giay-phep-lao-dong/get",

            //Quan ly so theo doi
            getDSSoTheoDoi: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/gpld-nguoi-nuoc-ngoai/danh-sach-so-theo-doi",
            getDSSoTheoDoiTheoNam: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/gpld-nguoi-nuoc-ngoai/danh-sach-so-theo-doi-theo-nam",
            getChiTietSoTheoDoiNguoiLaoDongNuocNgoai: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/gpld-nguoi-nuoc-ngoai/chi-tiet-so-theo-doi-nguoi-lao-dong-nuoc-ngoai",
            xoaSoTheoDoi: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/gpld-nguoi-nuoc-ngoai/xoa-so-theo-doi",
            xoaSoTheoDoiNguoiLDNuocNgoai: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/gpld-nguoi-nuoc-ngoai/xoa-so-theo-doi-nguoi-ld-nuoc-ngoai",
            updateSoTheoDoiNguoiLDNuocNgoai:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/gpld-nguoi-nuoc-ngoai/cap-nhat-so-theo-doi-nguoi-ld-nuoc-ngoai",
            insertSoTheoDoiNguoiLDNuocNgoai:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/gpld-nguoi-nuoc-ngoai/them-moi-so-theo-doi",
            xuatBCSoTheoDoiNguoiLDNuocNgoai:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao/so-theo-doi-nguoi-lao-dong-nuoc-ngoai",

            //import thong tin
            xuatFileImport: rootUrl_Micro + "quan-ly-san-viec-lam/v2/import-mau-so-03",
            checkImport: rootUrl_Micro + "quan-ly-san-viec-lam/v2/check-import-mau03",
            importNguoiNNLVTaiVN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/import-mau03"
          },
        // STG IT5ASXH-6210
        nguoiVNLVTaiNN: {
            //danh muc
            donViXKLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/don-vi-xkld/all",
            doiTuongXKLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/doi-tuong-xkld/all",
            tenNuocLamViecXKLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc/doi-tuong-xkld/all",
            //get list
            getDSNVNLVTNN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/xkld-stg/getAll",
            // get one by id
            getNVNLVTNNByID: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/xkld-stg",
            // them-sua-xoa
            addNewNguoiVN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/xkld-stg",
            updateNguoiVN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/xkld-stg",
            deleteNguoiVN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/xkld-stg",
            restoreNguoiVN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/xkld-stg/restore",
            //xuatM03: rootUrl_Micro + "quan-ly-san-viec-lam/v2/mau-so-03",
            xuatBCDanhSachNLDThamGiaXKLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/xkld-stg/bcMau01",

            getDSNVNLVTNN_STG: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/xkld-stg/getAll-STG-v2",
            thongKeXkldQuaCacNam: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/xkld-stg/thong-ke-xkld-qua-cac-nam",
            thongKeXkTheoViTriCongViec: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/xkld-stg/thong-ke-xkld-theo-vi-tri-cv",
            thongKeXkTheoNuocXk: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/xkld-stg/thong-ke-xkld-theo-nuoc-xk",
            thongKeXkTheoNgheNghiep: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/xkld-stg/thong-ke-xkld-theo-nghe-nghiep",
            thongKeXkTheoHanHopDong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/xkld-stg/thong-ke-xkld-theo-han-hop-dong",
        },
        laoDongVnLamViecChoTCCNNuocNgoaiTaiVN:{
          getDSTinhHinhCungUngChoThueLai: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cung-ung-lao-dong-thue-lai-doanh-nghiep-nuoc-ngoai/danh-sach-quan-ly-tinh-hinh-cung-ung-lao-dong-thue-lai",
          getDSChiTietThongTinLDThueLai: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cung-ung-lao-dong-thue-lai-doanh-nghiep-nuoc-ngoai/chi-tiet-tinh-hinh-cung-ung-lao-dong-thue-lai",
          addThongTinChoThueLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cung-ung-lao-dong-thue-lai-doanh-nghiep-nuoc-ngoai/them-moi-thong-tin-cung-ung-lao-dong-thue-lai",
          capNhatThongTinChoThueLDChiTiet: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cung-ung-lao-dong-thue-lai-doanh-nghiep-nuoc-ngoai/cap-nhat-thong-tin-cung-ung-lao-dong-thue-lai",
          capNhatTrangThaiThongTinCungUngLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cung-ung-lao-dong-thue-lai-doanh-nghiep-nuoc-ngoai/cap-nhat-trang-thai",
          xoaThongTinCungUngLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cung-ung-lao-dong-thue-lai-doanh-nghiep-nuoc-ngoai/xoa-thong-tin-cung-ung-lao-dong-thue-lai",
          xuatBaoCaoTinhHinhCungUngLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cung-ung-lao-dong-thue-lai-doanh-nghiep-nuoc-ngoai/report",
          checkReport: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cung-ung-lao-dong-thue-lai-doanh-nghiep-nuoc-ngoai/check-report"
        },
        // END STG IT5ASXH-6210
        XKLD_CMU: {
          getByID: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/xkld-cmu",
          getAll: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/xkld-cmu/getAll",
          //Thêm sửa xóa thông tin xkld
          addNewXKLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/xkld-cmu",
          updateXKLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/xkld-cmu",
          deleteXKLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/xkld-cmu",
          //Thân nhân
          getAllTN : rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/xkld-cmu/than_nhan/than_nhan_xkld",
          addTN : rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/xkld-cmu/than_nhan/insert",
          updateTN : rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/xkld-cmu/than_nhan/update",
          deleteTN : rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/xkld-cmu/than_nhan/delete",
          // Mức lương
          getAllMucLuong_CMU : rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/xkld-cmu/muc_luong_cmu",
          // Văn bản
          vb_cmu : rootUrl_Micro + "file/vb_cmu",
          vb_cmu_download : rootUrl_Micro + "file/cung-cau-lao-dong/import-thanh-vien/downloadTemplate",
          //Đối tượng
          getAllDT: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/xkld-cmu/search-thanh-vien",
          downLoadListXKLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/xkld-cmu/xuat-danh-sach",
          xuatDanhSach: rootUrl_Micro + "get-data/lao-dong-viec-lam/cung-cau-lao-dong/xuat-khau-lao-dong/xuat-danh-sach",
      },
        vanban: {
            getVanBan: rootUrl_Micro + "quan-ly-san-viec-lam/v2/van-ban/getAll",
            vanBan: rootUrl_Micro + "quan-ly-san-viec-lam/v2/van-ban",
            setStatus: rootUrl_Micro + "quan-ly-san-viec-lam/v2/van-ban/setStatus",
            getListVanBan: rootUrl_Micro + "quan-ly-san-viec-lam/v2/van-ban/getListVanBan",
            vanBanAddUpdate: rootUrl_Micro + "file/van-ban/uploadFile"

        },
        bhtn: {
            getDanhSachTroCapThatNghiep: rootUrl_Micro + "quan-ly-san-viec-lam/v2/bhtn/get-danhsach-chi-tra-that-nghiep",
            changeStatus: rootUrl_Micro + "quan-ly-san-viec-lam/v2/bhtn/update-duyet-dschitra",
            getDanhSachFile: rootUrl_Micro + "quan-ly-san-viec-lam/v2/bhtn/get-danhsach-filehoso",
            downloadFile: rootUrl_Micro + "file/bhtn/downloadFile/",
            hoanthanh: rootUrl_Micro + "file/bhtn/hoanthanh-hoso-khong-co-viec-lam",
            inquyetdinh: rootUrl_Micro + "quan-ly-san-viec-lam/v2/bhtn/quyet-dinh-huong",
        },
        doanhNghiep: {
            getListDKGioLamThemDN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/dang-ky-gio-lam-them-doanh-nghiep-danh-sach",
            getDNChoThueLaiLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/doanh-nghiep-cho-thue-lao-dong/danh-sach",
            addDNChoThueLaiLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/doanh-nghiep-cho-thue-lao-dong/them",
            editDNChoThueLaiLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/doanh-nghiep-cho-thue-lao-dong/cap-nhat",
            deleteDNChoThueLaiLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/doanh-nghiep-cho-thue-lao-dong/xoa-khoi-phuc",
            getUuidDNChoThueLaiLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/doanh-nghiep-cho-thue-lao-dong/chi-tiet",
            noiQuyCongTy: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cong-ty/noi-quy/danh-sach-noi-quy-phan-trang",
            //xuat khau lao dong
            getListDNXuatKhauLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/doanh-nghiep-xuat-khau-lao-dong/danh-sach",
            addDNXuatKhauLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/doanh-nghiep-xuat-khau-lao-dong/them",
            editDNXuatKhauLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/doanh-nghiep-xuat-khau-lao-dong/cap-nhat",
            deleteDNXuatKhauLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/doanh-nghiep-xuat-khau-lao-dong/xoa-khoi-phuc",
            getUuidDNXuatKhauLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/doanh-nghiep-xuat-khau-lao-dong/chi-tiet",
            //khai bao su dung may moc
            getListKhaiBaoSuDungMayMoc: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cong-ty/danh-sach-vat-tu-atvsld",
            addKhaiBaoSuDungMayMoc: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cong-ty/them-moi-vat-tu-atvsld",
            editKhaiBaoSuDungMayMoc: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cong-ty/cap-nhat-vat-tu-atvsld",
            deleteKhaiBaoSudungMayMoc: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cong-ty/cap-nhat-trang-thai-xoa-vat-tu-atvsld",
            //tai nan lao dong khong co hop dong lao dong
            getListTaiNanLDKhongCoHDLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cong-ty/danh-sach-tai-nan-khong-co-hdld",
            addTaiNanLDKhongCoHDLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cong-ty/them-moi-thong-tin-tai-nan-khong-co-hdld",
            editTaiNanLDKhongCoHDLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cong-ty/cap-nhat-thong-tin-tai-nan-khong-co-hdld",
            deleteTaiNanLDKhongCoHDLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cong-ty/cap-nhat-trang-thai-xoa-thong-tin-tai-nan-khong-co-hdld",
            exportBaoCao: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cong-ty/bao-cao-thong-tin-tai-nan-khong-co-hdld",
            exportBaoCaoThongKe: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cong-ty/thong-ke-tnld-khong-theo-hdld",
            //tai nan lao dong từ nguoi su dung lao dong
            getListTaiNanLDTuNguoiSDLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cong-ty/danh-sach-thong-tin-tnld-cua-nguoi-sdld",
            addTaiNanLDTuNguoiSDLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cong-ty/them-moi-thong-tin-tnld-cua-nguoi-sdld",
            editTaiNanLDTuNguoiSDLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cong-ty/cap-nhat-thong-tin-tnld-cua-nguoi-sdld",
            deleteTaiNanLDTuNguoiSDLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cong-ty/cap-nhat-trang-thai-xoa-thong-tin-tnld-cua-nguoi-sdld",
            exportBaoCaoThongKeNguoiSDLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cong-ty/thong-ke-tai-nan-lao-dong",
            //tai nan lao dong nang
            getTaiNanLaoDongNang: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cong-ty/danh-sach-tai-nan-lao-dong",
            exportBaoCaoTaiNanLaoDongNang: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cong-ty/bao-cao-tai-nan-lao-dong",
            exportBaoCaoTaiNanLaoDongTH: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cong-ty/bao-cao-tai-nan-lao-dong/bao-cao-tong-hop-agg",
            exportBaoCaoTaiNanLaoDongTinhHinh: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cong-ty/bao-cao-tai-nan-lao-dong/bao-cao-tinh-hinh-tai-nan-lao-dong-agg",
            //ket qua kiem tra chat luong san pham
            getKetQuaKiemTraChatLuongSP: rootUrl_Micro + "quan-ly-san-viec-lam/v2/kiem-tra-chat-luong-san-pham-search",
            addKetQuaKiemTraChatLuongSP: rootUrl_Micro + "quan-ly-san-viec-lam/v2/kiem-tra-chat-luong-san-pham-add",
            editKetQuaKiemTraChatLuongSP: rootUrl_Micro + "quan-ly-san-viec-lam/v2/kiem-tra-chat-luong-san-pham-edit",
            deleteKetQuaKiemTraChatLuongSP: rootUrl_Micro + "quan-ly-san-viec-lam/v2/kiem-tra-chat-luong-san-pham-delete",
            //ket qua trien khai hanh dong
            getKetQuaTrienKhaiHanhDong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/thang-hanh-dong-atvsld-search",
            addKetQuaTrienKhaiHanhDong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/thang-hanh-dong-atvsld-add",
            editKetQuaTrienKhaiHanhDong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/thang-hanh-dong-atvsld-edit",
            deleteKetQuaTrienKhaiHanhDong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/thang-hanh-dong-atvsld-delete",
            //tình hinh thuc hien
            getTinhHinhThucHien: rootUrl_Micro + "quan-ly-san-viec-lam/v2/atvsld-2021-2025-search",
            addTinhHinhThucHien: rootUrl_Micro + "quan-ly-san-viec-lam/v2/atvsld-2021-2025-add",
            editTinhHinhThucHien: rootUrl_Micro + "quan-ly-san-viec-lam/v2/atvsld-2021-2025-edit",
            deleteTinhHinhThucHien: rootUrl_Micro + "quan-ly-san-viec-lam/v2/atvsld-2021-2025-delete",
            //tình hinh hỗ trợ huấn luyện
            getTinhHinhHoTroHuanLuyen: rootUrl_Micro + "quan-ly-san-viec-lam/v2/huan-luyen-atvsld-search",
            addTinhHinhHoTroHuanLuyen: rootUrl_Micro + "quan-ly-san-viec-lam/v2/huan-luyen-atvsld-add",
            editTinhHinhHoTroHuanLuyen: rootUrl_Micro + "quan-ly-san-viec-lam/v2/huan-luyen-atvsld-edit",
            deleteTinhHinhHoTroHuanLuyen: rootUrl_Micro + "quan-ly-san-viec-lam/v2/huan-luyen-atvsld-delete",
            //Dashboard
            getSoLuongDN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/dashboard-doanh-nghiep/thong-ke-tong-doanh-nghiep",
            getTLQuyMoDN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/dashboard-doanh-nghiep/ty-le-quy-mo-doanh-nghiep",
            getloaiHinhDN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/dashboard-doanh-nghiep/ty-le-loai-hinh-doanh-nghiep",
            getDNByHC: rootUrl_Micro + "quan-ly-san-viec-lam/v2/dashboard-doanh-nghiep/thong-ke-doanh-nghiep-theo-hanh-chinh",

        },
        BHXH: {
            //lao dong tham gia BHXH
            addLaoDongThamGiaBHXH: rootUrl_Micro + "quan-ly-san-viec-lam/v2/nguoi-lao-dong/nld-tham-gia-bhxh-them-moi",
            getLaoDongThamGiaBHXH: rootUrl_Micro + "quan-ly-san-viec-lam/v2/nguoi-lao-dong/nld-tham-gia-bhxh-danh-sach"
        },
        chucNangKhac: {
            //tien luong thu nhap
            addTienLuongThuNhap: rootUrl_Micro + "quan-ly-san-viec-lam/v2/nguoi-lao-dong/them-tien-luong-nld-theo-loai-doanh-nghiep",
            getTienLuongThuNhap: rootUrl_Micro + "quan-ly-san-viec-lam/v2/nguoi-lao-dong/danh-sach-tien-luong-nld-theo-loai-doanh-nghiep"
        },
        // Begin AGG
        nld_dn:{
          // Số lao động trong doanh nghiệp theo quận/huyện
          importSoLDTrongDNTheoHuyen: rootUrl_Micro + "quan-ly-san-viec-lam/v2/nguoi-lao-dong/import-so-ld-theo-huyen-from-template",
          timKiemSoLDTrongDNTheoHuyen: rootUrl_Micro + "quan-ly-san-viec-lam/v2/nguoi-lao-dong/tim-kiem-so-ld-theo-huyen",
          themMoiSoLDTrongDNTheoHuyen: rootUrl_Micro + "quan-ly-san-viec-lam/v2/nguoi-lao-dong/them-moi-so-ld-theo-huyen",
          caNhatSoLDTrongDNTheoHuyen: rootUrl_Micro + "quan-ly-san-viec-lam/v2/nguoi-lao-dong/cap-nhap-so-ld-theo-huyen",
          xoaSoLDTrongDNTheoHuyen: rootUrl_Micro + "quan-ly-san-viec-lam/v2/nguoi-lao-dong/xoa-so-ld-theo-huyen",
          laySoLDTrongDNTheoHuyen: rootUrl_Micro + "quan-ly-san-viec-lam/v2/nguoi-lao-dong/lay-so-ld-theo-id",
          downloadTemplateSoLDTrongDNTheoHuyen: rootUrl_Micro + "quan-ly-san-viec-lam/v2/nguoi-lao-dong/template-so-ld-theo-huyen",

          // Số lao động trong doanh nghiệp theo loại hình
          importSoLDTheoLH: rootUrl_Micro + "quan-ly-san-viec-lam/v2/nguoi-lao-dong/import-so-ld-theo-lh-from-template",
          danhMucLoaiHinhDoanhNghiep: rootUrl_Micro + "quan-ly-san-viec-lam/v2/nguoi-lao-dong/danh-muc-loai-hinh-doanh-nghiep",
          timKiemSoLDTheoLH: rootUrl_Micro + "quan-ly-san-viec-lam/v2/nguoi-lao-dong/tim-kiem-so-ld-theo-lh",
          themMoiSoLDTrongDNTheoLH: rootUrl_Micro + "quan-ly-san-viec-lam/v2/nguoi-lao-dong/them-moi-so-ld-theo-lh",
          caNhatSoLDTheoLH: rootUrl_Micro + "quan-ly-san-viec-lam/v2/nguoi-lao-dong/cap-nhap-so-ld-theo-lh",
          xoaSoLDTheoLH: rootUrl_Micro + "quan-ly-san-viec-lam/v2/nguoi-lao-dong/xoa-so-ld-theo-lh",
          downloadTemplateSoLDTrongDNTheoLH: rootUrl_Micro + "quan-ly-san-viec-lam/v2/nguoi-lao-dong/template-so-ld-theo-lh",
        },
        thongKeThiTruong: {
          importThongKeThiTruongLaoDong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/import-thong-ke-thi-truong-lao-dong",
          themMoiThongKeThiTruongLaoDong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/them-moi-thong-ke-thi-truong-lao-dong",
          capNhatThongKeThiTruongLaoDong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cap-nhat-thong-ke-thi-truong-lao-dong",
          xoaThongKeThiTruongLaoDong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/xoa-thong-ke-thi-truong-lao-dong",
          timKiemThongKeThiTruongLaoDong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/tim-kiem-thong-ke-thi-truong-lao-dong",
          getDMTKThiTruongLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/get-danh-muc-thi-truong-lao-dong",
          getSampleFileThiTruongLaoDong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/get-sample-file-thi-truong-lao-dong"

        },
        // End AGG
        AGG: {
          getXuatKhauLaoDong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/xkld-agg/getAll",
          addXuatKhauLaoDong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/xkld-agg/insert-xkld-agg",
          editXuatKhauLaoDong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/xkld-agg/update-xkld-agg",
          deleteXuatKhauLaoDong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/xkld-agg",
          importXuatKhauLaoDong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/xkld-agg/import-xkld-agg",
          templateXuatKhauLaoDong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/xkld-agg/template-xkld-agg",

          getLDNNLVTaiVN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/danh_sach_nldnn",
          addLDNNLVTaiVN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/them_moi_nldnn",
          editLDNNLVTaiVN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cap_nhat_nldnn",
          deleteLDNNLVTaiVN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/xoa_nldnn",
          importLDNNLVTaiVN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/import_nldnn",
          templateLDNNLVTaiVN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/template_nldnn",
          chuyenTrangThaiGPLDNNLVTaiVN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/chuyen_trang_thai_giay_phep_nldnn",
          getHinhThucLamViec: rootUrl_Micro + "quan-ly-san-viec-lam/v2/get-hinh-thuc-lam-viec",

          anToanLaoDong:{
            importATLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/import-an-toan-lao-dong",
            searchATLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/tim-kiem-an-toan-lao-dong",
            addATLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/them-moi-an-toan-lao-dong",
            updateATLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/cap-nhat-an-toan-lao-dong",
            deleteATLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/xoa-an-toan-lao-dong",
            downloadTemplateATLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/download-template_atld-co-hd",
            downloadTemplateATLD_KHD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/download-template_atld-khong-hd",
            dmChiTieuATLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/dm-chi-tieu-atld-co-hd",
            dmMaSoATLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/dm-ma-so-atld-co-hd",
          },
          DASHBOARD:{
            // Người lao động làm việc ở nước ngoài
            getDataLabelXKLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/label-xkld",
            getDataXKLDTheoThiTruong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/xkld-theo-thi-truong",
            getDataXKLDTheoGioiTinh: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/xkld-theo-gioi-tinh",
            getDataXKLDTheoHuyen: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/xkld-theo-huyen",
            getDataXKLDTheoNganh: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/xkld-theo-nganh",

            // Người lao động và việc làm
            getDataLabelBHTN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/label-bhtn",
            getDataLabelVTN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/label-vtn",
            getDataLabelNTV: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/label-ntv",
            getDataBHTNTheoGioiTinh: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/bhtn-theo-gioi-tinh",
            getDataLDVLTheoTrinhDo: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/ldvl-theo-trinh-do",
            getDataLDVLTheoLoaiHinh: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/ldvl-theo-loai-hinh",
            getDataLDVLTrongDoanhNghiep: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/ldvl-so-ld-trong-doanh-nghiep",
            getDataLDVLTheoNhom: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/ldvl-lao-dong-theo-nhom",
            getDataLDVLTheoHuyen: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/ldvl-lao-dong-theo-huyen",

            // An toàn lao động
            getDataLabelATLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/label-atld",
            getDataATLDChiPhiHoTrop: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/atld-chi-phi-ho-tro",
            getDataATLDTNLDCoSo: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/atld-tnld-theo-co-so",

            // Người lao động nước ngoài làm việc tại VN
            getDataLDVLLabelNNNLvTaiVN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/ldvl-label-nguoi-nuoc-ngoai-lv-tai-vn",
            getDataLDVLNNNLvTaiVNTheoQuocGia: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/ldvl-nguoi-nuoc-ngoai-lv-tai-vn-theo-quoc-gia",
            getDataLDVLNNNLvTaiVNTheoGioiTinh: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/ldvl-nguoi-nuoc-ngoai-lv-tai-vn-theo-gioi-tinh",
            getDataLDVLNNNLvTaiVNTheoChucDanh: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/ldvl-nguoi-nuoc-ngoai-lv-tai-vn-theo-chuc-danh",
          },
          laoDongToanTinh:{
            importLaoDongCoViecLam: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/import-lao-dong-co-viec-lam",
            importLaoDongThatNghiep: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/import-lao-dong-that-dong",
            importLaoDongKHDKT: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/import-lao-dong-khdkt",
            searchLaoDongToanTinh: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/tim-kiem-lao-dong-toan-tinh",
            addLaoDongToanTinh: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/them-moi-lao-dong-toan-tinh",
            updateLaoDongToanTinh: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/cap-nhat-lao-dong-toan-tinh",
            deleteLaoDongToanTinh: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/xoa-lao-dong-toan-tinh",
            downloadTemplateLaoDongCVL: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/template-lao-dong-co-viec-lam",
            downloadTemplateLaoDongTN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/template-lao-dong-that-nghiep",
            downloadTemplateLaoDongKHDKT: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/template-lao-dong-co-khdkt",
            dmTrinhDoHocVan: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/dm-trinh-do-hoc-van",
            dmTrinhDoChuyenMon: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/dm-trinh-do-chuyen-mon",
            dmLinhVucDaoTao: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/dm-linh-vuc-dao-tao",
            dmLoaiTN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/dm-loai-that-nghiep",
            dmTGTN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/dm-thoi-gian-that-nghiep",
            dmTinh: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/dm-tinh",
            dmNhomNganhKD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/agg/dm-nhom-nganh-kinh-doanh",
          },
        },

        phienGiaoDichVL : {
          addOrUpdatePhienGD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/phien-giao-dich/cap-nhat-phien",
          updateTrangThai: rootUrl_Micro + "quan-ly-san-viec-lam/v2/phien-giao-dich/cap-nhat-trang-thai-phien",
          getDSPhienGD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/phien-giao-dich/danh-sach-phien-giao-dich-phan-trang",
          lichSuPhienGD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/phien-giao-dich/lich-su-duyet-phien",
          chiTietPhienGD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/phien-giao-dich/chi-tiet-phien",
          chiTietLSPhienGD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/phien-giao-dich/chi-tiet-phien-lich-su-duyet",
          },

          // Số lao động trong doanh nghiệp theo loại hình
          importSoLDTheoLH: rootUrl_Micro + "quan-ly-san-viec-lam/v2/nguoi-lao-dong/import-so-ld-theo-lh-from-template",
          danhMucLoaiHinhDoanhNghiep: rootUrl_Micro + "quan-ly-san-viec-lam/v2/nguoi-lao-dong/danh-muc-loai-hinh-doanh-nghiep",
          timKiemSoLDTheoLH: rootUrl_Micro + "quan-ly-san-viec-lam/v2/nguoi-lao-dong/tim-kiem-so-ld-theo-lh",
          themMoiSoLDTrongDNTheoLH: rootUrl_Micro + "quan-ly-san-viec-lam/v2/nguoi-lao-dong/them-moi-so-ld-theo-lh",
          caNhatSoLDTheoLH: rootUrl_Micro + "quan-ly-san-viec-lam/v2/nguoi-lao-dong/cap-nhap-so-ld-theo-lh",
          xoaSoLDTheoLH: rootUrl_Micro + "quan-ly-san-viec-lam/v2/nguoi-lao-dong/xoa-so-ld-theo-lh",
          downloadTemplateSoLDTrongDNTheoLH: rootUrl_Micro + "quan-ly-san-viec-lam/v2/nguoi-lao-dong/template-so-ld-theo-lh",
        // End AGG
        DVVL:{
          // Begin IT5ASXH-14279
          addOrUpdateQLTinhHinhHoatDongDVVL: rootUrl_Micro + "quan-ly-san-viec-lam/v2/dich-vu-viec-lam/them-cap-nhat",
          timKiemQLTinhHinhHoatDongDVVL: rootUrl_Micro + "quan-ly-san-viec-lam/v2/dich-vu-viec-lam/tim-kiem",
          xoaQLTinhHinhHoatDongDVVL: rootUrl_Micro + "quan-ly-san-viec-lam/v2/dich-vu-viec-lam/xoa",
          capnhatTrangThaiQLTinhHinhHoatDongDVVL: rootUrl_Micro + "quan-ly-san-viec-lam/v2/dich-vu-viec-lam/cap-nhat-trang-thai",
          downloadMauQLTinhHinhHoatDongDVVL: rootUrl_Micro + "quan-ly-san-viec-lam/v2/dich-vu-viec-lam/download-mau-quan-ly-tinh-hinh-hoat-dong-dvvl",
          importQLTinhHinhHoatDongDVVL: rootUrl_Micro + "quan-ly-san-viec-lam/v2/dich-vu-viec-lam/import-quan-ly-tinh-hinh-hoat-dong-dvvl",
          // End IT5ASXH-14279
          addOrUpdateQLKQHoatDongDVVL: rootUrl_Micro + "quan-ly-san-viec-lam/v2/dich-vu-viec-lam/them-cap-nhat-ket-qua-hoat-dong-dvvl",
          timKiemQLKQHoatDongDVVL: rootUrl_Micro + "quan-ly-san-viec-lam/v2/dich-vu-viec-lam/tim-kiem-ket-qua-hoat-dong-dvvl",
          xoaQLKQHoatDongDVVL: rootUrl_Micro + "quan-ly-san-viec-lam/v2/dich-vu-viec-lam/xoa-ket-qua-hoat-dong-dvvl",
          capnhatTrangThaiQLKQHoatDongDVVL: rootUrl_Micro + "quan-ly-san-viec-lam/v2/dich-vu-viec-lam/cap-nhat-trang-thai-ket-qua-hoat-dong-dvvl",
          downloadMauQLKQHoatDongDVVL: rootUrl_Micro + "quan-ly-san-viec-lam/v2/dich-vu-viec-lam/download-mau-quan-ly-ket-qua-hoat-dong-dvvl",
          importQLKQHoatDongDVVL: rootUrl_Micro + "quan-ly-san-viec-lam/v2/dich-vu-viec-lam/import-quan-ly-ket-qua-hoat-dong-dvvl",

        // End IT5ASXH-14346
        // Begin IT5ASXH-14432
          addOrUpdateQLTinhHinhHoatDongDVVLTongHop: rootUrl_Micro + "quan-ly-san-viec-lam/v2/dich-vu-viec-lam/them-cap-nhat-tinh-hinh-hoat-dong-dvvl-tong-hop",
          timKiemQLTinhHinhHoatDongDVVLTongHop: rootUrl_Micro + "quan-ly-san-viec-lam/v2/dich-vu-viec-lam/tim-kiem-tinh-hinh-hoat-dong-dvvl-tong-hop",
          xoaQLTinhHinhHoatDongDVVLTongHop: rootUrl_Micro + "quan-ly-san-viec-lam/v2/dich-vu-viec-lam/xoa-tinh-hinh-hoat-dong-dvvl-tong-hop",
          capnhatTrangThaiQLTinhHinhHoatDongDVVLTongHop: rootUrl_Micro + "quan-ly-san-viec-lam/v2/dich-vu-viec-lam/cap-nhat-trang-thai-tinh-hinh-hoat-dong-dvvl-tong-hop",
          xuatbaocaoQLTinhHinhHoatDongDVVL: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao/quan-ly-tinh-hinh-hoat-dong-dvvl",

          //start IT5ASXH-15119
          xuatbaocaoQLTinhHinhHoatDongDVVL_TongHop: rootUrl_Micro + "quan-ly-san-viec-lam/v2/bao-cao/quan-ly-tinh-hinh-hoat-dong-dvvl-tong-hop"
          //end IT5ASXH-15119
        },
        // End IT5ASXH-14279
        //BEGIN SRS_20
        THUE_LAI_LD:{
          getListTinhHinhHDChoThueLaiLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-thhd-cho-thue-lai-ld/search",
          getThongTinChiTiet: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-thhd-cho-thue-lai-ld",
          insertTinhHinhHDChoThueLaiLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-thhd-cho-thue-lai-ld/them-moi",
          updateTinhHinhHDChoThueLaiLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-thhd-cho-thue-lai-ld/cap-nhat",
          deleteTinhHinhHDChoThueLaiLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-thhd-cho-thue-lai-ld/xoa",
          capNhatTrangThaiDuyet: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-thhd-cho-thue-lai-ld/cap-nhat-trang-thai-duyet",
          xuatBaoCaoTinhHinhHDChoThueLaiLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-thhd-cho-thue-lai-ld/xuat-bao-cao",
          checkBaoCaoTinhHinhHDChoThueLaiLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-thhd-cho-thue-lai-ld/check-bao-cao"
        },
        //END SRS_20
        traCuuThongTinDoanhNghiep: rootUrl_Micro+ "quan-ly-san-viec-lam/v2/tra-cuu/tra-cuu-thong-tin-doanh-nghiep",
        traCuuThongTinDoanhNghiepChiTiet: rootUrl_Micro+ "quan-ly-san-viec-lam/v2/tra-cuu/tra-cuu-thong-tin-doanh-nghiep-chi-tiet",
        danhSachBaoCao : rootUrl_Micro + "get-data/matuy/ldvl-thongtu11/danh-muc-bao-cao"
      },
    // API địa phương
    diaPhuong: {
        tinhPublic: rootUrlDefault + 'dia-phuong/v2/danh-muc-tinh',
        tinhURL: rootUrl_Micro + 'dia-phuong/v2/danh-sach-tinh',
        tinhURLLogin: rootUrl_Micro + 'dia-phuong/v2/danh-sach-tinh-login',
        huyenURL: rootUrl_Micro + 'dia-phuong/v2/danh-sach-huyen',
        xaURL: rootUrl_Micro + 'dia-phuong/v2/danh-sach-xa',
        thonURL: rootUrl_Micro + 'dia-phuong/v2/danh-sach-thon',
        huyenURLBHXH: rootUrl_Micro + 'dia-phuong/danh-sach-huyen-bhxh',
        xaURLBHXH: rootUrl_Micro + 'dia-phuong/danh-sach-xa-bhxh',
        thonURLBHXH: rootUrl_Micro + 'dia-phuong/v2/danh-sach-thon',
        getAllRegionUrl: rootUrl_Micro + 'dia-phuong/v2/tim-kiem',
        addVillageUrl: rootUrl_Micro + 'dia-phuong/v2/thon/them-moi',
        updateVillageUrl: rootUrl_Micro + 'dia-phuong/v2/thon/sua',
        removeVillageUrl: rootUrl_Micro + 'dia-phuong/v2/thon/xoa',
        recoverVillageUrl: rootUrl_Micro + 'dia-phuong/v2/thon/khoi-phuc',
        danhSachTinh: rootUrl_Micro + 'dia-phuong/v2/danh-muc-tinh/tim-kiem-phan-trang',
        themMoiTinh: rootUrl_Micro + 'dia-phuong/v2/danh-muc-tinh/them-moi',
        capNhatTinh: rootUrl_Micro + 'dia-phuong/v2/danh-muc-tinh/cap-nhat',
        xoaTinh: rootUrl_Micro + 'dia-phuong/v2/danh-muc-tinh/xoa',
        khoiPhucTinh: rootUrl_Micro + 'dia-phuong/v2/danh-muc-tinh/khoi-phuc?MaTinhThanhBHXH=',
        timKiemHuyen: rootUrl_Micro + 'dia-phuong/danh-muc-huyen/tim-kiem',
        themMoiHuyen: rootUrl_Micro + 'dia-phuong/danh-muc-huyen/them-moi',
        capNhatHuyen: rootUrl_Micro + 'dia-phuong/danh-muc-huyen/cap-nhat',
        xoaHuyen: rootUrl_Micro + 'dia-phuong/danh-muc-huyen/xoa',
        khoiPhucHuyen: rootUrl_Micro + 'dia-phuong/danh-muc-huyen/khoi-phuc?maQuanHuyenBHXH=',
        timKiemXa: rootUrl_Micro + 'dia-phuong/v2/danh-muc-xa/tim-kiem',
        themMoiXa: rootUrl_Micro + 'dia-phuong/v2/danh-muc-xa/them-moi',
        capNhatXa: rootUrl_Micro + 'dia-phuong/v2/danh-muc-xa/cap-nhat',
        xoaXa: rootUrl_Micro + 'dia-phuong/v2/danh-muc-xa/xoa',
        khoiPhucXa: rootUrl_Micro + 'dia-phuong/v2/danh-muc-xa/khoi-phuc?maXaBHXH=',
    },

    //Drug addiction
    maTuy: {
        category: {
            maritalStatus: rootUrl_Micro + 'matuy/tinh-trang-hon-nhan/list',
            formOfUse: rootUrl_Micro + 'matuy/hinh-thuc-su-dung/list',
            nation: rootUrl_Micro + 'matuy/danh-muc/dan-toc',
            religion: rootUrl_Micro + 'matuy/danh-muc/ton-giao',
            level: rootUrl_Micro + 'matuy/danh-muc/trinh-do',
            drugType: rootUrl_Micro + 'matuy/loai-ma-tuy/list',
            stateAfterAdiction: rootUrl_Micro + 'matuy/danh-muc/tinh-trang-sau-cai',
            doanTheHoTro: rootUrl_Micro + 'matuy/danh-muc/doan-the-ho-tro',
            formOfMove: rootUrl_Micro + 'matuy/hinh-thuc-chuyen/list',
            //cac hoi
            canBo: rootUrl_Micro + "matuy/v2/danh-muc/can-bo",
            canBoAll: rootUrl_Micro + "matuy/v2/danh-muc/can-bo/get-all",
            hoi: rootUrl_Micro + "matuy/v2/danh-muc/cac-hoi",
            getAllHoi: rootUrl_Micro + "matuy/v2/danh-muc/cac-hoi/get-all",
            doiTuongHoi: rootUrl_Micro + "matuy/v2/quan-ly-cac-hoi/cong-tac-hoi",
            getAllDoiTuong: rootUrl_Micro + "matuy/quan-ly-cac-hoi/cong-tac-hoi/get-all/doi-tuong",
            baoCao: rootUrl_Micro + "matuy/quan-ly-cac-hoi/cong-tac-hoi/bao-cao",
            getListBaoCao: rootUrl_Micro + "matuy/quan-ly-cac-hoi/cong-tac-hoi/bao-cao/danh-sach",
            //Thanh tra
            getDonVi: rootUrl_Micro + "matuy/v2/danh-sach-don-vi",
            addDonVi: rootUrl_Micro + "matuy/v2/them-moi-don-vi",
            deleteDonVi: rootUrl_Micro + "matuy/v2/xoa-don-vi",
            editDonVi: rootUrl_Micro + "matuy/v2/cap-nhat-don-vi",
            getAllDonVi: rootUrl_Micro + "matuy/v2/don-vi/get-all",

            getTiepCongDan: rootUrl_Micro + "matuy/v2/tiep-cong-dan/danh-sach",
            getChiTietTiepCongDan: rootUrl_Micro + "matuy/tiep-cong-dan/chi-tiet",
            addTiepCongDan: rootUrl_Micro + "matuy/v2/tiep-cong-dan/insert",
            deleteTiepCongDan: rootUrl_Micro + "matuy/tiep-cong-dan/xoa-khoi-phuc",
            editTiepCongDan: rootUrl_Micro + "matuy/v2/tiep-cong-dan/update",

            getKhieuNai: rootUrl_Micro + "matuy/v2/don-thu-khieu-nai/danh-sach",
            getKhieuNaiUuid: rootUrl_Micro + "matuy/don-thu-khieu-nai/chi-tiet",
            addKhieuNai: rootUrl_Micro + "matuy/v2/don-thu-khieu-nai/them-moi",
            deleteKhieuNai: rootUrl_Micro + "matuy/don-thu-khieu-nai/xoa-khoi-phuc",
            editKhieuNai: rootUrl_Micro + "matuy/v2/don-thu-khieu-nai/cap-nhat",

            addPhanAnh: rootUrl_Micro + "matuy/v2/phan-anh/insert",
            uploadFilePhanAnh: rootUrl_Micro + "file/uploadFilePhanAnh",
            getPhanAnh: rootUrl_Micro + "matuy/v2/phan-anh/danh-sach",
            gePhanAnhUuid: rootUrl_Micro + "matuy/phan-anh/chi-tiet",
            deletePhanAnh: rootUrl_Micro + "matuy/phan-anh/xoa",
            editPhanAnh: rootUrl_Micro + "matuy/v2/phan-anh/update",
            downloadPhanAnh: rootUrl_Micro + "file/downloadFilePhanAnh",

            addNganhQuanLy: rootUrl_Micro + "matuy/v2/thanh-tra-nganh/insert",
            getNganhQuanLyUuid: rootUrl_Micro + "matuy/thanh-tra-nganh/chi-tiet",
            editNganhQuanLy: rootUrl_Micro + "matuy/v2/thanh-tra-nganh/update",
            deleteNganhQuanLy: rootUrl_Micro + "matuy/thanh-tra-nganh/xoa-khoi-phuc",
            getNganhQuanLy: rootUrl_Micro + "matuy/v2/thanh-tra-nganh/danh-sach",

            fileImportNganhQuanLy: rootUrl_Micro + "file/matuy/downloadFile/f2ac9a6e-6e58-11ee-924d-0050568863c2",
            importNganhQuanLy: rootUrl_Micro + "matuy/v2/import-thanhtra-from-template",
            fileImportKhieuNai: rootUrl_Micro + "file/matuy/downloadFile/82bd7be2-7150-11ee-924d-0050568863c2",
            importKhieuNai: rootUrl_Micro + "matuy/v2/import-don-khieu-nai-from-template",
            //End thanh tra

            //Văn phong
            addLichCongTac: rootUrl_Micro + "matuy/them-moi-lich-cong-tac",
            editLichCongTac: rootUrl_Micro + "matuy/cap-nhat-lich-cong-tac",
            getLichCongTac: rootUrl_Micro + "matuy/lich-cong-tac",
            deleteLichCongTac: rootUrl_Micro + "matuy/xoa-lich-cong-tac",

            // bao cao tong hop
            addBaoCaoTongHop: rootUrl_Micro + "matuy/them-moi-bao-cao",
            editBaoCaoTongHop: rootUrl_Micro + "matuy/cap-nhat-bao-cao",
            getBaoCaoTongHop: rootUrl_Micro + "matuy/danh-sach-bao-cao",
            deleteBaoCaoTongHop: rootUrl_Micro + "matuy/xoa-bao-cao",
            exportBaoCaoTongHop: rootUrl_Micro + "matuy/bao-cao-lich-cong-tac",

            //Ke hoach tai chính
            addTroCapUuDai: rootUrl_Micro + "matuy/ke-toan/tro-cap-uu-dai/them-moi",
            editTroCapUuDai: rootUrl_Micro + "matuy/ke-toan/tro-cap-uu-dai/cap-nhat",
            getUuidTroCapUuDai: rootUrl_Micro + "matuy/ke-toan/tro-cap-uu-dai/chi-tiet",
            deleteTroCapUuDai: rootUrl_Micro + "matuy/ke-toan/tro-cap-uu-dai/xoa",
            getTroCapUuDai: rootUrl_Micro + "matuy/ke-toan/tro-cap-uu-dai/danh-sach",

            addKeToan: rootUrl_Micro + "matuy/ke-toan/danh-muc-ke-toan/them-moi",
            editKeToan: rootUrl_Micro + "matuy/ke-toan/danh-muc-ke-toan/cap-nhat",
            getUuidKeToan: rootUrl_Micro + "matuy/ke-toan/danh-muc-ke-toan/chi-tiet",
            deleteKeToan: rootUrl_Micro + "matuy/ke-toan/danh-muc-ke-toan/xoa",
            getKeToan: rootUrl_Micro + "matuy/ke-toan/danh-muc-ke-toan/danh-sach",

            addHocSinh: rootUrl_Micro + "matuy/ke-toan/v2/hoc-sinh/them-moi",
            editHocSinh: rootUrl_Micro + "matuy/ke-toan/v2/hoc-sinh/cap-nhat",
            getUuidHocSinh: rootUrl_Micro + "matuy/ke-toan/hoc-sinh/chi-tiet",
            deleteHocSinh: rootUrl_Micro + "matuy/ke-toan/hoc-sinh/xoa",
            getHocSinh: rootUrl_Micro + "matuy/ke-toan/v2/hoc-sinh/danh-sach",
            getAllLoaiHocSinh: rootUrl_Micro + "matuy/ke-toan/danh-muc-loai-hoc-sinh/get-all",

            addChinhSach: rootUrl_Micro + "matuy/ke-toan/v2/hoc-sinh/them-moi-chinh-sach",
            editChinhSach: rootUrl_Micro + "matuy/ke-toan/hoc-sinh/cap-nhat-chinh-sach",
            deleteChinhSach: rootUrl_Micro + "matuy/ke-toan/hoc-sinh/xoa-chinh-sach",

            lapDsChiTra: rootUrl_Micro + "matuy/ke-toan/v2/danh-sach-chi-tra-hoc-sinh/cap-nhat-trang-thai",
            getDsDaLap: rootUrl_Micro + "matuy/ke-toan/v2/danh-sach-chi-tra-hoc-sinh/danh-sach-da-lap",
            chiTietDsChiTra: rootUrl_Micro + "matuy/ke-toan/danh-sach-chi-tra-hoc-sinh/chi-tiet-danh-sach",
            capNhatChiTra: rootUrl_Micro + "matuy/ke-toan/danh-sach-chi-tra-hoc-sinh/cap-nhat-trang-thai-chi-tra-hoc-sinh",

            checkDaLap: rootUrl_Micro + "matuy/ke-toan/v2/danh-sach-chi-tra-hoc-sinh/check-da-lap",
            //Bao cao thong ke
            tiepCongDan: rootUrl_Micro + "matuy/v2/tiep-cong-dan/xuat-danh-sach",
            donThuKhieuNai: rootUrl_Micro + "matuy/v2/tiep-cong-dan/xuat-danh-sach",
            phanAnh: rootUrl_Micro + "matuy/v2/phan-anh/xuat-danh-sach",
            thanhTraNganh: rootUrl_Micro + "matuy/v2/thanh-tra-nganh/xuat-danh-sach",
            listBaoCaoThongKe: rootUrl_Micro + "matuy/bao-cao/tim-kiem",

            //Tro cap dieu duong
            getDieuDuong: rootUrl_Micro + "matuy/ke-toan/v2/dieu-duong/danh-sach",
            addDieuDuong: rootUrl_Micro + "matuy/ke-toan/v2/dieu-duong/them-moi",
            editDieuDuong: rootUrl_Micro + "matuy/ke-toan/v2/dieu-duong/cap-nhat",
            getUuidDieuDuong: rootUrl_Micro + "matuy/ke-toan/dieu-duong/chi-tiet",
            deleteDieuDuong: rootUrl_Micro + "matuy/ke-toan/dieu-duong/xoa",

            addChinhSachDieuDuong: rootUrl_Micro + "matuy/ke-toan/v2/dieu-duong/them-moi-chinh-sach",
            editChinhSachDieuDuong: rootUrl_Micro + "matuy/ke-toan/dieu-duong/cap-nhat-chinh-sach",
            deleteChinhSachDieuDuong: rootUrl_Micro + "matuy/ke-toan/dieu-duong/xoa-chinh-sach",

            lapDsChiTraDieuDuong: rootUrl_Micro + "matuy/ke-toan/v2/danh-sach-chi-tra-dieu-duong/cap-nhat-trang-thai",
            getDsDaLapDieuDuong: rootUrl_Micro + "matuy/ke-toan/v2/danh-sach-chi-tra-dieu-duong/danh-sach-da-lap",
            chiTietDsChiTraDieuDuong: rootUrl_Micro + "matuy/ke-toan/danh-sach-chi-tra-dieu-duong/chi-tiet-danh-sach",
            capNhatChiTraDieuDuong: rootUrl_Micro + "matuy/ke-toan/danh-sach-chi-tra-dieu-duong/cap-nhat-trang-thai-chi-tra-dieu-duong",

            checkDaLapDieuDuong: rootUrl_Micro + "matuy/ke-toan/v2/danh-sach-chi-tra-dieu-duong/check-da-lap",

            getChinhHinh: rootUrl_Micro + "matuy/ke-toan/v2/dung-cu/danh-sach",
            addChinhHinh: rootUrl_Micro + "matuy/ke-toan/v2/dung-cu/them-moi",
            editChinhHinh: rootUrl_Micro + "matuy/ke-toan/dung-cu/cap-nhat",
            getUuidChinhHinh: rootUrl_Micro + "matuy/ke-toan/dung-cu/chi-tiet",
            deleteChinhHinh: rootUrl_Micro + "matuy/ke-toan/dung-cu/xoa",
            chiTietDsChiTraChinhHinh: rootUrl_Micro + "matuy/ke-toan/danh-sach-chi-tra-dung-cu/chi-tiet-danh-sach",
            capNhatChiTraChinhHinh: rootUrl_Micro + "matuy/ke-toan/danh-sach-chi-tra-dung-cu/cap-nhat-trang-thai-chi-tra-dung-cu",
            lapDsChiTraChinhHinh: rootUrl_Micro + "matuy/ke-toan/v2/danh-sach-chi-tra-dung-cu/cap-nhat-trang-thai",
            getDsDaLapChinhHinh: rootUrl_Micro + "matuy/ke-toan/v2/danh-sach-chi-tra-dung-cu/danh-sach-da-lap",
            checkDaLapChinhHinh: rootUrl_Micro + "matuy/ke-toan/v2/danh-sach-chi-tra-dung-cu/check-da-lap",

            getChiHoTro: rootUrl_Micro + "matuy/ke-toan/v2/chi-ho-tro/danh-sach",
            addChiHoTro: rootUrl_Micro + "matuy/ke-toan/v2/chi-ho-tro/them-moi",
            editChiHoTro: rootUrl_Micro + "matuy/ke-toan/v2/chi-ho-tro/cap-nhat",
            getUuidChiHoTro: rootUrl_Micro + "matuy/ke-toan/chi-ho-tro/chi-tiet",
            deleteChiHoTro: rootUrl_Micro + "matuy/ke-toan/chi-ho-tro/xoa",
            chiTietDsChiTraChiHoTro: rootUrl_Micro + "matuy/ke-toan/danh-sach-chi-tra-chi-ho-tro/chi-tiet-danh-sach",
            capNhatChiTraChiHoTro: rootUrl_Micro + "matuy/ke-toan/danh-sach-chi-tra-chi-ho-tro/cap-nhat-trang-thai-chi-tra-ho-tro",
            lapDsChiTraChiHoTro: rootUrl_Micro + "matuy/ke-toan/v2/danh-sach-chi-tra-chi-ho-tro/cap-nhat-trang-thai",
            getDsDaLapChiHoTro: rootUrl_Micro + "matuy/ke-toan/v2/danh-sach-chi-tra-chi-ho-tro/danh-sach-da-lap",
            checkDaLapChiHoTro: rootUrl_Micro + "matuy/ke-toan/v2/danh-sach-chi-tra-chi-ho-tro/check-da-lap",
            //ma tuy
            getHSNguoiBanDam: rootUrl_Micro + 'matuy/v2/ho-so-nguoi-ban-dam/danh-sach',
            addHSNguoiBanDam: rootUrl_Micro + 'matuy/v2/ho-so-nguoi-ban-dam/them-moi',
            editHSNguoiBanDam: rootUrl_Micro + 'matuy/v2/ho-so-nguoi-ban-dam/cap-nhat',
            getUuidHSNguoiBanDam: rootUrl_Micro + 'matuy/ho-so-nguoi-ban-dam/chi-tiet',
            deleteHSNguoiBanDam: rootUrl_Micro + 'matuy/ho-so-nguoi-ban-dam/xoa-khoi-phuc',
            //Chi tra can bo nhan vien
            getCanBo: rootUrl_Micro + "matuy/v2/can-bo/danh-sach",
            addCanBo: rootUrl_Micro + "matuy/v2/can-bo/them-moi",
            editCanBo: rootUrl_Micro + "matuy/v2/can-bo/cap-nhat",
            getUuidCanBo: rootUrl_Micro + "matuy/can-bo/chi-tiet",
            deleteCanBo: rootUrl_Micro + "matuy/can-bo/xoa",
            templateCanBo: rootUrl_Micro + "matuy/v2/can-bo/template-import",
            checkImportCanBo: rootUrl_Micro + "matuy/v2/can-bo/check-import",
            importCanBo: rootUrl_Micro + "matuy/v2/can-bo/import",

            addChinhSachCanBo: rootUrl_Micro + "matuy/v2/can-bo/them-moi-chinh-sach",
            editChinhSachCanBo: rootUrl_Micro + "matuy/can-bo/cap-nhat-chinh-sach",
            deleteChinhSachCanBo: rootUrl_Micro + "matuy/can-bo/xoa-chinh-sach",

            lapDsChiTraCanBo: rootUrl_Micro + "matuy/v2/danh-sach-chi-tra-can-bo/cap-nhat-trang-thai",
            getDsDaLapCanBo: rootUrl_Micro + "matuy/v2/danh-sach-chi-tra-can-bo/danh-sach-da-lap",
            chiTietDsChiTraCanBo: rootUrl_Micro + "matuy/danh-sach-chi-tra-can-bo/chi-tiet",
            capNhatChiTraCanBo: rootUrl_Micro + "matuy/danh-sach-chi-tra-can-bo/cap-nhat-trang-thai-chi-tra",
            checkDaLapCanBo: rootUrl_Micro + "matuy/v2/danh-sach-chi-tra-can-bo/check-da-lap",

            //Đối tượng trợ cấp học nghề
            getDoiTuongTroCapHocNghe: rootUrl_Micro + "matuy/v2/doi-tuong-tro-cap-hoc-nghe/danh-sach",
            addDoiTuongTroCapHocNghe: rootUrl_Micro + "matuy/v2/doi-tuong-tro-cap-hoc-nghe/insert",
            editDoiTuongTroCapHocNghe: rootUrl_Micro + "matuy/v2/doi-tuong-tro-cap-hoc-nghe/update",
            getUuidDoiTuongTroCapHocNghe: rootUrl_Micro + "matuy/doi-tuong-tro-cap-hoc-nghe/chi-tiet",
            deleteDoiTuongTroCapHocNghe: rootUrl_Micro + "matuy/doi-tuong-tro-cap-hoc-nghe/xoa",
            uploadFile: rootUrl_Micro + "file/uploadFileDoiTuongTroCapHocNghe",
            downloadFile: rootUrl_Micro + "file/downloadFileDoiTuongTroCapHocNghe",

            //danh mục loai co so cai nghien
            getListLoaiCoSo: rootUrl_Micro + "matuy/danh-muc-co-so-cai-nghien/danh-sach",
            addLoaiCoSo: rootUrl_Micro + "matuy/danh-muc-co-so-cai-nghien/them-moi",
            editLoaiCoSo: rootUrl_Micro + "matuy/danh-muc-co-so-cai-nghien/cap-nhat",
            deleteLoaiCoSo: rootUrl_Micro + "matuy/danh-muc-co-so-cai-nghien/xoa-khoi-phuc",

            //Báo cáo không tệ nạn
            getKhongTeNan: rootUrl_Micro + "matuy/v2/pham-mem-so/so-lieu-xa-phuong-khong-co-te-nan-ma-tuy-mai-dam/tim-kiem",
            addKhongTeNan: rootUrl_Micro + "matuy/v2/pham-mem-so/so-lieu-xa-phuong-khong-co-te-nan-ma-tuy-mai-dam/them-moi",
            editKhongTeNan: rootUrl_Micro + "matuy/v2/pham-mem-so/so-lieu-xa-phuong-khong-co-te-nan-ma-tuy-mai-dam/cap-nhat",
            getChiTietKhongTeNan: rootUrl_Micro + "matuy/pham-mem-so/so-lieu-xa-phuong-khong-co-te-nan-ma-tuy-mai-dam/chi-tiet",
            deleteKhongTeNan: rootUrl_Micro + "matuy/pham-mem-so/so-lieu-xa-phuong-khong-co-te-nan-ma-tuy-mai-dam/xoa-khoi-phuc",
            exportBaoCaoKhongTeNan: rootUrl_Micro + "matuy/v2/pham-mem-so/so-lieu-xa-phuong-khong-co-te-nan-ma-tuy-mai-dam/xuat",

        },
        findById: {
            communeEducation:
                rootUrl_Micro + 'matuy/thong-tin-giao-duc-dia-phuong/select',
            findPerformAtAddictionCenterById:
                rootUrl_Micro + 'matuy/thong-tin-cai-nghien-tai-cscn/select',
            communityAddiction:
                rootUrl_Micro + 'matuy/thong-tin-cai-nghien-cong-dong/select',
            stayAtAddictionCenter:
                rootUrl_Micro + 'matuy/thong-tin-luu-tru-tai-cscn/select',
            treatingMethadone:
                rootUrl_Micro + 'matuy/thong-tin-cai-nghien-methadone/select',
            currentPerform:
                rootUrl_Micro + 'matuy/thong-tin-doi-tuong/tinh-trang-hien-tai',
            otherAddiction: rootUrl_Micro + 'matuy/thong-tin-cai-nghien-khac/select',
            managingAfterAddiction:
                rootUrl_Micro + 'matuy/thong-tin-sau-cai-nghien/select',
            findPerformOutsideAddictionCenterById:
                rootUrl_Micro + 'matuy/thong-tin-ngoai-cscn/select',
            findThongTinCoBan: rootUrl_Micro + "bao-tro-xa-hoi/v2/thanh-vien/v2/thong-tin-co-ban-by-cmnd"
        },
        list: {
            drugAddict: rootUrl_Micro + 'matuy/v2/danh-sach-doi-tuong',
            getInfoOfDrugAddict: rootUrl_Micro + 'matuy/v2/thong-tin-doi-tuong/select',
            communeEducation:
                rootUrl_Micro + 'matuy/thong-tin-giao-duc-dia-phuong/list',
            file: rootUrl_Micro + 'matuy/file-dinh-kem/list',
            checkIdentityCard: rootUrl_Micro + 'matuy/doi-tuong/check-identity-card',
            checkIdentityCardOnUpdate: rootUrl_Micro + 'matuy/doi-tuong/check-identity-card-update',
            archivedRecords: rootUrl_Micro + 'matuy/thong-tin-ho-so-luu-tru/select',
            performAtAddictionCenter:
                rootUrl_Micro + 'matuy/thong-tin-cai-nghien-tai-cscn/list',
            communityAddiction:
                rootUrl_Micro + 'matuy/thong-tin-cai-nghien-cong-dong/list',
            stayAtAddictionCenter:
                rootUrl_Micro + 'matuy/thong-tin-luu-tru-tai-cscn/list',
            methadoneTreatment:
                rootUrl_Micro + 'matuy/thong-tin-cai-nghien-methadone/list',
            otherAddiction: rootUrl_Micro + 'matuy/thong-tin-cai-nghien-khac/list',
            managementAfterAddiction:
                rootUrl_Micro + 'matuy/thong-tin-sau-cai-nghien/list',
            performOutsideAddictionCenter:
                rootUrl_Micro + 'matuy/thong-tin-ngoai-cscn/list',
        },
        count: {
            drugAddictByProvince: rootUrl_Micro + 'matuy/thong-ke-doi-tuong/tinh',
            drugAddictByDistrict: rootUrl_Micro + 'matuy/v2/thong-ke-doi-tuong/xa',
            drugAddictByDistrictV1: rootUrl_Micro + 'matuy/v2/thong-ke-doi-tuong-v1/xa',
            drugAddictByCommune: rootUrl_Micro + 'matuy/v2/thong-ke-doi-tuong/xa',
            drugAddictByCommuneV1: rootUrl_Micro + 'matuy/v2/thong-ke-doi-tuong-v1/xa',
            drugAddictByAddictionCenter:
                rootUrl_Micro + 'matuy/thong-ke-doi-tuong/co-so-cai-nghien',
            communeEducation:
                rootUrl_Micro + 'matuy/thong-tin-giao-duc-dia-phuong/count',
            communityAddiction:
                rootUrl_Micro + 'matuy/thong-tin-cai-nghien-cong-dong/count',
            performAtAddictionCenter:
                rootUrl_Micro + 'matuy/thong-tin-cai-nghien-tai-cscn/count',
            stayAtAddictionCenter:
                rootUrl_Micro + 'matuy/thong-tin-luu-tru-tai-cscn/count',
            managementAfterAddiction:
                rootUrl_Micro + 'matuy/thong-tin-sau-cai-nghien/count',
            methadoneTreatment:
                rootUrl_Micro + 'matuy/thong-tin-cai-nghien-methadone/count',
            otherAddiction: rootUrl_Micro + 'matuy/thong-tin-cai-nghien-khac/count',
            countDrugAddictByAllCommune:
                rootUrl_Micro + 'matuy/thong-ke-doi-tuong/tat-ca-huyen',
            tiLeTangTheoThang: rootUrl_Micro + 'matuy/so-tang-theo-tinh',
            performOutsideAddictionCenter:
                rootUrl_Micro + 'matuy/thong-tin-ngoai-cscn/count',
        },
        CURD: {
            addingDrugAddict: rootUrl_Micro + 'matuy/thong-tin-doi-tuong/insert-check',
            updatingDrugAddict: rootUrl_Micro + 'matuy/v2/thong-tin-doi-tuong/update',
            deletingDrugAddict: rootUrl_Micro + 'matuy/thong-tin-doi-tuong/delete',
            addingCommuneEducation:
                rootUrl_Micro + 'matuy/thong-tin-giao-duc-dia-phuong/insert',
            transferToDrugCenter:
                rootUrl_Micro + 'matuy/thong-tin-doi-tuong/chuyen-cscn',
            transferToLocal:
                rootUrl_Micro + 'matuy/v2/thong-tin-doi-tuong/chuyen-don-vi',
            updatingDeadState:
                rootUrl_Micro + 'matuy/thong-tin-doi-tuong/cap-nhat-tu-vong',
            updatingCommuneEducation:
                rootUrl_Micro + 'matuy/thong-tin-giao-duc-dia-phuong/update',
            updatingFinishToCommuneEducation:
                rootUrl_Micro + 'matuy/thong-tin-giao-duc-dia-phuong/updateHoanThanh',
            updatingPerformOutsideAddictionCenterDetail:
                rootUrl_Micro + 'matuy/thong-tin-ngoai-cscn/update',
            updatingFinishPerformOutsideAddictionCenterDetail:
                rootUrl_Micro + 'matuy/thong-tin-ngoai-cscn/updateHoanThanh',
            transferToInvestigationAgency:
                rootUrl_Micro + 'matuy/thong-tin-doi-tuong/chuyen-co-quan-dieu-tra',
            moveTo: rootUrl_Micro + 'matuy/thong-tin-doi-tuong/chuyen-di-ly',
            transferToeducationalInstitution:
                rootUrl_Micro + 'matuy/thong-tin-doi-tuong/chuyen-co-so-giao-duc',
            transferReformatory:
                rootUrl_Micro + 'matuy/thong-tin-doi-tuong/chuyen-truong-giao-duong',
            goToPrison: rootUrl_Micro + 'matuy/thong-tin-doi-tuong/chuyen-di-tu',
            backToAddictionCenter:
                rootUrl_Micro + 'matuy/thong-tin-doi-tuong/chuyen-ve-cscn',
            addingStayAtAddictionCenter:
                rootUrl_Micro + 'matuy/thong-tin-luu-tru-tai-cscn/insert',
            updateMethadoneTreating:
                rootUrl_Micro + 'matuy/thong-tin-cai-nghien-methadone/update',
            updateOtherAddiction:
                rootUrl_Micro + 'matuy/thong-tin-cai-nghien-khac/update',
            updateManagementAfterAddiction:
                rootUrl_Micro + 'matuy/thong-tin-sau-cai-nghien/update',
            finishingUpdatingManagementAfterAddiction:
                rootUrl_Micro + 'matuy/thong-tin-sau-cai-nghien/updateHoanThanh',
            addingOtherAddiction:
                rootUrl_Micro + 'matuy/thong-tin-cai-nghien-khac/insert',
            addingMethadoneTreating:
                rootUrl_Micro + 'matuy/thong-tin-cai-nghien-methadone/insert',
            addingPerformAtAddictionCenterByVoluntary:
                rootUrl_Micro + 'matuy/thong-tin-cai-nghien-tai-cscn-tu-nguyen/insert',
            addingPerformOutsideAddictionCenterByVoluntary:
                rootUrl_Micro + 'matuy/thong-tin-ngoai-cscn/insert',
            addingPerformAtAddictionCenterByForce:
                rootUrl_Micro + 'matuy/thong-tin-cai-nghien-tai-cscn-bat-buoc/insert',
            addingCommunityAddictionByForce:
                rootUrl_Micro + 'matuy/thong-tin-cai-nghien-cong-dong-bat-buoc/insert',
            addingManagementAfterAddiction:
                rootUrl_Micro + 'matuy/thong-tin-sau-cai-nghien/insert',
            addingCommunityAddictionByVoluntary:
                rootUrl_Micro + 'matuy/thong-tin-cai-nghien-cong-dong-tu-nguyen/insert',
            updateCommunityAddictionByForce:
                rootUrl_Micro + 'matuy/thong-tin-cai-nghien-cong-dong-bat-buoc/update',
            updateCommunityAddictionByVoluntary:
                rootUrl_Micro + 'matuy/thong-tin-cai-nghien-cong-dong-tu-nguyen/update',
            finishingUpdatingCommunityAddictionByForce:
                rootUrl_Micro +
                'matuy/thong-tin-cai-nghien-cong-dong-bat-buoc/updateHoanThanh',
            finishingUpdatingCommunityAddictionByVoluntary:
                rootUrl_Micro +
                'matuy/thong-tin-cai-nghien-cong-dong-tu-nguyen/updateHoanThanh',
            updatePerformAtAddictionCenterByForce:
                rootUrl_Micro + 'matuy/thong-tin-cai-nghien-tai-cscn-bat-buoc/update',
            updatePerformAtAddictionCenterByVoluntary:
                rootUrl_Micro + 'matuy/thong-tin-cai-nghien-tai-cscn-tu-nguyen/update',
            finishingUpdatingPerformAtAddictionCenterByForce:
                rootUrl_Micro +
                'matuy/thong-tin-cai-nghien-tai-cscn-bat-buoc/updateHoanThanh',
            finishingUpdatingPerformAtAddictionCenterByVoluntary:
                rootUrl_Micro +
                'matuy/thong-tin-cai-nghien-tai-cscn-tu-nguyen/updateHoanThanh',
            updateStayAtAddictionCenter:
                rootUrl_Micro + 'matuy/thong-tin-luu-tru-tai-cscn/update',
            finishingUpdatingStayAtAddictionCenter:
                rootUrl_Micro + 'matuy/thong-tin-luu-tru-tai-cscn/updateHoanThanh',
        },
        files: {
            getImageOfDrugAddict: rootUrl_Micro + 'matuy/file-dinh-kem/get-image',
            uploadImage: rootUrl_Micro + 'file/matuy/upload-image',
            updateDrugAddictImage:
                rootUrl_Micro + 'file/matuy/update-drug-addict-image',
            uploadFile: rootUrl_Micro + 'file/matuy/upload-file',
            deleteFile: rootUrl_Micro + 'file/matuy/delete-file',
            downloadFile: rootUrl_Micro + 'file/matuy/downloadFile',
        },
        reports: {
            reportByProvince: rootUrl_Micro + 'matuy/bao-cao-theo-tinh',
            reportByCommume: rootUrl_Micro + 'matuy/v2/bao-cao-theo-huyen-xa',
            reportByDrugCenter: rootUrl_Micro + 'matuy/bao-cao-theo-cscn',
            reportByDeath: rootUrl_Micro + 'matuy/v2/bao-cao-tu-vong',
            reportListByProvice:
                rootUrl_Micro + 'matuy/v2/bao-cao-theo-tinh-danh-sach-doi-tuong',
            reportListByCommume:
                rootUrl_Micro + 'matuy/v2/bao-cao-theo-huyen-xa-danh-sach-doi-tuong',
            reportListByDrugCenter:
                rootUrl_Micro + 'matuy/v2/bao-cao-theo-cscn-danh-sach-doi-tuong',
        },
        GET_DATA: {
            xuatFileTinh: rootUrl_Micro + 'get-data/matuy/v2/export-excel-tinh',
            xuatFileHuyen: rootUrl_Micro + 'get-data/matuy/v2/export-excel-huyen-xa',
            xuatFileCscn: rootUrl_Micro + 'get-data/matuy/v2/export-excel-cscn',
            xuatFileTuVong: rootUrl_Micro + 'get-data/matuy/v2/export-excel-tu-vong',
            reportCaiNghien503: rootUrl_Micro + 'get-data/matuy/v2/bao-cao-503-so/',
            templateImport: rootUrl_Micro + 'get-data/matuy/v2/template-import',
            checkTemplateImport: rootUrl_Micro + 'get-data/matuy/v2/echeck-import',
            ImportMaTuy: rootUrl_Micro + 'get-data/matuy/v2/import',
            reportCaiNghien504_505: rootUrl_Micro + 'get-data/matuy/v2/bao-cao-504-505-so/'
        },
        SYS_LOG: {
          nhatKyHeThong: rootUrl_Micro + "matuy/logs",
          taiNhatKyHeThong: rootUrl_Micro + "matuy/logs/download",
          getStackTraceDetail: rootUrl_Micro + "matuy/logs/error"
        },
        AGG: {
          // Tiếp công dân
          getTiepCongDan: rootUrl_Micro + "matuy/agg/tiep-cong-dan/tim-kiem",
          getChiTietTiepCongDan: rootUrl_Micro + "matuy/agg/tiep-cong-dan/chi-tiet",
          addTiepCongDan: rootUrl_Micro + "matuy/agg/tiep-cong-dan/them-moi",
          deleteTiepCongDan: rootUrl_Micro + "matuy/agg/tiep-cong-dan/xoa",
          editTiepCongDan: rootUrl_Micro + "matuy/agg/tiep-cong-dan/cap-nhat",
          //Xử phạt vi phạm hành chính AGG
          getXuPhatViPham: rootUrl_Micro + "matuy/xu-phat-vi-pham-hanh-chinh/tim-kiem",
          getChiTietXuPhatViPham: rootUrl_Micro + "matuy/xu-phat-vi-pham-hanh-chinh/chi-tiet",
          addXuPhatViPham: rootUrl_Micro + "matuy/xu-phat-vi-pham-hanh-chinh/them-moi",
          editXuPhatViPham: rootUrl_Micro + "matuy/xu-phat-vi-pham-hanh-chinh/cap-nhat",
          deleteXuPhatViPham: rootUrl_Micro + "matuy/xu-phat-vi-pham-hanh-chinh/xoa",

          // Điều tra tai nạn
          getDieuTraTaiNan: rootUrl_Micro + "matuy/agg/dieu-tra-tai-nan/tim-kiem",
          addDieuTraTaiNan: rootUrl_Micro + "matuy/agg/dieu-tra-tai-nan/them-moi",
          deleteDieuTraTaiNan: rootUrl_Micro + "matuy/agg/dieu-tra-tai-nan/xoa",
          editDieuTraTaiNan: rootUrl_Micro + "matuy/agg/dieu-tra-tai-nan/cap-nhat",

          // Đối tượng cai nghiện ma túy
          importDoiTuongCaiNghienCoQD: rootUrl_Micro + "matuy/agg/import-doi-tuong-cai-nghien-da-co-quyet-dinh",
          getDoiTuongCaiNghienCoQD: rootUrl_Micro + "matuy/agg/tim-kiem-doi-tuong-cai-nghien-da-co-quyet-dinh",
          addDoiTuongCaiNghienCoQD: rootUrl_Micro + "matuy/agg/them-moi-doi-tuong-cai-nghien-da-co-quyet-dinh",
          deleteDoiTuongCaiNghienCoQD: rootUrl_Micro + "matuy/agg/xoa-doi-tuong-cai-nghien-da-co-quyet-dinh",
          editDoiTuongCaiNghienCoQD: rootUrl_Micro + "matuy/agg/cap-nhat-doi-tuong-cai-nghien-da-co-quyet-dinh",
          getDoiTuongCaiNghienCoQDChoDuyet: rootUrl_Micro + "matuy/agg/tim-kiem-doi-tuong-cai-nghien-da-co-quyet-dinh-cho-duyet",

          // Đối tượng cai nghiện ma túy
          importDoiTuongCaiNghienChuaQD: rootUrl_Micro + "matuy/agg/import-doi-tuong-cai-nghien-chua-quyet-dinh",
          getDoiTuongCaiNghienChuaQD: rootUrl_Micro + "matuy/agg/tim-kiem-doi-tuong-cai-nghien-chua-quyet-dinh",
          addDoiTuongCaiNghienChuaQD: rootUrl_Micro + "matuy/agg/them-moi-doi-tuong-cai-nghien-chua-quyet-dinh",
          editDoiTuongCaiNghienChuaQD: rootUrl_Micro + "matuy/agg/cap-nhat-doi-tuong-cai-nghien-chua-co-quyet-dinh",
          downloadTemplateDtCoQD: rootUrl_Micro + 'matuy/agg/download-template-dt-cai-nghien-co-quyet-dinh',

          chuyenCNBB: rootUrl_Micro + "matuy/agg/chuyen-cnbb",
          thuHoiChuyenCNBB: rootUrl_Micro + "matuy/agg/thu-hoi-chuyen-cnbb",
          getDoiTuongCaiNghienChuaQDDaChuyenCNBB: rootUrl_Micro + "matuy/agg/tim-kiem-doi-tuong-cai-nghien-chua-quyet-dinh-da-chuyen-cnbb",
          tuChoiChuyenCNBB: rootUrl_Micro + "matuy/agg/tu-choi-chuyen-cnbb",
          downloadTemplateDtChuaQD: rootUrl_Micro + 'matuy/agg/download-template-dt-cai-nghien-chua-quyet-dinh',

          // Phòng chống mại dâm
          getPhongChongMaiDam: rootUrl_Micro + "matuy/agg/tim-kiem-phong-chong-mai-dam",
          addPhongChongMaiDam: rootUrl_Micro + "matuy/agg/them-moi-phong-chong-mai-dam",
          deletePhongChongMaiDam: rootUrl_Micro + "matuy/agg/xoa-phong-chong-mai-dam",
          editPhongChongMaiDam: rootUrl_Micro + "matuy/agg/cap-nhat-phong-chong-mai-dam",
          getChiTietPhongChongMaiDam: rootUrl_Micro + "matuy/agg/get-chi-tiet-phong-chong-mai-dam",

          // Mua bán người
          getMuaBanNguoi: rootUrl_Micro + "matuy/agg/tim-kiem-mua-ban-nguoi",
          getDMChiTieuMuaBanNguoi: rootUrl_Micro + "matuy/agg/get-dm-mua-ban-nguoi",
          getChiTietMuaBanNguoi: rootUrl_Micro + "matuy/agg/get-chi-tiet-mua-ban-nguoi",
          addMuaBanNguoi: rootUrl_Micro + "matuy/agg/them-moi-mua-ban-nguoi",
          updateMuaBanNguoi: rootUrl_Micro + "matuy/agg/cap-nhat-mua-ban-nguoi",
          deleteItemMuaBanNguoi: rootUrl_Micro + "matuy/agg/xoa-mua-ban-nguoi-theo-id",
          deleteAllItemsMuaBanNguoi: rootUrl_Micro + "matuy/agg/xoa-tat-ca-mua-ban-nguoi-theo-id",
        },
        coSoCaiNghien:{
          getDanhSachCoSoCaiNghien: rootUrl_Micro + "matuy/co-so-cai-nghien/danh-sach",
          addCoSoCaiNghien: rootUrl_Micro + "matuy/co-so-cai-nghien/them-cap-nhat",
          deleteCoSoCaiNghien: rootUrl_Micro + "matuy/co-so-cai-nghien/xoa-khoi-phuc",
          getCoSoCaiNghien: rootUrl_Micro + "matuy/co-so-cai-nghien/chi-tiet",
          getTemplateImport: rootUrl_Micro + "matuy/co-so-cai-nghien/template-import",
          checkTemplateImport: rootUrl_Micro + "matuy/co-so-cai-nghien/check-import",
          importCSCN: rootUrl_Micro + "matuy/co-so-cai-nghien/import",
          exportDanhSachCSCN: rootUrl_Micro + "matuy/co-so-cai-nghien/xuat-danh-sach",
        },
        nguoiCaiNghien:{
          getDanhSachNguoiCaiNghien: rootUrl_Micro + "matuy/v2/nguoi-cai-nghien/danh-sach",
          addNguoiCaiNghien: rootUrl_Micro + "matuy/v2/nguoi-cai-nghien/them-cap-nhat",
          deleteNguoiCaiNghien: rootUrl_Micro + "matuy/nguoi-cai-nghien/xoa-khoi-phuc",
          getNguoiCaiNghien: rootUrl_Micro + "matuy/nguoi-cai-nghien/chi-tiet",
          getTemplateImport: rootUrl_Micro + "matuy/v2/nguoi-cai-nghien/template-import",
          checkTemplateImport: rootUrl_Micro + "matuy/nguoi-cai-nghien/check-import",
          importNguoiCaiNghien: rootUrl_Micro + "matuy/nguoi-cai-nghien/import",
          exportDanhSachNguoiCaiNghien: rootUrl_Micro + "matuy/v2/nguoi-cai-nghien/xuat-danh-sach",
          checkCmndNguoiCaiNghien: rootUrl_Micro + "matuy/nguoi-cai-nghien/check-cmnd",
          baoCao1: rootUrl_Micro + "get-data/matuy/chia-theo-hinh-thuc-cai-nghien",
          baoCao2: rootUrl_Micro + "get-data/matuy/chia-theo-hinh-thuc-sau-cai-nghien-tai-noi-cu-tru",
          baoCao3: rootUrl_Micro + "get-data/matuy/bao-cao-co-so-cai-nghien",
          baoCao4: rootUrl_Micro + "get-data/matuy/bao-cao-can-bo",
          thongKeNguoiCaiNghien: rootUrl_Micro + "matuy/v2/dashboard-nguoi-cai-nghien/thong-ke-nguoi-cai-nghien",
          thongKeTheoHanhChinh: rootUrl_Micro + "matuy/v2/dashboard-nguoi-cai-nghien/thong-ke-nguoi-cai-nghien-theo-hanh-chinh",
          thongKeTyLeTheoGioiTinh: rootUrl_Micro + "matuy/v2/dashboard-nguoi-cai-nghien/ty-le-gioi-tinh",
          thongKeTyLeTheoLoaiMaTuySuDung: rootUrl_Micro + "matuy/v2/dashboard-nguoi-cai-nghien/ty-le-loai-ma-tuy-su-dung",
          thongKeTyLeTheoHinhThucSuDung: rootUrl_Micro + "matuy/v2/dashboard-nguoi-cai-nghien/ty-le-hinh-thuc-su-dung",
        },
        danhMuc: {
          getAllListThanhPhan: rootUrl_Micro + "matuy/danh-muc-ma-tuy/danh-muc-thanh-phan",
          getAllListNhanThan: rootUrl_Micro + "matuy/danh-muc-ma-tuy/danh-muc-nhan-than",
          getAllListSoLanCaiNghien: rootUrl_Micro + "matuy/danh-muc-ma-tuy/danh-muc-so-lan-cai-nghien",
          getAllListHoanCanhGiaDinh: rootUrl_Micro + "matuy/danh-muc-ma-tuy/danh-muc-hoan-canh-gia-dinh",
          getAllListHinhThucQuanLyCaiNghien: rootUrl_Micro + "matuy/danh-muc-ma-tuy/danh-muc-hinh-thuc-quan-ly-cai-nghien",
          getAllListHinhThucSuDung: rootUrl_Micro + "matuy/danh-muc-ma-tuy/danh-muc-hinh-thuc-su-dung",
          getAllListLoaiMaTuySuDung: rootUrl_Micro + "matuy/danh-muc-ma-tuy/danh-muc-loai-ma-tuy-su-dung",
          getAllListNgheNghiepHienTai: rootUrl_Micro + "matuy/danh-muc-ma-tuy/danh-muc-nghe-nghiep-hien-tai",
          getAllDmLoaiCanBo: rootUrl_Micro + "matuy/danh-muc/dung-chung",
          getAllListTrinhDo: rootUrl_Micro + "matuy/nguoi-cai-nghien/get-all-trinh-do",
          getAllListThoiGianChapHanh: rootUrl_Micro + "matuy/nguoi-cai-nghien/get-all-thoi-gian-chap-hanh-an",
          getAllListNguyenNhan: rootUrl_Micro + "matuy/nguoi-cai-nghien/get-all-nguyen-nhan"
        }
    },

    // API trẻ em
    treEm: {
        treEmURL: rootUrl_Micro + 'tre-em/v2/danh-sach',
        treEmPhatSinhURL: rootUrl_Micro + 'tre-em/phat-sinh',
        syncTreEmPhatSinhURL: rootUrl_Micro + 'tre-em/v2/them-moi',
        getTEbyCMND: rootUrl_Micro + 'tre-em/thong-tin-6-phan-he',
        treEmDetailURL: rootUrl_Micro + 'tre-em/v2/chi-tiet',
        hoGiaDinhBHXHURL: rootUrl_Micro + 'tre-em/tra-cuu',
        nguoiDungDetailURL: rootUrl_Micro + 'nguoi-dung/v2/thong-tin-chi-tiet',
        searchTreEmHCDBURL: rootUrl_Micro + 'tre-em/v2/hoan-canh',
        searchTreEmHuongTroGiupURL: rootUrl_Micro + 'tre-e/v2/huong-tro-giup',
        updateTreEmByIDURL: rootUrl_Micro + 'tre-em/v2/sua',
        deleteTreEmByIDURL: rootUrl_Micro + 'tre-em/xoa',
        recoverTreEmByIDURL: rootUrl_Micro + 'tre-em/khoi-phuc?maTreEm=',
        treEmPhatSinhDetailURL: rootUrl_Micro + 'tre-em/tra-cuu-nhanh',
        egwLoginURL: 'http://egw.vndis.vn/api/token/take/',
        danhMucHCDBUIrl: rootUrl_Micro + 'danh-muc/chi-tiet-hoan-canh-theo-loai',
        TreemHCDBUrl: rootUrl_Micro + 'tre-em/v2/hoan-canh',
        AccoutUrl: rootUrl_Micro + 'nguoi-dung/v2/thong-tin-chi-tiet',
        DHTGUrl: rootUrl_Micro + 'tre-em/v2/huong-tro-giup',
        getListGetHelpUrl: rootUrl_Micro + 'danh-muc/huong-tro-giup',
        getListHoanCanhUrl: rootUrl_Micro + 'danh-muc/hoan-canh-theo-loai?maLoaiHoanCanh=',
        KhaiThacBCTreEmBTURL: rootUrl_Micro + 'tre-em/v2/bao-cao/danh-sach-tre-em-binh-thuong',
        KhaiThacBCTreEmURL: rootUrl_Micro + 'tre-em/v2/bao-cao/danh-sach-tre-em',
        KhaiThacBCTreEmTheoCTURL: rootUrl_Micro + 'tre-em/v2/bao-cao/danh-sach-tre-em-theo-chi-tieu',
        danhMucChiTieuURL: rootUrl_Micro + 'danh-muc/chi-tieu',
        chiTietHCDBUrl: rootUrl_Micro + 'danh-muc/chi-tiet-hoan-canh',
        chiTietTroGiupUrl: rootUrl_Micro + 'danh-muc/chi-tiet-huong-tro-giup',
        soLuongPhatSinh: rootUrl_Micro + 'tre-em/tra-cuu-theo-ngay',
        chuyenTreEmKhongPheDuyet: rootUrl_Micro + 'tre-em/v2/chuyen-tre-em-sang-dp-khac',
        chuyenTreEmPheDuyet: rootUrl_Micro + "tre-em/v2/yeu-cau-chuyen-tre-em",
        danhSachYeuCau: rootUrl_Micro + "tre-em/v2/danh-sach-yeu-cau-chuyen-tre-em",
        pheDuyetChuyen: rootUrl_Micro + "tre-em/tu-choi-yeu-cau-chuyen-tre-em",
        guiLaiYeuCauChuyen: rootUrl_Micro + "tre-em/v2/gui-lai-yeu-cau-chuyen-tre-em",
        xoaYeuCauChuyen: rootUrl_Micro + "tre-em/huy-yeu-cau-chuyen-tre-em",
        yeuCauTuChoi: rootUrl_Micro + "tre-em/yeu-cau-tu-choi-tre-em",
        thongKeTreEmTheoHuyen_Map: rootUrl_Micro + "tre-em/v2/thong-ke-tre-em-huyen-map",
        thongKeTreEmTheoXa_Map: rootUrl_Micro + "tre-em/thong-ke-tre-em-xa-map",
        qdChamDutChamSocTT: rootUrl_Micro + "tre-em/v2/danh-sach-don-de-nghi-cham-dut-viec-cham-soc-thay-the",

        exportPDFqdChamDutChamSocTT: rootUrl_Micro + "tre-em/v2/don-de-nghi-cham-dut-viec-cham-soc-thay-the-pdf",
        addQdChamSocChamDutChamSocTT: rootUrl_Micro + "tre-em/them-don-de-nghi-cham-dut-viec-cham-soc-thay-the",
        qdChuyenHinhThucChamSocTT: rootUrl_Micro + "tre-em/v2/danh-sach-don-quyet-dinh-chuyen-hinh-thuc-cham-soc-thay-the",

        addQdChuyenHinhThucChamSocTT: rootUrl_Micro + "tre-em/them-quyet-dinh-chuyen-hinh-thuc-cham-soc-thay-the",
        // Ke hoach ho tro
        getKeHoachHoTroCanThiepND56: rootUrl_Micro + "tre-em/v2/ke-hoach-ho-tro/danh-sach",
        addKeHoachHoTroCanThiepND56: rootUrl_Micro + "tre-em/v2/ke-hoach-ho-tro/them",
        updateKeHoachHoTroCanThiepND56: rootUrl_Micro + "tre-em/v2/ke-hoach-ho-tro/cap-nhat",
        getUuiddKeHoachHoTroCanThiepND56: rootUrl_Micro + "tre-em/ke-hoach-ho-tro/chi-tiet",
        exportKeHoachHoTro: rootUrl_Micro + "tre-em/ke-hoach-ho-tro/xuat-file",
        deleteKeHoachHoTro: rootUrl_Micro + "tre-em/ke-hoach-ho-tro/xoa-khoi-phuc",

        //Quyet dinh cham dut va chuyen hinh thuc cham soc thay the
        qdChamDutVaChuyenHinhThucChamSocTT: rootUrl_Micro + "tre-em/danh-sach-don-quyet-dinh-cham-dut-va-chuyen-hinh-thuc-cham-soc-thay-the",
        addQdChamDutVaChuyenHinhThucChamSocTT: rootUrl_Micro + "tre-em/them-quyet-dinh-cham-dut-va-chuyen-hinh-thuc-cham-soc-thay-the",

        //Bien ban nhan cham soc tre em
        bienBanNhanChamSocTT: rootUrl_Micro + "tre-em/v2/danh-sach-bien-nhan-cham-soc",
        exportPDFBienBanNhanChamSocTT: rootUrl_Micro + "tre-em/bien-nhan-cham-soc-pdf",
        addBienBanNhanChamSocTT: rootUrl_Micro + "tre-em/them-moi-bien-nhan-cham-soc",

        //Danh sách chuyen hinh thuc cham soc thay the
        getListChuyenHinhThucChamSocTT: rootUrl_Micro + "tre-em/v2/cham-soc-thay-the/danh-sach",
        exportPDFListChuyenHinhThucChamSocTT: rootUrl_Micro + "tre-em/v2/cham-soc-thay-the/xuat-file",
        addListChuyenHinhThucChamSocTT: rootUrl_Micro + "tre-em/v2/cham-soc-thay-the/them",
        updateListChuyenHinhThucChamSocTT: rootUrl_Micro + "tre-em/v2/cham-soc-thay-the/cap-nhat",
        deleteListChuyenHinhThucChamSocTT: rootUrl_Micro + "tre-em/cham-soc-thay-the/xoa-khoi-phuc",
        xoaDoiTuong: rootUrl_Micro + "",

        templateImportTreEm: rootUrl_Micro + "tre-em/template-import-tre-em",
        importTreEm: rootUrl_Micro + "tre-em/v2/import-tre-em-from-template",

        templateImportTreEmHCDB: rootUrl_Micro + "tre-em/template-import-tre-em-hcdb",
        importTreEmHCDB: rootUrl_Micro + "tre-em/v2/import-tre-em-hcdb-from-template",
        templateImportTreEmNCHCDB: rootUrl_Micro + "tre-em/v2/template-import-tre-em-nchcdb",
        importTreEmNCHCDB: rootUrl_Micro + "tre-em/v2/import-tre-em-nchcdb-from-template",
        templateImportTreEmHTG: rootUrl_Micro + "tre-em/template-import-tre-em-htg",
        importTreEmHTG: rootUrl_Micro + "tre-em/v2/import-tre-em-htg-from-template",
        // Danh mục
        getTroGiupCacCap: rootUrl_Micro + 'tre-em/huong-tro-giup/tim-kiem-theo-cap',
        timKiemHuongTroGiup: rootUrl_Micro + 'tre-em/huong-tro-giup/tim-kiem-danh-muc',
        themMoiHuongTroGiup: rootUrl_Micro + 'tre-em/huong-tro-giup/them-moi',
        capNhatHuongTroGiup: rootUrl_Micro + 'tre-em/huong-tro-giup/sua-thong-tin',
        xoaHuongTroGiup: rootUrl_Micro + 'tre-em/huong-tro-giup/xoa?idHuong=',
        khoiPhucHuongTroGiup: rootUrl_Micro + 'tre-em/huong-tro-giup/khoi-phuc?idHuong=',
        timKiemHoanCanh: rootUrl_Micro + 'tre-em/hoan-canh/tim-kiem-danh-muc',
        themMoiHoanCanh: rootUrl_Micro + 'tre-em/hoan-canh/them-moi',
        capNhatHoanCanh: rootUrl_Micro + 'tre-em/hoan-canh/sua-thong-tin',
        xoaHoanCanh: rootUrl_Micro + 'tre-em/hoan-canh/xoa?idHoanCanh=',
        khoiPhucHoanCanh: rootUrl_Micro + 'tre-em/hoan-canh/khoi-phuc?idHoanCanh=',
        loaiHoanCanh: rootUrl_Micro + 'tre-em/loai-hoan-canh/danh-sach',
        hoanCanhCacCap: rootUrl_Micro + 'tre-em/hoan-canh/tim-kiem-theo-cap',
        reportChildrenCoHcbdMau03: rootUrl_Micro + 'tre-em/v2/xuat-bao-cao-tre-em-db-mau-3?',
        reportLaoDongTreEm: rootUrl_Micro + 'get-data/tre-em/v2/xuat-danh-sach-tinh-hinh-lao-dong-tre-em',
        downloadFileTreEm: rootUrl_Micro + 'file/v2/downloadFileTreEm',
        cauHinhBaoCao: rootUrl_Micro + 'tre-em/cau-hinh-bao-cao/get-by-ma-bao-cao',

        //Nghi đinh 56
        listTreEmNghiDinh56: rootUrl_Micro + "tre-em/v2/danh-sach-tiep-nhan-thong-tin-tre-em",
        //danh gia nguy co ban dau
        listDanhGiaNguyCoBanDau: rootUrl_Micro + "tre-em/v2/danh-sach-danh-gia-nguy-co-ban-dau-tre-em",
        //theo doi danh gia
        listDanhSachTheoDoiDanhGia: rootUrl_Micro + "tre-em/v2/danh-sach-theo-doi-danh-gia-tre-em-duoc-nhan-cham-soc-thay-the",
        //thu thap xac minh
        listDanhSachThuThapXacMinh: rootUrl_Micro + "tre-em/v2/danh-sach-thu-thap-xac-minh-danh-gia-nguy-co-cu-the-tre-em",
        //danh gia nguy co ban dau khac ND56
        listDanhGiaNguyCoBanDauKhacND56: rootUrl_Micro + "tre-em/v2/danh-sach-danh-gia-nguy-co-ban-dau-tre-em-khac-nd56",
        //thu thap xac minh khac ND56
        listDanhSachThuThapXacMinhKhacND56: rootUrl_Micro + "tre-em/v2/danh-sach-thu-thap-xac-minh-danh-gia-nguy-co-cu-the-tre-em-khac-nd56",

        exportTreEmNghiDinh68: rootUrl_Micro + "get-data/tre-em/v2/danh-sach-tiep-nhan-thong-tin-tre-em-pdf",
        exportWordQdchamDutChamSocTT: rootUrl_Micro + "get-data/tre-em/v2/don-de-nghi-cham-dut-viec-cham-soc-thay-the",
        exportPDFqdChuyenHinhThucChamSocTT: rootUrl_Micro + "get-data/tre-em/v2/quyet-dinh-chuyen-hinh-thuc-cham-soc-thay-the",
        exportDanhGiaNguyCoBanDau: rootUrl_Micro + "get-data/tre-em/v2/danh-sach-danh-gia-nguy-co-ban-dau-tre-em-pdf",
        exportDanhSachThuThapXacMinh: rootUrl_Micro + "get-data/tre-em/v2/danh-sach-thu-thap-xac-minh-danh-gia-nguy-co-cu-the-tre-em-pdf",
        exportDanhSachTheoDoiDanhGia: rootUrl_Micro + "get-data/tre-em/v2/danh-sach-theo-doi-danh-gia-tre-em-duoc-nhan-cham-soc-thay-the-pdf",
        exportPDFqdChamDutVaChuyenHinhThucChamSocTT: rootUrl_Micro + "get-data/tre-em/v2/quyet-dinh-cham-dut-va-chuyen-hinh-thuc-cham-soc-thay-the",
        exportDanhGiaNguyCoBanDauKhacND56: rootUrl_Micro + "get-data/tre-em/v2/danh-sach-danh-gia-nguy-co-ban-dau-tre-em-khac-nd56-pdf",
        exportDanhSachThuThapXacMinhKhacND56: rootUrl_Micro + "get-data/tre-em/v2/danh-sach-thu-thap-xac-minh-danh-gia-nguy-co-cu-the-tre-em-khac-nd56-pdf",

        // HGI
        templateImportTreEmHgi: rootUrl_Micro + "tre-em/hgi/template-import",
        checkImportTreEmHgi: rootUrl_Micro + "tre-em/hgi/check-import",
        importTreEmHgi: rootUrl_Micro + "tre-em/v2/hgi/import",
        templateImportTreEmHCDBHgi: rootUrl_Micro + "tre-em/hgi/hcdb/template-import",
        checkImportTreEmHCDBHgi: rootUrl_Micro + "tre-em/hgi/hcdb/check-import",
        importTreEmHCDBHgi: rootUrl_Micro + "tre-em/v2/hgi/hcdb/import",
        templateImportTreEmNCHCDBHgi: rootUrl_Micro + "tre-em/hgi/nchcdb/template-import",
        checkImportTreEmNCHCDBHgi: rootUrl_Micro + "tre-em/hgi/nchcdb/check-import",
        importTreEmNCHCDBHgi: rootUrl_Micro + "tre-em/v2/hgi/nchcdb/import",
        importTreEmHCKHgi: rootUrl_Micro + "tre-em/v2/hgi/hck/import",
        templateImportTreEmHCKHgi: rootUrl_Micro + "tre-em/hgi/hck/template-import",
        checkImportTreEmHCKHgi: rootUrl_Micro + "tre-em/hgi/hck/check-import",
        templateImportTreEmHTGHgi: rootUrl_Micro + "tre-em/hgi/htg/template-import",
        checkImportTreEmHTGHgi: rootUrl_Micro + "tre-em/hgi/htg/check-import",
        importTreEmHTGHgi: rootUrl_Micro + "tre-em/v2/hgi/htg/import",


        GET_DATA: {
            xuatPdfTreEmBinhThuong: rootUrl_Micro + 'get-data/tre-em/v2/xuat-danh-sach-tre-em-binh-thuong',
            xuatPdfTreEm: rootUrl_Micro + 'get-data/tre-em/v2/xuat-danh-sach-tre-em',
            reportChildrenCoHcbd: rootUrl_Micro + 'get-data/tre-em/v2/xuat-bao-cao-tre-em-db?',
            reportChildrenByYear: rootUrl_Micro + 'get-data/tre-em/v2/xuat-bao-cao-tre-em-theo_nam?',
            xuatPdfTreEmTheoChiTieu: rootUrl_Micro + 'get-data/tre-em/v2/xuat-danh-sach-tre-em-theo-doi-tuong',
            xuatExeclDongBoDuLieu: rootUrl_Micro + 'get-data/tre-em/v2/xuat-danh-sach-tre-em-dong-bo',
            xuatExcelTeHcdb: rootUrl_Micro + 'get-data/tre-em/v2/xuat-bao-cao-excel-tre-em-db',
            xuatExcelTeTheoNam: rootUrl_Micro + 'get-data/tre-em/v2/xuat-bao-cao-excel-tre-em-theo_nam',
            reportChildrenCoHcbdByObject: rootUrl_Micro + 'get-data/tre-em/v2/xuat-bao-cao-tre-em-hcdb',
            reportChildrenCoNcHcbdByObject: rootUrl_Micro + 'get-data/tre-em/v2/xuat-bao-cao-tre-em-nchcdb',
            reportChildrenCoHckByObject: rootUrl_Micro + 'get-data/tre-em/v2/xuat-bao-cao-tre-em-hck',
            reportChildrenHtgByObject: rootUrl_Micro + 'get-data/tre-em/v2/xuat-bao-cao-tre-em-htg',
            reportChildrenByObject: rootUrl_Micro + 'get-data/tre-em/v2/xuat-bao-cao-tre-em',
            reportChildrenOver16ByObject: rootUrl_Micro + 'get-data/tre-em/v2/xuat-bao-cao-tre-em-16t',

            exportTreEmNghiDinh68: rootUrl_Micro + "get-data/tre-em/v2/danh-sach-tiep-nhan-thong-tin-tre-em-pdf",
            exportWordQdchamDutChamSocTT: rootUrl_Micro + "get-data/tre-em/v2/don-de-nghi-cham-dut-viec-cham-soc-thay-the",
            exportPDFqdChuyenHinhThucChamSocTT: rootUrl_Micro + "get-data/tre-em/quyet-dinh-chuyen-hinh-thuc-cham-soc-thay-the",
            exportDanhGiaNguyCoBanDau: rootUrl_Micro + "get-data/tre-em/v2/danh-sach-danh-gia-nguy-co-ban-dau-tre-em-pdf",
            exportDanhSachThuThapXacMinh: rootUrl_Micro + "get-data/tre-em/v2/danh-sach-thu-thap-xac-minh-danh-gia-nguy-co-cu-the-tre-em-pdf",
            exportDanhSachTheoDoiDanhGia: rootUrl_Micro + "get-data/tre-em/v2/danh-sach-theo-doi-danh-gia-tre-em-duoc-nhan-cham-soc-thay-the-pdf",
            exportPDFqdChamDutVaChuyenHinhThucChamSocTT: rootUrl_Micro + "get-data/tre-em/v2/quyet-dinh-cham-dut-va-chuyen-hinh-thuc-cham-soc-thay-the",
            exportDanhGiaNguyCoBanDauKhacND56: rootUrl_Micro + "get-data/tre-em/v2/danh-sach-danh-gia-nguy-co-ban-dau-tre-em-khac-nd56-pdf",
            exportDanhSachThuThapXacMinhKhacND56: rootUrl_Micro + "get-data/tre-em/v2/danh-sach-thu-thap-xac-minh-danh-gia-nguy-co-cu-the-tre-em-khac-nd56-pdf",

            xuatCSVTreEm: rootUrl_Micro + 'get-data/tre-em/v2/xuat-bao-cao-tre-em-csv',
            xuatCSVTreEmBinhThuong: rootUrl_Micro + 'get-data/tre-em/v2/xuat-bao-cao-tre-em-binh-thuong-csv',
            xuatCSVTreEmTheoDoiTuong: rootUrl_Micro + 'get-data/tre-em/v2/xuat-bao-cao-tre-em-theo-doi-tuong-csv',

            xuatPdfTreEmBinhThuongPage: rootUrl_Micro + 'get-data/tre-em/v2/xuat-danh-sach-tre-em-binh-thuong-page',
            xuatPdfTreEmPage: rootUrl_Micro + 'get-data/tre-em/v2/xuat-danh-sach-tre-em-page',
            xuatPdfTreEmTheoChiTieuPage: rootUrl_Micro + 'get-data/tre-em/v2/xuat-danh-sach-tre-em-theo-doi-tuong-page',
        },

        QUY_BAO_TRO:{
          timKiemQuyBaoTro: rootUrl_Micro + "tre-em/tim-kiem-quy-bao-tro",
          getDMNhomTaiTro: rootUrl_Micro + "tre-em/danh-muc-nhom-quy-bao-tro",
          themMoiQuyBaoTro: rootUrl_Micro + "tre-em/them-moi-quy-bao-tro",
          capNhatQuyBaoTro: rootUrl_Micro + "tre-em/cap-nhat-quy-bao-tro",
          xoaQuyBaoTro: rootUrl_Micro + "tre-em/xoa-quy-bao-tro",
        },
        // AGG - 13/11/2023
        TreemHCDBAGG: rootUrl_Micro + 'tre-em/tre-em-agg/v2/search-tre-em-hoan-canh',
        TreEmAGG: rootUrl_Micro + 'tre-em/tre-em-agg/v2/search-tre-em-binh-thuong',
        addTreemAGG: rootUrl_Micro + 'tre-em/tre-em-agg/v2/insert-tre-em',
        delTreemAGG : rootUrl_Micro + 'tre-em/tre-em-agg/delete-tre-em',
        treEmDetailAGG: rootUrl_Micro + 'tre-em/tre-em-agg/chi-tiet',
        importTreEmAGG : rootUrl_Micro + 'tre-em/tre-em-agg/v2/import-tre-em-binh-thuong',
        importTreEmHCDBAGG : rootUrl_Micro + 'tre-em/tre-em-agg/v2/import-tre-em-hcdb',
        importTreEmNCAGG : rootUrl_Micro + 'tre-em/tre-em-agg/v2/import-tre-em-nchcdb',
        importTreEmHCKAGG : rootUrl_Micro + 'tre-em/tre-em-agg/v2/import-tre-em-hck',
        templateTreEmBinhThuongAGG : rootUrl_Micro + 'tre-em/tre-em-agg/teplate-tre-em-binh-thuong',
        templateTreEmHCDBAGG : rootUrl_Micro + 'tre-em/tre-em-agg/teplate-tre-em-hcdb',
        templateTreEmNCHCDBAGG : rootUrl_Micro + 'tre-em/tre-em-agg/teplate-tre-em-nchcdb',
        templateTreEmHCKAGG : rootUrl_Micro + 'tre-em/tre-em-agg/teplate-tre-em-hck',

        DASHBOARD: {
          getDataLabel: rootUrl_Micro + "tre-em/tre-em-agg/v2/dashboard-get-data-label",
          getTreEmTheoThang: rootUrl_Micro + "tre-em/tre-em-agg/v2/dashboard-get-data-tre-em-theo-thang",
          getQuyBaoTroTreEm: rootUrl_Micro + "tre-em/tre-em-agg/dashboard-get-quy-bao-tro-tre-em",
          getHCDBTheoNhom: rootUrl_Micro + "tre-em/tre-em-agg/v2/dashboard-get-hcdb-theo-nhom",
          getHCDBTheoHuyen: rootUrl_Micro + "tre-em/tre-em-agg/v2/dashboard-get-hcdb-theo-huyen",
          getNCHCDBTheoNhom: rootUrl_Micro + "tre-em/tre-em-agg/v2/dashboard-get-nc-hcdb-theo-nhom",
          getNCHCDBTheoHuyen: rootUrl_Micro + "tre-em/tre-em-agg/v2/dashboard-get-nc-hcdb-theo-huyen",
          getTongTreEm: rootUrl_Micro + "tre-em/v2/thong-ke-tong-tre-em",
          getTreEmTheoHC: rootUrl_Micro + "tre-em/v2/thong-ke-tre-em-theo-hanh-chinh",
          getTyLeGioiTinh: rootUrl_Micro + "tre-em/v2/ty-le-gioi-tinh-tre-em",
          getTyLeDanToc: rootUrl_Micro + "tre-em/v2/ty-le-dan-toc-tre-em",
          getTongTreEmTC: rootUrl_Micro + "tre-em/v2/thong-ke-tong-tre-em-tro-cap",
          getTreEmTheoHCTC: rootUrl_Micro + "tre-em/v2/thong-ke-tre-em-tro-cap-theo-hanh-chinh",
          getTyLeGioiTinhTC: rootUrl_Micro + "tre-em/v2/ty-le-gioi-tinh-tre-em-tro-cap",
          getTyLeDanTocTC: rootUrl_Micro + "tre-em/v2/ty-le-dan-toc-tre-em-tro-cap",
        }
      },

    // API bảo trợ
    baoTro: {
        getBaoCaoMatTranToQuoc: rootUrl_Micro + 'bao-tro-xa-hoi/mat-tran-to-quoc/v2/thong-ke-2e',
        getAllManhThuongQuan: rootUrl_Micro + 'bao-tro-xa-hoi/mat-tran-to-quoc/v2/get-all-manh_thuong_quan',
        dsManhThuongQuan: rootUrl_Micro + 'bao-tro-xa-hoi/mat-tran-to-quoc/v2/danh-sach-manh_thuong_quan',
        themManhThuongQuan: rootUrl_Micro + 'bao-tro-xa-hoi/mat-tran-to-quoc/v2/them-manh_thuong_quan',
        chiTietManhThuongQuan: rootUrl_Micro + 'bao-tro-xa-hoi/mat-tran-to-quoc/v2/chi-tiet-manh_thuong_quan',
        capNhatManhThuongQuan: rootUrl_Micro + 'bao-tro-xa-hoi/mat-tran-to-quoc/v2/cap-nhat-manh_thuong_quan',
        xoaKhoiPhucManhThuongQuan: rootUrl_Micro + 'bao-tro-xa-hoi/mat-tran-to-quoc/v2/xoa-khoi-phuc-manh_thuong_quanh',
        getAllSoThuChi: rootUrl_Micro + 'bao-tro-xa-hoi/mat-tran-to-quoc/v2/get-all-so-thu',
        dsSoThuChi: rootUrl_Micro + 'bao-tro-xa-hoi/mat-tran-to-quoc/v2/danh-sach-so-thu',
        themSoThuChi: rootUrl_Micro + 'bao-tro-xa-hoi/mat-tran-to-quoc/v2/them-so-thu',
        chiTietSoThuChi: rootUrl_Micro + 'bao-tro-xa-hoi/mat-tran-to-quoc/v2/chi-tiet-so-thu',
        capNhatSoThuChi: rootUrl_Micro + 'bao-tro-xa-hoi/mat-tran-to-quoc/v2/cap-nhat-so-thu',
        xoaKhoiPhucSoThuChi: rootUrl_Micro + 'bao-tro-xa-hoi/mat-tran-to-quoc/v2/xoa-khoi-phuc-so-thu',
        thongKeThuChi: rootUrl_Micro + 'bao-tro-xa-hoi/mat-tran-to-quoc/v2/thong-ke-thu-chi',
        getListNguonThu: rootUrl_Micro + 'bao-tro-xa-hoi/mat-tran-to-quoc/v2/danh-sach-nguon-thu',
        themNguonThu: rootUrl_Micro + 'bao-tro-xa-hoi/mat-tran-to-quoc/v2/them-nguon-thu',
        chiTietNguonThu: rootUrl_Micro + 'bao-tro-xa-hoi/mat-tran-to-quoc/v2/chi-tiet-nguon-thu',
        capNhatNguonThu: rootUrl_Micro + 'bao-tro-xa-hoi/mat-tran-to-quoc/v2/cap-nhat-nguon-thu',
        xoaKhoiPhucNguonThu: rootUrl_Micro + 'bao-tro-xa-hoi/mat-tran-to-quoc/v2/xoa-khoi-phuc-nguon-thu',
        getAllNguonThu: rootUrl_Micro + 'bao-tro-xa-hoi/mat-tran-to-quoc/v2/get-all-nguon-thu',
        getListNguonChi: rootUrl_Micro + 'bao-tro-xa-hoi/mat-tran-to-quoc/v2/danh-sach-nguon-chi',
        themNguonChi: rootUrl_Micro + 'bao-tro-xa-hoi/mat-tran-to-quoc/v2/them-nguon-chi',
        chiTietNguonChi: rootUrl_Micro + 'bao-tro-xa-hoi/mat-tran-to-quoc/v2/chi-tiet-nguon-chi',
        capNhatNguonChi: rootUrl_Micro + 'bao-tro-xa-hoi/mat-tran-to-quoc/v2/cap-nhat-nguon-chi',
        xoaKhoiPhucNguonChi: rootUrl_Micro + 'bao-tro-xa-hoi/mat-tran-to-quoc/v2/xoa-khoi-phuc-nguon-chi',
        timKiemLoaiChinhSach: rootUrl_Micro + 'bao-tro-xa-hoi/cau-hinh-chinh-sach-tcxh/tim-kiem-loai-chinh-sach',
        themMoiLoaiChinhSach: rootUrl_Micro + 'bao-tro-xa-hoi/cau-hinh-chinh-sach-tcxh/them-moi-loai-chinh-sach',
        timKiemLoaiDoiTuong: rootUrl_Micro + 'bao-tro-xa-hoi/cau-hinh-chinh-sach-tcxh/tim-kiem-loai-doi-tuong',
        themMoiLoaiDoiTuong: rootUrl_Micro + 'bao-tro-xa-hoi/cau-hinh-chinh-sach-tcxh/them-moi-loai-doi-tuong',
        themMoiLoaiDoiTuongDotXuat: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-loai-doi-tuong-dot-xuat',
        capNhatLoaiDoiTuongDotXuat: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-loai-doi-tuong-dot-xuat',
        chiTietLoaiDoiTuongDotXuat: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/chi-tiet-loai-doi-tuong-dot-xuat',
        xoaLoaiDoiTuongDotXuat: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-loai-doi-tuong-dot-xuat',
        timKiemDoiTuong: rootUrl_Micro + 'bao-tro-xa-hoi/cau-hinh-chinh-sach-tcxh/tim-kiem-doi-tuong',
        themMoiDoiTuong: rootUrl_Micro + 'bao-tro-xa-hoi/cau-hinh-chinh-sach-tcxh/them-moi-doi-tuong',
        capNhatDoiTuong: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-doi-tuong-dot-xuat',
        themMoiDoiTuongDotXuat: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-doi-tuong-dot-xuat',
        chiTietDoiTuongDotXuat: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/chi-tiet-doi-tuong-dot-xuat',
        xoaDoiTuongDotXuat: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-doi-tuong-dot-xuat',
        getHeSo: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/he-so',
        getTrangThaiQuyTrinh: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/trang-thai-quy-trinh',
        getListLog: rootUrl_Micro + 'bao-tro-xa-hoi/v2/log/get-danh-sach-log',
        chiTietLog: rootUrl_Micro + 'bao-tro-xa-hoi/log/chi-tiet-log',

        // Hộ gia đình
        tinhDiemB1: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/tinh-diem-b1',
        soHGD: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/them-so-ho-gia-dinh', // số hộ gia đình
        soHGDByMaXa: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/get-so-hgd-by-ma-xa', // số hộ gia đình theo mã xã
        // danh sách hộ gia đình
        traCuuChiTraHoGd: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/search-data-chi-tra-ho-gia-dinh',
        detailHoGd: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/thong-tin-chung', // chi tiết hộ gia đình       ?maHoGD=
        chiTietHoGd: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/thong-tin-chung-public',
        registryHoGD: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/dang-ky', // đăng ký hộ gia đình
        updateHoGD: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/cap-nhat', // cập nhật hộ gia đình
        capNhatThongTinChungHo: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/cap-nhat-thong-tin-chung', // cập nhật thông tin chung của hộ gia đình
        capNhatDacDiemHo: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/cap-nhat-dac-diem', // cập nhật thông tin đặc điểm hộ
        deletHoGD: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/xoa-khoi-he-thong', // xóa hộ gia đình            ?maHoGD=
        recoverHoGD: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/khoi-phuc', // khôi phục hộ gia đình      ?maHoGD=
        themCSHo: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/them-moi-chinh-sach-doi-tuong', // thêm mới chính sách hộ
        themChinhSachDongLoat: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/them-moi-chinh-sach-doi-tuong-dong-loat',
        xuatDanhSachCatChet: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/xuat-danh-sach-cat-chet',
        updateChinhSachDoiTuong: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/cap-nhat-chinh-sach-doi-tuong',
        chuyenChuHo: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/chuyen-chu-ho',
        chuyenVungHo: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/quy-trinh-chuyen-ho/yeu-cau-chuyen-ho-dia-phuong-khac',
        chuyenVungDiaLy: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/quy-trinh-chuyen-ho/chuyen-ho-dia-ly',
        tachHoKhauMoi: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/tach-ho-moi',
        searchHoGiaDinh: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/search-chuyen-ho',
        nhapHoKhauCungXa: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/chuyen-ho-cung-dia-phuong',
        nhapHoKhauKhacXa: rootUrl_Micro + 'bao-tro-xa-hoi/v2/thanh-vien/v2/yeu-cau-chuyen-thanh-vien-dia-phuong-khac',
        checkYeuCauHo: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/quy-trinh-chuyen-ho/check-yeu-cau-ho',
        checkYeuCauThanhVien: rootUrl_Micro + 'bao-tro-xa-hoi/v2/thanh-vien/v2/check-yeu-cau-thanh-vien',
        danhSachYeuCauChuyenVung: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/quy-trinh-chuyen-ho/danh-sach-yeu-cau-ho',
        pheDuyetYeuCauHo: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/quy-trinh-chuyen-ho/duyet-tu-choi-yeu-cau',
        yeuCauTuChoiHo: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/quy-trinh-chuyen-ho/gui-yeu-cau-huy-yeu-cau-ho',
        guiLaiYeuCauHo: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/quy-trinh-chuyen-ho/gui-lai-yeu-cau-ho',
        xoaYeuCauHo: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/quy-trinh-chuyen-ho/huy-yeu-cau-ho',
        danhSachYeuCauNhapHoKhau: rootUrl_Micro + 'bao-tro-xa-hoi/v2/thanh-vien/v2/danh-sach-yeu-cau-thanh-vien',
        pheDuyetYeuCauThanhVien: rootUrl_Micro + 'bao-tro-xa-hoi/v2/thanh-vien/v2/duyet-tu-choi-yeu-cau-thanh-vien',
        yeuCauTuChoiThanhVien: rootUrl_Micro + 'bao-tro-xa-hoi/v2/thanh-vien/v2/gui-yeu-cau-tu-choi-thanh-vien',
        guiLaiYeuCauThanhVien: rootUrl_Micro + 'bao-tro-xa-hoi/v2/thanh-vien/v2/gui-lai-yeu-cau-thanh-vien',
        xoaYeuCauThanhVien: rootUrl_Micro + 'bao-tro-xa-hoi/v2/thanh-vien/v2/huy-yeu-cau-thanh-vien',
        danhSachPhatSinh: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/danh-sach-quyet-dinh-phan-trang',
        xuatTemplatePhatSinh: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/xuat-template-QD-phat-sinh',
        xuatTemplateDieuChinh: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/xuat-template-QD-dieu-chinh',
        xuatTemplateThoiHuong: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/xuat-template-QD-thoi-huong',
        importPhatSinh: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/import-excel-phat-sinh',
        importDieuChinh: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/import-excel-dieu-chinh',
        importThoiHuong: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/import-excel-thoi-huong',
        inQuyetDinhPhatSinh: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/in-quyet-dinh-mau-tro-cap',
        inQuyetDinhDieuChinh: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/in-quyet-dinh-dieu-chinh-mau',
        inQuyetDinhThoiHuong: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/in-quyet-dinh-mau-thoi-huong',
        xoaChinhSachNhanKhauImport: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/xoa-huong-chinh-sach-import',
        xuatChungNhan: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/xuat-chung-nhan-ho-ngheo',
        exportBcMauBaMotHo: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/xuat-mau-3-1',
        exportBcMauBaHaiHo: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/xuat-mau-3-2',
        exportBcMauBaBonHo: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/xuat-mau-3-45678910',
        exportBcMauBaBonHoHGI: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/xuat-mau-3-4',
        exportBcMauBaBayHo: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/xuat-mau-3-7',
        exportBcMauBaTamHo: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/xuat-mau-3-8',

        danhMucNganHang: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/lay-danh-sach-ngan-hang',
        dacDiemHGDlog: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/ds-dacDiemHGDLog',

        GET_DATA: {
            hoGdList: rootUrl_Micro + 'get-data/bao-tro-xa-hoi/v2/ho-gia-dinh/tim-kiem-phan-trang',
            xuatKetQuaRaSoatHoNgheo: rootUrl_Micro + 'get-data/bao-tro-xa-hoi/v2/ho-gia-dinh/xuat-template-ra-soat-ho-ngheo-co-thong-tin',
            xuatHoGd: rootUrl_Micro + 'get-data/bao-tro-xa-hoi/v2/ho-gia-dinh/xuat-danh-sach',
            tVHoGdList: rootUrl_Micro + 'get-data/bao-tro-xa-hoi/v2/thanh-vien/tim-kiem-phan-trang',
            xuatThanhVien: rootUrl_Micro + 'get-data/bao-tro-xa-hoi/v2/thanh-vien/xuat-danh-sach',
            nhanKhauHuongCS: rootUrl_Micro + 'get-data/bao-tro-xa-hoi/v2/ho-gia-dinh/ds-nhan-khau-huong-chinh-sach',
            danhSachCatChet: rootUrl_Micro + 'get-data/bao-tro-xa-hoi/v2/ho-gia-dinh/danh-sach-cat-chet-phan-trang',
            mauBaoCaoSo8: rootUrl_Micro + 'get-data/bao-tro-xa-hoi/v2/bao-cao/tong-hop-mau-08',
            mauBaoCao11d: rootUrl_Micro + 'get-data/bao-tro-xa-hoi/v2/bao-cao/tong-hop-mau-11d',
            mauBaoCaoCacLoaiDoiTuong: rootUrl_Micro + 'get-data/bao-tro-xa-hoi/v2/bao-cao/bao-cao-loai-doi-tuong',
            mauBaoCaoChiTietLoaiDoiTuong: rootUrl_Micro + 'get-data/bao-tro-xa-hoi/v2/bao-cao/bao-cao-chi-tiet-loai-doi-tuong',
            // Mẫu báo cáo kế toán
            mbcKeToan: rootUrl_Micro + 'get-data/bao-tro-xa-hoi/v2/bao-cao/', // phiếu kế toán abcd
            mauBaoCaoGiamNgheo: rootUrl_Micro + 'get-data/bao-tro-xa-hoi/v2/bao-cao/tong-hop-mau-',
            baoCaoSoBNH: rootUrl_Micro + 'get-data/bao-tro-xa-hoi/v2/bao-cao/bao-cao-bnh',
            exportExcelBTXH : rootUrl_Micro + 'get-data/bao-tro-xa-hoi/v2/doi-tuong-btxh/xuat-danh-sach-doi-tuong-btxh',
        },
        // Thành viên hộ gia đình
        dsThanhVien: rootUrl_Micro + 'bao-tro-xa-hoi/v2/thanh-vien/v2/danh-sach', // danh sách thành viên
        detailThanhVien: rootUrl_Micro + 'bao-tro-xa-hoi/v2/thanh-vien/v2/thong-tin-chi-tiet', // chi tiết thành viên
        chiTietThanhVien: rootUrl_Micro + 'bao-tro-xa-hoi/v2/thanh-vien/v2/thong-tin-chung-public',
        detailTVHuong: rootUrl_Micro + 'bao-tro-xa-hoi/v2/thanh-vien/v2/chi-tiet-chinh-sach-dang-huong', // chi tiết thành viên đang hưởng chính sách
        chinhSachDangHuong: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/chinh-sach-doi-tuong-dang-huong', // chính sách đang hưởng
        updateTVHoGD: rootUrl_Micro + 'bao-tro-xa-hoi/v2/thanh-vien/v2/cap-nhat',
        thanhVienHGD: rootUrl_Micro + 'bao-tro-xa-hoi/v2/thanh-vien/v2/thong-tin-chung',
        deleteThanhVien: rootUrl_Micro + 'bao-tro-xa-hoi/v2/thanh-vien/v2/xoa',
        recoverThanhVien: rootUrl_Micro + 'bao-tro-xa-hoi/v2/thanh-vien/v2/khoi-phuc',
        themThanhVien: rootUrl_Micro + 'bao-tro-xa-hoi/v2/thanh-vien/v2/them-moi',

        // Chính sách hộ gia đình
        chinhSachHo: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/chinh-sach-dang-huong', // chính sách hộ
        chinhSachThanhVien: rootUrl_Micro + 'bao-tro-xa-hoi/v2/thanh-vien/v2/chinh-sach-dang-huong', // chính sách thành viên
        chinhSach: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chinh-sach/danh-sach', // danh sách chính sách
        catChet: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/cat-chet-thanh-vien-ho',
        thongTinTheoDoiTuong: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chinh-sach/thong-tin-theo-doi-tuong',

        // Chi trả
        lapDanhSachChiTra: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/lap-moi-danh-sach',
        danhSachChiTraDaLap: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/danh-sach-da-lap',
        lichSuQuyTrinh: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/lich-su-phan-trang',
        lichSuChiTra: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/get-log-chi-tra',
        chiTietChiTraDaLap: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/chi-tiet-danh-sach-da-lap',
        danhSachXaLapChiTra: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/danh-sach-xa-da-lap', // ?maTinh=82&maHuyen=823&kyChot=11/2020
        huyDanhSachChiTra: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/huy-danh-sach-da-lap', // ?maTinh=82&maHuyen=823&maXa=28675&idLoaiChinhSach=1&chotKy=11/2020
        tongHopDanhSachChiTra: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/tong-hop-danh-sach',
        chiTietDsTongHop: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/chi-tiet-danh-sach-tong-hop',
        chotDsChiTra: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/chot-du-lieu-tong-hop',
        dsChinhSachTongHop: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/danh-muc-loai-chinh-sach',
        huyDanhSachTongHop: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/huy-danh-sach-tong-hop',
        taiMauUpdateTrangThai: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/tai-mau-excel-cap-nhat',
        updateTrangThaiChiTra: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/cap-nhat-toan-bo-trang-thai',
        uploadFileChiTra: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/upload',
        dsChotKyChiTra: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/danh-sach-chot-thang',
        moKy: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/mo-ky',
        dongKy: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/chot-ky',
        kiemTraChotKy: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/kiem-tra-chot-ky',
        checkChotDuLieuTongHop: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/thong-bao',
        capNhatTrangThaiChiTra: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/cap-nhat-trang-thai',
        khoiPhucCatChet: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/khoi-phuc-cat-chet-thanh-vien-ho',
        infoChiTraMtp: rootUrl_Micro + 'bao-tro-xa-hoi/v2/thanh-vien/v2/thong-tin-chi-tra-mai-tang-phi',
        capNhatMtp: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/cap-nhat-mai-tang-phi',
        kiemTraDoiTuongTonTai: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/kiem-tra-doi-tuong-trung',
        xuatDanhSachChiTietDaLap: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/xuat-excel-chi-tiet-danh-sach-da-lap',
        inQuyetDinhMtp: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/in-quyet-dinh-mai-tang-phi',
        xuatDsPheDuyetQd: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/xuat-excel-danh-sach-phe-duyet-quyet-dinh',
        xuatDanhSachChiTraTongHopDaChot: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/xuat-excel-danh-sach-chi-tra-tong-hop',
        guiPheDuyetDanhSachDaLap: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/chuyen-phe-duyet-danh-sach-da-lap',
        pheDuyetDanhSachDaLap: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/phe-duyet-danh-sach-da-lap',
        canhBaoLapDanhSach: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/canh-bao-lap-danh-sach',
        dongKyChiTra: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/dong-ky',
        thongKeCuoiKy: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/thong-ke-cuoi-ky',
        chiTraTienDien: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/xuat-danh-sach-chi-tien-dien',
        chuyenPheDuyetDanhSachTongHop: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/chuyen-phe-duyet-tong-hop',
        kiemTraDongKyKhiThemChinhSach: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/thong-tin-ky-hien-tai',
        kiemTraCacKyDaDong: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/thong-tin-ky-chi-tra',
        kiemTraTruyLinh: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/so-thang-truy-linh',
        kiemTraTruyLinhTheoKy: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/so-thang-truy-linh-theo-ky',
        xuatDanhSachChiTraHoKinhDoanh: rootUrl_Micro + 'bao-tro-xa-hoi/v2/bao-cao/xuat-danh-sach-chi-tra-ho-kinh-doanh',
        xuatDanhSachChiTraNguoiLaoDong: rootUrl_Micro + 'bao-tro-xa-hoi/v2/bao-cao/xuat-danh-sach-chi-tra-nguoi-lao-dong',
        getListNgayChot: rootUrl_Micro + 'bao-tro-xa-hoi/v2/bao-cao/get-ngay-chi-tra/v2',
        xuatTemplateImportMtp: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/xuat-template-QD-mtp',
        importMtp: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/import-excel-mtp',
        capNhatSoQD: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/cap-nhat-so-quyet-dinh',
        capNhatSoVB: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/cap-nhat-so-van-ban',
        capNhatSoTT: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/cap-nhat-so-to-trinh',
        chiTraVnptPay: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/chi_tra_qua_vnpt_pay',
        capNhatViVnptPay: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/cap_nhat_vi_vnpt_pay',

        // Báo cáo
        tuyBien01: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/bao-cao-chinh-sach-theo-phan-loai-va-dia-ban',
        baoCaoChiTraDoiTuong: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/xuat-pdf-bao-cao-chi-tra-doi-tuong',
        xuatExcelRaSoatHoNgheo: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/xuat-excel-ra-soat-ho-ngheo',
        importExcelRaSoatHoNgheo: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/import-excel-ra-soat-ho-ngheo',
        importKetQuaRaSoatHoNgheo: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/import-template-ra-soat-ho-ngheo',
        timKiemTongDanCuDieuTra: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/tim-kiem-tong-dan-cu',
        nhapLieuTongDanCu: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-moi-dan-cu',
        capNhatSoLieuTongDanCu: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/sua-dan-cu',
        danhSachMauBaoCao: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/tim-kiem-bao-cao',
        raSoatSoLieuDoiTuongCacNganh: rootUrl_Micro + 'bao-tro-xa-hoi/v2/bao-cao/them-ra-soat-loai-doi-tuong',
        // Mâu báo cáo giảm nghèo
        raSoatHoNgheo: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/ra-soat-ho-ngheo',
        xuatTemplateRaSoatHoNgheo: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/xuat-template-ra-soat-ho-ngheo',
        xuatTemplateRaSoatHoNgheoGLI: rootUrl_Micro + 'file/btxh/dung-chung/downloadFile',
        mauBaoCao10c: rootUrl_Micro + 'bao-tro-xa-hoi/v2/bao-cao/bao-cao-10c-pdf-word',
        mauBaoCaoGiamNgheo4a: rootUrl_Micro + 'bao-tro-xa-hoi/v2/bao-cao/tong-hop-dien-bien-ho-ngheo-4a',
        mauBaoCaoGiamNgheo15: rootUrl_Micro + 'bao-tro-xa-hoi/v2/bao-cao/bao-cao-mau-gn-th-',
        // Mẫu báo cáo BTXH
        raSoatBtxh: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/ra-soat-doi-tuong-btxh',
        mauBaoCao: rootUrl_Micro + 'bao-tro-xa-hoi/v2/bao-cao/',

        mauBaoCaoCacLoaiDoiTuong: rootUrl_Micro + 'bao-tro-xa-hoi/v2/bao-cao/bao-cao-loai-doi-tuong',
        mauBaoCaoChiTietLoaiDoiTuong: rootUrl_Micro + 'bao-tro-xa-hoi/v2/bao-cao/bao-cao-chi-tiet-loai-doi-tuong',
        // mẫu báo cáo đối tượng cơ sở BTXH - VLG
        xuatDSDTcosoBTXH: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/xuat-danh-sach-doi-tuong-tai-co-so-btxh',
        xuatDSDTcosoBTXHExcel: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/doi-tuong-excel',
        // mẫu báo cáo tăng giảm đối tượng cơ sở BTXH - VLG
        xuatbaocaoTangGiam: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/bao-cao-danh-sach-tang-giam-doi-tuong-btxh',
        // mẫu báo cáo đối tượng theo nhóm - VLG
        xuatbaocaoDTTheoNhom: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/bao-cao-danh-sach-doi-tuong-btxh-theo-nhom',
        ///mẫu báo cáo tổng hợp đối tượng - VLG
        xuatbaocaoTongHop: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/bao-cao-tong-hop-doi-tuong-duoc-nuoi-duong-tai-tt',
        // mẫu báo cáo biến động đối tượng hàng tháng - VLG
        xuatbaocaoBienDong: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/bao-cao-danh-sach-tiep-nhan-doi-tuong-btxh',
        // mẫu 10a
        xuatbaocao10a: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/bao-cao-mau-10a-doi-tuong-btxh',
        // mẫu 10d
        xuatbaocao10d: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/bao-cao-mau-10d-doi-tuong-btxh',
        //ảnh đối tượng - VLG
        anhDoiTuong: rootUrl_Micro + 'file/btxh/uploadAnhDoiTuong',
        xoaAnhDoiTuong: rootUrl_Micro + 'file/btxh/deleteAnhDoiTuong',
        // hồ sơ số hóa - VLG
        listDangKhuyetTat: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/danh-sach-dang-khuyet-tat',
        listCoSoBTXH: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/danh-sach-co-so-btxh',
        themMoiDoiTuongThuocTtbtxhvlg: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/them-doi-tuong-tai-co-so-btxh_vlg',
        chiTietDoiTuongTrungTamBtxhvlg: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/chi-tiet-doi-tuong-tai-co-so-btxh_vlg',
        capNhatDoiTuongThuocTtbtxhvlg: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/cap-nhat-doi-tuong-tai-co-so-btxh_vlg',
        timKiemDoiTuongThuocTtbtxhvlg: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/danh-sach-doi-tuong-tai-co-so-btxh_vlg',
        listKho: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/danh-sach-kho-luu-tru-ho-so',
        listKe: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/danh-sach-ke-luu-tru-ho-so',
        listTang: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/danh-sach-tang-luu-tru-ho-so',
        listHop: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/danh-sach-hop-luu-tru-ho-so',
        listHoSo: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/danh-sach-ho-so-theo-doi-tuong',
        getHoSoSoHoaDaCo: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/danh-sach-ho-so-so-hoa-doi-tuong-btxh',
        getHoSoSoHoaChuaCo: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/danh-sach-ho-so-so-hoa-chua-co',
        uploadFileHoSoDoiTuong: rootUrl_Micro + 'file/btxh/uploadFileHoSoDoiTuong',
        deleteFileHoSoDoiTuong: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/xoa-ho-so-so-hoa-doi-tuong-btxh',
        downFileHoSoDoiTuong: rootUrl_Micro + 'file/btxh/downloadFileHoSoDoiTuong',
        exportDoiTuong: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/export-danh-sach-doi-tuong',
        luuHoSoSHDoiTuong: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/them-ho-so-so-hoa-doi-tuong-btxh',
        doTuoiDoiTuongVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/danh-sach-do-tuoi',
        // chính sách TCXH - VLG
        loaiDTChinhSachDoiTuongVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/danh-sach-loai-doi-tuong-vlg',
        listDTChinhSachDoiTuongVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/danh-sach-doi-tuong-vlg',
        heSoChinhSachDoiTuongVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/chinh-sach-theo-doi-tuong-vlg',
        luuChinhSachDoiTuongVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/cap_nhat_chinh_sach_doi_tuong_btxh_vlg',
        //Tra cứu hồ sơ đối tượng - VLG
        traCuuHSDoiTuong: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/tim_kiem_ho_so_doi_tuong_btxh',
        //Nhà tài trợ - VLG
        listKhoNTT: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/lay-danh-sach-kho',
        listHangHoaNTT: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/lay-danh-sach-hang-hoa-tai-tro',
        xuatPDFTheKho: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/xem-bao-cao-the-kho',
        xemxuatNhapTonKho: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/xem-bao-cao-xuat-nhap-ton-kho',
        inxuatNhapTonKho: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/in-bao-cao-xuat-nhap-ton-kho',
        // DM phân hệ nhà tài trợ - VLG
        listHinhThucNTTVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/lay-hinh-thuc-tai-tro',
        themMoiHinhThucNTTVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/them-hinh-thuc-tai-tro',
        capNhatHinhThucNTTVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/sua-hinh-thuc-tai-tro',
        xoaHinhThucNTTVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/xoa-hinh-thuc-tai-tro',

        listLoaiNTTVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/lay-loai-tai-tro',
        themMoiLoaiNTTVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/them-loai-tai-tro',
        capNhatLoaiNTTVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/sua-loai-tai-tro',
        xoaLoaiNTTVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/xoa-loai-tai-tro',

        listDonViTinhVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/lay-danh-muc-don-vi-tinh',
        themMoiDonViTinhVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/them-don-vi-tinh',
        capNhatDonViTinhVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/sua-don-vi-tinh',
        xoaDonViTinhVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/xoa-don-vi-tinh',

        listHangHoaVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/lay-danh-sach-hang-hoa',
        themMoiHangHoaVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/them-hang-hoa',
        capNhatHangHoaVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/sua-hang-hoa',
        xoaHangHoaVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/xoa-hang-hoa',

        listKhoVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/lay-danh-muc-kho',
        themMoiKhoVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/them-kho',
        capNhatKhoVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/sua-kho',
        xoaKhoVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/xoa-kho',
        // DM phân hệ đối tượng - VLG
        timKiemDangTatVLG: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/dang-tat/tim-kiem-danh-muc',
        themMoiDangTatVLG: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/dang-tat/them-moi',
        capNhatDangTatVLG: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/dang-tat/sua-thong-tin',
        xoaDangTatVLG: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/dang-tat/xoa',
        khoiPhucDangTatVLG: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/dang-tat/khoi-phuc?idDangTat=',
        listDangTatVLG: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/dang-tat/danh-sach-dang-tat',

        timKiemDoiTuongVLG: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/tim-kiem-doi-tuong-tai-co-so-bao-tro',
        themMoiNhomDoiTuongVLG: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-doi-tuong-tai-co-so-bao-tro',
        capNhatNhomDoiTuongVLG: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-doi-tuong-tai-co-so-bao-tro',
        xoaNhomDoiTuongVLG: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-doi-tuong-tai-co-so-bao-tro',
        khoiPhucNhomDoiTuongVLG: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/khoi-phuc-doi-tuong-tai-co-so-bao-tro?idNhomDoiTuong=',

        timKiemLoaiDoiTuongVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/tim_kiem_loai_doi_tuong_btxh',
        themMoiLoaiDoiTuongVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/them_loai_doi_tuong_btxh',
        capNhatLoaiDoiTuongVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/them_loai_doi_tuong_btxh',
        xoaLoaiDoiTuongVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/xoa_loai_doi_tuong_btxh',
        khoiPhucLoaiDoiTuongVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/xoa_loai_doi_tuong_btxh',

        timKiemHinhThucLuuTruVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/tim_kiem_hinh_thuc_luu_tru',
        themMoiHinhThucLuuTruVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/them_hinh_thuc_luu_tru',
        capNhatHinhThucLuuTruVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/them_hinh_thuc_luu_tru',
        xoaHinhThucLuuTruVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/xoa_hinh_thuc_luu_tru',
        khoiPhucHinhThucLuuTruVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/xoa_hinh_thuc_luu_tru',

        timKiemDoTuoiVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/tim_kiem_do_tuoi',
        themMoiDoTuoiVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/them_do_tuoi',
        capNhatDoTuoiVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/them_do_tuoi',
        xoaDoTuoiVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/xoa_do_tuoi',
        khoiPhucDoTuoiVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/xoa_do_tuoi',

        timKiemCoSoVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/danh-sach-co-so-btxh-vlg',
        themMoiCoSoVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/them-co-so-btxh-vlg',
        capNhatCoSoVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/them-co-so-btxh-vlg',
        xoaCoSoVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/xoa-co-so-btxh-vlg',
        khoiPhucCoSoVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/xoa-co-so-btxh-vlg',

        timKiemLoaiHoSoVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/danh-sach-danh-muc-ho-so',
        themMoiLoaiHoSoVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/them-danh-muc-ho-so',
        capNhatLoaiHoSoVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/them-danh-muc-ho-so',
        xoaLoaiHoSoVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/xoa-danh-muc-ho-so',
        khoiPhucLoaiHoSoVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/xoa-danh-muc-ho-so',

        timKiemKhoLuuTruVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/danh-sach-kho-luu-tru',
        themMoiKhoLuuTruVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/them-kho-luu-tru-ho-so',
        capNhatKhoLuuTruVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/them-kho-luu-tru-ho-so',
        xoaKhoLuuTruVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/xoa-kho-luu-tru-ho-so',
        khoiPhucKhoLuuTruVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/xoa-kho-luu-tru-ho-so',

        timKiemKeLuuTruVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/danh-sach-ke-luu-tru',
        themMoiKeLuuTruVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/them-ke-luu-tru-ho-so',
        capNhatKeLuuTruVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/them-ke-luu-tru-ho-so',
        xoaKeLuuTruVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/xoa-ke-luu-tru-ho-so',
        KhoiPhucKeLuuTruVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/xoa-ke-luu-tru-ho-so',

        timKiemTangLuuTruVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/danh-sach-tang-luu-tru',
        themMoiTangLuuTruVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/them-tang-luu-tru-ho-so',
        capNhatTangLuuTruVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/them-tang-luu-tru-ho-so',
        xoaTangLuuTruVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/xoa-tang-luu-tru-ho-so',
        KhoiPhucTangLuuTruVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/xoa-tang-luu-tru-ho-so',

        timKiemHopLuuTruVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/danh-sach-hop-luu-tru',
        themMoiHopLuuTruVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/them-hop-luu-tru-ho-so',
        capNhatHopLuuTruVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/them-hop-luu-tru-ho-so',
        xoaHopLuuTruVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/xoa-hop-luu-tru-ho-so',
        KhoiPhucHopLuuTruVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/xoa-hop-luu-tru-ho-so',

        timKiemHSTheoDTVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/tim_kiem_loai_doi_tuong_btxh_ho_so',
        themMoiHSTheoDTVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/them_loai_doi_tuong_btxh_ho_so',
        capNhatHSTheoDTVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/them_loai_doi_tuong_btxh_ho_so',
        xoaHSTheoDTVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/xoa_loai_doi_tuong_btxh_ho_so',
        KhoiPhucHSTheoDTVLG: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/xoa_loai_doi_tuong_btxh_ho_so',

        timKiemMucDoKhuyetTatVLG: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/tim-kiem-muc-do-khuyet-tat',
        themMoiMucDoKhuyetTatVLG: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-muc-do-khuyet-tat',
        capNhatMucDoKhuyetTatVLG: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-muc-do-khuyet-tat',
        xoaMucDoKhuyetTatVLG: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-muc-do-khuyet-tat',
        KhoiPhucMucDoKhuyetTatVLG: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-muc-do-khuyet-tat',
        // Mẫu báo cáo kế toán

        tyLeDanTocHoNgheo : rootUrl_Micro + 'bao-tro-xa-hoi/dashboard-ho-ngheo/ty-le-dan-toc-ho-ngheo',
        tyLeGioiTinhHoNgheo : rootUrl_Micro + 'bao-tro-xa-hoi/dashboard-ho-ngheo/ty-le-gioi-tinh-ho-ngheo',
        thongKeTongHoNgheo: rootUrl_Micro + 'bao-tro-xa-hoi/dashboard-ho-ngheo/thong-ke-tong-ho-ngheo',
        thongKeTongHopTheoHC : rootUrl_Micro + 'bao-tro-xa-hoi/dashboard-ho-ngheo/thong-ke-ho-ngheo-theo-hanh-chinh',

        // Danh mục
        timKiemHeSo: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/tim-kiem-danh-muc-he-so',
        themMoiHeSo: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-moi-he-so',
        capNhatHeSo: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/sua-thong-tin-he-so',
        xoaHeSo: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-he-so',
        khoiPhucHeSo: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/khoi-phuc-he-so?idHeSo=',
        timKiemDangTat: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/dang-tat/tim-kiem-danh-muc',
        themMoiDangTat: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/dang-tat/them-moi',
        capNhatDangTat: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/dang-tat/sua-thong-tin',
        xoaDangTat: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/dang-tat/xoa',
        khoiPhucDangTat: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/dang-tat/khoi-phuc?idDangTat=',
        listDangTat: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/dang-tat/danh-sach-dang-tat',
        quanHeVoiCHKhongCoCH: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/quan-he-khong-chu-ho',
        getListReportPrototype: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/bao-cao',
        danhMucChieuThieuHut: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/lay-chi-tiet-loai-ho-ngheo?maLoaiHoNgheo=',
        themMoiChieuThieuHut: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-chi-tiet-loai-ho-ngheo',
        capNhatChieuThieuHut: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-chi-tiet-loai-ho-ngheo',
        xoaChieuThieuHut: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-khoi-phuc-chi-tiet-ho-ngheo',
        timKiemDanhMucChieuThieuHut: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/tim-kiem-chi-tiet-loai-ho-ngheo',
        danhSachThietBiThongTin: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/lay-danh-sach-thiet-bi',
        danhSachChinhSachHoDangHuong: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/lay-danh-sach-chinh-sach-ho',
        getChiSoDaChieu: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/lay-chi-so-theo-chieu',
        danhMucLoaiDoiTuong: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/loai-doi-tuong',
        themMoiBaoCao: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-bao-cao',
        capNhatBaoCao: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-bao-cao',
        xoaBaoCao: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-danh-muc-bao-cao?idDanhMucBaoCao=',
        khoiPhucBaoCao: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/khoi-phuc-bao-cao?idDanhMucBaoCao=',
        themChiSoDaChieu: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-chi-so-chieu',
        capNhatChiSoDaChieu: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-chi-so-chieu',
        xoaChiSoChieu: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-khoi-phuc-chi-so-chieu',
        dsVatLieuCotNha: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/get-all-vat-lieu-cot',
        dsVatLieuMaiNha: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/get-all-vat-lieu-mai',
        dsVatLieuTuongNha: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/get-all-vat-lieu-tuong',
        dsTaiSanBenLau: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/get-all-tai-san-lau-ben',
        dsChanNuoi: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/get-all-chan-nuoi',
        dsDatDai: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/get-all-dat-dai',
        dsNguyenNhanKhoKhan: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/get-all-nguyen-nhan-kho-khan',
        searchChinhSachHoTro: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/tim-kiem-chinh-sach-ho',
        searchVatLieuCot: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/tim-kiem-vat-lieu-cot-nha',
        searchVatLieuMai: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/tim-kiem-vat-lieu-mai-nha',
        searchVatLieuTuong: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/tim_kiem-vat-lieu-tuong',
        searchDienTichDat: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/tim-kiem-dien-tich-dat',
        searchChanNuoi: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/tim-kiem-danh-muc-chan-nuoi',
        searchTaiSan: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/tim-kiem-tai-san-lau-ben',
        searchDienSuDung: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/tim-kiem-loai-dien',
        searchNuocSinhHoat: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/tim-kiem-nuoc-sinh-hoat',
        searchLoaiHoXi: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/tim-kiem-loai-ho-xi',
        searchNguyenNhan: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/tim-kiem-nguyen-nhan-kho-khan',
        searchCapHoc: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/tim-kiem-cap-hoc',
        searchLoaiTheBhyt: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/tim-kiem-loai-the-bhyt',
        searchVanHoa: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/tim-kiem-trinh-do-van-hoa',
        searchDaoTao: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/tim-kiem-trinh-do-dao-tao',
        searchDtCs: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/tim-kiem-doi-tuong-chinh-sach',
        searchLyDo: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/tim-kiem-ly-do-khong-kcb',
        searchDtHuongTcxh: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/tim-kiem-doi-tuong-huong-tc-hang-thang',
        searchTinhTrangViecLam: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/tim-kiem-tinh-trang-viec-lam',
        searchLoaiViecLam: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/tim-kiem-danh-muc-loai-viec-lam',
        searchViecLamCong: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/tim-kiem-danh-muc-viec-lam-cong-an-luong',
        searchHonNhan: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/tim-kiem-tinh-trang-hon-nhan',
        searchMucDoKhuyetTat: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/tim-kiem-muc-do-khuyet-tat',
        searchPhanLoaiHo: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/tim-kiem-phan_loai-ho',
        searchChiTietHo: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/tim-kiem-chi-tiet-ho',
        themChinhSachHoTro: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-chinh-sach-ho',
        themVatLieuCot: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-vat-lieu-cot-nha',
        themVatLieuMai: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-vat-lieu-mai-nha',
        themVatLieuTuong: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-vat-lieu-tuong',
        themDienTichDat: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-dien-tich-dat',
        themChanNuoi: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-chan-nuoi',
        themTaiSan: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-tai-san-lau-ben',
        themDienSuDung: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-loai-dien',
        themNuocSinhHoat: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-nuoc-sinh-hoat',
        themLoaiHoXi: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-loai-ho-xi',
        themNguyenNhan: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-nguyen-nhan-kho-khan',
        themCapHoc: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-cap-hoc',
        themLoaiTheBhyt: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-loai-the-bhyt',
        themVanHoa: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-trinh-do-van-hoa',
        themDaoTao: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-trinh-do-dao-tao',
        themDtCs: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-doi-tuong-chinh-sach',
        themLyDo: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-ly-do-khong-kcb',
        themDtHuongTcxh: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-doi-tuong-huong-tc-hang-thang',
        themTinhTrangViecLam: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-tinh-trang-viec-lam',
        themLoaiViecLam: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-loai-viec-lam',
        themViecLamCong: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-viec-lam-cong-an-luong',
        themHonNhan: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-tinh-trang-hon-nhan',
        themMucDoKhuyetTat: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-muc-do-khuyet-tat',
        themPhanLoaiHo: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-phan-loai-ho',
        themChiTietHo: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-chi-tiet-ho',
        capNhatChinhSachHoTro: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-chinh-sach-ho',
        capNhatVatLieuCot: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-vat-lieu-cot-nha',
        capNhatVatLieuMai: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-vat-lieu-mai-nha',
        capNhatVatLieuTuong: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-vat-lieu-tuong',
        capNhatDienTichDat: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-dien-tich-dat',
        capNhatChanNuoi: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-chan-nuoi',
        capNhatTaiSan: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-tai-san-lau-ben',
        capNhatDienSuDung: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-loai-dien',
        capNhatNuocSinhHoat: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-nuoc-sinh-hoat',
        capNhatLoaiHoXi: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-loai-ho-xi',
        capNhatNguyenNhan: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-nguyen-nhan-kho-khan',
        capNhatCapHoc: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-cap-hoc',
        capNhatLoaiTheBhyt: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-loai-the-bhyt',
        capNhatVanHoa: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-trinh-do-van-hoa',
        capNhatDaoTao: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-trinh-do-dao-tao',
        capNhatDtCs: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-doi-tuong-chinh-sach',
        capNhatLyDo: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-ly-do-khong-kcb',
        capNhatDtHuongTcxh: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-doi-tuong-huong-tc-hang-thang',
        capNhatTinhTrangViecLam: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-tinh-trang-viec-lam',
        capNhatLoaiViecLam: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-loai-viec-lam',
        capNhatViecLamCong: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-viec-lam-cong-an-luong',
        capNhatHonNhan: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-tinh-trang-hon-nhan',
        capNhatMucDoKhuyetTat: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-muc-do-khuyet-tat',
        capNhatPhanLoaiHo: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-phan_loai-ho',
        capNhatChiTietHo: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-chi-tiet-ho',
        xoaChinhSachHoTro: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-chinh-sach-ho',
        xoaVatLieuCot: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-vat-lieu-cot-nha',
        xoaVatLieuMai: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-vat-lieu-mai-nha',
        xoaVatLieuTuong: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-vat-lieu-tuong',
        xoaDienTichDat: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-dien-tich-dat',
        xoaChanNuoi: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-danh-muc-chan-nuoi',
        xoaTaiSan: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-tai-san-lau-ben',
        xoaDienSuDung: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-loai-dien',
        xoaNuocSinhHoat: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-nuoc-sinh-hoat',
        xoaLoaiHoXi: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-loai-ho-xi',
        xoaNguyenNhan: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-nguyen-nhan-kho-khan',
        xoaCapHoc: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-cap-hoc',
        xoaLoaiTheBhyt: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-loai-the-bhyt',
        xoaVanHoa: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-trinh-do-van-hoa',
        xoaDaoTao: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-trinh-do-dao-tao',
        xoaDtCs: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-doi-tuong-chinh-sach',
        xoaLyDo: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-ly-do-khong-kcb',
        xoaDtHuongTcxh: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-doi-tuong-huong-tc-hang-thang',
        xoaTinhTrangViecLam: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-tinh-trang-viec-lam',
        xoaLoaiViecLam: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-loai-viec-lam',
        xoaViecLamCong: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-viec-lam-cong-an-luong',
        xoaHonNhan: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-tinh-trang-hon-nhan',
        xoaMucDoKhuyetTat: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-muc-do-khuyet-tat',
        xoaPhanLoaiHo: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-phan_loai-ho',
        xoaChiTietHo: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-chi-tiet-ho',
        loaiDoiTuongThanhVien: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/lay-danh-sach-doi-tuong-tcxh-theo-nhom',
        searchTraCuu: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/tim-kiem-danh-muc-tim-kiem',
        themTraCuu: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-danh-muc-tim-kiem',
        capNhatTraCuu: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-danh-muc-tim-kiem',
        xoaTraCuu: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-danh-muc-tim-kiem',
        searchNgheo: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/tim-kiem-danh-muc-ngheo-can-ngheo',
        themNgheo: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-danh-muc-ngheo-can-ngheo',
        capNhatNgheo: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-danh-muc-ngheo-can-ngheo',
        xoaNgheo: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-danh-muc-ngheo-can-ngheo',
        searchDoiTuongTaiCSBTXH: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/tim-kiem-doi-tuong-tai-co-so-bao-tro',
        themDoiTuongTaiCSBTXH: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/them-doi-tuong-tai-co-so-bao-tro',
        capNhatDoiTuongTaiCSBTXH: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/cap-nhat-doi-tuong-tai-co-so-bao-tro',
        xoaDoiTuongTaiCSBTXH: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/xoa-doi-tuong-tai-co-so-bao-tro',

        // Trung tâm BTXH và đối tượng thuộc trung tâm
        doiTuongPhucVu: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/lay-danh-sach-doi-tuong-phuc-vu',
        loaiHinhTrungTam: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/lay-danh-sach-loai-hinh-trung-tam',
        chiTietLoaiHinh: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/lay-danh-sach-chi-tiet-loai-hinh',
        trungTamTrucThuoc: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/lay-danh-sach-trung-tam-truc-thuoc',
        themMoiTrungTamBtxh: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/them-co-so-btxh',
        timKiemTrungTamBtxh: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/danh-sach-co-so-btxh',
        chiTietTrungTamBtxh: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/chi-tiet-co-so-btxh',
        capNhatTrungTamBtxh: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/cap-nhat-co-so-btxh',
        xoaTrungTamBtxh: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/xoa-khoi-phuc-co-so-btxh',
        trangThaiDoiTuongTaiTrungTam: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/lay-danh-sach-trang-thai-tai-trung-tam',
        loaiDoiTuong: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/lay-danh-sach-loai-doi-tuong-csbtxh',
        chiTietDoiTuong: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/lay-danh-sach-doi-tuong-csbtxh',
        timKiemDoiTuongThuocTtbtxh: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/danh-sach-doi-tuong-tai-co-so-btxh',
        xoaDoiTuong: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/xoa-khoi-phuc-doi-tuong-tai-co-so-btxh',
        hinhThucLuuTru: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/lay-danh-sach-hinh-thuc-luu-tru',
        dichVuDuocCungCap: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/lay-danh-sach-dich-vu',
        themMoiDoiTuongThuocTtbtxh: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/them-doi-tuong-tai-co-so-btxh',
        chiTietDoiTuongTrungTamBtxh: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/chi-tiet-doi-tuong-tai-co-so-btxh',
        capNhatDoiTuongThuocTtbtxh: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/cap-nhat-doi-tuong-tai-co-so-btxh',

        getHoatDongNguoiCaoTuoi: rootUrl_Micro + 'bao-tro-xa-hoi/v2/hoat-dong/danh-sach',
        addHoatDongNguoiCaoTuoi: rootUrl_Micro + 'bao-tro-xa-hoi/v2/hoat-dong/them-moi',
        editHoatDongNguoiCaoTuoi: rootUrl_Micro + "bao-tro-xa-hoi/v2/hoat-dong/cap-nhat",
        getChiTietHoatDongNguoiCaoTuoi: rootUrl_Micro + "bao-tro-xa-hoi/v2/hoat-dong/chi-tiet",
        xoaHoatDongNguoiCaoTuoi: rootUrl_Micro + "bao-tro-xa-hoi/v2/hoat-dong/xoa-khoi-phuc",
        guiDanhSachNguoiCaoTuoi: rootUrl_Micro + "bao-tro-xa-hoi/v2/hoat-dong/gui-danh-sach",
        exportBaoCaoHdNguoiCaoTuoi: rootUrl_Micro + "bao-tro-xa-hoi/v2/hoat-dong/xuat-danh-sach",

        // Covid
        ketQuaTraCuuTroCap: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/search-data-chi-tra',
        chiTietKetQuaTraCuuTroCap: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/chi-tiet-data-chi-tra',
        xuatDanhSachKetQuaTraCuuTroCap: rootUrl_Micro + 'bao-tro-xa-hoi/v2/chi-tra/v2/xuat-excel-data-chi-tra',
        danhMucTrangThaiHoSo: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/trang-thai-hs',

        //Map csdldc
        mapCSDLDC : rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/mapCSDLDC',
        mapCSDLDC_CBG : 'https://am.caobang.gov.vn/apiBTXH/1.0/DanhSachHoSo',
        gettoken_CBG : rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/getToken_CBG',
        templateBTXH: rootUrl_Micro + 'bao-tro-xa-hoi/v2/template-import',
        checkImportBTXH: rootUrl_Micro + 'bao-tro-xa-hoi/v2/check-import-btxh',
        importBTXH: rootUrl_Micro + 'bao-tro-xa-hoi/v2/import-btxh',
        xoaBTXH: rootUrl_Micro + 'bao-tro-xa-hoi/v2/xoa-doi-tuong',


        //Dashboard BTXH
        dashboardTroCapHoNgheo: rootUrl_Micro + 'bao-tro-xa-hoi/dashboard-ho-ngheo/dashboard-tro-cap-ho-ngheo',
        dashboardTroCapBTXH: rootUrl_Micro + 'bao-tro-xa-hoi/dashboard-ho-ngheo/dashboard-tro-cap-btxh',
        dashboardDoiTuongBTXH: rootUrl_Micro + 'bao-tro-xa-hoi/dashboard-ho-ngheo/dashboard-doi-tuong-tro-cap-btxh',


        nhatKy: {
          nhatKyHeThong: rootUrl_Micro + "bao-tro-xa-hoi/logs",
          taiNhatKyHeThong: rootUrl_Micro + "bao-tro-xa-hoi/logs/download",
          getStackTraceDetail: rootUrl_Micro + "bao-tro-xa-hoi/logs/error"
      },


        //Ho trung binh
        addHoTrungBinh: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-trung-binh/them-moi',
        editHoTrungBinh: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-trung-binh/cap-nhat',
        getHoTrungBinh: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-trung-binh/danh-sach',
        xoaHoTrungBinh: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-trung-binh/xoa',
        chiTietHoTrungBinh: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-trung-binh/chi-tiet',
        duyetTuChoiHoTrungBinh: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-trung-binh/duyet-tu-choi',
        tinhThuNhap: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-trung-binh/tinh-thu-nhap',
        addThanhVien: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-trung-binh/them-moi-thanh-vien',
        getThanhVienHo: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-trung-binh/danh-sach-thanh-vien-thuoc-ho',
        capNhatThanhVien: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-trung-binh/cap-nhat-thanh-vien',
        xoaThanhVien: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-trung-binh/xoa-thanh-vien',
        getListThanhVien: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-trung-binh/danh-sach-thanh-vien',
        getChiTietThanhVien: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-trung-binh/chi-tiet-thanh-vien',
        getAllTinhTrangViecLam: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-trung-binh/get-all-tinh-trang-viec-lam',
        getAllLoaiHo: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-trung-binh/get-all-loai-ho',
        exportFileRaSoatHoTrungBinh: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-gia-dinh/v2/xuat-ra-soat-ho-trung-binh',
        updateTrangThaiQuyTrinh: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-trung-binh/cap-nhat-trang-thai-ho-trung-binh',
        themMoiThongTinBHXH : rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-trung-binh/them-moi-bhxh',
        capNhatThongTinBHXH : rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-trung-binh/cap-nhat-bhxh',
        xoaKhoiPhucThongTinBHXH : rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-trung-binh/xoa-thong-tin-bhxh',
        timKiemThongTinBHXH : rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-trung-binh/tim-kiem-bhxh',
        xuatThongTinBHXH : rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-trung-binh/xuat-doi-tuong-bhxh',
        QD_CN_HTB: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-trung-binh/qd-cn-ho-trung-binh',
        exportDonDeNghi: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-trung-binh/quy-trinh-ho-trung-binh/xuat-de-nghi',
        chuyenQuyetDinh: rootUrl_Micro + 'file/btxh/ho-trung-binh/chuyenFileQLVB',
        getQuyetDinh: rootUrl_Micro + 'file/btxh/ho-trung-binh/danh-sach-file-chuyen-qlvb',
        downloadQuyetDinh: rootUrl_Micro + 'file/btxh/ho-trung-binh/danh-sach-file-chuyen-qlvb/downloadFile',
        //quy trinh ho trung binh
        getListHTBTheoXa: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/quy-trinh-ho-trung-binh/danh-sach-theo-xa',
        getChiTietHTB: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/quy-trinh-ho-trung-binh/chi-tiet-danh-sach',
        updateTrangThaiHTB: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/quy-trinh-ho-trung-binh/cap-nhat-trang-thai-quy-trinh',
        phanAnhHTB: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/quy-trinh-ho-trung-binh/phan-anh',
        khoaHTB: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/quy-trinh-ho-trung-binh/mo-khoa-thao-tac',
        uploadFileHTB: rootUrl_Micro + 'file/btxh/ho-trung-binh/uploadFile',
        downloadFileHTB: rootUrl_Micro + 'file/btxh/ho-trung-binh/downloadFile',
        downloadListHoTrungBinh: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-trung-binh/xuat-danh-sach-ho-trung-binh',
        getDmNghe: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/quy-trinh-ho-trung-binh/get-all-danh-muc-nghe',
        BCTheoNam: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/bao-cao/bao-cao-ho-trung-binh-theo-nam',
        BCTheoQuy: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/bao-cao/bao-cao-ho-trung-binh-theo-quy',
        BCTheoNgheNghiep: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/bao-cao/bao-cao-ho-trung-binh-theo-nghe-nghiep',
        BCTheoDiaBan: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/bao-cao/bao-cao-ho-trung-binh-theo-dia-ban',
        BCTheoDoTuoi: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/bao-cao/bao-cao-ho-trung-binh-theo-do-tuoi',
        getSoluongHTB: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/bao-cao/dashboard-so-luong-ho-trung-binh',
        getSoluongBHYT: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/bao-cao/dashboard-so-luong-bhyt',
        getThuNhapHTB: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/bao-cao/dashboard-thu-nhap-binh-quan',
        getAllListPhieuKhaoSat: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-trung-binh/get-all-phieu-khao-sat',
        xuatPhieuKhaoSat: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-trung-binh/xuat-phieu-khao-sat-ho',
        xuatDanhSachDangKy: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/bao-cao/danh-sach-dang-ky',
        xuatDanhSachDaRaSoat: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/bao-cao/danh-sach-da-khao-sat',
        xuatDanhSachDaNiemYet: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/bao-cao/danh-sach-da-niem-yet',
        xuatDanhSachCongNhan: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/bao-cao/danh-sach-cong-nhan',
        xuatDanhSachDangKyDaoTaoNghe: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/bao-cao/danh-sach-nhu-cau-dao-tao-nghe',
        getChinhSachHoTro: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-trung-binh/danh-sach-doi-tuong-duoc-ho-tro',
        xacNhanThamGiaBHYT: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-trung-binh/them-doi-tuong-duoc-ho-tro-bhyt',
        updateHoTroDaoTaoNghe: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-trung-binh/them-ho-tro-hoc-nghe',
        getDanhMucNgheHoTro: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-trung-binh/get-all-nghe-ho-tro',
        xuatDanhSachHoTroDaoTaoNghe: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/bao-cao/danh-sach-ho-tro-dao-tao-nghe',
        xuatDanhSachDangKyBHYT: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-trung-binh/xuat-doi-tuong-bhxh',
        xuatDanhSachChinhSachHoTro: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-trung-binh/danh-sach-doi-tuong-ho-tro-chinh-sach',
        xuatTemplateHoGiaDinh: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-trung-binh/xuat-template-ho-trung-binh-quy-trinh-moi',
        importHoGiaDinh: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-trung-binh/import-ho-trung-binh-quy-trinh-moi',
        baoCaoDanhSachDangKy: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/bao-cao/bao-cao-danh-sach-dang-ky',
        baoCaoDanhSachDaRaSoat: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/bao-cao/bao-cao-danh-sach-da-khao-sat',
        baoCaoDanhSachDaNiemYet: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/bao-cao/bao-cao-danh-sach-da-niem-yet',
        baoCaoDanhSachCongNhan: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/bao-cao/bao-cao-danh-sach-cong-nhan',
        baoCaoDanhSachPhanAnh: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/bao-cao/bao-cao-danh-sach-phan-anh',
        baoCaoDanhSachConTGCongNhan: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/bao-cao/bao-cao-danh-sach-ho-con-thoi-han-cong-nhan',
        //Người dùng HTB
        getListNguoiDung: rootUrl_Micro + 'bao-tro-xa-hoi/v2/ho-trung-binh/nguoi-dung-htb/danh-sach',
        chiTietNguoiDung: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/nguoi-dung-htb/chi-tiet-nguoi-dung',
        resetPass: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/nguoi-dung-htb/reset-mat-khau',
        deleteUserHTB: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/nguoi-dung-htb/xoa-nguoi-dung',
        khoiPhucUserHTB: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/nguoi-dung-htb/khoi-phuc',
        deleteUserHTBRaKhoiHT: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/nguoi-dung-htb/xoa-khoi-he-thong',
        checkTenTonTaiBTXH: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/nguoi-dung-htb/check-ton-tai-ten-dang-nhap',
        thayDoiUsernameBTXH: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/nguoi-dung-htb/thay-doi-ten-dang-nhap',
        checkTrungusername: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/nguoi-dung-htb/check-ton-tai-ten-dang-nhap',
        editUsername: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/nguoi-dung-htb/thay-doi-ten-dang-nhap',
        editUserHTB: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/nguoi-dung-htb/sua',
        registerUserHTB: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/nguoi-dung-htb/dang-ky',
        getXacDinhMucHTB: rootUrl_Micro + 'bao-tro-xa-hoi/danh-muc/muc-xac-dinh-hien-hanh',
        getDanhSachFileChuyenQLVB: rootUrl_Micro + 'file/btxh/ho-trung-binh/danh-sach-file-chuyen-qlvb',
        dongBoTrangThai: rootUrl_Micro + 'file/btxh/ho-trung-binh/dong-bo-trang-thai',
        chiTietQLVB: rootUrl_Micro + 'file/qlvb/get-chi-tiet-qlvb',
        uploadFileChuyenQLVB: rootUrl_Micro + 'file/btxh/ho-trung-binh/chuyenFileQLVB/uploadFile',
        danhSachFileDinhKemTheoId: rootUrl_Micro + 'file/btxh/ho-trung-binh/danh-sach-file-dinh-kem-theo-id',
        downloadFileUpload: rootUrl_Micro + 'file/qlvb/danh-sach-file-chuyen-qlvb/downloadFile',
        getTrangThaiVanBan: rootUrl_Micro + 'file/qlvb/get-all-trang-thai-vb',

        KIEM_DINH: {
          addHoTrungBinh: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/them-moi',
          editHoTrungBinh: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/cap-nhat',
          getHoTrungBinh: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/danh-sach',
          xoaHoTrungBinh: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/xoa',
          chiTietHoTrungBinh: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/chi-tiet',
          duyetTuChoiHoTrungBinh: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/duyet-tu-choi',
          tinhThuNhap: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/tinh-thu-nhap',
          addThanhVien: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/them-moi-thanh-vien',
          getThanhVienHo: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/danh-sach-thanh-vien-thuoc-ho',
          capNhatThanhVien: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/cap-nhat-thanh-vien',
          xoaThanhVien: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/xoa-thanh-vien',
          getListThanhVien: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/danh-sach-thanh-vien',
          getChiTietThanhVien: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/chi-tiet-thanh-vien',
          getAllTinhTrangViecLam: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/get-all-tinh-trang-viec-lam',
          getAllLoaiHo: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/get-all-loai-ho',
          exportFileRaSoatHoTrungBinh: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/xuat-ra-soat-ho-trung-binh',
          updateTrangThaiQuyTrinh: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/cap-nhat-trang-thai-ho-trung-binh',
          themMoiThongTinBHXH : rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/them-moi-bhxh',
          capNhatThongTinBHXH : rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/cap-nhat-bhxh',
          xoaKhoiPhucThongTinBHXH : rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/xoa-thong-tin-bhxh',
          timKiemThongTinBHXH : rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/tim-kiem-bhxh',
          xuatThongTinBHXH : rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/xuat-doi-tuong-bhxh',
          QD_CN_HTB: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/kiem-dinh/qd-cn-ho-trung-binh',
          exportDonDeNghi: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/quy-trinh-ho-trung-binh/xuat-de-nghi',
          //quy trinh ho trung binh
          getListHTBTheoXa: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/quy-trinh-ho-trung-binh/danh-sach-theo-xa',
          getChiTietHTB: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/quy-trinh-ho-trung-binh/chi-tiet-danh-sach',
          updateTrangThaiHTB: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/quy-trinh-ho-trung-binh/cap-nhat-trang-thai-quy-trinh',
          phanAnhHTB: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/quy-trinh-ho-trung-binh/phan-anh',
          khoaHTB: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/quy-trinh-ho-trung-binh/mo-khoa-thao-tac',
          uploadFileHTB: rootUrl_Micro + 'file/btxh/ho-trung-binh/kiem-dinh/uploadFile',
          downloadFileHTB: rootUrl_Micro + 'file/btxh/ho-trung-binh/kiem-dinh/downloadFile',
          downloadListHoTrungBinh: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/xuat-danh-sach-ho-trung-binh',
          getDmNghe: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/quy-trinh-ho-trung-binh/get-all-danh-muc-nghe',
          BCTheoNam: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/bao-cao/bao-cao-ho-trung-binh-theo-nam',
          BCTheoQuy: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/bao-cao/bao-cao-ho-trung-binh-theo-quy',
          BCTheoNgheNghiep: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/bao-cao/bao-cao-ho-trung-binh-theo-nghe-nghiep',
          BCTheoDiaBan: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/bao-cao/bao-cao-ho-trung-binh-theo-dia-ban',
          BCTheoDoTuoi: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/bao-cao/bao-cao-ho-trung-binh-theo-do-tuoi',
          getSoluongHTB: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/bao-cao/dashboard-so-luong-ho-trung-binh',
          getSoluongBHYT: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/bao-cao/dashboard-so-luong-bhyt',
          getThuNhapHTB: rootUrl_Micro + 'bao-tro-xa-hoi/ho-trung-binh/kiem-dinh/bao-cao/dashboard-thu-nhap-binh-quan',
        }
    },

    // Người có công
    NGUOI_CO_CONG: {
      TABS: rootUrl_Micro + 'danh-muc/danh-muc-tab-ncc/danh-sach',
        MODE: rootUrl_Micro + 'ncc/thong-tin-che-do-duoc-huong',
        EXPORT_PDF_INVESTIGATE: rootUrl_Micro + 'ncc/record/exportPdfInvestigate',
        DELETE: rootUrl_Micro + "ncc/dungchung/xoa-ho-so",
        BASICINFO: rootUrl_Micro + 'bao-tro-xa-hoi/v2/thanh-vien/v2/thong-tin-co-ban-by-cmnd',
        TEMPLATE: rootUrl_Micro + 'get-data/ncc/import/template-import-ncc',
        IMPORT: rootUrl_Micro + 'get-data/ncc/import/import-ncc-from-template',
        IMPORT_MO: rootUrl_Micro + 'get-data/ncc/import/import-mo-ncc-agg',
        TEMPLATE_IMPORT_MO: rootUrl_Micro + 'get-data/ncc/import/template-import-mo-ncc-agg',
        TEMPLATE_TB_LS: rootUrl_Micro + 'ncc/template-import-ncc-tb-ls',
        IMPORT_TB: rootUrl_Micro + 'ncc/import-ncc-from-template-tb',
        IMPORT_LS: rootUrl_Micro + 'ncc/import-ncc-from-template-ls',
        LOG: {
            UPDATE: rootUrl_Micro + "ncc/record/ghi-log-v2",
            GET: rootUrl_Micro + "ncc/record/log",
            GET_ALL: rootUrl_Micro + "ncc/record/get-all-log",
            GET_DETAIL: rootUrl_Micro + "ncc/record/log-detail"
        },
        LOG_SYSTEM: {
          nhatKyHeThong: rootUrl_Micro + "ncc/logs",
          taiNhatKyHeThong: rootUrl_Micro + "ncc/logs/download",
          getStackTraceDetail: rootUrl_Micro + "ncc/logs/error"
        },
        SEARCH: {
            RECORD_TYPE: rootUrl_Micro + 'danh-muc/danh-muc-loai-ho-so-ncc/danh-sach',
            PROVINCE: rootUrl_Micro + 'ncc/huyen/tinh',
            DISTRICT: rootUrl_Micro + 'ncc/huyen/list',
            TOWN: rootUrl_Micro + 'ncc/xa/list',
            NATION: rootUrl_Micro + 'ncc/dan-toc/list',
            SEARCH: rootUrl_Micro + 'ncc/record/search',
            EXPORT: rootUrl_Micro + 'ncc/record/export',
            EXPORT_PDF: rootUrl_Micro + 'ncc/record/exportPdf'
        },
        HO_SO_LIET_SI: {
            GENERAL_INFORMATION: {
                CATEGORY: rootUrl_Micro + 'ncc/record/category'
            },
            ATTACHMENT_INFORMATION: {
                GET: rootUrl_Micro + 'ncc/file/listFile',
                UPLOAD: rootUrl_Micro + 'file/ncc/uploadFilev2',
                DELETE: rootUrl_Micro + 'ncc/file/deleteFile',
                DOWNLOAD: rootUrl_Micro + 'file/ncc/downloadFile',
                DOWNLOAD_ALL: rootUrl_Micro + 'ncc/file/zipFile',
            }
        },
        HO_SO_BA_ME_VN_ANH_HUNG: {
            MARTYRS_INFORMATION: {
                GET: rootUrl_Micro + 'ncc/me-anh-hung/danh-sach-con',
                UPDATE: rootUrl_Micro + 'ncc/me-anh-hung/cap-nhat-con',
                DELETE: rootUrl_Micro + 'ncc/me-anh-hung/xoa-con',
            }
        },


        TIM_KIEM_HO_SO: rootUrl_Micro + 'ncc/ho-so-chung/search',
        TIM_KIEM_HO_SO_NANG_CAO : rootUrl_Micro + 'ncc/ho-so-chung/tim-kiem-nang-cao-hgi',
        // TIM_KIEM_HO_SO_NANG_CAO :'http://localhost:9009/sldtbxh/ncc/ho-so-chung/tim-kiem-nang-cao-hgi',
        HO_SO_CHUNG: rootUrl_Micro + 'ncc/ho-so-chung',
        HO_SO_CM45_NEW: rootUrl_Micro + 'ncc/ho-so-hdcm-truoc-1945',
        HO_SO_CM45_TKN_NEW: rootUrl_Micro + 'ncc/ho-so-hdcm-tu-1945-den-tkn',
        HO_SO_ME_VN_NEW: rootUrl_Micro + 'ncc/ho-so-ba-me-viet-nam-anh-hung',
        HO_SO_AH_LLVT_ND_NEW: rootUrl_Micro + 'ncc/ho-so-anh-hung-luc-luong-vu-trang',
        HO_SO_NCC_GD_CM: rootUrl_Micro + 'ncc/ho-so-ncc-giup-do-cach-mang',
        HO_SO_TB_NEW: rootUrl_Micro + 'ncc/ho-so-thuong-binh',
        HO_SO_BB_NEW: rootUrl_Micro + 'ncc/ho-so-benh-binh',
        HO_SO_CDHH_NEW: rootUrl_Micro + 'ncc/ho-so-nguoi-hdcm-va-con-de-cdhh',
        HO_SO_LS: rootUrl_Micro + 'ncc/ho-so-liet-si',
        HO_SO_QN_XN: rootUrl_Micro + 'ncc/ho-so-quan-nhan-xuat-ngu',
        HO_SO_CA_XN: rootUrl_Micro + 'ncc/ho-so-cong-an-xuat-ngu',
        HO_SO_62: rootUrl_Micro + 'ncc/ho-so-doi-tuong-huong-theo-qd62',
        HO_SO_290: rootUrl_Micro + 'ncc/ho-so-doi-tuong-huong-theo-qd290',
        HO_SO_HDCM_GPDT_BVTQ: rootUrl_Micro + 'ncc/ho-so-nguoi-hdcm-gpdt-bvtq',
        HO_SO_MO_LS: rootUrl_Micro + 'ncc/ho-so-mo-liet-si',
        HO_SO_TNXP_NEW: rootUrl_Micro + 'ncc/ho-so-thanh-nien-xung-phong',
        HO_SO_CTGCLS: rootUrl_Micro + 'ncc/ho-so-cong-trinh-ghi-cong-liet-si',
        HO_SO_NTN: rootUrl_Micro + 'ncc/ho-so-nha-tinh-nghia',
        HO_SO_57: rootUrl_Micro + 'ncc/ho-so-doi-tuong-huong-theo-qd57',
        HO_SO_BTQGC: rootUrl_Micro + 'ncc/ho-so-bang-to-quoc-ghi-cong',
        HO_SO_CHINH_HINH_NEW: rootUrl_Micro + 'ncc/ho-so-chinh-hinh',
        HO_SO_UU_DAI_GIAO_DUC: rootUrl_Micro + 'ncc/ho-so-uu-dai-giao-duc',
        KIEM_TRA_TRUNG_HO_SO: rootUrl_Micro + 'ncc/kiem-tra-trung-ho-so',
        KIEM_TRA_TRUNG_THONG_TIN_QUA: rootUrl_Micro + 'ncc/kiem-tra-trung-thong-tin-qua',


        HO_SO_MO_LIET_SY: {
            NGHIA_TRANG: {
                INSERT: rootUrl_Micro + 'ncc/molietsy/them-moi-nghia-trang',
                SEARCH: rootUrl_Micro + 'ncc/molietsy/tim-kiem-nghia-trang',
                UPLOAD: rootUrl_Micro + 'file/ncc/uploadFile-mo',
                DELETE: rootUrl_Micro + 'ncc/molietsy/xoa-nghia-trang',
                UPDATE: rootUrl_Micro + 'ncc/molietsy/cap-nhat-nghia-trang',
                UPDATE_GEOJSON: rootUrl_Micro + 'ncc/molietsy/cap-nhat-geojson-nghia-trang',
                DELETE_IMG: rootUrl_Micro + 'ncc/molietsy/xoa-hinh-nghia-trang-v2',
                SELECT: rootUrl_Micro + 'ncc/molietsy/danh-sach-nghia-trang'
            },
            KHU_LO_HANG: {
                SELECT: rootUrl_Micro + 'ncc/molietsy/danh-sach-khu-lo-hang',
                INSERT: rootUrl_Micro + 'ncc/molietsy/them-khu-lo-hang',
                UPDATE: rootUrl_Micro + 'ncc/molietsy/cap-nhat-khu-lo-hang',
                DELETE: rootUrl_Micro + 'ncc/molietsy/xoa-khu-lo-hang',
                IMPORT: rootUrl_Micro + 'ncc/molietsy/import-nghia-trang',
                TEMPLATE: rootUrl_Micro + 'file/ncc/downloadFile/8142aced-70c9-417f-a62a-bed879f8b84e'
            },
            SEARCH_LIST: rootUrl_Micro + 'ncc/ho-so-mo-liet-si/search',
            NHA_BIA_DEN_THO: {
              INSERT: rootUrl_Micro + 'ncc/molietsy/them-moi-nha-bia-den-tho',
              SEARCH: rootUrl_Micro + 'ncc/molietsy/tim-kiem-nha-bia-den-tho',
              UPLOAD: rootUrl_Micro + 'file/ncc/uploadFile-file-nha-bia-den-tho',
              DELETE: rootUrl_Micro + 'ncc/molietsy/xoa-nha-bia-den-tho',
              UPDATE: rootUrl_Micro + 'ncc/molietsy/cap-nhat-nha-bia-den-tho',
              UPDATE_GEOJSON: rootUrl_Micro + 'ncc/molietsy/cap-nhat-geojson-nghia-trang',
              DELETE_IMG: rootUrl_Micro + 'ncc/molietsy/xoa-hinh-nha-bia-den-tho',
              SELECT: rootUrl_Micro + 'ncc/molietsy/danh-sach-nha-bia-den-tho'
          },
        },
        BAO_CAO: {
            TONG_HOP: rootUrl_Micro + 'ncc/baocao/thong-ke-tong-hop-v2',
            CHUNG: rootUrl_Micro + 'ncc/baocao/thong-ke-chung',
            TONG_HOP_EXCEL: rootUrl_Micro + 'get-data/ncc/baocao/thong-ke-tong-hop-excel-v2',
            DANH_MUC_CHI_TRA: rootUrl_Micro + 'ncc/baocao/danh-muc-dv-hanh-chinh',
            DANH_MUC_TRO_CAP_MOT_LAN: rootUrl_Micro + 'get-data/ncc/baocao/danh-muc-loai-tc-mot-lan',
            DANH_MUC_TRO_CAP_THANG: rootUrl_Micro + 'get-data/ncc/baocao/danh-muc-loai-tc-hang-thang-v2',
            REPORT_ONE_TIMES: rootUrl_Micro + 'get-data/ncc/baocao/chitratrocapmotlan',
            REPORT_MONTH: rootUrl_Micro + 'get-data/ncc/baocao/chitrahangthang',
            REPORT_ONE_TIMES_Q: rootUrl_Micro + 'get-data/ncc/baocao/chitratrocapmotlan-quy',
            REPORT_PAYMENT_MONTH: rootUrl_Micro + 'get-data/ncc/baocao/chitratrocaphangthang-v2',
            DUPLICATE_PROFILE_V2: rootUrl_Micro + 'ncc/baocao/thong-ke-ds-trung-dt-v3',
            DESICION_STATUS_REPORT: rootUrl_Micro + 'ncc/quyetdinh/bao-cao-quyet-dinh-theo-quy?',
            QD62: rootUrl_Micro + 'ncc/quyetdinh/danh-sach-thong-ke-quyet-dinh',
            EXPORTQD62: rootUrl_Micro + 'ncc/quyetdinh/xuat-danh-sach-thong-ke-quyet-dinh',
            THKP_LIST: rootUrl_Micro + 'ncc/baocao/ds-tong-hop-kinh-phi-p1?',
            THKP_REPORT: rootUrl_Micro + 'ncc/baocao/tong-hop-kinh-phi-p1?',
            SAVE_THKP_REPORT: rootUrl_Micro + 'ncc/baocao/ds-tong-hop-kinh-phi-p1-save',
            THKP_P2_LIST: rootUrl_Micro + 'ncc/baocao/ds-tong-hop-kinh-phi-p2?',
            THKP_P2_REPORT: rootUrl_Micro + 'ncc/baocao/tong-hop-kinh-phi-p2?',
            SAVE_THKP_P2_REPORT: rootUrl_Micro + 'ncc/baocao/ds-tong-hop-kinh-phi-p2-save',
            BCTHCTML: rootUrl_Micro + 'ncc/baocao/bc-tinh-hinh-chi-tra-mot-lan?',
            DSTCHT: rootUrl_Micro + 'ncc/baocao/bc-danh-sach-doi-tuong-tro-cap-hang-thang?',
            DSH2CD: rootUrl_Micro + 'ncc/baocao/bc-danh-sach-doi-tuong-tro-cap-2-che-do?',
            DSCTTCML: rootUrl_Micro + 'ncc/baocao/bc-danh-sach-chi-tra-mot-lan-theo-thang',
            BANG_THKP: rootUrl_Micro + 'ncc/baocao/bang-tong-hop-kinh-phi',
            EXPORT_THONG_KE_CHI_TRA: rootUrl_Micro + 'get-data/ncc/baocao/thong-ke-chi-tra',
            THONG_KE_HO_SO: rootUrl_Micro + 'get-data/ncc/baocao/thong-ke-ho-so',
            BAO_CAO_C73: rootUrl_Micro + 'get-data/ncc/quyetdinh/xuat-bang-ke-chi-tra-mau-c73',
            BAO_CAO_C64: rootUrl_Micro + 'get-data/ncc/quyetdinh/xuat-bao-cao-giam-chi-tra-tro-cap-c64',
            BAO_CAO_301: rootUrl_Micro + 'get-data/ncc/quyetdinh/bao-cao-so-nguoi-co-cong-chia-theo-loai-doi-tuong-301',
            BAO_CAO_B07: rootUrl_Micro + 'get-data/ncc/quyetdinh/xuat-bao-cao-tro-cap-mot-lan-mau-b07-v2',
            BAO_CAO_B09: rootUrl_Micro + 'get-data/ncc/chitra/xuat-bao-cao-tro-cap-uu-dai-giao-duc-mau-b09',
            BAO_CAO_BIEU_1: rootUrl_Micro + 'get-data/ncc/chitra/xuat-bao-cao-so-luong-doi-tuong-dang-huong-hang-thang',
            BAO_CAO_BIEU_2: rootUrl_Micro + 'get-data/ncc/chitra/xuat-bao-cao-so-luong-doi-tuong-tb-hang-thang',
            BAO_CAO_BIEU_5: rootUrl_Micro + 'get-data/ncc/chitra/xuat-bao-cao-so-luong-doi-tuong-dang-huong-mot-lan',
            BAO_CAO_S73: rootUrl_Micro + 'get-data/ncc/chitra/xuat-so-quan-ly-doi-tuong-hang-thang',
            BAO_CAO_BIEU_3: rootUrl_Micro + 'get-data/ncc/quyetdinh/xuat-bao-cao-tong-hop-mau-3-gui-bo',
            BAO_CAO_BIEU_4: rootUrl_Micro + 'get-data/ncc/quyetdinh/xuat-bao-cao-tong-hop-mau-4-gui-bo',
            BAO_CAO_C75: rootUrl_Micro + 'get-data/ncc/chitra/xuat-bao-cao-giam-doi-tuong-c75',
            BAO_CAO_304: rootUrl_Micro + 'ncc/baocao/tong-hop-304'
        },
        CATEGORY: {
            PERMISSTION: rootUrl_Micro + 'danh-muc/danh-muc-phan-quyen-v2',
            SCREEN: {
                GET: rootUrl_Micro + 'danh-muc/danh-muc-screen',
                UPDATE: rootUrl_Micro + 'danh-muc/cap-nhat-screen',
            },
            ACTION: {
                GET: rootUrl_Micro + 'danh-muc/danh-muc-action-v2',
                UPDATE: rootUrl_Micro + 'danh-muc/cap-nhat-action',
            },
            ACTION_TYPE: {
                GET: rootUrl_Micro + 'danh-muc/danh-muc-actiontype',
                UPDATE: rootUrl_Micro + 'danh-muc/cap-nhat-actiontype',
            },
            ROLE: {
                GET: rootUrl_Micro + 'danh-muc/danh-muc-chuc-danh-phan-quyen',
                UPDATE: rootUrl_Micro + 'danh-muc/cap-nhat-chuc-danh',
            },
            ROLE_AUTHORITY: {
                GET: rootUrl_Micro + 'danh-muc/danh-muc-roleauthority-phan-quyen',
                UPDATE: rootUrl_Micro + 'danh-muc/cap-nhat-roleauthority',
            },
            GROUP: {
                GET: rootUrl_Micro + 'danh-muc/danh-muc-nhomquyen',
                UPDATE: rootUrl_Micro + 'danh-muc/cap-nhat-nhomquyen',
            },
            GENERATE: {
                LOAI_HO_SO: {
                    // GET: rootUrl_Micro + 'danh-muc/danh-muc-loaihoso-master',
                    // UPDATE: rootUrl_Micro + 'danh-muc/cap-nhat-loaihoso-master',
                    // RECOVERY: rootUrl_Micro + 'danh-muc/khoi-phuc-loaihoso-master',
                    GET: rootUrl_Micro + 'danh-muc/danh-muc-loai-ho-so-ncc/tim-kiem',
                    UPDATE: rootUrl_Micro + 'danh-muc/danh-muc-loai-ho-so-ncc',
                    LIST: rootUrl_Micro + 'danh-muc/danh-muc-loai-ho-so-ncc/danh-sach',
                },
                TAB: {
                    // GET: rootUrl_Micro + 'danh-muc/danh-muc-tab-master',
                    // UPDATE: rootUrl_Micro + 'danh-muc/cap-nhat-tab-master',
                    GET: rootUrl_Micro + 'danh-muc/danh-muc-tab-ncc/tim-kiem',
                    LIST: rootUrl_Micro + 'danh-muc/danh-muc-tab-ncc/danh-sach',
                    DELETE: rootUrl_Micro + 'danh-muc/danh-muc-tab-ncc',
                    UPDATE: rootUrl_Micro + 'danh-muc/danh-muc-tab-ncc'
                },
                LOAI_THUONG_TAT: {
                    GET: rootUrl_Micro + 'danh-muc/danh-muc-loaithuongtat-master',
                    UPDATE: rootUrl_Micro + 'danh-muc/cap-nhat-loaithuongtat-master',
                },
                TINH_HINH_VIEC_LAM: {
                    GET: rootUrl_Micro + 'danh-muc/danh-muc-tinhhinhvieclam-master',
                    UPDATE: rootUrl_Micro + 'danh-muc/cap-nhat-tinhhinhvieclam-master',
                },
                CHE_DO_QUAN_NHAN: {
                    GET: rootUrl_Micro + 'danh-muc/danh-muc-chodoquannhan-master',
                    UPDATE: rootUrl_Micro + 'danh-muc/cap-nhat-chedoquannhan-master',
                },
                LOAI_CAP_NHA_TINH_NGHIA: {
                    GET: rootUrl_Micro + 'danh-muc/danh-muc-loaicapnhatinhnghia-master',
                    UPDATE: rootUrl_Micro + 'danh-muc/cap-nhat-loaicapnhatinhnghia-master',
                },
                LOAI_THU_NHAP_GIA_DINH: {
                    GET: rootUrl_Micro + 'danh-muc/danh-muc-loaithunhapgiadinh-master',
                    UPDATE: rootUrl_Micro + 'danh-muc/cap-nhat-loaithunhapgiadinh-master',
                },
                LUONG_SINH_HOAT_PHI: {
                    GET: rootUrl_Micro + 'danh-muc/danh-muc-luongsinhhoatphi-master',
                    UPDATE: rootUrl_Micro + 'danh-muc/cap-nhat-luongsinhhoatphi-master',
                },
                NGUON_GOC_HO_SO: {
                    GET: rootUrl_Micro + 'danh-muc/danh-muc-nguongochoso-master',
                    UPDATE: rootUrl_Micro + 'danh-muc/cap-nhat-nguongochoso-master',
                },
                THOI_KY: {
                    GET: rootUrl_Micro + 'danh-muc/danh-muc-thoiky-master',
                    UPDATE: rootUrl_Micro + 'danh-muc/cap-nhat-thoiky-master',
                },
                TINH_HINH_NHA_O: {
                    GET: rootUrl_Micro + 'danh-muc/danh-muc-tinhhinhnhao-master',
                    UPDATE: rootUrl_Micro + 'danh-muc/cap-nhat-tinhhinhnhao-master',
                },
                DOI_TUONG: {
                    GET: rootUrl_Micro + 'danh-muc/danh-muc-doituong-master',
                    UPDATE: rootUrl_Micro + 'danh-muc/cap-nhat-doituong-master',
                },
                MOI_QUAN_HE_GIA_DINH: {
                    GET: rootUrl_Micro + 'danh-muc/danh-muc-moiquanhegiadinh-master',
                    UPDATE: rootUrl_Micro + 'danh-muc/cap-nhat-moiquanhegiadinh-master',
                },
                DUOC_NHA_NUOC_PHONG_TANG: {
                    GET: rootUrl_Micro + 'danh-muc/danh-muc-duocnhanuocphongtang-master',
                    UPDATE: rootUrl_Micro + 'danh-muc/cap-nhat-duocnhanuocphongtang-master',
                },
                LOAI_HO_SO_MOI: {
                    GET: rootUrl_Micro + 'danh-muc/danh-muc-loaihosomoi-master',
                    UPDATE: rootUrl_Micro + 'danh-muc/cap-nhat-loaihosomoi-master',
                },
                SO_QUYET_DINH: {
                    GET: rootUrl_Micro + 'ncc/quyetdinh/get-can-cu-quyet-dinh',
                    UPDATE: rootUrl_Micro + 'ncc/quyetdinh/update-can-cu-quyet-dinh',
                    DELETE: rootUrl_Micro + 'ncc/quyetdinh/delete-can-cu-quyet-dinh'
                },
                TINH_TRANG_CA_NHAN: {
                    GET: rootUrl_Micro + "danh-muc/danh-muc-tinhtrangcanhan-master",
                    UPDATE: rootUrl_Micro + "danh-muc/cap-nhat-tinhtrangcanhan-master"
                }
            },
            MENU: {
                GET: rootUrl_Micro + 'danh-muc/danh-muc-menu-v2',
                UPDATE: rootUrl_Micro + 'danh-muc/cap-nhat-menu',
            },
        },
        QUYET_DINH: {
          DANH_MUC: rootUrl_Micro + 'get-data/ncc/quyetdinh/danh-muc',
          PATH: rootUrl_Micro + 'get-data/ncc/quyetdinh/',
          PATHOLD: rootUrl_Micro + 'ncc/quyetdinh/',
          QD_VO_LIET_SI: rootUrl_Micro + 'get-data/ncc/quyetdinh/quyet-dinh-vo-liet-si',
          TRO_CAP_UU_DAI_GIAO_DUC: rootUrl_Micro + 'get-data/ncc/quyetdinh/xuat-quyet-dinh-tro-cap-uu-dai-gdnn',
          QD_DINH_CHINH: 'quyet-dinh-sua-doi-bo-sung-ho-so-75',
          QD_THAN_NHAN: 'quyet-dinh-xac-nhan-than-nhan-45',
          QD_TRO_CAP_QUA_DOI: 'xuat-quyet-dinh-tro-cap-khi-qua-doi',
          QD_TAM_DUNG_TRO_CAP: 'xuat-qd-tam-dung-tro-cap-ncc-mau-72',
          QD_HUONG_LAI: 'xuat-qd-huong-lai-mau-73',
          GIAY_GIOI_THIEU: 'giay-gioi-thieu-chi-tra-c61',

          QD_TRO_CAP_THO_CUNG: 'xuat-quyet-dinh-tro-cap-tho-cung-liet-si', //55
          QD_TRO_CAP_TUAT_CHO_THAN_NHAN: 'xuat-qd-tro-cap-tuat-than-nhan-liet-si-mau-53',
          QD_BO_SUNG_THAN_NHAN: 'xuat-qd-bo-sung-than-nhan-liet-si-mau-56',
          QD_TRO_CAP_UU_DAI_AHLLVT: 'xuat-qd-tro-cap-uu-dai-ahllvt-ahld-mau-58',
          TRO_CAP_TUAT_THAN_NHAN_LIET_SI: 'xuat-qd-tro-cap-tuat-than-nhan-liet-si-mau-54',
          QD_TRO_CAP_CON_NHIEM_CDHH: 'xuat-qd-tro-cap-con-nhiem-cdhh-mau-65',
          QD_TRO_CAP_PHU_CAP_NHIEM_CDHH: 'xuat-qd-cap-gcn-tro-cap-phu-cap-nhiem-cdhh-mau-64',

          DIEU_DUONG: rootUrl_Micro + 'get-data/ncc/quyetdinh/xuat-quyet-dinh-tro-cap-dieu-duong-mau-68',
          TRICH_LUC_HO_SO: rootUrl_Micro + 'get-data/ncc/quyetdinh/xuat-trich-luc-',
          DUNG_CU_CHINH_HINH: rootUrl_Micro + 'get-data/ncc/quyetdinh/xuat-quyet-dinh-tro-cap-chinh-hinh-mau-69',
          THAN_NHAN_MOT_LAN_KHI_BAO_TU: 'xuat-quyet-dinh-cap-gcn-than-nhan-tro-cap-ml-khi-bao-tu-mau-52',
          XUAT_QUYET_DINH_TQGC: rootUrl_Micro + 'get-data/ncc/quyetdinh/xuat-bang-to-quoc-ghi-cong-104',
          EXPORT_DCCH: rootUrl_Micro + 'ncc/chi-tra/chi-tra-dung-cu-chinh-hinh/export-dcch',
        },
        CHI_TRA: {
            CHINH_SACH: rootUrl_Micro + 'ncc/chitra/thong-tin-chitrachinhsach',
            LOAI_DOI_TUONG_MOT_LAN: rootUrl_Micro + 'ncc/chitra/thong-tin-chitra1lan',
            NHOM_DOI_TUONG_MOT_LAN: rootUrl_Micro + 'ncc/chitra/thong-tin-chitranhomttcml',
            LOAI_DOI_TUONG: rootUrl_Micro + 'ncc/chitra/thong-tin-chitraloaidt',
            NHOM_DOI_TUONG: rootUrl_Micro + 'ncc/chitra/thong-tin-chitranhomdt',
            MAX_SO_GIAY_BAO: rootUrl_Micro + 'ncc/chitra/so-giay-bao',
            TON_TAI_GIAY_BAO: rootUrl_Micro + 'ncc/chitra/ton-tai-so-giay-bao',
            TY_LE: rootUrl_Micro + 'ncc/chitra/thong-tin-chitranhomtyle',
            DOI_TUONG_CONFIG: rootUrl_Micro + 'ncc/chitra/cau-hinh-doi-tuong',
            ADD_TCML: rootUrl_Micro + 'ncc/chitra/cap-nhat-tro-cap-mot-lan',
            SEARCH_DOI_TUONG: rootUrl_Micro + 'ncc/chitra/chi-tra-mot-lan',
            SEARCH_DOI_TUONG_HANG_THANG: rootUrl_Micro + 'ncc/chitra/chi-tra-hang-thang',
            SEARCH_CAT_CHET_HANG_THANG: rootUrl_Micro + 'ncc/chitra/chi-tra-hang-thang-cat-chet',
            ADD_TCHT: rootUrl_Micro + 'ncc/chitra/cap-nhat-tro-cap-hang-thang',
            DANH_SACH_XA_LAP: rootUrl_Micro + 'ncc/chitra/danh-sach-xa-lap',
            DANH_SACH_XA_HUYEN_HT: rootUrl_Micro + 'ncc/chitra/danh-sach-xa-huyen-chi-tra-hang-thang',
            LAP_DANH_SACH_CHI_TRA_HANG_THANG: rootUrl_Micro + 'ncc/chitra/lap-danh-sach-chi-tra-hang-thang',
            LAP_DANH_SACH_CHI_TRA_HANG_THANG_HGI: rootUrl_Micro + 'ncc/chitra/lap-danh-sach-chi-tra-hang-thang-toan-huyen',
            DANH_SACH_CHI_TIET_THANG: rootUrl_Micro + 'ncc/chitra/danh-sach-chi-tiet-thang',
            DANH_SACH_CHI_TIET_THANG_HGI: rootUrl_Micro + 'ncc/chitra/danh-sach-chi-tiet',
            CHI_TRA_TRO_CAP_THANG: rootUrl_Micro + 'ncc/chitra/chi-tra-tro-cap-hang-thang',
            CHI_TRA_TRO_CAP_THANG_ALL: rootUrl_Micro + 'ncc/chitra/chi-tra-tro-cap-hang-thang-all',
            CAP_NHAT_TRANG_THAI_QUY_TRINH: rootUrl_Micro + 'ncc/chitra/cap-nhat-trang-thai-quy-trinh-thang',
            CAP_NHAT_TRANG_THAI_QUY_TRINH_HGI: rootUrl_Micro + 'ncc/chitra/cap-nhat-trang-thai',
            TRANG_THAI_QUY_TRINH: rootUrl_Micro + 'ncc/chitra/trang-thai-quy-trinh-thang',
            DANH_SACH_MOT_LAN_CHUA_DUYET: rootUrl_Micro + 'ncc/chitra/get-danh-sach-chi-tra-duyet-ko-duyet-v2',
            LAP_DANH_SACH_CHI_TRA_MOT_LAN: rootUrl_Micro + 'ncc/chitra/lap-danh-sach-chi-tra-mot-lan',
            DANH_SACH_CHI_TRA_MOT_LAN: rootUrl_Micro + 'ncc/chitra/get-danh-sach-chi-tra-mot-lan',
            DUYET_DANH_SACH_MOT_LAN: rootUrl_Micro + 'ncc/chitra/cap-nhat-duyet-v2',
            CAT_CHET: rootUrl_Micro + 'ncc/chitra/cat-chet',
            KHOI_PHUC_CAT_CHET: rootUrl_Micro + 'ncc/chitra/cat-chet-khoi-phuc',
            HUU_TRI: rootUrl_Micro + 'ncc/chitra/cap-nhat-huu-tri',
            CHI_TRA_MOT_LAN: rootUrl_Micro + 'ncc/chitra/chi-tra-tro-cap-mot-lan-v2',
            EXPORT_TRO_CAP_HANG_THANG: rootUrl_Micro + 'get-data/ncc/chitra/danh-sach-chi-tiet-thang-pdf',
            DANH_SACH_XA_LAP_MOT_LAN: rootUrl_Micro + 'ncc/chitra/thong-ke-duyet-huyen-xa',
            EXPORT_TRO_CAP_MOT_LAN: rootUrl_Micro + 'get-data/ncc/chitra/danh-sach-chi-tiet-mot-lan-pdf',
            DANH_MUC_TCML_MASTER: rootUrl_Micro + 'ncc/chitra/nhom-tro-cap-ml-master',
            DANH_MUC_LOAI_TCML_MASTER: rootUrl_Micro + 'ncc/chitra/loai-tro-cap-ml-master',
            TAO_MOI_TCML_MASTER: rootUrl_Micro + 'ncc/chitra/nhom-tro-cap-ml-update-master',
            TAO_MOI_LOAI_TCML_MASTER: rootUrl_Micro + 'ncc/chitra/loai-tro-cap-ml-update-master',
            DANH_MUC_TCHT_MASTER: rootUrl_Micro + 'ncc/chitra/nhom-tro-cap-ht-master',
            DANH_MUC_LOAI_TCHT_MASTER: rootUrl_Micro + 'ncc/chitra/loai-tro-cap-ht-master',
            TAO_MOI_TCHT_MASTER: rootUrl_Micro + 'ncc/chitra/nhom-tro-cap-ht-update-master',
            TAO_MOI_LOAI_TCHT_MASTER: rootUrl_Micro + 'ncc/chitra/loai-tro-cap-ht-update-master',
            DANH_MUC_TY_LE_MASTER: rootUrl_Micro + 'ncc/chitra/ty-le-master',
            TAO_MOI_TY_LE_MASTER: rootUrl_Micro + 'ncc/chitra/ty-le-update-master',
            DANH_MUC_CONFIG_MASTER: rootUrl_Micro + 'ncc/chitra/config-doi-tuong-master',
            TAO_MOI_CONFIG_MASTER: rootUrl_Micro + 'ncc/chitra/config-doi-tuong-update-master',
            XOA_DT_TC_1LAN: rootUrl_Micro + 'ncc/chitra/xoa-chi-tra-mot-lan',
            XOA_DT_TC_HT: rootUrl_Micro + 'ncc/chitra/xoa-chi-tra-hang-thang',
            NHAP_TO_TRINH: rootUrl_Micro + 'ncc/chitra/cap-nhat-so-to-trinh',
            NHAP_SQD: rootUrl_Micro + 'ncc/chitra/cap-nhat-so-quyet-dinh',
            SO_NGUOI_NHAPQD: rootUrl_Micro + 'ncc/chitra/so-tien-chi-tra-theo-qd',
            TAM_DUNG_HUONG_LAI_HANG_THANG: rootUrl_Micro + 'ncc/chitra/tam_dung_huong_lai_hang_thang',
            TAM_DUNG_HUONG_LAI_MOT_LAN: rootUrl_Micro + 'ncc/chitra/tam_dung_huong_lai_mot_lan',
            EXPORT_DANH_SACH_CHI_TRA_1_LAN: rootUrl_Micro + 'ncc/chitra/export_danh_sach_chi_tra_1_lan',
            EXPORT_DANH_SACH_CHI_TRA_HANG_THANG: rootUrl_Micro + 'ncc/chitra/export_danh_sach_chi_tra_hang_thang',

            DANH_SACH_MOT_LAN_XA_LAP: rootUrl_Micro + 'ncc/chitra/danh-sach-xa-chi-tra-mot-lan',
            DANH_SACH_MOT_LAN_TINH_LAP: rootUrl_Micro + 'ncc/chitra/danh-sach-xa-huyen-chi-tra-mot-lan',
            CAP_NHAT_TRANG_THAI_QUY_TRINH_ML: rootUrl_Micro + 'ncc/chitra/cap-nhat-trang-thai-quy-trinh-chi-tra-mot-lan',
            DANH_SACH_CHI_TIET_MOT_LAN: rootUrl_Micro + 'ncc/chitra/danh-sach-chi-tiet-chi-tra-mot-lan',
            TRANG_THAI_QUY_TRINH_ML: rootUrl_Micro + 'ncc/chitra/trang-thai-quy-trinh-mot-lan',
            CHI_TRA_TRO_CAP_ML: rootUrl_Micro + 'ncc/chitra/cap-nhat-trang-thai-chi-tra-ml',
            NHAP_TO_TRINH_ML: rootUrl_Micro + 'ncc/chitra/cap-nhat-so-to-trinh-mot-lan',
            NHAP_SQD_ML: rootUrl_Micro + 'ncc/chitra/cap-nhat-so-quyet-dinh-mot-lan',
            SO_NGUOI_NHAPQD_ML: rootUrl_Micro + 'ncc/chitra/so-tien-chi-tra-theo-qd-mot-lan',
            DANH_SACH_CHI_TIET_MOT_LAN_TOAN_HUYEN: rootUrl_Micro + 'ncc/chitra/danh-sach-chi-tiet-mot-lan',
            CAP_NHAT_TRANG_THAI_QUY_TRINH_TOAN_HUYEN: rootUrl_Micro + 'ncc/chitra/cap-nhat-trang-thai-mot-lan',
            LAP_DANH_SACH_CHI_TRA_MOT_LAN_TOAN_HUYEN: rootUrl_Micro + 'ncc/chitra/lap-danh-sach-chi-tra-mot-lan-toan-huyen',

            DANH_SACH_CHI_TIET_UU_DAI: rootUrl_Micro + 'ncc/chitra/danh-sach-uu-dai',
            BIEU_DO_UU_DAI: rootUrl_Micro + 'ncc/chitra/bieu-do-uu-dai',

            DANH_SACH_BO_SUNG_XA_LAP: rootUrl_Micro + 'ncc/chitra/danh-sach-xa-chi-tra-bo-sung',
            CAP_NHAT_TRANG_THAI_QUY_TRINH_BO_SUNG: rootUrl_Micro + 'ncc/chitra/cap-nhat-trang-thai-quy-trinh-chi-tra-bo-sung',
            DANH_SACH_CHI_TIET_BO_SUNG: rootUrl_Micro + 'ncc/chitra/danh-sach-chi-tiet-chi-tra-bo-sung',
            TRANG_THAI_QUY_TRINH_BO_SUNG: rootUrl_Micro + 'ncc/chitra/trang-thai-quy-trinh-bo-sung',
            CHI_TRA_TRO_CAP_BO_SUNG: rootUrl_Micro + 'ncc/chitra/cap-nhat-trang-thai-chi-tra-bo-sung',
            EXPORT_TRO_CAP_BO_SUNG: rootUrl_Micro + 'get-data/ncc/chitra/danh-sach-chi-tiet-bo-sung-pdf',
            XAC_THUC_CMND_TC_BO_SUNG: rootUrl_Micro + 'ncc/chitra/xac-thuc-cmnd-bo-sung',
            XAC_THUC_CMND_TC_MOT_LAN: rootUrl_Micro + 'ncc/chitra/xac-thuc-cmnd-mot-lan',
            XAC_THUC_CMND_TC_HANG_THANG: rootUrl_Micro + 'ncc/chitra/xac-thuc-cmnd-hang-thang',
            SEARCH_DOI_TUONG_HANG_THANG_BY_HOSOID: rootUrl_Micro + 'ncc/chitra/danh-sach-doi-tuong-chi-tra-hang-thang-by-hosoid',
            SEARCH_DOI_TUONG_MOT_LAN_BY_HOSOID: rootUrl_Micro + 'ncc/chitra/danh-sach-doi-tuong-chi-tra-mot-lan-by-hosoid',
            THONG_TIN_HO_SO_CHUNG_BY_HOSOID: rootUrl_Micro + 'ncc/chitra/thong-tin-ho-so-chung-by-hosoid',

            PHAN_QUYEN_MENU_THEO_TINH: rootUrl_Micro + 'ncc/phan-quyen-menu/phan-quyen-menu-theo-tinh',
            TEMPLATE_TRO_CAP: rootUrl_Micro + 'ncc/template-chitra-ncc',
            IMPORT_HANG_THANG_CHECK: rootUrl_Micro + 'ncc/check-import-ht',
            IMPORT_HANG_THANG: rootUrl_Micro + 'ncc/import-doi-tuong-ht',
            IMPORT_TRO_CAP_1_LAN_CHECK: rootUrl_Micro + 'ncc/check-import-ml',
            IMPORT_TRO_CAP_1_LAN: rootUrl_Micro + 'ncc/import-doi-tuong-ml',

            BANG_KE_MOT_LAN_B07 : rootUrl_Micro + "ncc/chitra/b07",
            BANG_KE_HANG_THANG_B08 : rootUrl_Micro + "ncc/chitra/b08",
            BANG_KE_MOT_LAN_C66 : rootUrl_Micro + "get-data/ncc/chitra/bang-ke-doi-tuong-mot-lan-chua-linh",
            BANG_KE_HANG_THANG_C68 : rootUrl_Micro + "get-data/ncc/chitra/bang-ke-doi-tuong-hang-thang-chua-linh",
            REPORT_UU_DAI_MOT_LAN : rootUrl_Micro + "get-data/ncc/chitra/danh-sach-uu-dai-mot-lan-pdf",
            REPORT_UU_DAI_HANG_THANG : rootUrl_Micro + "get-data/ncc/chitra/danh-sach-uu-dai-hang-thang-pdf",
            REPORT_TL_DANH_SACH_UU_DAI: rootUrl_Micro + "get-data/ncc/chitra/danh-sach-uu-dai-trich-luc-pdf",
            EXPORT_BAO_CAO_08: rootUrl_Micro + 'get-data/ncc/quyetdinh/xuat-bao-cao-tro-cap-hang-thang-mau-b08',
            EXPORT_BAO_CAO_HANG_THANG: rootUrl_Micro + 'get-data/ncc/quyetdinh/xuat-bao-cao-tro-cap-hang-thang-mau-b08-v2',
            getFileDinhKem: rootUrl_Micro + 'file/ncc/uy-quyen/downloadFile',
            uploadFileDinhKem: rootUrl_Micro + 'file/ncc/uy-quyen/uploadFile',
            deleteFileDinhKem: rootUrl_Micro + 'file/ncc/uy-quyen/deleteFile',
            giayBaoMotLan: rootUrl_Micro + 'ncc/chitra/xuat-giay-bao-lanh-tien-mot-lan',
            giayBaoHangThang: rootUrl_Micro + 'ncc/chitra/xuat-giay-bao-lanh-tien-hang-thang',
        },
        DVC: {
            DANH_SACH: rootUrl_Micro + "ncc/dvc/danh-sach",
            CHUYEN_DUYET: rootUrl_Micro + "ncc/dvc/duyet",
            CHUYEN_DUYET_DS: rootUrl_Micro + "ncc/dvc/duyet-ds",
            CAP_NHAT: rootUrl_Micro + "ncc/dvc/cap-nhat",
            TU_CHOI: rootUrl_Micro + "ncc/dvc/xoa",
            GET_HO_SO: rootUrl_Micro + "ncc/dvc/downloadFileDinhKem",
            LIST_HO_SO: rootUrl_Micro + "ncc/dvc/danh-sach-file-dinh-kem"
        },
        CAU_HINH :{
            THEM_MOI: rootUrl_Micro + "danh-muc/cau-hinh-ncc",
            CAP_NHAT: rootUrl_Micro + "danh-muc/cau-hinh-ncc",
            DANH_SACH: rootUrl_Micro + "danh-muc/cau-hinh-ncc/danh-sach",
            XOA: rootUrl_Micro + "danh-muc/cau-hinh-ncc",
            TIM_KIEM: rootUrl_Micro + "danh-muc/cau-hinh-ncc/tim-kiem"
        },
        TRO_CAP : rootUrl_Micro + "ncc/thong-tin-che-do",
        THAN_NHAN : rootUrl_Micro + "ncc/thong-tin-than-nhan",
        THAN_NHAN_KHONG_CAT_CHET : rootUrl_Micro + "ncc/thong-tin-than-nhan/khong-cat-chet",
        DOI_SONG : rootUrl_Micro + "ncc/thong-tin-doi-song",
        TRO_CAP_QUA_DOI : rootUrl_Micro + "ncc/thong-tin-tro-cap-khi-qua-doi",
        QUA_TRINH_HOAT_DONG_CACH_MANG : rootUrl_Micro + "ncc/thong-tin-qua-trinh-hoat-dong",
        THONG_TIN_KHONG_CONG_NHAN : rootUrl_Micro + "ncc/thong-tin-khong-cong-nhan",
        THONG_TIN_KHEN_THUONG : rootUrl_Micro + "ncc/thong-tin-khen-thuong",
        THONG_TIN_GIA_DINH : rootUrl_Micro + "ncc/thong-tin-gia-dinh",
        THONG_TIN_DOI_TUONG_KHAC : rootUrl_Micro + "ncc/thuoc-doi-tuong-khac",
        THONG_TIN_THO_CUNG : rootUrl_Micro + "ncc/thong-tin-tho-cung",
        THONG_TIN_THOI_HUONG: rootUrl_Micro + "ncc/thong-tin-thoi-huong",
        THONG_TIN_THU_HOI : rootUrl_Micro + "ncc/thong-tin-thu-hoi",
        TIM_KIEM_DANH_MUC : rootUrl_Micro + "danh-muc/danh-muc-ncc/tim-kiem",
        DANH_SACH_DANH_MUC : rootUrl_Micro + "danh-muc/danh-muc-ncc/danh-sach",
        CAP_NHAT_DANH_MUC : rootUrl_Micro + "danh-muc/danh-muc-ncc",
        DANH_MUC_LOAI_QUYET_DINH : rootUrl_Micro + "danh-muc/danh-muc-quyet-dinh-ncc/danh-sach",
        THONG_TIN_GIAM_DINH_ADN : rootUrl_Micro + "ncc/thong-tin-giam-dinh-adn",
        UPLOAD_ADN : rootUrl_Micro + "file/ncc/uploadFile-adn",
        THONG_TIN_THAN_NHAN_THAM_MO : rootUrl_Micro + "ncc/thong-tin-than-nhan-tham-mo",
        OCR: {
          importFile: "https://api.idg.vnpt.vn/file-service/v1/addFile",
          bocTachFile: "https://api.idg.vnpt.vn/rpa-service/aidigdoc/v1/ocr/ban-trich-luc-ho-so-benh-binh"
        },
        //Danh mục quỹ đền ơn đáp nghĩa
        DANH_SACH_DEN_ON : rootUrl_Micro + "danh-muc/danh-muc-quy-den-on-dap-nghia/tim-kiem",
        CAP_NHAT_DEN_ON: rootUrl_Micro + "danh-muc/danh-muc-quy-den-on-dap-nghia",

        // Lập danh sách - chi trả điều dưỡng
        THONG_TINH_DIEU_DUONG : rootUrl_Micro + "ncc/chi-tra/chi-tra-dieu-duong/thong-tin",
        LAP_DANH_SACH_DIEU_DUONG : rootUrl_Micro + "ncc/chi-tra/chi-tra-dieu-duong/lap-danh-sach",
        DANH_SACH_CHI_TIET : rootUrl_Micro + "ncc/chi-tra/chi-tra-dieu-duong/danh-sach-chi-tiet",
        DANH_SACH_XA_HUYEN : rootUrl_Micro + "ncc/chi-tra/chi-tra-dieu-duong/danh-sach-xa-huyen",
        DANH_SACH_CAP_NHAT_TRANG_THAI : rootUrl_Micro + "ncc/chi-tra/chi-tra-dieu-duong/cap-nhat-trang-thai",
        LAP_DS_DIEU_DUONG : rootUrl_Micro + "ncc/chi-tra/chi-tra-dieu-duong/lap-danh-sach",
        XOA_HUONG_CHI_TRA : rootUrl_Micro + "ncc/chi-tra/chi-tra-dieu-duong/xoa-huong-chi-tra",
        CHI_TIET_CHI_TRA : rootUrl_Micro + "ncc/chi-tra/chi-tra-dieu-duong/danh-sach-chi-tiet",
        CHI_TRA_DIEU_DUONG : rootUrl_Micro + "ncc/chi-tra/chi-tra-dieu-duong/cap-nhat-trang-thai-chi-tra",
        LICH_SU_DIEU_DUONG : rootUrl_Micro + "ncc/chi-tra/chi-tra-dieu-duong/lich-su-chi-tra",
        MUC_CHUANG_DIEU_DUONG : rootUrl_Micro + "ncc/chi-tra/chi-tra-dieu-duong/get-muc-chuan",
        TEMPLATE_DIEU_DUONG: rootUrl_Micro + 'ncc/chi-tra/chi-tra-dieu-duong/template-import-dieu-duong',
        IMPORT_HANG_THANG_DIEU_DUONG: rootUrl_Micro + 'ncc/chi-tra/chi-tra-dieu-duong/check-file-dieu-duong',
        IMPORT_TRO_CAP_DIEU_DUONG: rootUrl_Micro + 'ncc/chi-tra/chi-tra-dieu-duong/import-dieu-duong',
        XUAT_BAO_CAO_DIEU_DUONG: rootUrl_Micro + 'ncc/chi-tra/chi-tra-dieu-duong/bao-cao-chi-tra-dieu-duong',
        DANH_SACH_TRUNG_DIEU_DUONG: rootUrl_Micro + 'ncc/chi-tra/chi-tra-dieu-duong/danh-sach-trung-dieu-duong',
        XUAT_DANH_SACH_TRUNG_DIEU_DUONG: rootUrl_Micro + 'get-data/ncc/chitra/danh-sach-chi-tra-dieu-duong-trung',
        LAP_DANH_SACH_DIEU_DUONG_TOAN_HUYEN: rootUrl_Micro + 'ncc/chi-tra/chi-tra-dieu-duong/lap-danh-sach-toan-huyen',
        EXPORT_DANH_SACH_DOI_TUONG_DIEU_DUONG: rootUrl_Micro + 'ncc/chi-tra/chi-tra-dieu-duong/export-danh-sach-doi-tuong-dieu-duong',
        CHI_TRA_DIEU_DUONG_ALL : rootUrl_Micro + "ncc/chi-tra/chi-tra-dieu-duong/cap-nhat-trang-thai-chi-tra-all",
        XOA_CHI_TRA_DIEU_DUONG : rootUrl_Micro + "ncc/chi-tra/chi-tra-dieu-duong/xoa-chi-tra",
        XOA_CHI_TRA_DUNG_CU_CHINH_HINH : rootUrl_Micro + "ncc/chi-tra/chi-tra-dung-cu-chinh-hinh/xoa-chi-tra",
        XOA_CHI_TRA_QUA : rootUrl_Micro + "ncc/chi-tra/chi-tra-qua/xoa-chi-tra",
        CAP_NHAT_LOAI_DIEU_DUONG : rootUrl_Micro + "ncc/chi-tra/chi-tra-dieu-duong/cap-nhat-loai-dieu-duong",
        EXPORT_DANH_SACH_CHI_TRA_DIEU_DUONG: rootUrl_Micro + 'ncc/chi-tra/chi-tra-dieu-duong/export-danh-sach-chi-tra-dieu-duong',
        CAP_NHAT_GHI_CHU: rootUrl_Micro + 'ncc/chi-tra/chi-tra-dieu-duong/cap-nhat-ghi-chu',
        DANH_SACH_TRUNG_DIEU_DUONG_TINH: rootUrl_Micro + 'ncc/chi-tra/chi-tra-dieu-duong/kiem-tra-trung-tinh',
        KHOI_PHUC_HUONG : rootUrl_Micro + "ncc/chi-tra/chi-tra-dieu-duong/khoi-phuc-huong-chi-tra",
        DANH_SACH_TRUNG_DUNG_CU_CHINH_HINH_TINH: rootUrl_Micro + 'ncc/chi-tra/chi-tra-dung-cu-chinh-hinh/kiem-tra-trung-tinh',
        KHOI_PHUC_HUONG_DCCH : rootUrl_Micro + "ncc/chi-tra/chi-tra-dung-cu-chinh-hinh/khoi-phuc-huong-chi-tra",
        DANH_SACH_TRUNG_QUA_TINH: rootUrl_Micro + 'ncc/chi-tra/chi-tra-qua/kiem-tra-trung-tinh',
        KHOI_PHUC_HUONG_QUA : rootUrl_Micro + "ncc/chi-tra/chi-tra-qua/khoi-phuc-huong-chi-tra",

        // Lập danh sách - chi trả ưu đãi giáo dục
        THONG_TINH_UU_DAI_GIAO_DUC : rootUrl_Micro + "ncc/chi-tra/chi-tra-uu-dai-giao-duc/thong-tin",
        LAP_DANH_SACH_UU_DAI_GIAO_DUC : rootUrl_Micro + "ncc/chi-tra/chi-tra-uu-dai-giao-duc/lap-danh-sach",
        LAP_DANH_SACH_UU_DAI_GIAO_DUC_TOAN_HUYEN : rootUrl_Micro + "ncc/chi-tra/chi-tra-uu-dai-giao-duc/lap-danh-sach-toan-huyen",
        DANH_SACH_CHI_TIET_UU_DAI_GIAO_DUC : rootUrl_Micro + "ncc/chi-tra/chi-tra-uu-dai-giao-duc/danh-sach-chi-tiet",
        DANH_SACH_XA_HUYEN_UU_DAI_GIAO_DUC : rootUrl_Micro + "ncc/chi-tra/chi-tra-uu-dai-giao-duc/danh-sach-xa-huyen",
        CAP_NHAT_TRANG_THAI_UU_DAI_GIAO_DUC: rootUrl_Micro + "ncc/chi-tra/chi-tra-uu-dai-giao-duc/cap-nhat-trang-thai",
        XOA_HUONG_CHI_TRA_UU_DAI_GIAO_DUC : rootUrl_Micro + "ncc/chi-tra/chi-tra-uu-dai-giao-duc/xoa-huong-chi-tra",
        CHI_TRA_UU_DAI_GIAO_DUC : rootUrl_Micro + "ncc/chi-tra/chi-tra-uu-dai-giao-duc/cap-nhat-trang-thai-chi-tra",
        DM_DOI_TUONG_UU_DAI_GIAO_DUC : rootUrl_Micro + "danh-muc/danh-muc-chi-tra-ncc/danh-sach",
        DANH_SACH_CAP_NHAT_TRANG_THAI_UU_DAI_GIAO_DUC : rootUrl_Micro + "ncc/chi-tra/chi-tra-uu-dai-giao-duc/cap-nhat-trang-thai",
        KIEM_TRA_TRUNG_UU_DAI_GIAO_DUC : rootUrl_Micro + "ncc/chi-tra/chi-tra-uu-dai-giao-duc/kiem-tra-trung",
        DANH_SACH_TRUNG_UDGD: rootUrl_Micro + "ncc/chi-tra/chi-tra-uu-dai-giao-duc/xuat-danh-sach-udgd-trung",
        xuatFileImportUDGD: rootUrl_Micro + "ncc/chi-tra/chi-tra-uu-dai-giao-duc/file-mau-import",
        checkfileImportGDGD: rootUrl_Micro + "ncc/chi-tra/chi-tra-uu-dai-giao-duc/check-file-import",
        importUDGD: rootUrl_Micro + "ncc/chi-tra/chi-tra-uu-dai-giao-duc/import-du-lieu",
        CHI_TRA_UU_DAI_GIAO_DUC_ALL : rootUrl_Micro + "ncc/chi-tra/chi-tra-uu-dai-giao-duc/cap-nhat-trang-thai-chi-tra-all",
        // Lập danh sách - chi trả phương tiện - dụng cụ chỉnh hình
        THONG_TINH_PTTG_DCCH : rootUrl_Micro + "ncc/chi-tra/chi-tra-dung-cu-chinh-hinh/thong-tin",
        LAP_DANH_SACH_PTTG_DCCH : rootUrl_Micro + "ncc/chi-tra/chi-tra-dung-cu-chinh-hinh/lap-danh-sach",
        LAP_DANH_SACH_PTTG_DCCH_TOAN_HUYEN : rootUrl_Micro + "ncc/chi-tra/chi-tra-dung-cu-chinh-hinh/lap-danh-sach-toan-huyen",
        DANH_SACH_CHI_TIET_PTTG_DCCH: rootUrl_Micro + "ncc/chi-tra/chi-tra-dung-cu-chinh-hinh/danh-sach-chi-tiet",
        DANH_SACH_XA_HUYEN_PTTG_DCCH : rootUrl_Micro + "ncc/chi-tra/chi-tra-dung-cu-chinh-hinh/danh-sach-xa-huyen",
        DANH_SACH_CAP_NHAT_TRANG_THAI_PTTG_DCCH: rootUrl_Micro + "ncc/chi-tra/chi-tra-dung-cu-chinh-hinh/cap-nhat-trang-thai",
        XOA_HUONG_CHI_TRA_PTTG_DCCH : rootUrl_Micro + "ncc/chi-tra/chi-tra-dung-cu-chinh-hinh/xoa-huong-chi-tra",
        KIEM_TRA_TRUNG_PTTG_DCCH : rootUrl_Micro + "ncc/chi-tra/chi-tra-dung-cu-chinh-hinh/kiem-tra-trung",
        CHI_TRA_DCCH : rootUrl_Micro + "ncc/chi-tra/chi-tra-dung-cu-chinh-hinh/cap-nhat-trang-thai-chi-tra",
        XUAT_BAO_CAO_B10 : rootUrl_Micro + "get-data/ncc/chitra/xuat-bao-cao-tro-cap-dung-cu-chinh-hinh-mau-b10",
        TEMPLATE_PTTG_DCCH: rootUrl_Micro + 'ncc/chi-tra/chi-tra-dung-cu-chinh-hinh/file-mau-import',
        IMPORT_HANG_THANG_PTTG_DCCH: rootUrl_Micro + 'ncc/chi-tra/chi-tra-dung-cu-chinh-hinh/check-file-import',
        IMPORT_TRO_CAP_PTTG_DCCH: rootUrl_Micro + 'ncc/chi-tra/chi-tra-dung-cu-chinh-hinh/import-du-lieu',
        EXPORT_LIST_PTTG_DCCH_C71: rootUrl_Micro + 'get-data/ncc/chitra/xuat-danh-sach-dung-cu-chinh-hinh-c71',
        LIST_TRUNG_DCCH: rootUrl_Micro + 'ncc/chi-tra/chi-tra-dung-cu-chinh-hinh/xuat-danh-sach-dcch-trung',
        EXPORT_DANH_SACH_DCCH: rootUrl_Micro + 'ncc/chi-tra/chi-tra-dung-cu-chinh-hinh/export-danh-sach-dcch',
        CHI_TRA_DCCH_ALL : rootUrl_Micro + "ncc/chi-tra/chi-tra-dung-cu-chinh-hinh/cap-nhat-trang-thai-chi-tra-all",
        XUAT_BAO_CAO_TONG_HOP_CHI_TRA_TRO_CAP_HANG_THANG_THEO_XA : rootUrl_Micro + "get-data/ncc/chitra/xuat-bao-cao-tong-hop-chi-tra-hang-thang-theo-xa",
        // Lập danh sách - chi trả điều dưỡng
        THONG_TIN_BHYT : rootUrl_Micro + "ncc/chi-tra/chi-tra-bhyt/thong-tin",
        CAT_GIAM_BHYT : rootUrl_Micro + "ncc/chi-tra/chi-tra-bhyt/cat-giam",
        DANH_SACH_XA_HUYEN_BHYT : rootUrl_Micro + "ncc/chi-tra/chi-tra-bhyt/danh-sach-xa-huyen",
        DANH_SACH_CAP_NHAT_TRANG_THAI_BHYT : rootUrl_Micro + "ncc/chi-tra/chi-tra-bhyt/cap-nhat-trang-thai",
        LAP_DS_BHYT : rootUrl_Micro + "ncc/chi-tra/chi-tra-bhyt/lap-danh-sach",
        CHI_TIET_BHYT : rootUrl_Micro + "ncc/chi-tra/chi-tra-bhyt/danh-sach-chi-tiet",
        BAO_CAO_DANH_SACH_BHYT : rootUrl_Micro + "ncc/chi-tra/chi-tra-bhyt/bao-cao-bhyt",
        // Lập danh sách - chi trả thờ cúng
        THO_CUNG: {
          THONG_TINH_THO_CUNG : rootUrl_Micro + "ncc/chi-tra/chi-tra-dieu-duong/thong-tin",
          LAP_DANH_SACH_THO_CUNG : rootUrl_Micro + "ncc/chi-tra/chi-tra-dieu-duong/lap-danh-sach",
          DANH_SACH_CHI_TIET : rootUrl_Micro + "ncc/chi-tra/chi-tra-dieu-duong/danh-sach-chi-tiet",
          DANH_SACH_XA_HUYEN : rootUrl_Micro + "ncc/chi-tra/chi-tra-dieu-duong/danh-sach-xa-huyen",
          DANH_SACH_CAP_NHAT_TRANG_THAI : rootUrl_Micro + "ncc/chi-tra/chi-tra-dieu-duong/cap-nhat-trang-thai",
          LAP_DS_THO_CUNG : rootUrl_Micro + "ncc/chi-tra/chi-tra-dieu-duong/lap-danh-sach",
          XOA_HUONG_CHI_TRA : rootUrl_Micro + "ncc/chi-tra/chi-tra-dieu-duong/xoa-huong-chi-tra",
          CHI_TIET_CHI_TRA : rootUrl_Micro + "ncc/chi-tra/chi-tra-dieu-duong/danh-sach-chi-tiet",
          CHI_TRA_THO_CUNG : rootUrl_Micro + "ncc/chi-tra/chi-tra-dieu-duong/cap-nhat-trang-thai-chi-tra",
          LICH_SU_THO_CUNG : rootUrl_Micro + "ncc/chi-tra/chi-tra-dieu-duong/lich-su-chi-tra",
        },
        DASH_BOARD: {
          THONG_KE_NCC : rootUrl_Micro + 'ncc/dashboard-nguoi-co-cong/thong-ke-tong-nguoi-co-cong',
          THONG_KE_THEO_HC : rootUrl_Micro + 'ncc/dashboard-nguoi-co-cong/thong-ke-nguoi-co-cong-theo-hanh-chinh',
          TY_LE_GT : rootUrl_Micro + 'ncc/dashboard-nguoi-co-cong/ty-le-gioi-tinh-nguoi-co-cong',
          TY_LE_DT : rootUrl_Micro + 'ncc/dashboard-nguoi-co-cong/ty-le-dan-toc-nguoi-co-cong',

          THONG_KE_NCC_TRO_CAP : rootUrl_Micro + 'ncc/dashboard-nguoi-co-cong/thong-ke-tong-nguoi-co-cong-tro-cap',
          THONG_KE_THEO_HC_TRO_CAP : rootUrl_Micro + 'ncc/dashboard-nguoi-co-cong/thong-ke-nguoi-co-cong-tro-cap-theo-hanh-chinh',
          TY_LE_GT_TRO_CAP : rootUrl_Micro + 'ncc/dashboard-nguoi-co-cong/ty-le-gioi-tinh-nguoi-co-cong-tro-cap',
          TY_LE_DT_TRO_CAP : rootUrl_Micro + 'ncc/dashboard-nguoi-co-cong/ty-le-dan-toc-nguoi-co-cong-tro-cap',

          THONG_KE_NCC_CHI_TRA : rootUrl_Micro + 'ncc/dashboard-nguoi-co-cong/thong-ke-tong-tien-tro-cap',
          THONG_KE_THEO_HC_CHI_TRA : rootUrl_Micro + 'ncc/dashboard-nguoi-co-cong/thong-ke-tien-tro-cap-theo-hanh-chinh',
          THONG_KE_THEO_QUY_CHI_TRA : rootUrl_Micro + 'ncc/dashboard-nguoi-co-cong/thong-ke-tien-tro-cap-theo-quy',

          THONG_KE_NCC_MOT_LAN : rootUrl_Micro + 'ncc/dashboard-nguoi-co-cong/thong-ke-tong-tien-tro-cap-mot-lan',
          THONG_KE_THEO_HC_MOT_LAN : rootUrl_Micro + 'ncc/dashboard-nguoi-co-cong/thong-ke-tien-tro-cap-mot-lan-theo-hanh-chinh',
          THONG_KE_THEO_QUY_MOT_LAN : rootUrl_Micro + 'ncc/dashboard-nguoi-co-cong/thong-ke-tien-tro-cap-mot-lan-theo-quy',
          THONG_KE_THEO_THANG_MOT_LAN : rootUrl_Micro + 'ncc/dashboard-nguoi-co-cong/thong-ke-tien-tro-cap-mot-lan-theo-thang',

          THONG_KE_NCC_HANG_THANG : rootUrl_Micro + 'ncc/dashboard-nguoi-co-cong/thong-ke-tong-tien-tro-cap-hang-thang',
          THONG_KE_THEO_HC_HANG_THANG : rootUrl_Micro + 'ncc/dashboard-nguoi-co-cong/thong-ke-tien-tro-cap-hang-thang-theo-hanh-chinh',
          THONG_KE_THEO_QUY_HANG_THANG: rootUrl_Micro + 'ncc/dashboard-nguoi-co-cong/thong-ke-tien-tro-cap-hang-thang-theo-quy',
          THONG_KE_THEO_THANG_HANG_THANG: rootUrl_Micro + 'ncc/dashboard-nguoi-co-cong/thong-ke-tien-tro-cap-hang-thang-theo-thang',

          THONG_KE_THEO_QUA_LE_TET: rootUrl_Micro + 'ncc/dashboard-chi-tra-qua',
          THONG_KE_THEO_DIEU_DUONG: rootUrl_Micro + 'ncc/dashboard-chi-tra-dieu-duong',
        },
        XUAT_DANH_SACH_BHYT : rootUrl_Micro + "ncc/chi-tra/chi-tra-bhyt/xuat-danh-sach-bhyt",
        XUAT_BAO_CAO_BHYT : rootUrl_Micro + "ncc/chi-tra/chi-tra-bhyt/xuat-danh-sach-bhyt-mau-b11-qd09",

        // Quy trình quà
        GETLISTDOITUONGQUA : rootUrl_Micro + "ncc/chi-tra/chi-tra-qua/get_loai_doi_tuong_qua",
        THONG_TIN_QUA : rootUrl_Micro + "ncc/chi-tra/chi-tra-qua/thong-tin",
        DANH_SACH_XA_HUYEN_QUA : rootUrl_Micro + "ncc/chi-tra/chi-tra-qua/danh-sach-xa-huyen",
        DANH_SACH_CAP_NHAT_TRANG_THAI_QUA : rootUrl_Micro + "ncc/chi-tra/chi-tra-qua/cap-nhat-trang-thai",
        LAP_DS_QUA : rootUrl_Micro + "ncc/chi-tra/chi-tra-qua/lap-danh-sach",
        CHI_TIET_QUA : rootUrl_Micro + "ncc/chi-tra/chi-tra-qua/danh-sach-chi-tiet",
        CHI_TRA_QUA : rootUrl_Micro + "ncc/chi-tra/chi-tra-qua/cap-nhat-trang-thai-chi-tra",
        XOA_HUONG_CHI_TRA_QUA : rootUrl_Micro + "ncc/chi-tra/chi-tra-qua/loai_khoi_danh_sach",
        XUAT_EXCEL_DOI_TUONG_NHAN_QUA : rootUrl_Micro + "get-data/ncc/chitra/danh-sach-chi-tra-chi-tiet-qua",
        TEMPLATE_QUA: rootUrl_Micro + 'ncc/chi-tra/chi-tra-qua/file-mau-import',
        IMPORT_HANG_THANG_QUA: rootUrl_Micro + 'ncc/chi-tra/chi-tra-qua/check-file-import',
        IMPORT_TRO_CAP_QUA: rootUrl_Micro + 'ncc/chi-tra/chi-tra-qua/import-du-lieu',
        XUAT_DANH_SACH_TRUNG: rootUrl_Micro + 'get-data/ncc/chitra/danh-sach-chi-tra-chi-tiet-qua-trung',
        DS_CHI_TRA_QUA_TOAN_HUYEN: rootUrl_Micro + 'ncc/chi-tra/chi-tra-qua/lap-danh-sach-toan-huyen',
        EXPORT_LIST_UU_DAI_GIAO_DUC_C69: rootUrl_Micro + 'get-data/ncc/chitra/xuat-danh-sach-uu-dai-giao-duc-c69',
        LIST_QUA_TRUNG: rootUrl_Micro + 'ncc/chi-tra/chi-tra-qua/danh-sach-trung-qua',
        EXPORT_DANH_SACH_DOI_TUONG_NHAN_QUA: rootUrl_Micro + 'ncc/chi-tra/chi-tra-qua/export-danh-sach-doi-tuong-nhan-qua',
        EXPORT_DANH_SACH_DOI_TUONG_NHAN_QUA_TET_TU_CTN : rootUrl_Micro + "ncc/chi-tra/chi-tra-qua/export-danh-sach-doi-tuong-nhan-qua-tet-tu-ctn",
        EXPORT_DANH_SACH_DOI_TUONG_NHAN_QUA_TET_THO_CUNG : rootUrl_Micro + "ncc/chi-tra/chi-tra-qua/export-danh-sach-doi-tuong-nhan-qua-tet-tho-cung",
        EXPORT_DANH_SACH_NHAN_QUA_TET_THEO_LOAI_DOI_TUONG : rootUrl_Micro + "ncc/chi-tra/chi-tra-qua/export-danh-sach-nhan-qua-tet-theo-loai-doi-tuong",
        //
        LICH_SU_TRO_CAP: rootUrl_Micro + "ncc/chitra/lich-su-dot-tro-cap",
        // Chuyển đến - chuyển đi
        CHUYEN_HS_DI: rootUrl_Micro + "ncc/chuyen-ho-so/yeu-cau-chuyen-ho-so",
        LIST_CHUYEN_HS: rootUrl_Micro + "ncc/chuyen-ho-so/danh-sach-yeu-cau-chuyen-ho-so",
        HUY_YC_CHUYEN: rootUrl_Micro + "ncc/chuyen-ho-so/huy-yeu-cau-chuyen-ho-so",
        DUYET_TC_CHUYEN: rootUrl_Micro + "ncc/chuyen-ho-so/duyet-tu-choi-yeu-cau-chuyen-ho-so",
        YC_TU_CHOI_CHUYEN: rootUrl_Micro + "ncc/chuyen-ho-so/yeu-cau-tu-choi-ho-so",
        GUI_LAI_YC_CHUYEN: rootUrl_Micro + "ncc/chuyen-ho-so/gui-lai-yeu-cau-chuyen-ho-so",
        KIEM_TRA_YC_CHUYEN: rootUrl_Micro + "ncc/chuyen-ho-so/check-yeu-cau-chuyen-ho-so",
        CHUYEN_THANG_SANG_KHAC: rootUrl_Micro + "ncc/chuyen-ho-so/chuyen-ho-so-sang-dp-khac",
        HUY_CHUYEN_THANG: rootUrl_Micro + "ncc/chuyen-ho-so/huy-chuyen-ho-so-sang-dp-khac",
        EXPORT_CHUYEN_DEN_DI: rootUrl_Micro + "ncc/chuyen-ho-so/xuat-yeu-cau-chuyen-ho-so",
        //Giám định y khoa
        THONG_TIN_GDYK : rootUrl_Micro + "ncc/thong-tin-giam-dinh-y-khoa",
        //Cắt chết
        YC_CAT_CHET : rootUrl_Micro + "ncc/cat-chet-ho-so/yeu-cau-cat-chet-ho-so",
        LIST_CAT_CHET : rootUrl_Micro + "ncc/cat-chet-ho-so/danh-sach-yeu-cau-cat-chet-ho-so",
        DUYET_TC_CAT_CHET : rootUrl_Micro + "ncc/cat-chet-ho-so/duyet-tu-choi-yeu-cau-cat-chet",
        XOA_CAT_CHET : rootUrl_Micro + "ncc/cat-chet-ho-so/huy-yeu-cau-cat-chet",
        CAT_CHET: rootUrl_Micro + "ncc/cat-chet-ho-so",
        HUY_CAT_CHET: rootUrl_Micro + "ncc/cat-chet-ho-so/huy-cat-chet-ho-so",
        VAN_BAN_CHINH_SACH: {
          GET_LIST: rootUrl_Micro + "ncc/chinh-sach-van-ban/danh-sach-chinh-sach-van-ban",
          ADD: rootUrl_Micro + "ncc/chinh-sach-van-ban/them-chinh-sach-van-ban",
          UPDATE: rootUrl_Micro + "ncc/chinh-sach-van-ban/cap-nhat-chinh-sach-van-ban",
          UPDATE_STATUS: rootUrl_Micro + "ncc/chinh-sach-van-ban/cap-nhat-trang-thai-chinh-sach-van-ban",
          DELETE: rootUrl_Micro + "ncc/chinh-sach-van-ban/xoa-khoi-phuc-chinh-sach-van-ban",
          UPLOAD_FILE: rootUrl_Micro + "file/file-upload/upload-file",
          DOWNLOAD_FILE: rootUrl_Micro + "file/file-upload/download-file",
        },
        VAN_BAN_EOFFICE: {
          LIST_VAN_BAN: rootUrl_Micro + "file/ncc/danh-sach-file-chuyen-qlvb",
          UPLOAD_FILE: rootUrl_Micro + "file/ncc/chuyenFileQLVB",
          DOWNLOAD_FILE: rootUrl_Micro + "file/ncc/danh-sach-file-chuyen-qlvb/downloadFile",
        },
        BAO_CAO_SO_TAY: rootUrl_Micro + "get-data/ncc/baocao/so-tay-so-lieu-co-ban-cac-linh-vuc",
        BAO_CAO_304: {
          GET_LIST: rootUrl_Micro + "ncc/baocao/ds-tong-hop-304",
          THEM_MOI_UPDATE: rootUrl_Micro + "ncc/baocao/ds-tong-hop-304-save"
        },
        QUAN_LY_VAN_BAN: {
          getDanhSachFileChuyenQLVB: rootUrl_Micro + 'file/ncc/danh-sach-file-chuyen-qlvb',
          dongBoTrangThai: rootUrl_Micro + 'file/ncc/dong-bo-trang-thai',
          chiTietQLVB: rootUrl_Micro + 'file/qlvb/get-chi-tiet-qlvb',
          uploadFileChuyenQLVB: rootUrl_Micro + 'file/ncc/chuyenFileQLVB/uploadFile',
          danhSachFileDinhKemTheoId: rootUrl_Micro + 'file/ncc/danh-sach-file-dinh-kem-theo-id',
          downloadFileUpload: rootUrl_Micro + 'file/qlvb/danh-sach-file-chuyen-qlvb/downloadFile',
        }

    },


    // VLG - Tham số hệ thống
    thamSoHeThong: {
      dmThamSoHeThong: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/danh-sach-tham-so-don-vi',
      capNhatThamSoHeThong: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/them-tham-so-don-vi',
      xoaThamSoHeThong: rootUrl_Micro + 'bao-tro-xa-hoi/v2/co-so-bao-tro/xoa-tham-so-don-vi'

    },



    // Giáo dục nghề nghiệp
    GDNN: {

        BAOCAO: {
            CHUYEN_MON: rootUrl_Micro + 'gdnn/bao-cao-thong-tin-nang-luc-chuyen-mon',
            LIST_TUYEN_SINH: rootUrl_Micro + 'gdnn/tong-hop/danh-sach-tuyen-sinh',
            LIST_THIET_BI: rootUrl_Micro + 'gdnn/tong-hop/danh-sach-thiet-bi',
            LIST_DAO_TAO_NGHE: rootUrl_Micro + 'gdnn/tong-hop/danh-sach-dao-tao-nghe',
            LIST_CO_SO_DAO_TAO: rootUrl_Micro + 'gdnn/tong-hop/danh-sach-co-so-dao-tao',
            LIST_BOI_DUONG: rootUrl_Micro + 'gdnn​/tong-hop​/danh-sach-boi-duong',
            HAILEMOT_GDNN_SO: rootUrl + "gdnn",
            REPORT_CANBO: rootUrl_Micro + "gdnn/bao-cao-danh-sach-can-bo-nha-giao",
            QUA_TRINH_CONG_TAC: rootUrl_Micro + "gdnn/bao-cao-danh-sach-thong-tin-qua-trinh-cong-tac",
            thongTinDayNghe: rootUrl_Micro + "gdnn/bao-cao-stg/thong-tin-day-nghe",
            thongTinCanBo: rootUrl_Micro + "gdnn/bao-cao-stg/thong-tin-can-bo",
            thongTinSinhVien: rootUrl_Micro + "gdnn/bao-cao-stg/thong-tin-sinh-vien",
            coSoDayNghe: rootUrl_Micro + "gdnn/bao-cao-stg/thong-tin-co-so-day-nghe",
            thietBiMuonChuaTra: rootUrl_Micro + "gdnn/bao-cao-stg/thiet-bi-muon-qua-han",
            sinhVienCoMayDauNam: rootUrl_Micro + "gdnn/bao-cao-stg/sv-co-mat-dau-nam-tai-co-so",
            sinhVienTuyenMoi: rootUrl_Micro + "gdnn/bao-cao-stg/sv-tuyen-moi",
            sinhVienTuyenMoiSoCap: rootUrl_Micro + "gdnn/bao-cao-stg/sv-tuyen-moi-so-cap",
            sinhVienTuyenMoiTrungCap: rootUrl_Micro + "gdnn/bao-cao-stg/sv-tuyen-moi-trung-cap",
            sinhVienTuyenMoiCaoDang: rootUrl_Micro + "gdnn/bao-cao-stg/sv-tuyen-moi-cao-dang",
            sinhVienTuyenMoiTheoDienChinhSach: rootUrl_Micro + "gdnn/bao-cao-stg/sv-tuyen-moi-theo-dien-chinh-sach",
            sinhVienTotNghiep: rootUrl_Micro + "gdnn/bao-cao-stg/sv-tot-nghiep",
            sinhVienTotNghiepKhacNam: rootUrl_Micro + "gdnn/bao-cao-stg/sv-tot-nghiep-khac-nam",
            sinhVienTotNghiepCaoDang: rootUrl_Micro + "gdnn/bao-cao-stg/sv-tot-nghiep-cao-dang",
            sinhVienTotNghiepTrungCap: rootUrl_Micro + "gdnn/bao-cao-stg/sv-tot-nghiep-trung-cap",
            sinhVienTotNghiepSoCap: rootUrl_Micro + "gdnn/bao-cao-stg/sv-tot-nghiep-so-cap",
            sinhVienTotNghiepPhanA: rootUrl_Micro + "gdnn/bao-cao-stg/sv-tot-nghiep-phan-a",
            sinhVienTotNghiepPhanB: rootUrl_Micro + "gdnn/bao-cao-stg/sv-tot-nghiep-phan-b",
            DS_HOC_VIEN: rootUrl_Micro + "gdnn/xuat-danh-sach-hoc-vien",
            exportMauImportSinhVien: rootUrl_Micro + "gdnn/xuat-template-import-hoc-vien",
            ImportSinhVien: rootUrl_Micro + "gdnn/import-danh-sach-hoc-vien",
            exportMauImportBoSung: rootUrl_Micro + "gdnn/xuat-mau-bo-sung-ho-so",
            importBoSung: rootUrl_Micro + "gdnn/import-bo-sung-ho-so-hoc-vien"
        },

        VACCEIN: {
            GET_LIST: rootUrl_Micro + 'gdnn/danh-sach-thong-tin-ky-tiem-vaccine',
            ADD: rootUrl_Micro + 'gdnn/them-moi-thong-tin-ky-tiem-vaccine',
            UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-thong-tin-ky-tiem-vaccine',
            DELETE: rootUrl_Micro + 'gdnn/xoa-thong-tin-ky-tiem-vaccine',
            LIST_PHAN_BO: rootUrl_Micro + 'gdnn/danh-sach-dang-ky-tiem-vaccine',
            LIST_TIEM: rootUrl_Micro + 'gdnn/tim-kiem-thong-tin-tiem-vaccine',
            PHAN_BO_LAN_MOT: rootUrl_Micro + 'gdnn/phan-bo-ky-tiem-vaccine-lan-mot',
            PHAN_BO_LAN_HAI: rootUrl_Micro + 'gdnn/phan-bo-ky-tiem-vaccine-lan-hai',
            goiSSO: "https://idp.haugiang.gov.vn/oauth2/token",
        },
        CAN_BO_GIAO_VIEN: {
            CATEGORY_LIST: rootUrl_Micro + 'gdnn/danh-muc-can-bo',
            THEM_CANBO: rootUrl_Micro + 'gdnn/them-moi-thong-tin-can-bo-nha-giao',
            GET_DANH_SACH_PAGEABLE: rootUrl_Micro + 'gdnn/danh-sach-can-bo-nha-giao-pageable',
            GET_DANH_SACH: rootUrl_Micro + 'gdnn/danh-sach-can-bo-nha-giao',
            GIAO_VIEN_CHU_NHIEM_LIST: rootUrl_Micro + 'gdnn/danh-sach-giao-vien-chu-nhiem',
            GIAO_VIEN_LOP_MON_HOC_LIST: rootUrl_Micro + 'gdnn/danh-sach-giao-vien-lop-mon-hoc',
            XOA_CANBO: rootUrl_Micro + 'gdnn/xoa-thong-tin-can-bo-nha-giao',
            UPDATE_MA_CAN_BO: rootUrl_Micro + 'gdnn/cap-nhat-ma-so-can-bo-nha-giao',
            XAC_NHAN: rootUrl_Micro + 'gdnn/xac-nhan-thong-tin-can-bo-nha-giao',
            TU_CHOI: rootUrl_Micro + 'gdnn/tu-choi-thong-tin-can-bo-nha-giao',
            CHUYEN_CONG_TAC: rootUrl_Micro + 'gdnn/thoi-viec-chuyen-cong-tac-can-bo-nha-giao',
            CAP_NHAT_ANH: rootUrl_Micro + 'gdnn/cap-nhat-anh-dai-dien-can-bo-nha-giao',
            GET_CAN_BO_ID: rootUrl_Micro + 'gdnn/thong-tin-can-bo-nha-giao-theo-id',
            CAP_NHAT_CAN_BO: rootUrl_Micro + 'gdnn/cap-nhat-thong-tin-can-bo-nha-giao',
            GET_ANH_DAI_DIEN: rootUrl_Micro + 'file/gdnn/download-file/',
            UPLOAD_ANH_DAI_DIEN: rootUrl_Micro + 'file/gdnn/upload-file',
            CHINH_SACH: rootUrl_Micro + "gdnn/danh-muc/chinh-sach-trong-giao-duc",

        },
        // SINH_VIEN_CAO_DANG: {
        //   CATEGORY_LIST: rootUrl_Micro + 'gdnn/danh-sach-sinh-vien',
        //   COURSE_LIST: rootUrl_Micro + 'gdnn/danh-muc-khoa-hoc',
        //   JOB_LIST: rootUrl_Micro + 'gdnn/danh-muc-lop-hoc-va-nghe',
        //   STUDENT_LIST: rootUrl_Micro + 'gdnn/tim-kiem-tong-quat-hoc-vien',
        //   EXPORT_EXCEL_STUDENT: rootUrl_Micro + 'gdnn/export-excel-hoc-vien-tong-quat',
        //   EXPORT_PDF_STUDENT: rootUrl_Micro + 'gdnn/export-excel-hoc-vien-tong-quat'
        // },
        CAN_BO_QUAN_LY: {
            CATEGORY_LIST: rootUrl_Micro + 'gdnn/danh-muc-can-bo',
            THEM_CANBO: rootUrl_Micro + 'gdnn/them-moi-thong-tin-can-bo-nha-giao',
            CANBO_LIST: rootUrl_Micro + 'gdnn/danh-sach-can-bo-nha-giao',
            XOA_CANBO: rootUrl_Micro + 'gdnn/xoa-thong-tin-can-bo-nha-giao',
            UPDATE_MA_CAN_BO: rootUrl_Micro + 'gdnn/cap-nhat-ma-so-can-bo-nha-giao',
            XAC_NHAN: rootUrl_Micro + 'gdnn/xac-nhan-thong-tin-can-bo-nha-giao',
            TU_CHOI: rootUrl_Micro + 'gdnn/tu-choi-thong-tin-can-bo-nha-giao',
            CHUYEN_CONG_TAC: rootUrl_Micro + 'gdnn/thoi-viec-chuyen-cong-tac-can-bo-nha-giao',
            CAP_NHAT_ANH: rootUrl_Micro + 'gdnn/cap-nhat-anh-dai-dien-can-bo-nha-giao',
            GET_CAN_BO_ID: rootUrl_Micro + 'gdnn/thong-tin-can-bo-nha-giao-theo-id',
            CAP_NHAT_CAN_BO: rootUrl_Micro + 'gdnn/cap-nhat-thong-tin-can-bo-nha-giao',
            GET_ANH_DAI_DIEN: rootUrl_Micro + 'file/gdnn/download-file/',
            UPLOAD_ANH_DAI_DIEN: rootUrl_Micro + 'file/gdnn/upload-file',
            CHINH_SACH: rootUrl_Micro + "gdnn/danh-muc/chinh-sach-trong-giao-duc",

        },
        CO_SO_VAT_CHAT: {
            CSVC_LIST: rootUrl_Micro + 'gdnn/danh-sach-thong-tin-co-so-vat-chat',
            CSVC_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-thong-tin-co-so-vat-chat',
            CSVC_DELETE: rootUrl_Micro + 'gdnn/xoa-thong-tin-co-so-vat-chat',
            CSVC_CREATE: rootUrl_Micro + 'gdnn/them-moi-thong-tin-co-so-vat-chat',
            PHONG_UNG_DUNG_LIST: rootUrl_Micro + 'gdnn/danh-sach-thong-tin-phong-ung-dung',
            PHONG_UNG_DUNG_ADD: rootUrl_Micro + 'gdnn/them-moi-thong-tin-phong-ung-dung',
            PHONG_UNG_DUNG_DELETE: rootUrl_Micro + 'gdnn/xoa-thong-tin-phong-ung-dung',
            PHONG_UNG_DUNG_EDIT: rootUrl_Micro + 'gdnn/cap-nhat-thong-tin-phong-ung-dung',
        },
        CHUONG_TRINH: {
            //   CATEGORY_LIST: rootUrl_Micro + 'gdnn/danh-muc-csdt-va-gtdt',
            CHUONGTRINH_LIST: rootUrl_Micro + 'gdnn/danh-sach-ctdt',
            CHUONGTRINH_LIST_ID: rootUrl_Micro + 'gdnn/tim-kiem-chuong-trinh-dao-tao-id',
            THEM_CHUONGTRINH: rootUrl_Micro + 'gdnn/cap-nhat-ctdt',

            XOA_CHUONGTRINH: rootUrl_Micro + 'gdnn/xoa-thong-tin-chuong-trinh-dao-tao',
            CHUONGTRINH_LIST_TIMKIEM: rootUrl_Micro + 'gdnn/danh-sach-thong-tin-chuong-trinh-dao-tao',
            GET_DS_CHUONG_TRINH: rootUrl_Micro + 'gdnn/get-danh-sach-chuong-trinh-dao-tao',
            THEM_CHUONGTRINHDAOTAO: rootUrl_Micro + 'gdnn/them-moi-thong-tin-chuong-trinh-dao-tao',
            SUA_CHUONGTRINHDAOTAO: rootUrl_Micro + 'gdnn/cap-nhat-thong-chuong-trinh-dao-tao',
            CAPNHAT_CHUONGTRINHDAOTAO: rootUrl_Micro + 'gdnn/cap-nhat-chuong-trinh-dao-tao',

            MON_LIST: rootUrl_Micro + 'gdnn/danh-sach-thong-tin-mon-hoc',
            THEM_MON: rootUrl_Micro + 'gdnn/them-moi-mon-hoc-vao-chuong-trinh',
            SUA_MON: rootUrl_Micro + 'gdnn/cap-nhat-thong-tin-mon-Hoc',
            XOA_MON: rootUrl_Micro + 'gdnn/xoa-mon-hoc-trong-chuong-trinh',
            SAO_CHEP: rootUrl_Micro + 'gdnn/sao-chep-thong-tin-chuong-trinh-dao-tao',
        },
        GIAO_TRINH: {
            GIAOTRINH_LIST: rootUrl_Micro + 'gdnn/tim-kiem-thong-tin-giao-trinh-dao-tao',
            THEM_GIAOTRINH: rootUrl_Micro + 'gdnn/them-moi-thong-tin-giao-trinh-dao-tao',
            XOA_GIAOTRINH: rootUrl_Micro + 'gdnn/xoa-thong-tin-giao-trinh-dao-tao',
            CAP_NHAT_GIAOTRINH: rootUrl_Micro + 'gdnn/cap-nhat-thong-tin-giao-trinh-dao-tao',
        },
        THIET_BI_DAO_TAO: {
            TBDT_LIST: rootUrl_Micro + 'gdnn/danh-sach-thong-tin-thiet-bi-dao-tao',
            TBDT_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-thong-tin-thiet-bi-dao-tao',
            TBDT_DELETE: rootUrl_Micro + 'gdnn/xoa-thong-tin-thiet-bi-dao-tao',
            //   TBDT_DANH_MUC: rootUrl_Micro + 'gdnn/danh-muc-csdt-va-gtdt',
            TBDT_THEM: rootUrl_Micro + 'gdnn/them-moi-thong-tin-thiet-bi-dao-tao',
            PUD_LIST: rootUrl_Micro + 'gdnn/danh-sach-thong-tin-phong-ung-dung',
        },
        SUBJECT: {
            SUBJECT_LIST: rootUrl_Micro + 'gdnn/tim-kiem-thong-tin-mon-hoc',
            SUBJECT_ADD: rootUrl_Micro + 'gdnn/them-moi-thong-tin-mon-hoc',
            SUBJECT_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-thong-tin-mon-Hoc',
            SUBJECT_DELETE: rootUrl_Micro + 'gdnn/xoa-thong-tin-mon-hoc',
        },
        HOC_KY: {
            HOC_KY_LIST: rootUrl_Micro + 'gdnn/danh-muc-hoc-ky',
            HOC_KY_ADD: rootUrl_Micro + 'gdnn/them-moi-danh-muc-hoc-ky',
            HOC_KY_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-danh-muc-hoc-ky',
            HOC_KY_DELETE: rootUrl_Micro + 'gdnn/xoa-danh-muc-hoc-ky',
            HOC_KY_KTX: rootUrl_Micro + 'gdnn/danh-sach-hoc-ky-dang-ky-ktx',
        },
        CSDT: {
            CSDT_LIST: rootUrl_Micro + 'gdnn/danh-sach-thong-tin-co-so-dao-tao',
            CSDT_ADD: rootUrl_Micro + 'gdnn/them-moi-thong-tin-co-so-dao-tao',
            CSDT_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-thong-tin-co-so-dao-tao',
            CSDT_DELETE: rootUrl_Micro + 'gdnn/xoa-thong-tin-co-so-dao-tao',
        },
        KTX: {
            CREATE: rootUrl_Micro + 'gdnn/them-moi-thong-tin-ky-thuc-xa',
            UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-thong-tin-ky-thuc-xa',
            DELETE: rootUrl_Micro + 'gdnn/xoa-thong-tin-ky-thuc-xa',
        },
        DANH_MUC: {
            DANTOC_LIST: rootUrl_Micro + 'gdnn/danh-muc-dan-toc',
            DANTOC_ADD: rootUrl_Micro + 'gdnn/them-moi-danh-muc-dan-toc',
            DANTOC_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-danh-muc-dan-toc',
            DANTOC_DELETE: rootUrl_Micro + 'gdnn/xoa-danh-muc-dan-toc',
            DANTOC_SEARCH: rootUrl_Micro + 'gdnn/danh-muc-dan-toc-by-ten',

            TONGIAO_LIST: rootUrl_Micro + 'gdnn/danh-muc-ton-giao',
            TONGIAO_ADD: rootUrl_Micro + 'gdnn/them-moi-danh-muc-ton-giao',
            TONGIAO_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-danh-muc-ton-giao',
            TONGIAO_DELETE: rootUrl_Micro + 'gdnn/xoa-danh-muc-ton-giao',
            TONGIAO_SEARCH: rootUrl_Micro + 'gdnn/danh-muc-ton-giao-by-ten',

            KHUVUCTUYENSINH_LIST: rootUrl_Micro + 'gdnn/danh-muc-khu-vuc-tuyen-sinh',
            KHUVUCTUYENSINH_ADD: rootUrl_Micro + 'gdnn/them-moi-danh-muc-khu-vuc-tuyen-sinh',
            KHUVUCTUYENSINH_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-danh-muc-khu-vuc-tuyen-sinh',
            KHUVUCTUYENSINH_DELETE: rootUrl_Micro + 'gdnn/xoa-danh-muc-khu-vuc-tuyen-sinh',

            DOITUONGTUYENSINH_LIST: rootUrl_Micro + 'gdnn/danh-muc-doi-tuong-tuyen-sinh',
            DOITUONGTUYENSINH_ADD: rootUrl_Micro + 'gdnn/them-moi-danh-muc-doi-tuong-tuyen-sinh',
            DOITUONGTUYENSINH_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-danh-muc-doi-tuong-tuyen-sinh',
            DOITUONGTUYENSINH_DELETE: rootUrl_Micro + 'gdnn/xoa-danh-muc-doi-tuong-tuyen-sinh',

            TIENTINCHI_LIST: rootUrl_Micro + 'gdnn/danh-muc-tien-tin-chi',
            TIENTINCHI_ADD: rootUrl_Micro + 'gdnn/them-moi-danh-muc-tien-tin-chi',
            TIENTINCHI_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-danh-muc-tien-tin-chi',
            TIENTINCHI_DELETE: rootUrl_Micro + 'gdnn/xoa-danh-muc-tien-tin-chi',

            THANHPHANGIADINH_LIST: rootUrl_Micro + 'gdnn/danh-muc-thanh-phan-gia-dinh',
            THANHPHANGIADINH_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-danh-muc-thanh-phan-gia-dinh',
            THANHPHANGIADINH_ADD: rootUrl_Micro + 'gdnn/them-moi-danh-muc-thanh-phan-gia-dinh',
            THANHPHANGIADINH_DELETE: rootUrl_Micro + 'gdnn/xoa-danh-muc-thanh-phan-gia-dinh',
            THANHPHANGIADINH_SEARCH: rootUrl_Micro + 'gdnn/danh-muc-thanh-phan-gia-dinh-by-ten',

            HINHTHUCDONGHOCPHI_LIST: rootUrl_Micro + 'gdnn/danh-muc-hinh-thuc-dong-hoc-phi',
            HINHTHUCDONGHOCPHI_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-hinh-thuc-dong-hoc-phi',
            HINHTHUCDONGHOCPHI_DELETE: rootUrl_Micro + 'gdnn/xoa-hinh-thuc-dong-hoc-phi',

            HINHTHUCTUYENSINH_LIST: rootUrl_Micro + 'gdnn/danh-muc-hinh-thuc-tuyen-sinh',
            HINHTHUCTUYENSINH_ADD: rootUrl_Micro + 'gdnn/them-moi-danh-muc-hinh-thuc-tuyen-sinh',
            HINHTHUCTUYENSINH_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-danh-muc-hinh-thuc-tuyen-sinh',
            HINHTHUCTUYENSINH_DELETE: rootUrl_Micro + 'gdnn/xoa-danh-muc-hinh-thuc-tuyen-sinh',

            NGANH_LIST: rootUrl_Micro + 'gdnn/danh-sach-thong-tin-nganh',
            NGANH_TIM_KIEM: rootUrl_Micro + 'gdnn/tim-kiem-nganh',
            NGANH_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-thong-tin-nganh',
            NGANH_ADD: rootUrl_Micro + 'gdnn/them-moi-thong-tin-nganh',
            NGANH_DELETE: rootUrl_Micro + 'gdnn/xoa-thong-tin-nganh',

            CHINHSACH_LIST: rootUrl_Micro + 'gdnn/danh-muc-dien-chinh-sach',
            CHINHSACH_ADD: rootUrl_Micro + 'gdnn/them-moi-danh-muc-dien-chinh-sach',
            CHINHSACH_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-danh-muc-dien-chinh-sach',
            CHINHSACH_DELETE: rootUrl_Micro + 'gdnn/xoa-danh-muc-dien-chinh-sach',

            KHOA: rootUrl_Micro + 'gdnn/danh-sach-thong-tin-khoa',
            KHOA_ADD: rootUrl_Micro + 'gdnn/them-moi-thong-tin-khoa',
            KHOA_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-thong-tin-khoa',
            kHOA_DELETE: rootUrl_Micro + 'gdnn/xoa-thong-tin-khoa',


            HEDAOTAO_LIST: rootUrl_Micro + 'gdnn/danh-sach-thong-tin-he-dao-tao',
            HEDAOTAO_CREATE: rootUrl_Micro + 'gdnn/them-moi-thong-tin-he-dao-tao',
            HEDAOTAO_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-thong-tin-he-dao-tao',
            HEDAOTAO_DELETE: rootUrl_Micro + 'gdnn/xoa-thong-tin-he-dao-tao',

            NIENKHOA_LIST: rootUrl_Micro + 'gdnn/tim-kiem-danh-muc-nien-khoa',
            NIENKHOA_ADD: rootUrl_Micro + 'gdnn/them-moi-danh-muc-nien-khoa',
            NIENKHOA_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-danh-muc-nien-khoa',
            NIENKHOA_DELETE: rootUrl_Micro + 'gdnn/xoa-danh-muc-nien-khoa',

            HINHTHUCDAOTAO_LIST: rootUrl_Micro + 'gdnn/danh-muc-hinh-thuc-dao-tao',
            HINHTHUCDAOTAO_ADD: rootUrl_Micro + 'gdnn/them-moi-danh-muc-hinh-thuc-dao-tao',
            HINHTHUCDAOTAO_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-danh-muc-hinh-thuc-dao-tao',
            HINHTHUCDAOTAO_DELETE: rootUrl_Micro + 'gdnn/xoa-danh-muc-hinh-thuc-dao-tao',

            DOITUONGUUTIEN_LIST: rootUrl_Micro + 'gdnn/danh-muc-doi-tuong-uu-tien',
            DOITUONGUUTIEN_ADD: rootUrl_Micro + 'gdnn/them-moi-danh-muc-doi-tuong-uu-tien',
            DOITUONGUUTIEN_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-danh-muc-doi-tuong-uu-tien',
            DOITUONGUUTIEN_DELETE: rootUrl_Micro + 'gdnn/xoa-danh-muc-doi-tuong-uu-tien',

            THONGTU_EDIT: rootUrl_Micro + "gdnn/cap-nhat-danh-muc-thong-tu-tuyen-sinh",
            THONGTU_ADD: rootUrl_Micro + "gdnn/them-moi-danh-muc-thong-tu-tuyen-sinh",
            THONGTU_DELETE: rootUrl_Micro + "gdnn/xoa-danh-muc-thong-tu-tuyen-sinh",
            THONGTU_LIST: rootUrl_Micro + "gdnn/danh-muc-thong-tu-tuyen-sinh",

            LEPHIKHAC_EDIT: rootUrl_Micro + "gdnn/cap-nhat-danh-muc-le-phi-khac",
            LEPHIKHAC_ADD: rootUrl_Micro + "gdnn/them-moi-danh-muc-le-phi-khac",
            LEPHIKHAC_DELETE: rootUrl_Micro + "gdnn/xoa-danh-muc-le-phi-khac",
            LEPHIKHAC_LIST: rootUrl_Micro + "gdnn/danh-muc-le-phi-khac",

            getListTrinhDoGD: rootUrl_Micro + "gdnn/danh-muc-trinh-do-giang-day",
            themTrinhDoGiangDay: rootUrl_Micro + 'gdnn/them-moi-danh-muc-trinh-do-giang-day',
            suaTrinhDoGiangDay: rootUrl_Micro + 'gdnn/cap-nhat-danh-muc-trinh-do-giang-day',
            xoaTrinhDoGiangDay: rootUrl_Micro + 'gdnn/xoa-danh-muc-trinh-do-giang-day',

            themChucVuCB: rootUrl_Micro + "gdnn/them-moi-danh-muc-chuc-vu-can-bo",
            capNhatChucVuCB: rootUrl_Micro + "gdnn/cap-nhat-danh-muc-chuc-vu-can-bo",
            xoaChucVuCB: rootUrl_Micro + "gdnn/xoa-danh-muc-chuc-vu-can-bo",
            getListChucVuCB: rootUrl_Micro + "gdnn/danh-muc-chuc-vu-can-bo",

            getListNgach: rootUrl_Micro + "gdnn/danh-muc-ngach",
            capNhatNgach: rootUrl_Micro + "gdnn/cap-nhat-danh-muc-ngach",
            xoaNgach: rootUrl_Micro + "gdnn/xoa-danh-muc-ngach",
            themNgach: rootUrl_Micro + "gdnn/them-moi-danh-muc-ngach",

            searchChuyenMonNV: rootUrl_Micro + "gdnn/danh-muc-chuyen-mon-nghiep-vu/tim-kiem",
            getListChuyenMonNV: rootUrl_Micro + "gdnn/danh-muc-chuyen-mon-nghiep-vu",
            capNhatChuyenMonNV: rootUrl_Micro + 'gdnn/cap-nhat-danh-muc-chuyen-mon-nghiep-vu',
            xoaChuyenMonNV: rootUrl_Micro + 'gdnn/xoa-danh-muc-chuyen-mon-nghiep-vu',
            themChuyenMonNV: rootUrl_Micro + 'gdnn/them-moi-danh-muc-chuyen-mon-nghiep-vu',

            getListHoaDon: rootUrl_Micro + "gdnn/danh-muc-hoa-don",
            capNhatHoaDon: rootUrl_Micro + "gdnn/cap-nhat-danh-muc-hoa-don",
            xoaHoaDon: rootUrl_Micro + "gdnn/xoa-danh-muc-hoa-don",
            themHoaDon: rootUrl_Micro + "gdnn/them-moi-danh-muc-hoa-don"


            // NGHEDAOTAO_LIST: rootUrl_Micro + 'gdnn/danh-muc-nghe-dao-tao',
            // NGHEDAOTAO_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-nghe-dao-tao',
            // NGHEDAOTAO_DELETE: rootUrl_Micro + 'gdnn/xoa-nghe-dao-tao',
            // KYNANGNGHE_LIST: rootUrl_Micro + 'gdnn/danh-muc-ky-nang-nghe',
            // KYNANGNGHE_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-ky-nang-nghe',
            // KYNANGNGHE_DELETE: rootUrl_Micro + 'gdnn/xoa-ky-nang-nghe',
            // KETQUAHOCTAP_LIST: rootUrl_Micro + 'gdnn/danh-muc-ket-qua-hoc-tap',
            // KETQUAHOCTAP_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-ket-qua-hoc-tap',
            // KETQUAHOCTAP_DELETE: rootUrl_Micro + 'gdnn/xoa-ket-qua-hoc-tap',
            // CHUYENNGANHDAOTAO_LIST: rootUrl_Micro + 'gdnn/danh-muc-chuyen-nganh-dao-tao',
            // CHUYENNGANHDAOTAO_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-chuyen-nganh-dao-tao',
            // CHUYENNGANHDAOTAO_DELETE: rootUrl_Micro + 'gdnn/xoa-chuyen-nganh-dao-tao',
            // NGHIEPVUSUPHAM_LIST: rootUrl_Micro + 'gdnn/danh-muc-nghiep-vu-su-pham',
            // NGHIEPVUSUPHAM_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-nghiep-vu-su-pham',
            // NGHIEPVUSUPHAM_DELETE: rootUrl_Micro + 'gdnn/xoa-nghiep-vu-su-pham',
            // LYLUANCHINHTRI_LIST: rootUrl_Micro + 'gdnn/danh-muc-ly-luan-chinh-tri',
            // LYLUANCHINHTRI_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-ly-luan-chinh-tri',
            // LYLUANCHINHTRI_DELETE: rootUrl_Micro + 'gdnn/xoa-ly-luan-chinh-tri',
            // CHUC_VU: rootUrl_Micro + 'gdnn/danh-muc/chuc-vu',//new
            // CHUCVU_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-chuc-vu',
            // CHUCVU_DELETE: rootUrl_Micro + 'gdnn/xoa-chuc-vu',
            // CHUYENMONNGHIEPVU_LIST: rootUrl_Micro + 'gdnn/danh-muc-chuyen-mon-nghiep-vu',
            // CHUYENMONNGHIEPVU_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-chuyen-mon-nghiep-vu',
            // CHUYENMONNGHIEPVU_DELETE: rootUrl_Micro + 'gdnn/xoa-chuyen-mon-nghiep-vu',
            // HINHTHUCTUYENDUNG_LIST: rootUrl_Micro + 'gdnn/danh-muc-hinh-thuc-tuyen-dung',
            // HINHTHUCTUYENDUNG_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-hinh-thuc-tuyen-dung',
            // HINHTHUCTUYENDUNG_DELETE: rootUrl_Micro + 'gdnn/xoa-hinh-thuc-tuyen-dung',
            // QUANLYNHANUOC_LIST: rootUrl_Micro + 'gdnn/danh-muc-quan-ly-nha-nuoc',
            // QUANLYNHANUOC_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-quan-ly-nha-nuoc',
            // QUANLYNHANUOC_DELETE: rootUrl_Micro + 'gdnn/xoa-quan-ly-nha-nuoc',
            // HINHTHUCGIANGDAY_LIST: rootUrl_Micro + 'gdnn/danh-muc-hinh-thuc-giang-day',
            // HINHTHUCGIANGDAY_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-hinh-thuc-giang-day',
            // HINHTHUCGIANGDAY_DELETE: rootUrl_Micro + 'gdnn/xoa-hinh-thuc-giang-day',
            // TRINHDOGIANGDAY_LIST: rootUrl_Micro + 'gdnn/danh-muc-trinh-do-giang-day',
            // TRINHDOGIANGDAY_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-trinh-do-giang-day',
            // TRINHDOGIANGDAY_DELETE: rootUrl_Micro + 'gdnn/xoa-trinh-do-giang-day',
            // NGHENGHIEPGIANGDAY_LIST: rootUrl_Micro + 'gdnn/danh-muc-nghe-nghiep-giang-day',
            // NGHENGHIEPGIANGDAY_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-nghe-nghiep-giang-day',
            // NGHENGHIEPGIANGDAY_DELETE: rootUrl_Micro + 'gdnn/xoa-nghe-nghiep-giang-day',
            // CHUCVUCANBO_LIST: rootUrl_Micro + 'gdnn/danh-muc-chuc-vu-can-bo',
            // CHUCVUCANBO_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-chuc-vu-can-bo',
            // CHUCVUCANBO_DELETE: rootUrl_Micro + 'gdnn/xoa-chuc-vu-can-bo',
        },
        DIEM: {
            GET_DIEM: rootUrl_Micro + 'gdnn/danh-sach-thong-tin-diem-tung-mon',
            TIM_KIEM_DIEM_LAN_MOT: rootUrl_Micro + 'gdnn/danh-sach-hoc-vien-thi-lai',
            DANH_GIA: rootUrl_Micro + 'gdnn/danh-gia-thong-tin-tung-mon',
            DIEM_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-thong-tin-diem-mon-Hoc',
            LAP_DANH_SACH_THI: rootUrl_Micro + 'gdnn/len-danh-sach-thi-theo-mon-hoc',
            DIEM_THI_LAI_UPDATE: rootUrl_Micro + 'gdnn/cap-nhap-diem-thi-lai-hoc-vien',

            THANHTOAN_HOCPHI: rootUrl_Micro + 'gdnn/cap-nhat-thong-tin-hoc-phi-mon-hoc',
            THANHTOAN_VNPT_PAY: rootUrl_Micro + 'gdnn/initial-payment-transaction',
            HOC_PHI: rootUrl_Micro + 'gdnn/danh-sach-thong-tin-hoc-phi-mon-hoc',
            GET_HOC_VIEN_ID: rootUrl_Micro + 'gdnn/ma-hoc-vien-theo-co-so-dao-tao',
            GET_MA_HOC_VIEN_ID: rootUrl_Micro + 'gdnn/ma-hoc-vien-id-theo-co-so-dao-tao',
            THONG_TIN_CO_BAN_HOC_VIEN: rootUrl_Micro + 'gdnn/thong-tin-co-ban-hoc-vien',
            HOC_PHI_THEO_LOP: rootUrl_Micro + 'gdnn/danh-sach-thong-tin-hoc-phi-theo-lop',
            THANHTOAN_HOC_PHI_THEO_LOP: rootUrl_Micro + 'gdnn/cap-nhat-thong-tin-hoc-phi-theo-lop',
            THONG_KE_LE_PHI_THI: rootUrl_Micro + 'gdnn/thong-ke-le-phi-tuyen-sinh',
            hocPhiTheoThang: rootUrl_Micro + 'gdnn/danh-sach-thong-tin-hoc-phi-mon-hoc-theo-ky',
            thanhToanTheoThang: rootUrl_Micro + 'gdnn/cap-nhat-thong-tin-hoc-phi-mon-hoc-theo-ky',
            ketXuatHocPhi: rootUrl_Micro + 'gdnn/danh-sach-ket-xuat-thong-tin-hoc-phi-theo-ky',
            xepGiaoVienChamThi: rootUrl_Micro + "gdnn/xep-giao-vien-cham-thi",
            getTrangBiaHoaDon: rootUrl_Micro + "gdnn/xuat-hoa-don-hoc-phi-theo-ky",

            getHoaDonTheoTinChi: rootUrl_Micro + "gdnn/xuat-hoa-don-hoc-phi-theo-tin-chi",
            getHoaDonLePhi: rootUrl_Micro + 'gdnn/xuat-hoa-don-le-phi',
            getHocPhiTheoThang: rootUrl_Micro + 'gdnn/danh-sach-thong-tin-hoc-phi-theo-nganh',
            deletePhiTheoNganh: rootUrl_Micro + "gdnn/xoa-hoc-phi-mon-hoc",

            GET_LICH_THI: rootUrl_Micro + 'gdnn/danh-sach-lich-thi',
            ADD_LICH_THI: rootUrl_Micro + 'gdnn/them-moi-thong-tin-lich-thi',
            UPDATE_LICHTHI: rootUrl_Micro + 'gdnn/cap-nhat-thong-tin-lich-thi',
            LIST_DUTHI: rootUrl_Micro + 'gdnn/danh-sach-du-dieu-kien-du-thi',
            XEP_LICH_THI: rootUrl_Micro + 'gdnn/xep-lich-thi-theo-phong',
            DANH_SACH_DU_THI: rootUrl_Micro + 'gdnn/danh-sach-du-thi',
            getLopDuThi: rootUrl_Micro + 'gdnn/danh-sach-lop-du-thi',
            addLopDuThi: rootUrl_Micro + 'gdnn/them-moi-lop-du-thi',
            xoaLopDuThi: rootUrl_Micro + 'gdnn/xoa-lop-du-thi',
            danhSoBaoDanh: rootUrl_Micro + 'gdnn/danh-so-bao-danh',
            danhPhachMaDe: rootUrl_Micro + 'gdnn/danh-so-phach-ma-de',
            chamThi: rootUrl_Micro + 'gdnn/danh-sach-cham-diem-theo-phach',
            diemThiTheoPhach1: rootUrl_Micro + 'gdnn/cham-diem-thi-lan-mot-theo-phach',
            diemThiTheoPhach2: rootUrl_Micro + 'gdnn/cham-diem-thi-lan-hai-theo-phach',
            diemThiTheoPhach3: rootUrl_Micro + 'gdnn/cham-diem-thi-tong-ket-theo-phach',
            getListDiemThiTheoMonTheoLop: rootUrl_Micro + "gdnn/danh-sach-diem-thi",
            getListNghiemThu: rootUrl_Micro + "gdnn/danh-sach-nghiem-thu-coi-thi",
            getListNghiemThuChamThi: rootUrl_Micro + "gdnn/danh-sach-nghiem-thu-cham-thi",
            getListCoiThi: rootUrl_Micro + "gdnn/danh-sach-coi-thi",


            GET_LIST_MON_TOT_NGHIEP: rootUrl_Micro + 'gdnn/danh-sach-mon-tot-nghiep-theo-lop',
            GET_LIST_DIEM_TOT_NGHIEP_THEO_LOP: rootUrl_Micro + 'gdnn/danh-sach-diem-tot-nghiep-theo-lop',
            UPDATE_DIEM_TOT_NGHIEP_THEO_LOP: rootUrl_Micro + 'gdnn/cap-nhat-thong-tin-diem-tot-nghiep',
            GET_LIST_NGAY_TOT_NGHIEP: rootUrl_Micro + 'gdnn/danh-sach-ngay-thi-theo-lop',

            PHAN_BO_DIEM_REN_LUYEN: rootUrl_Micro + 'gdnn/phan-bo-diem-ren-luyen-theo-hoc-ky',
            DIEM_REN_LUYEN: rootUrl_Micro + 'gdnn/danh-sach-diem-ren-luyen-theo-hoc-ky',
            UPDATE_DIEM_REN_LUYEN: rootUrl_Micro + 'gdnn/danh-gia-diem-ren-luyen-theo-hoc-ky',
            updateGhiChu: rootUrl_Micro + 'gdnn/cap-nhat-ghi-chu-ren-luyen',
            THANG_THEO_HOC_KY: rootUrl_Micro + 'gdnn/danh-sach-thang-theo-hoc-ky',
            LIST_REN_LUYEN_THEO_HK: rootUrl_Micro + 'gdnn/danh-sach-diem-ren-luyen-theo-hoc-ky',

            DIEM_HOC_LAI: rootUrl_Micro + 'gdnn/danh-sach-hoc-vien-hoc-lai',
            LIST_HOC_LAI: rootUrl_Micro + 'gdnn/thiet-lap-diem-hoc-lai',
            LIST_DK_KTX: rootUrl_Micro + 'gdnn/tim-kiem-thong-tin-ktx',
            DK_HK_KTX: rootUrl_Micro + 'gdnn/danh-sach-hoc-ky-dang-ky-ktx',
            KTX_PHI: rootUrl_Micro + 'gdnn/thanh-toan-ktx-phi',
            listDangOKTX: rootUrl_Micro + 'gdnn/danh-sach-dang-o-ktx',
            thanhToanPhiKTX: rootUrl_Micro + 'gdnn/thanh-toan-ktx-phi',

            listLePhiKhac: rootUrl_Micro + 'gdnn/danh-sach-le-phi-khac-hoc-vien',
            themLePhiKhac: rootUrl_Micro + 'gdnn/them-moi-thong-tin-le-phi-khac-hoc-vien',
            suaLePhiKhac: rootUrl_Micro + 'gdnn/cap-nhat-thong-tin-le-phi-khac-hoc-vien',
            xoaLePhiKhac: rootUrl_Micro + 'gdnn/xoa-thong-tin-le-phi-khac-hoc-vien',

            themHocPhiTheoThang: rootUrl_Micro + 'gdnn/them-moi-hoc-phi-theo-tung-nganh',
            capNhatHocPhiTheoThang: rootUrl_Micro + 'gdnn/cap-nhat-hoc-phi-theo-tung-nganh',

            //old
            DIEM_LIST: rootUrl_Micro + 'gdnn/danh-muc-diem-sinh-vien',
            DIEM_ADD: rootUrl_Micro + 'gdnn/them-moi-diem-sinh-vien',
            DIEM_DELETE: rootUrl_Micro + 'gdnn/xoa-diem-sinh-vien',
            MON_HOC_LIST: rootUrl_Micro + 'gdnn/danh-sach-mon-hoc',
            HEN_NGAY: rootUrl_Micro + 'gdnn/cap-nhat-ngay-hen',
            HOC_BONG: rootUrl_Micro + 'gdnn/danh-sach-xet-bong',

            DIEM_TONG_KET_LIST: rootUrl_Micro + 'gdnn/tim-kiem-diem-tong-ket',

            DELETE_LICHTHI: rootUrl_Micro + 'gdnn/xoa-thong-tin-lich-thi',
            GET_DANH_SACH_THI_TONG_QUAT: rootUrl_Micro + 'gdnn/tim-kiem-danh-sach-thi',
            GET_XAC_NHAN: rootUrl_Micro + 'gdnn/them-moi-danh-sach-thi-has-lich-thi',
            GET_DANH_SACH_THI: rootUrl_Micro + 'gdnn/tim-kiem-tong-quat-lich-thi',

            GET_THONG_KE_DIEM: rootUrl_Micro + 'gdnn/thong-ke-diem-lan-mot',

            LE_PHI_THEO_HOC_KY: rootUrl_Micro + 'gdnn/tim-le-phi-theo-hoc-ky',
            TEMPLATE_IMPORT_DIEM_TUNG_MON: rootUrl_Micro + 'gdnn/template-import-excel',
            EXPORT_EXCEL_DIEM_TUNG_MON: rootUrl_Micro + 'gdnn/diem-tung-mon-export-excel',
            IMPORT_EXCEL_DIEM_TUNG_MON: rootUrl_Micro + 'gdnn/diem-tung-mon-import',
            EXCEL_CHECK_DATA_IMPORT: rootUrl_Micro + 'gdnn/check-data-import'
        },
        TUYEN_SINH: {
            KYTUYENSINH_LIST: rootUrl_Micro + 'gdnn/danh-sach-thong-tin-ky-tuyen-sinh',
            KYTUYENSINH_THEM: rootUrl_Micro + 'gdnn/them-moi-thong-tin-ky-tuyen-sinh',
            KYTUYENSINH_SUA: rootUrl_Micro + 'gdnn/cap-nhat-thong-tin-ky-tuyen-sinh',
            KYTUYENSINH_XOA: rootUrl_Micro + 'gdnn/xoa-thong-tin-ky-tuyen-sinh',
            DONG_KYTUYENSINH: rootUrl_Micro + 'gdnn/dong-ky-tuyen-sinh',

            TUYEN_SINH_HOC_BA_LIST: rootUrl_Micro + 'gdnn/danh-sach-tuyen-sinh-hoc-ba-theo-ky',
            TUYEN_SINH_HOC_BA_ADD: rootUrl_Micro + 'gdnn/them-moi-thong-tin-tuyen-sinh-theo-hoc-ba',
            TUYEN_SINH_HOC_BA_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-thong-tin-tuyen-sinh-theo-hoc-ba',
            TUYEN_SINH_HOC_BA_DELETE: rootUrl_Micro + 'gdnn/xoa-thong-tin-tuyen-sinh-theo-hoc-ba',

            TUYEN_SINH_LIEN_THONG_LIST: rootUrl_Micro + 'gdnn/danh-sach-tuyen-sinh-lien-thong-theo-ky',
            TUYEN_SINH_LIEN_THONG_ADD: rootUrl_Micro + 'gdnn/them-moi-thong-tin-tuyen-sinh-lien-thong',
            TUYEN_SINH_LIEN_THONG_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-thong-tin-tuyen-sinh-lien-thong',
            TUYEN_SINH_LIEN_THONG_DELETE: rootUrl_Micro + 'gdnn/xoa-thong-tin-tuyen-sinh-lien-thong',

            XET_TUYEN_HOC_BA: rootUrl_Micro + 'gdnn/xet-tuyen-theo-hoc-ba',
            XET_TUYEN_THEO_HOC_BA_LIST: rootUrl_Micro + 'gdnn/danh-sach-xet-tuyen-theo-hoc-ba',
            XET_TUYEN_LIEN_THONG: rootUrl_Micro + 'gdnn/xet-tuyen-lien-thong',
            XET_TUYEN_LIEN_THONG_LIST: rootUrl_Micro + 'gdnn/danh-sach-xet-tuyen-lien-thong',

            TUYEN_SINH_LIST: rootUrl_Micro + 'gdnn/danh-sach-tuyen-sinh',
            TUYEN_SINH_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-tuyen-sinh',
            TUYEN_SINH_DELETE: rootUrl_Micro + 'gdnn/xoa-tuyen-sinh',
            HINH_THUC_TUYEN_SINH_LIST: rootUrl_Micro + 'gdnn/danh-muc-hinh-thuc-tuyen-sinh',
            HINH_THUC_TUYEN_SINH_SEARCH: rootUrl_Micro + 'gdnn/danh-muc-hinh-thuc-tuyen-sinh-by-ten',
            NGANH_LIST: rootUrl_Micro + 'gdnn/danh-muc-nganh',
            SINHVIEN_LIST: rootUrl_Micro + 'gdnn/tim-kiem-hoc-vien',
            SINHVIEN_ID: rootUrl_Micro + 'gdnn/tim-kiem-hoc-vien-id',
            SINHVIEN_THEM: rootUrl_Micro + 'gdnn/them-moi-hoc-vien',
            SINHVIEN_SUA: rootUrl_Micro + 'gdnn/cap-nhat-hoc-vien',
            SINHVIEN_XOA: rootUrl_Micro + 'gdnn/xoa-hoc-vien',
            NGUOITHAN_LIST: rootUrl_Micro + 'gdnn/danh-sach-nguoi-than',
            NGUOITHAN_THEM: rootUrl_Micro + 'gdnn/them-moi-nguoi-than',
            NGUOITHAN_SUA: rootUrl_Micro + 'gdnn/cap-nhat-nguoi-than',
            NGUOITHAN_XOA: rootUrl_Micro + 'gdnn/xoa-nguoi-than',
            TUYENSINH_LIST_ID: rootUrl_Micro + 'gdnn/tim-kiem-tuyen-sinh-id',
            TUYENSINH_THEM: rootUrl_Micro + 'gdnn/them-moi-tuyen-sinh',
            TUYENSINH_SUA: rootUrl_Micro + 'gdnn/cap-nhat-tuyen-sinh',
            TUYENSINH_XOA: rootUrl_Micro + 'gdnn/xoa-tuyen-sinh',
            DIEMDUTUYEN_LIST: rootUrl_Micro + 'gdnn/danh-sach-diem-du-tuyen',
            DIEMDUTUYEN_SUA: rootUrl_Micro + 'gdnn/cap-nhat-diem-du-tuyen',
            DIEMDUTUYEN_THEM: rootUrl_Micro + 'gdnn/them-moi-diem-du-tuyen',
            DIEMDUTUYEN_XOA: rootUrl_Micro + 'gdnn/xoa-diem-du-tuyen',
            NGANH_LIST_TS: rootUrl_Micro + 'gdnn/danh-sach-nganh-dang-ky-hoc',
            NGANH_THEM_TS: rootUrl_Micro + 'gdnn/them-moi-nganh-dang-ky-hoc',
            NGANH_DELETE_TS: rootUrl_Micro + 'gdnn/xoa-nganh-dang-ky-hoc',
        },
        HOC_VIEN: {
            LIST_TRUNG_TUYEN: rootUrl_Micro + 'gdnn/danh-sach-trung-tuyen',
            LIST_NHAP_HOC: rootUrl_Micro + 'gdnn/danh-sach-nhap-hoc',
            BO_SUNG_THONG_TIN: rootUrl_Micro + 'gdnn/bo-sung-thong-tin-nhap-hoc',
            CAP_NHAT_ANH: rootUrl_Micro + 'gdnn/cap-nhat-anh-dai-dien-hoc-vien',
            XEP_LOP: rootUrl_Micro + 'gdnn/phan-bo-lop-hoc',
            LIST_HOC_VIEN_THEO_LOP: rootUrl_Micro + 'gdnn/danh-sach-hoc-vien-theo-lop',
            KHONG_NHAP_HOC: rootUrl_Micro + 'gdnn/danh-dau-khong-nhap-hoc',
            THAY_DOI_LOP: rootUrl_Micro + 'gdnn/thay-doi-lop-hoc',
            LIST_HOC_VIEN: rootUrl_Micro + 'gdnn/tim-kiem-thong-tin-hoc-vien',
            HOC_VIEN_DETAIL: rootUrl_Micro + 'gdnn/thong-tin-chi-tiet-hoc-vien',
            thietLapLop: rootUrl_Micro + 'gdnn/thiet-lap-hoc-phi-theo-ky',
            thayDoiMaHocVien: rootUrl_Micro + "gdnn/thay-doi-ma-hoc-vien",
            LUU_DIEM_DANH: rootUrl_Micro + "gdnn/them-moi-thong-tin-diem-danh",
            UPDATE_DIEM_DANH: rootUrl_Micro + "gdnn/cap-nhat-thong-tin-diem-danh",
            LICH_SU_DIEM_DANH: rootUrl_Micro + "gdnn/tim-kiem-lich-su-diem-danh",
            MAP_SINH_VIEN: rootUrl_Micro + 'bao-tro-xa-hoi/v2/thanh-vien/v2/thong-tin-co-ban-by-cmnd',
            PHAN_LUONG_HOC_SINH: rootUrl_Micro + 'gdnn/phan-luong-hoc-sinh/them-moi',
            CHI_TIET_PHAN_LUONG: rootUrl_Micro + 'gdnn/phan-luong-hoc-sinh/chi-tiet',
            CAP_NHAT_PHAN_LUONG: rootUrl_Micro + 'gdnn/phan-luong-hoc-sinh/cap-nhat',
            XOA_PHAN_LUONG: rootUrl_Micro + 'gdnn/phan-luong-hoc-sinh/xoa'
        },
        CLASS: {
            CLASS_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-thong-tin-lop-hoc',
            CLASS_CREATE: rootUrl_Micro + 'gdnn/them-moi-thong-tin-lop-hoc',
            CLASS_DELETE: rootUrl_Micro + 'gdnn/xoa-thong-tin-lop-hoc',
            CLASS_LIST: rootUrl_Micro + 'gdnn/danh-sach-thong-tin-lop-hoc',

            GET_LOP_BIEN_CHE: rootUrl_Micro + 'gdnn/tim-kiem-lop-bien-che',
            ADD_LOP_BIEN_CHE: rootUrl_Micro + 'gdnn/them-lop-bien-che',
            UPDATE_LOP_BIEN_CHE: rootUrl_Micro + 'gdnn/cap-nhat-lop-bien-che',
            DELETE_LOP_BIEN_CHE: rootUrl_Micro + 'gdnn/xoa-lop-bien-che',
            ADD_HOC_VIEN_BIEN_CHE: rootUrl_Micro + 'gdnn/them-hoc-vien-lop-bien-che',
            XOA_HOC_VIEN_LOP_BIEN_CHE: rootUrl_Micro + 'gdnn/xoa-hoc-vien-lop-bien-che',
            XOA_TAT_CA_HOC_VIEN: rootUrl_Micro + 'gdnn/xoa-tat-ca-hoc-vien-lop-bien-che',
            HOC_VIEN_BIEN_CHE: rootUrl_Micro + 'gdnn/danh-sach-hoc-vien-lop-bien-che',
            DELETE_HOC_VIEN: rootUrl_Micro + 'gdnn/xoa-hoc-vien-lop-bien-che',
            DELETE_TAT_CA_HOC_VIEN: rootUrl_Micro + 'gdnn/xoa-tat-ca-hoc-vien-lop-bien-che',

            GET_LOP_MON_HOC: rootUrl_Micro + 'gdnn/tim-kiem-lop-mon-hoc',
            ADD_LOP_MON_HOC: rootUrl_Micro + 'gdnn/them-lop-mon-hoc',
            DELETE_LOP_MON_HOC: rootUrl_Micro + 'gdnn/xoa-lop-mon-hoc',
            UPDATE_LOP_MON_HOC: rootUrl_Micro + 'gdnn/cap-nhat-lop-mon-hoc',
            ADD_HOC_VIEN_LOP_MON_HOC: rootUrl_Micro + 'gdnn/them-hoc-vien-lop-mon-hoc',
            DELETE_HOC_VIEN_LOP_MON_HOC: rootUrl_Micro + 'gdnn/xoa-hoc-vien-lop-mon-hoc',
            DELETE_ALL_HOC_VIEN_LOP_MON_HOC: rootUrl_Micro + 'gdnn/xoa-tat-ca-hoc-vien-lop-mon-hoc',
            DS_HOC_VIEN_LOP_MON_HOC: rootUrl_Micro + 'gdnn/danh-sach-hoc-vien-lop-mon-hoc',

            DS_LOP_MON_HOC: rootUrl_Micro + 'gdnn/tim-kiem-lop-mon-hoc',
            DS_HOC_VIEN_SAP_LOP_MON_HOC: rootUrl_Micro + 'gdnn/danh-sach-hoc-vien-sap-lop-mon-hoc',
            SAP_LOP_MON_HOC: rootUrl_Micro + 'gdnn/sap-lop-mon-hoc',
            GET_LIST_NHOM_LOP_MON_HOC: rootUrl_Micro + 'gdnn/danh-sach-nhom-lop-mon-hoc',
            CHIA_NHOM_LOP_MON_HOC: rootUrl_Micro + 'gdnn/phan-nhom-lop-mon-hoc',
            DELETE_NHOM_LOP_MON_HOC: rootUrl_Micro + 'gdnn/xoa-nhom-lop-mon-hoc',
            UPDATE_NHOM_LOP_MON_HOC: rootUrl_Micro + 'gdnn/cap-nhat-nhom-lop-mon-hoc',
            UPDATE_HOC_VIEN_NHOM_LOP_MON_HOC: rootUrl_Micro + 'gdnn/cap-nhat-hoc_vien-nhom-lop-mon-hoc',
            DS_LOP_MON_HOC_SO_DAU_BAI: rootUrl_Micro + 'gdnn/lop-mon-hoc-so-dau-bai',
            GET_LIST_NHOM_BY_IDS: rootUrl_Micro + 'gdnn/lay-danh-sach-nhom-theo-id',
        },
        XETTUYEN: {
            XETTUYEN_LIST: rootUrl_Micro + 'gdnn/danh-sach-xet-tuyen',
            TRUNGTUYEN_UPDATE: rootUrl_Micro + 'gdnn/xet-tuyen-danh-sach-tuyen-sinh',
            DANHROT_UPDATE: rootUrl_Micro + 'gdnn/danh-rot-danh-sach-tuyen-sinh',
            TRUNGTUYEN_LIST: rootUrl_Micro + 'gdnn/danh-sach-trung-tuyen',
            XEPLOP: rootUrl_Micro + 'gdnn/xep-lop-danh-sach-trung-tuyen',
        },
        SO_DAU_BAI: {
            GET_DS_HOC_VIEN_DIEM_DANH: rootUrl_Micro + 'gdnn/danh-sach-hoc-vien-diem-danh',
            CHI_TIET_SO_DAU_BAI: rootUrl_Micro + 'gdnn/chi-tiet-so-dau-bai',
            KY_SO_DAU_BAI: rootUrl_Micro + 'gdnn/ky-so-dau-bai'
        },
        XETTIENDO: {
            XET_TIEN_DO_LIST: rootUrl_Micro + 'gdnn/danh-sach-xet-tien-do-tung-nam',
            DIEU_KIEN_DU_THI_TOT_NGHIEP: rootUrl_Micro + 'gdnn/danh-sach-du-dieu-kien-du-thi-tot-nghiep',
            XET_TOT_NGHIEP: rootUrl_Micro + 'gdnn/danh-sach-diem-tot-nghiep',
            MON_TOT_NGHIEP: rootUrl_Micro + 'gdnn/danh-sach-mon-tot-nghiep-theo-lop',
            EXPORT_XET_TIEN_DO: rootUrl_Micro + 'gdnn/dinh-dang-file'
        },
        PHONG: {
            PHONG_UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-thong-phong',
            PHONG_CREATE: rootUrl_Micro + 'gdnn/them-moi-thong-tin-phong',
            PHONG_DELETE: rootUrl_Micro + 'gdnn/xoa-thong-tin-phong',
            PHONG_LIST: rootUrl_Micro + 'gdnn/danh-sach-thong-tin-phong',
        },
        EXCEL: {
            LICH_THI: rootUrl_Micro + 'gdnn/lich-thi-export-excel',
            DU_THI: rootUrl_Micro + 'gdnn/du-thi-export-excel',
            lePhiKhac: rootUrl_Micro + "gdnn/le-phi-khac-hoc-vien-export-excel",
            //OLD
            CHUONGTRINH_DAOTAO: rootUrl_Micro + 'gdnn/bao-cao-thong-tin-chuong-trinh-dao-tao',
            COSO_VATCHAT: rootUrl_Micro + 'gdnn/export-excel-co-so-vat-chat',
            XET_TUYEN_HOC_BA: rootUrl_Micro + 'gdnn/tuyen-sinh-hoc-ba-export-excel',
            TRUNG_TUYEN_HOC_BA: rootUrl_Micro + 'gdnn/trung-tuyen-hoc-ba-export-excel',
            XET_TUYEN_LIEN_THONG: rootUrl_Micro + 'gdnn/tuyen-sinh-lien-thong-export-excel',
            TRUNG_TUYEN_LIEN_THONG: rootUrl_Micro + 'gdnn/trung-tuyen-lien-thong-export-excel',
            DANH_SACH_LOP: rootUrl_Micro + 'gdnn/danh-sach-lop-export-excel',
            DIEM_REN_LUYEN: rootUrl_Micro + 'gdnn/diem-ren-luyen-export-excel',
            xuatHoaDonHocPhi: rootUrl_Micro + 'gdnn',
            xuatHoaDonLePhi: rootUrl_Micro + 'gdnn',
            xuatDiemThiTheoMonTheoLop: rootUrl_Micro + "gdnn/diem-thi-export-excel",
            nghiemThu: rootUrl_Micro + "gdnn/xuat-danh-sach-nghiem-thu-coi-thi",
            nghiemThuChamThi: rootUrl_Micro + "gdnn/xuat-danh-sach-nghiem-thu-cham-thi",
            listCoiThi: rootUrl_Micro + "gdnn/coi-thi-export-excel",
            exportExcelTraCuuHocPhi: rootUrl_Micro + "gdnn/xuat-ket-xuat-thong-tin-hoc-phi-theo-thang",
            exportGiayBaoNhapHoc: rootUrl_Micro + "gdnn/download-giay-bao-trung-tuyen",
            exportDsXetDieuKienDuThi: rootUrl_Micro + "gdnn/xuat-danh-sach-du-dieu-kien-du-thi-tot-nghiep",
            exportDangOKTX: rootUrl_Micro + "gdnn/xuat-danh-sach-dang-o-ktx",
            exportDangKyKTX: rootUrl_Micro + "gdnn/xuat-danh-sach-dang-ky-moi",
            exportImportCanBo: rootUrl_Micro + "file/gdnn/download-file-admin/fad875f0-a6b6-4bdb-9a13-70bfdadc3f24",
            importCanBo: rootUrl_Micro + "gdnn/import-thong-tin-can-bo-nha-giao",
            DANH_SACH_TRUNG_TUYEN: rootUrl_Micro + "gdnn/export-excel-danh-sach-trung-tuyen",
            exportImportMaSinhVien: rootUrl_Micro + "gdnn/template-dieu-chinh-msv",
            importMaSinhVien: rootUrl_Micro + "gdnn/import-dieu-chinh-msv"
        },
        WORD: {
            XET_TUYEN_HOC_BA: rootUrl_Micro + 'gdnn/tuyen-sinh-hoc-ba-export-word',
            XET_TUYEN_LIEN_THONG: rootUrl_Micro + 'gdnn/tuyen-sinh-lien-thong-export-word',
        },
        PDF_GDNN: {
            COSO_VATCHAT: rootUrl_Micro + 'gdnn/bao-cao-thong-tin-co-so-vat-chat',
            CHUONGTRINH_DAOTAO: rootUrl_Micro + 'gdnn/export-pdf-chuong-trinh-dao-tao',
            LICH_SU_DIEM_DANH: rootUrl_Micro + "gdnn/xuat-danh-sach-diem-danh",
            PHI_DAO_TAO_THANG: rootUrl_Micro + "gdnn/danh-sach-thong-tin-hoc-phi-theo-nganh-xuat-excel"
        },
        DETAIL_USER: {
            USER: rootUrl_Micro + 'nguoi-dung/v2/thong-tin-chi-tiet'
        },
        QUA_TRINH_CONG_TAC: {
            GET_LIST: rootUrl_Micro + 'gdnn/danh-sach-thong-tin-qua-trinh-cong-tac',
            CREATE: rootUrl_Micro + 'gdnn/them-moi-thong-tin-qua-trinh-cong-tac',
            UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-thong-qua-trinh-cong-tac',
            DELETE: rootUrl_Micro + 'gdnn/xoa-thong-tin-qua-trinh-cong-tac',
            KHOI_PHUC: rootUrl_Micro + 'gdnn/khoi-phuc-thong-tin-qua-trinh-cong-tac',
            import: rootUrl_Micro + "gdnn/import-qua-trinh-cong-tac",
            mauImport: rootUrl_Micro + "gdnn/xuat-template-import-qua-trinh-cong-tac"
        },
        TRINH_DO_CHUYEN_MON: {
            GET_LIST: rootUrl_Micro + 'gdnn/danh-sach-thong-tin-trinh-do-chuyen-mon',
            CREATE: rootUrl_Micro + 'gdnn/them-moi-thong-tin-trinh-do-chuyen-mon',
            UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-thong-trinh-do-chuyen-mon',
            DELETE: rootUrl_Micro + 'gdnn/xoa-thong-tin-trinh-do-chuyen-mon',
            THONG_KE: rootUrl_Micro + 'gdnn/thong-ke-trinh-do-chuyen-mon',
            import: rootUrl_Micro + "gdnn/import-qua-trinh-dao-tao",
            mauImport: rootUrl_Micro + "gdnn/xuat-template-import-qua-trinh-dao-tao",
            khoiPhuc: rootUrl_Micro + "gdnn/khoi-phuc-thong-tin-trinh-do-chuyen-mon"
        },
        TRINH_DO_NGOAI_NGU: {
            GET_LIST: rootUrl_Micro + 'gdnn/danh-sach-thong-tin-trinh-do-ngoai-ngu',
            CREATE: rootUrl_Micro + 'gdnn/them-moi-thong-tin-trinh-do-ngoai-ngu',
            UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-thong-trinh-do-ngoai-ngu',
            DELETE: rootUrl_Micro + 'gdnn/xoa-thong-tin-trinh-do-ngoai-ngu',
            THONG_KE: rootUrl_Micro + 'gdnn/thong-ke-trinh-do-ngoai-ngu',
        },
        TRINH_DO_TIN_HOC: {
            GET_LIST: rootUrl_Micro + 'gdnn/danh-sach-thong-tin-trinh-do-tin-hoc',
            CREATE: rootUrl_Micro + 'gdnn/them-moi-thong-tin-trinh-do-tin-hoc',
            UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-thong-trinh-do-tin-hoc',
            DELETE: rootUrl_Micro + 'gdnn/xoa-thong-tin-trinh-do-tin-hoc',
            THONG_KE: rootUrl_Micro + 'gdnn/thong-ke-trinh-do-tin-hoc'
        },
        TRINH_DO_CHINH_TRI: {
            GET_LIST: rootUrl_Micro + 'gdnn/danh-sach-thong-tin-ly-luan-chinh-tri',
            CREATE: rootUrl_Micro + 'gdnn/them-moi-thong-tin-ly-luan-chinh-tri',
            UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-thong-ly-luan-chinh-tri',
            DELETE: rootUrl_Micro + 'gdnn/xoa-thong-tin-ly-luan-chinh-tri',
            THONG_KE: rootUrl_Micro + 'gdnn/thong-ke-ly-luan-chinh-tri'
        },
        MON_TOT_NGHIEP: {
            GET_LIST: rootUrl_Micro + 'gdnn/danh-sach-thong-tin-mon-tot-nghiep',
            CREATE: rootUrl_Micro + 'gdnn/them-moi-thong-tin-mon-tot-nghiep',
            UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-thong-tin-mon-tot-nghiep',
            DELETE: rootUrl_Micro + 'gdnn/xoa-thong-tin-mon-tot-nghiep',
            PHAN_BO_MON_TOT_NGHIEP: rootUrl_Micro + 'gdnn/phan-bo-mon-thi-tot-nghiep',
            UPDATE_CC_TIENGANH: rootUrl_Micro + 'gdnn/cap-nhat-thong-tin-dieu-kien-tieng-anh',
            UPDATE_CC_TINHOC: rootUrl_Micro + 'gdnn/cap-nhat-thong-tin-dieu-kien-tin-hoc',
        },
        XEP_MON: {
            GET_LOP: rootUrl_Micro + 'gdnn/tim-kiem-nhanh-lop-ky-hieu',
            MON_HOC_KY: rootUrl_Micro + 'gdnn/danh-sach-mon-hoc-theo-hoc-ky',
            HOC_KY_THEO_LOP: rootUrl_Micro + 'gdnn/danh-sach-hoc-ky-theo-lop',
            MON_HOC_THEO_LOP: rootUrl_Micro + 'gdnn/danh-sach-mon-hoc-theo-lop',
            LEN_DANH_SACH_MON_HOC: rootUrl_Micro + 'gdnn/len-danh-sach-mon-hoc',
            CAP_NHAT_MON_HOC: rootUrl_Micro + 'gdnn/cap-nhat-thong-tin-mon-hoc-theo-mon',
            CAN_BO_GIANG_VIEN: rootUrl_Micro + 'gdnn/danh-sach-can-bo-nha-giao',
            XOA_MON: rootUrl_Micro + 'gdnn/xoa-mon-hoc-trong-hoc-ky',
            THIET_LAP: rootUrl_Micro + 'gdnn/thiet-lap-diem-hoc-phi-cho-lop'
        },
        VNPT_PAY: {
            UPDATE_MODULES_STATUS: rootUrl_Micro + 'gdnn/update-modules-status'
        },
        ROLE: {
            LIST: rootUrl_Micro + 'gdnn/danh-sach-nhom-quyen',
            UPDATE: rootUrl_Micro + 'gdnn/cap-nhat-thong-tin-nhom-quyen',
            NEW: rootUrl_Micro + 'gdnn/them-moi-thong-tin-nhom-quyen',
            DELETE: rootUrl_Micro + 'gdnn/xoa-thong-tin-nhom-quyen',
        },
        TONG_HOP: {
            danhSachTuyenSinh: rootUrl_Micro + "gdnn/tong-hop/danh-sach-tuyen-sinh",
            danhSachThietBi: rootUrl_Micro + "gdnn/tong-hop/danh-sach-thiet-bi",
            danhSachDaoTaoNghe: rootUrl_Micro + "gdnn/tong-hop/danh-sach-dao-tao-nghe",
            danhSachCoSoDaoTao: rootUrl_Micro + "gdnn/tong-hop/danh-sach-co-so-dao-tao",
            danhSachBoiDuong: rootUrl_Micro + "gdnn/tong-hop/danh-sach-boi-duong"
        },
        STG: {
            capGiayChungNhan: rootUrl_Micro + "gdnn/them-giay-chung-nhan-gddt",
            getGiayChungNhan: rootUrl_Micro + "gdnn/bao-cao-giay-chung-nhan-gdnn",
            getListCapGiay: rootUrl_Micro + "gdnn/danh-sach-giay-chung-nhan-gddt",
            exportExcel: rootUrl_Micro + "gdnn/bao-cao-danh-sach-giay-chung-nhan-gddt",
            updateGiayChungNhan: rootUrl_Micro + "gdnn/cap-nhat-giay-chung-nhan-gddt",
            deleteGiayChungNhan: rootUrl_Micro + "gdnn/xoa-giay-chung-nhan-gddt"
        },
        HO_SO_XUAT_NGU: {
            getListHoSoXuatNgu: rootUrl_Micro + "gdnn/ho-so-xuat-ngu/danh-sach",
            addHoSoXuatNgu: rootUrl_Micro + "gdnn/ho-so-xuat-ngu/them-moi",
            editHoSoXuatNgu: rootUrl_Micro + "gdnn/ho-so-xuat-ngu/cap-nhat",
            getUuidHoSoXuatNgu: rootUrl_Micro + "gdnn/ho-so-xuat-ngu/chi-tiet",
            deleteHoSoXuatNgu: rootUrl_Micro + "gdnn/ho-so-xuat-ngu/xoa",
        },
        CAP_PHAT_BANG: {
            GET_LIST: rootUrl_Micro + 'gdnn/bang-cap-chung-chi/danh-sach-van-bang-chung-chi-hoc-vien',
            THEM: rootUrl_Micro + 'gdnn/bang-cap-chung-chi/them-moi',
            XOA: rootUrl_Micro + 'gdnn/bang-cap-chung-chi/xoa',
            CAP_NHAT: rootUrl_Micro + 'gdnn/bang-cap-chung-chi/cap-nhat',
            GET_CHI_TIET: rootUrl_Micro + "gdnn/bang-cap-chung-chi/chi-tiet",
            EXPORT: rootUrl_Micro + "gdnn/bang-cap-chung-chi/xuat",
            xepLoaiTotNghiep: rootUrl_Micro + "gdnn/loai-tot-nghiep/get-all"
        },
        LIEN_KET_HOP_TAC: {
            THEM_SUA_XOA: rootUrl_Micro + "gdnn/lien-ket-hop-tac",
            CHI_TIET: rootUrl_Micro + "gdnn/lien-ket-hop-tac/chi-tiet"
        },

        // Báo cáo kết quả tuyển sinh AGG
        BAO_CAO_KQTS_AGG:{
          SEARCH_BAO_CAO_KQTS: rootUrl_Micro + "gdnn/bao-cao/search-bao-cao-kqts",
          IMPORT_BAO_CAO_KQTS: rootUrl_Micro + "gdnn/bao-cao/import-bao-cao-kqts",
          THEM_BAO_CAO_KQTS: rootUrl_Micro + "gdnn/bao-cao/them-bao-cao-kqts",
          SUA_BAO_CAO_KQTS: rootUrl_Micro + "gdnn/bao-cao/sua-bao-cao-kqts",
          XOA_BAO_CAO_KQTS: rootUrl_Micro + "gdnn/bao-cao/xoa-bao-cao-kqts",
          EXPORT_TEMPLATE_BAO_CAO_KQTS: rootUrl_Micro + "gdnn/bao-cao/export-template-bao-cao-kqts"
        },
    },

    file: {
        downloadNotToken: rootUrl_Micro + 'file/svl/downloadFile/'
    },
    //BTXH VLG -> Quản lý nhà tài trợ -> Báo cáo phát trực tiếp hàng hoá
    BaoCaoPhatTrucTiepHangHoa: {
        BaoCao: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/xem-bao-cao-phat-truc-tiep-hang-hoa',
    },
    congDan: {
        tinhURL: rootUrl_Micro + 'dia-phuong/v2/danh-muc-tinh',
        huyenURL: rootUrl_Micro + 'dia-phuong/danh-muc-huyen',
        xaURL: rootUrl_Micro + 'dia-phuong/v2/danh-muc-xa',
        thonURL: rootUrl_Micro + 'dia-phuong/v2/danh-muc-thon',
        getAnhCMND: rootUrl_Micro + 'file/btxh/downloadFile/'
    },

    //BTXH VLG -> Quản lý nhà tài trợ -> Báo cáo xuất kho hàng hoá
    BaoCaoXuatKhoHangHoa: {
      BaoCao: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/xem-bao-cao-xuat-kho-hang-hoa',
    },

    //BTXH VLG -> Quản lý nhà tài trợ -> Báo cáo thông tin tài trợ trong năm
    BaoCaoThongTinTaiTroTongNam: {
        BaoCao: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/bao-cao-thong-tin-tai-tro',
        LayDanhSachNhaTaiTro: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/lay-nha-tai-tro',
    },

    XKLD:{

        fileStorage: {
          downloadFile: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/file-storage/download-file/" ,
          deleteFile: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/file-storage/delete-file"
        },
        danhMuc:{

          danh_muc:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/thuc-thi-du-lieu",
          },
          dm_trinhdo_vanhoa: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/trinhdo-vanhoa/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/trinhdo-vanhoa/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/trinhdo-vanhoa/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/trinhdo-vanhoa/export-excel"
          },
          dm_noi_quy_vi_pham: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/noi-quy-vi-pham/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/noi-quy-vi-pham/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/noi-quy-vi-pham/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/noi-quy-vi-pham/export-excel"
          },
          dm_danhgia_hoctap: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/danhgia-hoctap/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/danhgia-hoctap/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/danhgia-hoctap/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/danhgia-hoctap/export-excel"
          },
          dm_danhgia_ythuc: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/danhgia-ythuc/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/danhgia-ythuc/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/danhgia-ythuc/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/danhgia-ythuc/export-excel"
          },
          dm_thoigian_lamviec_xuatkhau: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/thoigian-lamviec-xuatkhau/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/thoigian-lamviec-xuatkhau/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/thoigian-lamviec-xuatkhau/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/thoigian-lamviec-xuatkhau/export-excel"
          },
          dm_nhom_khoanthu: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/nhom-khoanthu/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/nhom-khoanthu/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/nhom-khoanthu/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/nhom-khoanthu/export-excel"
          },
          dm_nhom_khoanchi: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/nhom-khoanchi/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/nhom-khoanchi/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/nhom-khoanchi/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/nhom-khoanchi/export-excel"
          },
          dm_nhom_hoso: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/nhom-hoso/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/nhom-hoso/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/nhom-hoso/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/nhom-hoso/export-excel"
          },
          dm_tinhtrang_thituyen: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/tinhtrang-thituyen/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/tinhtrang-thituyen/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/tinhtrang-thituyen/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/tinhtrang-thituyen/export-excel"
          },
          dm_trinhdo_chuyenmon: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/trinhdo-chuyenmon/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/trinhdo-chuyenmon/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/trinhdo-chuyenmon/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/trinhdo-chuyenmon/export-excel"
          },
          dm_nguoi_gioi_thieu_nguon: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/nguoi-gioi-thieu-nguon/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/nguoi-gioi-thieu-nguon/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/nguoi-gioi-thieu-nguon/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/nguoi-gioi-thieu-nguon/export-excel"
          },
          ds_quan_huyen_VN: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/quan-huyen-vn/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/quan-huyen-vn/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/quan-huyen-vn/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/quan-huyen-vn/export-excel"
          },
          ds_phuong_xa_VN: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/phuong-xa-vn/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/phuong-xa-vn/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/phuong-xa-vn/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/phuong-xa-vn/export-excel"
          },
          ds_tinh_tp_NN: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/tinh-tp-nn/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/tinh-tp-nn/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/tinh-tp-nn/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/tinh-tp-nn/export-excel"
          },
          dm_trangthaituyendung: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/trangthaituyendung/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/trangthaituyendung/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/trangthaituyendung/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/trangthaituyendung/export-excel"
          },
          ds_thanh_vien_gia_dinh: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/thanh-vien-gia-dinh/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/thanh-vien-gia-dinh/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/thanh-vien-gia-dinh/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/thanh-vien-gia-dinh/export-excel"
          },
          ds_giayto_canthu: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/giayto-canthu/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/giayto-canthu/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/giayto-canthu/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/giayto-canthu/export-excel"
          },
          ds_hoso_can_hoanthien: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/hoso-can-hoanthien/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/hoso-can-hoanthien/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/hoso-can-hoanthien/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/hoso-can-hoanthien/export-excel"
          },
          ds_cauhoi_bosung: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/cauhoi-bosung/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/cauhoi-bosung/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/cauhoi-bosung/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/cauhoi-bosung/export-excel"
          },
          dm_tiendo_hoso: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/tiendo-hoso/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/tiendo-hoso/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/tiendo-hoso/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/tiendo-hoso/export-excel"
          },
          dm_trangthai_hoso_laodong: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/trangthai-hoso-laodong/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/trangthai-hoso-laodong/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/trangthai-hoso-laodong/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/trangthai-hoso-laodong/export-excel"
          },
          ds_tinh_tp_VN: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/tinh-tp-vn/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/tinh-tp-vn/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/tinh-tp-vn/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/tinh-tp-vn/export-excel"
          },
          dm_nganh_nghe_VN: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/nganh-nghe-vn/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/nganh-nghe-vn/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/nganh-nghe-vn/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/nganh-nghe-vn/export-excel"
          },
          dm_nhom_hoso_laodong: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/nhom-hoso-laodong/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/nhom-hoso-laodong/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/nhom-hoso-laodong/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/nhom-hoso-laodong/export-excel"
          },
          dm_loai_quanhe_giadinh: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/loai-quanhe-giadinh/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/loai-quanhe-giadinh/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/loai-quanhe-giadinh/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/loai-quanhe-giadinh/export-excel"
          },
          dm_trangthai_donhang: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/trangthai-donhang/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/trangthai-donhang/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/trangthai-donhang/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/trangthai-donhang/export-excel"
          },
          dm_loai_chungchi_daotao_laodong: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/loai-chungchi-daotao/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/loai-chungchi-daotao/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/loai-chungchi-daotao/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/loai-chungchi-daotao/export-excel"
          },
          dm_tinhtrang_khoanvay: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/tinhtrang-khoanvay/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/tinhtrang-khoanvay/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/tinhtrang-khoanvay/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/tinhtrang-khoanvay/export-excel"
          },
          dm_nganh_nghe_nuoc_ngoai: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/nganh-nghe-nuoc-ngoai/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/nganh-nghe-nuoc-ngoai/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/nganh-nghe-nuoc-ngoai/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/nganh-nghe-nuoc-ngoai/export-excel"
          },
          dm_loai_hanhdong_lichsu_vayvon: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/loai-hanhdong-lichsu-vayvon/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/loai-hanhdong-lichsu-vayvon/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/loai-hanhdong-lichsu-vayvon/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/loai-hanhdong-lichsu-vayvon/export-excel"
          },
          dm_doi_tuong_lao_dong: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/doi-tuong-lao-dong/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/doi-tuong-lao-dong/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/doi-tuong-lao-dong/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/doi-tuong-lao-dong/export-excel"
          },
          nguoi_dung: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/ld-tbxh-nguoi-dung/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/ld-tbxh-nguoi-dung/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/ld-tbxh-nguoi_dung/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/ld-tbxh-nguoi_dung/export-excel"
            },
          dm_noidung_daotao: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/noidung-daotao/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/noidung-daotao/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/noidung-daotao/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/noidung-daotao/export-excel"
          },
          dm_tongiao: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/ton-giao/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/ton-giao/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/ton-giao/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/ton-giao/export-excel"
          },
          dm_dantoc: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/dan-toc/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/dan-toc/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/dan-toc/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/dan-toc/export-excel"
          },
          dm_trangthai_hoctap: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/trangthai-hoctap/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/trangthai-hoctap/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/trangthai-hoctap/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/trangthai-hoctap/export-excel"
          },
          dm_noiquy_vipham_nuocngoai: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/noiquy-vipham-nuocngoai/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/noiquy-vipham-nuocngoai/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/noiquy-vipham-nuocngoai/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/noiquy-vipham-nuocngoai/export-excel"
          },
          dm_ruiro:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/rui-ro/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/rui-ro/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/rui-ro/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/rui-ro/export-excel"
          },

          dm_nhom_nganhnghe:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/nhom-nganhnghe/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/nhom-nganhnghe/thuc-thi-du-lieu",
          },

          dm_thoigian_thatnghiep:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/thoigian-thatnghiep/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/thoigian-thatnghiep/thuc-thi-du-lieu",
          },
          dm_quocgia_fdi:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/quocgia-fdi/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/quocgia-fdi/thuc-thi-du-lieu",
          },
          dm_loaihinh_doanhnghiep:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/loaihinh-doanhnghiep/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/loaihinh-doanhnghiep/thuc-thi-du-lieu",
          },
          dm_hoatdong_kinhte:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/hoatdong-kinhte/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/hoatdong-kinhte/thuc-thi-du-lieu",
          },
          dm_tinhtrang_hoatdong_kinhte:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/tinhtrang-hoatdong-kinhte/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/tinhtrang-hoatdong-kinhte/thuc-thi-du-lieu",
          },





          dm_thamso_hethong: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/tham-so-he-thong/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/tham-so-he-thong/thuc-thi-du-lieu",
          }
        },
        daoTao:{
          dm_giao_vien:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/giao-vien/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/giao-vien/thuc-thi-du-lieu",
          },
          ds_lop_hoc:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/lop-hoc/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/lop-hoc/thuc-thi-du-lieu",
          },
          ds_chungchi_daotao_laodong:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/chungchi-laodong/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/chungchi-laodong/thuc-thi-du-lieu",
            importExcel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/chungchi-laodong/import-excel",
          },
          hocvien_lophoc:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/hocvien-lophoc/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/hocvien-lophoc/thuc-thi-du-lieu",
            cap_nhat_ket_qua_hoc_tap: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/hocvien-lophoc/cap-nhat-ket-qua-hoc-tap",
          },
          diem_danh:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/diem-danh/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/diem-danh/thuc-thi-du-lieu",
          },
          diemdanh_suatan:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/diemdanh-suatan/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/diemdanh-suatan/thuc-thi-du-lieu",
          },
          hoc_sinh_vi_pham_noi_quy:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/hoc-sinh-vi-pham-noi-quy/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/hoc-sinh-vi-pham-noi-quy/thuc-thi-du-lieu",
          }
        },
        quanlyDoiTacNgoai:{
          ds_quota:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/quota/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/quota/thuc-thi-du-lieu",
          },
          ds_lienhe_xinghiep:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/lienhe-xinghiep/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/lienhe-xinghiep/thuc-thi-du-lieu",
          },
          ds_lienhe_nghiepdoan:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/lienhe-nghiepdoan/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/lienhe-nghiepdoan/thuc-thi-du-lieu",
          },
          ds_xinghiep_tiepnhan:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/xinghiep-tiepnhan/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/xinghiep-tiepnhan/thuc-thi-du-lieu",
            them_sua_xoa: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/xinghiep-tiepnhan/lienhe-xinghiep/them-sua-xoa",
          },
          ds_nghiep_doan:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/nghiep-doan/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/nghiep-doan/thuc-thi-du-lieu",
            them_sua_xoa: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/nghiep-doan/lienhe-nghiepdoan/them-sua-xoa",
          },
        },
        quanLyDoiTacNoi:{
          dm_cty_xkld:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/cty-xkld/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/cty-xkld/thuc-thi-du-lieu",
          },
          dm_thi_truong:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/thi-truong/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/thi-truong/thuc-thi-du-lieu",
          },
          dm_noi_cap_ho_chieu:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/noi-cap-ho-chieu/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/noi-cap-ho-chieu/thuc-thi-du-lieu",
          },
          dm_trungtam_daotao:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/trungtam-daotao/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/trungtam-daotao/thuc-thi-du-lieu",
          },
          dm_don_vi_phai_cu:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/don-vi-phai-cu/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/don-vi-phai-cu/thuc-thi-du-lieu",
            them_sua_xoa: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/don-vi-phai-cu/dvpc-lien-he/them-sua-xoa",
          },
          dm_dvpc_lien_he:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/dvpc-lien-he/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/dvpc-lien-he/thuc-thi-du-lieu",
            them_sua_xoa: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/don-vi-phai-cu/dvpc-lien-he/them-sua-xoa",
          },
          ds_doitac_VN:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/doitac-vn/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/doitac-vn/thuc-thi-du-lieu",
            them_sua_xoa: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/doitac-vn/lienhe-doitac-vn/them-sua-xoa",
          },
          ds_lienhe_doitac_VN:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/lienhe-doitac-vn/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/lienhe-doitac-vn/thuc-thi-du-lieu",
          },
          nganhnghe_thitruong: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/nganhnghe-thitruong/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/nganhnghe-thitruong/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/nganhnghe-thitruong/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/nganhnghe-thitruong/export-excel"
          },
          thitruong_hoahong: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/thitruong-hoahong/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/thitruong-hoahong/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/thitruong-hoahong/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/thitruong-hoahong/export-excel"
          },

        },

        quanLyDonHang: {

          don_hang:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/don-hang/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/don-hang/thuc-thi-du-lieu",
          },
          nganhnghetuyendung_donhang: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/nganhnghetuyendung-donhang/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/nganhnghetuyendung-donhang/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/nganhnghetuyendung-donhang/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/nganhnghetuyendung-donhang/export-excel"
          },
          kinhnghiem_donhang: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/kinhnghiem-donhang/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/kinhnghiem-donhang/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/kinhnghiem-donhang/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/kinhnghiem-donhang/export-excel"
          },
          don_hang_thong_tin_bo_sung: {
            themmoi_capnhat: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/don-hang-thong-tin-bo-sung/themmoi-capnhat",
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/don-hang-thong-tin-bo-sung/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/don-hang-thong-tin-bo-sung/thuc-thi-du-lieu",

            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/don-hang-thong-tin-bo-sung/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/don-hang-thong-tin-bo-sung/export-excel"
          },
          thu_donhang: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/thu-donhang/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/thu-donhang/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/thu-donhang/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/thu-donhang/export-excel"
          },
          chi_donhang: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/chi-donhang/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/chi-donhang/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/chi-donhang/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/chi-donhang/export-excel"
          },
          hoso_donhang: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/hoso-donhang/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/hoso-donhang/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/hoso-donhang/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/hoso-donhang/export-excel"
          },
          hoso_laodong_donhang:{
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/hoso-laodong-donhang/thuc-thi-du-lieu",
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/hoso-laodong-donhang/truy-van-du-lieu",
          }
        },
        taiChinh:{
          ds_khoanthu:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/khoanthu/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/khoanthu/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/khoanthu/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/khoanthu/export-excel"
          },
          ds_khoanchi:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/khoanchi/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/khoanchi/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/khoanchi/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/khoanchi/export-excel"
          },
          phieu_thu:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/phieu-thu/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/phieu-thu/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/phieu-thu/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/phieu-thu/export-excel"
          },
          phieu_chi:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/phieu-chi/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/phieu-chi/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/phieu-chi/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/phieu-chi/export-excel"
          },
          chitiet_phieuthu:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/chitiet-phieuthu/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/chitiet-phieuthu/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/chitiet-phieuthu/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/chitiet-phieuthu/export-excel"
          },
          chitiet_phieuchi:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/chitiet-phieuchi/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/chitiet-phieuchi/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/chitiet-phieuchi/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/nhom-khoanthu/export-excel"
          },
          ds_chuongtrinh_vayvon:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/chuongtrinh-vayvon/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/chuongtrinh-vayvon/thuc-thi-du-lieu",
          },

          ds_hsld_vayvon:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/hsld-vayvon/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/hsld-vayvon/thuc-thi-du-lieu",
          }

        },
        ho_so_lao_dong:{
          danh_muc: {
            tinh_thanh: {
              truy_van: rootUrl_Micro +"quan-ly-xuat-khau-lao-dong/danh-sach/tinh-tp-vn/truy-van-du-lieu"
            },
            quan_huyen: {
              truy_van: rootUrl_Micro +"quan-ly-xuat-khau-lao-dong/danh-sach/quan-huyen-vn/truy-van-du-lieu"
            },
            phuong_xa: {
              truy_van: rootUrl_Micro +"quan-ly-xuat-khau-lao-dong/danh-sach/phuong-xa-vn/truy-van-du-lieu"
            },
            danh_muc_dung_chung: {
              truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/truy-van-du-lieu"
            },
            noi_cap_ho_chieu: {
              truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/noi-cap-ho-chieu/truy-van-du-lieu"
            },
            thi_truong: {
              truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/thi-truong/truy-van-du-lieu"
            },
            nguoi_gioi_thieu_nguon: {
              truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/nguoi-gioi-thieu-nguon/truy-van-du-lieu"
            },
            doi_tac_VN: {
              truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/doitac-vn/truy-van-du-lieu"
            },
            nhom_hoso_laodong: {
              truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-muc/nhom-hoso-laodong/truy-van-du-lieu"
            }
          },
          danh_sach_ho_so: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/hoso-laodong/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/hoso-laodong/thuc-thi-du-lieu",
            truy_van_phan_trang: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/hoso-laodong/truy-van-du-lieu-phan-trang",
          },
          nguoi_lien_he_lao_dong: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/nguoi-lienhe-laodong/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/nguoi-lienhe-laodong/thuc-thi-du-lieu",
            themmoi_capnhat_danhsach: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/nguoi-lienhe-laodong/themmoi-capnhat-danhsach",
          },
          quan_he_gia_dinh: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/thanh-vien-gia-dinh/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/thanh-vien-gia-dinh/thuc-thi-du-lieu",
            themmoi_capnhat_danhsach: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/thanh-vien-gia-dinh/themmoi-capnhat-danhsach",
          },
          qua_trinh_hoc_tap: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/quatrinh-hoctap-laodong/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/quatrinh-hoctap-laodong/thuc-thi-du-lieu",
            themmoi_capnhat_danhsach: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/quatrinh-hoctap-laodong/themmoi-capnhat-danhsach",
          },
          qua_trinh_lam_viec: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/quatrinh-lamviec-laodong/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/quatrinh-lamviec-laodong/thuc-thi-du-lieu",
            themmoi_capnhat_danhsach: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/quatrinh-lamviec-laodong/themmoi-capnhat-danhsach",
          },
          nguoi_than_nuoc_ngoai: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/nguoithan-nuocngoai-laodong/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/nguoithan-nuocngoai-laodong/thuc-thi-du-lieu",
            themmoi_capnhat_danhsach: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/nguoithan-nuocngoai-laodong/themmoi-capnhat-danhsach",
          },
          thong_tin_mo_rong: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/cauhoi-bosung/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/cauhoi-bosung/thuc-thi-du-lieu",
            themmoi_capnhat_danhsach: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/danh-sach/cauhoi-bosung/themmoi-capnhat-danhsach",
          },
          lich_su_trang_thai_ho_so:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/lichsu-trangthai-hoso/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/lichsu-trangthai-hoso/thuc-thi-du-lieu",
          },
          nguoi_phung_duong: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/nguoithan-phungduong-laodong/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/nguoithan-phungduong-laodong/thuc-thi-du-lieu",
            themmoi_capnhat_danhsach: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/nguoithan-phungduong-laodong/themmoi-capnhat-danhsach",
          },
          kinhnghiem_laodong: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/kinhnghiem-laodong/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/kinhnghiem-laodong/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/kinhnghiem-laodong/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/kinhnghiem-laodong/export-excel"
              },
          quan_ly_lich_bay: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/quan-ly-lich-bay/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/quan-ly-lich-bay/thuc-thi-du-lieu",
          },
          qua_trinh_lam_viec_lao_dong_ve_nuoc:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/quatrinh-lamviec-laodong-venuoc/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/quatrinh-lamviec-laodong-venuoc/thuc-thi-du-lieu",
          },
          gioithieu_vieclam_laodong_venuoc: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/gioithieu-vieclam-laodong-venuoc/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/gioithieu-vieclam-laodong-venuoc/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/gioithieu-vieclam-laodong-venuoc/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/gioithieu-vieclam-laodong-venuoc/export-excel"
          },
          laodong_vipham_noiquy_nuocngoai: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/laodong-vipham-noiquy-nuocngoai/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/laodong-vipham-noiquy-nuocngoai/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/laodong-vipham-noiquy-nuocngoai/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/laodong-vipham-noiquy-nuocngoai/export-excel"
          },
          hotro_ruiro: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/ho-tro-rui-ro/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/ho-tro-rui-ro/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/ho-tro-rui-ro/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/ho-tro-rui-ro/export-excel"
          },
          khoi_nghiep: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/lao-dong-khoi-nghiep/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/lao-dong-khoi-nghiep/thuc-thi-du-lieu",
            import_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/lao-dong-khoi-nghiep/import-excel",
            export_excel: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/lao-dong-khoi-nghiep/export-excel"
          },
          phieu_thuthap_thongtin:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/phieu-thuthap-thongtin/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/phieu-thuthap-thongtin/thuc-thi-du-lieu",
          }
        },
        File:{
          upload: rootUrl_Micro +"quan-ly-xuat-khau-lao-dong/file-storage/upload-file",
        },
        tuyen_sinh: {
          danh_sach_ho_so: {
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/hoso-laodong/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/hoso-laodong/thuc-thi-du-lieu",
            truy_van_phan_trang: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/hoso-laodong/truy-van-du-lieu-phan-trang",
          },
          don_hang:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/don-hang/truy-van-du-lieu",
            truy_van_phan_trang: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/don-hang/truy-van-du-lieu-phan-trang",
          },
          don_hang_tuyen_dung:{
            truy_van: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/donhang-tuyendung/truy-van-du-lieu",
            thuc_thi: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/donhang-tuyendung/thuc-thi-du-lieu",
            truy_van_phan_trang: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/donhang-tuyendung/truy-van-du-lieu-phan-trang",
            themmoi_capnhat_danhsach: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/donhang-tuyendung/themmoi-capnhat-danhsach",
          },
        },
        so_lieu_dieu_hanh:{
          get_token: rootUrl_Micro + "quan-ly-xuat-khau-lao-dong/doi-tuong/xkld/get-token-power-bi",
        }

    },
    //BTXH VLG -> Quản lý nhà tài trợ -> Kiểm kê hàng hoá -> Luongnc
    KiemKeHangHoa: {
        LayDanhSachThongTinTaiTro: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/lay-danh-sach-thong-tin-tai-tro?p_id=-1&p_size=10&p_page=1',
        LayDanhSachKho: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/lay-danh-sach-kho?p_id=-1',
        LayDanhSachPhieuTuNgayDenNgay: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/tim-kiem-chi-tiet-thong-tin-phieu-nhap-kho-hang-hoa',
        ThemPhieu: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/them-chi-tiet-thong-tin-phieu-nhap-kho-hang-hoa',
        SuaPhieu: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/cap-nhat-chi-tiet-thong-tin-phieu-nhap-kho-hang-hoa',
        XoaPhieu: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/xoa-chi-tiet-thong-tin-phieu-nhap-kho-hang-hoa',
        LayDanhSachHangHoaTaiTro: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/lay-danh-sach-hang-hoa-tai-tro?p_id=-1',
        LayDanhSachHangHoaKiemKe: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/lay-danh-sach-thong-tin-hang-hoa-nhap-kho',
        LayDanhSachDonViTinh: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/lay-danh-sach-don-vi-tinh?p_id=-1',
        ThemHangHoa: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/them-chi-tiet-thong-tin-hang-hoa-nhap-kho',
        SuaHangHoa: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/cap-nhat-chi-tiet-thong-tin-hang-hoa-nhap-kho',
        XoaHangHoa: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/xoa-chi-tiet-thong-tin-hang-hoa-nhap-kho',
        LayDanhSachCanBoKiemKe: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/lay-danh-sach-can-bo-kiem-ke',
        ThemCanBoKiemKe: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/them-can-bo-kiem-ke',
        SuaCanBoKiemKe: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/sua-can-bo-kiem-ke',
        XoaCanBoKiemKe: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/xoa-can-bo-kiem-ke',
        InBienBanKiemKe: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/in-bien-ban-kiem-ke'
    },

    BDG: {
        danhMuc: {
            timKiemChienLuocQuocGia: rootUrl_Micro + 'tre-em/danh-muc/tim-kiem-chien-luoc',
            themMoiChienLuocQuocGia: rootUrl_Micro + 'tre-em/danh-muc/them-moi-chien-luoc',
            capNhatChienLuocQuocGia: rootUrl_Micro + 'tre-em/danh-muc/sua-thong-tin-chien-luoc',
            xoaChienLuocQuocGia: rootUrl_Micro + 'tre-em/danh-muc/xoa-chien-luoc',

            timKiemHinhThucBaoLuc: rootUrl_Micro + 'tre-em/danh-muc/tim-kiem-hinh-thuc-bao-luc',
            themMoiHinhThucBaoLuc: rootUrl_Micro + 'tre-em/danh-muc/them-moi-hinh-thuc-bao-luc',
            capNhatHinhThucBaoLuc: rootUrl_Micro + 'tre-em/danh-muc/sua-thong-tin-hinh-thuc-bao-luc',
            xoaHinhThucBaoLuc: rootUrl_Micro + 'tre-em/danh-muc/xoa-hinh-thuc-bao-luc',
        },
        nuLanhDao: {
            addNuLanhDao: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/them-nu-lanh-dao',
            editNuLanhDao: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/cap-nhat-nu-lanh-dao',
            deleteNuLanhDao: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/xoa-nu-lanh-dao',
            getNuLanhDao: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/danh-sach-nu-lanh-dao',
            chiTietLanhDao: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/chi-tiet-nu-lanh-dao',
            templateLanhDao: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/xuat-template-nu-lanh-dao',
            importLanhDao: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/import-nu-can-bo',
        },
        nuTrinhDoDaiHoc: {
            addNuDaiHoc: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/them-nu-trinh-do-dh-ts',
            editNuDaiHoc: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/cap-nhat-nu-trinh-do-dh-ts',
            deleteNuDaiHoc: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/xoa-nu-trinh-do-dh-ts',
            getNuDaiHoc: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/danh-sach-nu-trinh-do-dh-ts',
            getAllTrinhDo: rootUrl_Micro + 'tre-em/danh-muc/get-all-trinh-do-bdg'
        },
        nuGiamDoc: {
            addNuGiamDoc: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/them-nu-giam-doc',
            editNuGiamDoc: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/cap-nhat-nu-giam-doc',
            deleteNuGiamDoc: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/xoa-nu-giam-doc',
            getNuGiamDoc: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/danh-sach-nu-giam-doc',
            xuatNuGiamDoc: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/xuat-danh-sach-nu-giam-doc'
        },
        nuHocVien: {
            addNuHocVien: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/them-nu-hoc-vien',
            editNuHocVien: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/cap-nhat-nu-hoc-vien',
            deleteNuHocVien: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/xoa-nu-hoc-vien',
            getNuHocVien: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/danh-sach-nu-hoc-vien'
        },
        baoLucTrenCoSoGioi: {
            addHoNanNhan: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/them-ho',
            getChiTietHo: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/chi-tiet-ho',
            getThanhVienHo: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/danh-sach-thanh-vien-ho',
            getHoNanNhan: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/danh-sach-ho',

            addNanNhan: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/them-nan-nhan-bao-luc-cs-gioi',
            editNanNhan: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/cap-nhat-nan-nhan-bao-luc-cs-gioi',
            deleteNanNhan: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/xoa-nan-nhan-bao-luc-cs-gioi',
            getNanNhan: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/danh-sach-nan-nhan-bao-luc-cs-gioi',
            getChiTietNanNhan: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/chi-tiet-nan-nhan-bao-luc-cs-gioi'
        },
        GET_DATA: {
            xuatNuLanhDao: rootUrl_Micro + 'get-data/tre-em/binh-dang-gioi/v2/xuat-danh-sach-nu-lanh-dao',
            xuatNuDaiHoc: rootUrl_Micro + 'get-data/tre-em/binh-dang-gioi/v2/xuat-danh-sach-nu-trinh-do-dh-ts',
            xuatNanNhan: rootUrl_Micro + 'get-data/tre-em/binh-dang-gioi/v2/xuat-danh-sach-nan-nhan-bao-luc-cs-gioi',
            xuatNuGiamDoc: rootUrl_Micro + 'get-data/tre-em/binh-dang-gioi/v2/xuat-danh-sach-nu-giam-doc',
            xuatNuHocVien: rootUrl_Micro + 'get-data/tre-em/binh-dang-gioi/v2/xuat-danh-sach-nu-hoc-vien',
        },
        BAO_CAO: {
          mucTieuA: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/bao-cao-muc-tieu-1',
          mucTieuB: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/bao-cao-muc-tieu-2',
          mucTieuC: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/bao-cao-muc-tieu-ung-pho-bao-luc',
          mucTieuD: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/bao-cao-muc-tieu-4',
          mucTieuSau: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/bao-cao-muc-tieu-6',
          mucTieuNam: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/bao-cao-muc-tieu-5',
          thongTu15: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/xuat-bieu-tong-hop-tt15-2019-cong-tac-bdg',
        },
        mucTieu2: {
          addMucTieu2: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/them-muc-tieu-kinh-te',
          editMucTieu2: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/cap-nhat-muc-tieu-kinh-te',
          deleteMucTieu2: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/xoa-muc-tieu-kinh-te',
          getMucTieu2: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/danh-sach-muc-tieu-kinh-te',
          chiTietMucTieu2: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/chi-tiet-muc-tieu-kinh-te',
      },
      mucTieu4: {
        addMucTieu4: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/them-muc-tieu-y-te',
        editMucTieu4: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/cap-nhat-muc-tieu-y-te',
        deleteMucTieu4: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/xoa-muc-tieu-y-te',
        getMucTieu4: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/danh-sach-muc-tieu-y-te',
        chiTietMucTieu4: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/chi-tiet-muc-tieu-y-te'
      },
      mucTieu1: {
        addMucTieu1: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/them-muc-tieu-chinh-tri',
        editMucTieu1: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/cap-nhat-muc-tieu-chinh-tri',
        deleteMucTieu1: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/xoa-muc-tieu-y-te',
        getMucTieu1: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/danh-sach-muc-tieu-chinh-tri',
        chiTietMucTieu1: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/chi-tiet-muc-tieu-chinh-tri',
        importMucTieu1: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/import-muc-tieu-chinh-tri',
        xuatTemplateMucTieu1: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/xuat-template-muc-tieu-chinh-tri'
      },
      mucTieu6: {
        addMucTieu6: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/them-muc-tieu-thong-tin-truyen-thong',
        editMucTieu6: rootUrl_Micro + 'tre-em/v2/binh-dang-gioi/v2/cap-nhat-muc-tieu-thong-tin-truyen-thong',
        deleteMucTieu6: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/xoa-muc-tieu-thong-tin-truyen-thong',
        getMucTieu6: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/danh-sach-muc-tieu-thong-tin-truyen-thong',
        chiTietMucTieu6: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/chi-tiet-muc-tieu-thong-tin-truyen-thong'
      },
      mucTieu5: {
        addMucTieu: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/them-muc-tieu-gddt',
        editMucTieu: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/cap-nhat-muc-tieu-gddt',
        deleteMucTieu: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/xoa-muc-tieu-gddt',
        getMucTieu: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/danh-sach-muc-tieu-gddt',
        chiTietMucTieu: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/chi-tiet-muc-tieu-gddt'
      },
      mucTieu3: {
        addMucTieu: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/them-muc-tieu-ung-pho-bao-luc',
        editMucTieu: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/cap-nhat-muc-tieu-ung-pho-bao-luc',
        deleteMucTieu: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/xoa-muc-tieu-ung-pho-bao-luc',
        getMucTieu: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/danh-sach-muc-tieu-ung-pho-bao-luc',
        chiTietMucTieu: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/chi-tiet-muc-tieu-ung-pho-bao-luc'
      },
      thongTu15: {
        addMucTieu: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/them-bieu-tong-hop-tt15-2019-cong-tac-bdg',
        editMucTieu: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/cap-nhat-bieu-tong-hop-tt15-2019-cong-tac-bdg',
        deleteMucTieu: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/xoa-bieu-tong-hop-tt15-2019-cong-tac-bdg',
        getMucTieu: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/danh-sach-bieu-tong-hop-tt15-2019-cong-tac-bdg',
        chiTietMucTieu: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/chi-tiet-bieu-tong-hop-tt15-2019-cong-tac-bdg',
        getChiTiet: rootUrl_Micro + 'tre-em/binh-dang-gioi/v2/chi-tiet-bieu-tong-hop-tt15-2019-cong-tac-bdg'
      },
    },

    //BTXH VLG -> Quản lý nhà tài trợ -> Xuất kho hàng hoá -> Luongnc
    XuatKhoHangHoa: {
        LayDanhSachThongTinTaiTro: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/lay-danh-sach-thong-tin-tai-tro?p_id=-1&p_size=10&p_page=1',
        LayDanhSachKho: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/lay-danh-sach-kho?p_id=-1',
        LayDanhSachPhieuTuNgayDenNgay: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/tim-kiem-chi-tiet-thong-tin-phieu-nhap-kho-hang-hoa',
        ThemPhieu: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/them-chi-tiet-thong-tin-phieu-nhap-kho-hang-hoa',
        SuaPhieu: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/cap-nhat-chi-tiet-thong-tin-phieu-nhap-kho-hang-hoa',
        XoaPhieu: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/xoa-chi-tiet-thong-tin-phieu-nhap-kho-hang-hoa',
        InPhieu: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/in-phieu-xuat-kho-hang-hoa',
        LayDanhSachHangHoaTonKho: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/lay-danh-sach-hang-hoa-ton-kho',
        LayDanhSachHangHoaNhapKho: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/lay-danh-sach-thong-tin-hang-hoa-nhap-kho',
        LayDanhSachDonViTinh: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/lay-danh-sach-don-vi-tinh?p_id=-1',
        ThemHangHoa: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/them-chi-tiet-thong-tin-hang-hoa-nhap-kho',
        SuaHangHoa: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/cap-nhat-chi-tiet-thong-tin-hang-hoa-nhap-kho',
        XoaHangHoa: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/xoa-chi-tiet-thong-tin-hang-hoa-nhap-kho',
        LayDanhSachHinhThucXuatKho: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/lay-danh-sach-hinh-thuc-xuat-kho',
        LayDanhSachHangHoaTaiTro: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/lay-danh-sach-hang-hoa-tai-tro?p_id=-1',
    },

    BHTN_CMU: {
        tuVanViecLam: {
            getListHoSoTVVL: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/tu-van-viec-lam/danh-sach-hs-tvvl",
            getInfoHoSoTVVL: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/tu-van-viec-lam/thong-tin-hs-tvvl",
            getInfoCongDan: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/cong-dan/thong-tin-cong-dan",
            getInfoCongDan2: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/tu-van-viec-lam/tim-kiem-hs-tvvl",
            getCongDanByUuid: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/cong-dan/thong-tin-cong-dan-theo-uuid",

            themCongDan: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/cong-dan/them-cong-dan",
            themHoSoTVVL: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/tu-van-viec-lam/them-hs-tvvl",
            capNhatHoSoTVVL: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/tu-van-viec-lam/cap-nhat-hs-tvvl",
            capNhatCongDan: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/cong-dan/cap-nhat-cong-dan",
            xoaHoSoTVVL: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/tu-van-viec-lam/xoa-hs-tvvl",
            themQuaTrinhLamViec: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/tu-van-viec-lam/them-qtlv",
            getQuaTrinhLamViec: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/tu-van-viec-lam/lay-ds-qtlv",
            getLichSuGTVL: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/tu-van-viec-lam/lay-ds-gtvl",
            taiPhieuTVVL: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/tu-van-viec-lam/tai-phieu-tvvl",
            taiPhieuDangKyMau01: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/tu-van-viec-lam/tai-phieu-dang-ky-mau-01",
            themChuyenMonKyThuat: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/tu-van-viec-lam/them-cmkt",
            getChuyenMonKyThuat: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/tu-van-viec-lam/lay-ds-cmkt",
            themGioiThieuViecLam: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/tu-van-viec-lam/them-gtvl",
            uploadFile: rootUrl_Micro + "sldtbxh/file/bhtn/upload-file-hs-tu-van-viec-lam",
            getListFile: rootUrl_Micro + "sldtbxh/file/bhtn/list-file-hs-tu-van-viec-lam",
            downloadFile: rootUrl_Micro + "sldtbxh/file/bhtn/download-file-hs-tu-van-viec-lam",
            deleteFile: rootUrl_Micro + "sldtbxh/file/bhtn/delete-file-hs-tu-van-viec-lam",
            taiPhieuGtvl: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/tu-van-viec-lam/tai-phieu-gtvl",
            xoaPhieuGtvl: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/tu-van-viec-lam/xoa-gtvl"
        },
        danhMuc: {
            tonGiao: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/ton-giao/lay-ds-ton-giao",
            tinHoc: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/dm-trinh-do-tin-hoc/lay-ds-dm-trinh-do-tin-hoc",
            ngoaiNgu: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/dm-trinh-do-ngoai-ngu/lay-ds-dm-trinh-do-ngoai-ngu",
            trinhDoVanHoa: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/dm-trinh-do-van-hoa/lay-ds-dm-trinh-do-van-hoa",
            nganHang: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/dm-ngan-hang/lay-ds-dm-ngan-hang",
            lyDoNghiViec: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/dm-ly-do-nghi-viec/lay-ds-dm-ly-do-nghi-viec",
            mucLuong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/dm-muc-luong/lay-ds-dm-muc-luong",
            loaiHinhDoanhNghiep: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/dm-loai-doanh-nghiep/lay-ds-dm-loai-doanh-nghiep",
            chuyenMonKyThuat: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/dm-chuyen-mon-kt/lay-ds-dm-chuyen-mon-kt",
            chuyenNganhDaoTao: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/dm-chuyen-nganh-dt/lay-ds-dm-chuyen-nganh-dt",
            loaiHopDong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/dm-loai-hop-dong-ld/lay-ds-dm-loai-hop-dong-ld",
            noiKhamChuaBenh: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/dm-co-so-kham-bhyt/lay-ds-dm-co-so-kham-bhyt",
            nguyenNhanTn: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/dm-nguyen-nhan-tn/lay-ds-dm-nguyen-nhan-tn",
            ngheTruocKhiMatViec: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/dm-nghe-truoc-khi-mat-viec/lay-ds-dm-nghe-truoc-khi-mat-viec",
            nganhTruocKhiMatViec: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/dm-nganh-truoc-khi-mat-viec/lay-ds-dm-nganh-truoc-khi-mat-viec",
            viTriViecLam: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/dm-vi-tri-viec-lam/lay-ds-dm-vi-tri-viec-lam",
            congViec: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/dm-cong-viec/lay-ds-dm-cong-viec",
            chiNhanhNganHang: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/dm-chi-nhanh-ngan-hang/lay-ds-chi-nhanh-theo-ngan-hang",
            mucLuongToiThieu: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/dm-muc-luong-toi-thieu/lay-ds-dm-muc-luong-toi-thieu",
            noiCapCccd: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/noi-cap-cccd",
        },

        troCapThatNghiep: {

            thongTin: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/thong-tin-hs-huong-tctn",
            xoa: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/xoa-hs-huong-tctn",
            timKiem: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/tim-kiem-hs-huong-tctn-tiep-nhan",
            layNgayHenTraKetQua: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/lay-ngay-tra-kq",
            themChiTietDongBaoHiem: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/them-ct-dong-bhtn",

            canBoNhanTinhHuongs: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/nguoi-dung/danh-sach-v2",
            canBoNhanThamDinhs: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/nguoi-dung/danh-sach-v2",
            canBoNhanTrinhDuyets: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/nguoi-dung/danh-sach-v2",
            canBoNhanTrinhKys: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/nguoi-dung/danh-sach-v2",
            vanThus: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/nguoi-dung/danh-sach-v2",
            canBoNhanTraKqs: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/nguoi-dung/danh-sach-v2",

            taiPhieuHenTctn: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/tai-phieu-hen-hs-tctn",
            taiPhieuHenHthn: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/tai-phieu-hen-hs-tctn",
            taiPhieuDeNghiHuongTctn: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/tai-phieu-de-nghi-huong-tctn",
            taiQuyetDinhTinhHuong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/tai-quyet-dinh-huong-tctn",
            taiPhieuTinhHuong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/tai-phieu-tinh-huong",
            taiBangKiem: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/tai-bang-kiem",
            taiBanCamKet: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/tai-ban-cam-ket",
            taiQuyetDinhTamDung: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/tai-quyet-dinh-tam-dung",
            taiQuyetDinhTiepTuc: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/tai-quyet-dinh-tiep-tuc",
            taiQuyetDinhChamDut: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/tai-quyet-dinh-cham-dut",
            taiQuyetDinhHuy: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/tai-quyet-dinh-huy",
            taiDeNghiChamDutHuong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/tai-phieu-de-nghi-cham-dut-huong",
            taiThongBaoBhxhChuyenHuongDen: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/tai-giay-thong-bao-bhxh-chuyen-huong-den",
            taiPhieuTiepNhanVaTraKq: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/tai-phieu-tiep-nha-va-tra-kq",


            layDsDongBhtn: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/lay-ds-ct-dong-bhtn",
            timKiemHoSoChuyenTinhHuong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/tim-kiem-hs-huong-tctn-tinh-huong",
            timKiemHoSoChuyenThamDinh: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/tim-kiem-hs-huong-tctn-tham-dinh",
            // timKiemHoSoChoDuyet:rootUrl_Micro+"quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/tim-kiem-hs-huong-tctn-cho-duyet",
            // timKiemHoSoChoKy:rootUrl_Micro+"quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/tim-kiem-hs-huong-tctn-cho-ky",
            timKiemHoSoChoDuyet: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/tim-kiem-hs-huong-tctn-trinh-duyet",
            timKiemHoSoChoKy: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/tim-kiem-hs-huong-tctn-trinh-ky",
            timKiemHoSoChoDanhSo: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/tim-kiem-hs-huong-tctn-danh-so",
            timKiemHoSoChoTraKq: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/tim-kiem-hs-huong-tctn-tra-kq",

            themMoi: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/them-hs-huong-tctn",
            capNhat: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/cap-nhat-hs-huong-tctn",
            chuyenTinhHuong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/chuyen-tinh-huong",
            tinhHuong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/tinh-huong",
            luuTinhHuong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/luu-tinh-huong",
            chuyenThamDinh: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/chuyen-tham-dinh",
            luuThamDinh: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/luu-tham-dinh",
            chuyenTrinhDuyet: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/chuyen-trinh-duyet",
            duyet: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/duyet-hs",
            chuyenTrinhKy: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/chuyen-trinh-ky",
            ky: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/ky-hs",
            chuyenVaoSo: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/chuyen-van-thu",
            vaoSo: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/danh-so",
            capNhatSoQd: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/cap-nhat-so-qd",
            chuyenTraKq: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/chuyen-tra-kq",
            traKq: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/tra-kq",
            luuKhongDuDieuKienHuong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/hs-khong-du-dk-huong",
            choSoTruoc: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/cho-so-quyet-dinh",
            capNhatNhanh: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/cap-nhat-nhanh",

            tinhHuongTraTiepNhan: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/tinh-huong-tra-tiep-nhan",
            thamDinhTraTiepNhan: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/tham-dinh-tra-tiep-nhan",
            thamDinhTraTinhHuong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/tham-dinh-tra-tinh-huong",


            uploadHoSoDinhKemTctn: rootUrl_Micro + "file/bhtn/upload-file-hs-huong-tctn",
            layDsHoSoDinhKemTctn: rootUrl_Micro + "file/bhtn/list-file-hs-huong-tctn",
            downloadHoSoDinhKemTctn: rootUrl_Micro + "file/bhtn/download-file-hs-huong-tctn",
            xoaHoSoDinhKemTctn: rootUrl_Micro + "file/bhtn/delete-file-hs-huong-tctn",

            uploadQuyetDinh: rootUrl_Micro + "file/bhtn/upload-file-quyet-dinh",
            layDsQuyetDinh: rootUrl_Micro + "file/bhtn/list-file-quyet-dinh",
            downloadQuyetDinh: rootUrl_Micro + "file/bhtn/download-file-quyet-dinh",
            xoaQuyetDinh: rootUrl_Micro + "file/bhtn/delete-file-quyet-dinh",

            urlKySoCallback: rootUrl_Micro + "file/bhtn/ky-so-callback",
            danhMaHoSo: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/danh-ma-ho-so-tctn",
            deNghiKhongHuongTctn: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/de-nghi-khong-huong",
            taiDeNghiKhongHuongTctn: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/tai-phieu-de-nghi-khong-huong-tctn",
            taiXmlHoSo: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/xml-hs-huong-tctn",

            taoHoSoCon: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/them-hs-huong-tctn",
            capNhatHoSoCon: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/cap-nhat-hs-huong-tctn",
            danhSachHSTctn: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/ds-hs-huong-tctn",
            danhSachCosodaotao: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/dm-co-so-dt/lay-ds-dm-co-so-dt",
            danhSachKhoahoc: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/dm-khoa-dao-tao/lay-ds-dm-khoa-dao-tao",
            taoHoSohocnghe: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/them-hs-huong-tctn",
            capnhatHoSohocnghe: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/cap-nhat-hs-huong-tctn",
            taiHSHocnghe: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/tai-phieu-de-nghi-ho-tro-hoc-nghe",
            thongtinKhoahoc: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/dm-khoa-dao-tao/lay-thong-tin",

            xoaThongBaoViecLam: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/xoa-lich-thong-bao",
            taiDeNghiChuyenHuongDi: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/tai-phieu-de-nghi-chuyen-huong-di",
            taiGiayGioiThieuChuyenHuongDi: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/tai-giay-gioi-thieu-chuyen-huong-di",
            taiGiayThongBaoBhxhChuyenHuongDi: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/tai-giay-thong-bao-bhxh-chuyen-huong-di",
            baoCaoM1TongHopTheoDoiTinhHinhThucHienBhtnNam: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/bao-cao-thong-ke/tk-mau-01",
            baoCaoM2ThongKeKetQuaTiepNhanGiaiQuyetHoSo: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/bao-cao-thong-ke/tk-mau-02",
            baoCaoM3BaoCaoNhanhTinhHinhThucHienBhtnThang: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/bao-cao-thong-ke/tk-mau-03",
            baoCaoM4BaoCaoTinhHinhThucHienBhtnThang: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/bao-cao-thong-ke/tk-mau-04",
            baoCaoM5BaoCaoChiTietVeThucHienCacCheDoBhtnThang: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/bao-cao-thong-ke/tk-mau-05",
            baoCaoM6BaoCaoCacChiSoDanhGiaHieuQuaThucHienBhtnNam: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/bao-cao-thong-ke/tk-mau-06",

            nhacViec: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/nhac-viec",
            capNhatThongTinNganHang: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/cong-dan/cap-nhat-cong-dan-mau-03",
            exportTraKq: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/export-tra-kq",

            taiQuyetDinhHoTroHocNghe: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/tai-quyet-dinh-ho-tro-hoc-nghe",
            taiPhieuDeNghiHoTroHocNghe: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/tai-phieu-de-nghi-ho-tro-hoc-nghe",

            baoCaoM7BangTheoDoiTinhHinhBHTNThang: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/bao-cao-thong-ke/bang-theo-doi-tinh-hinh-thuc-hien-bao-hiem-that-nghiep-theo-thang"

        },

        thongBaoViecLam: {
            getListTbViecLam: rootUrl_Micro + "sldtbxh/quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/tim-kiem-thong-bao-viec-lam",
            getChiTietTbViecLam: rootUrl_Micro + "sldtbxh/quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/lay-ds-lich-thong-bao",
            capNhatLichTbvl: rootUrl_Micro + "sldtbxh/quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/cap-nhat-lich-thong-bao",
            taiThongBao: rootUrl_Micro + "sldtbxh/quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/tai-phieu-thong-bao-viec-lam",
            luuDeNghiKhongThongBao: rootUrl_Micro + "sldtbxh/quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/de-nghi-khong-thong-bao",
            taiDeNghiKhongThongBao: rootUrl_Micro + "sldtbxh/quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/tai-phieu-de-nghi-khong-thong-bao"
        },
        timKiem: {
            timKiemNhanh: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/tra-cuu-hs",
            chiTietHoSoTimKiemNhanh: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/hs-huong-tctn/chi-tiet-tra-cuu-hs"
        },
        nhatKy: {
            nhatKyHeThong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/logs",
            taiNhatKyHeThong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/logs/download",
            getStackTraceDetail: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/logs/error"
        }

    },

    //BTXH VLG -> Quản lý nhà tài trợ -> Nhập kho hàng hoá - Luongnc
    NhapKhoHangHoa: {
        LayDanhSachThongTinTaiTro: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/lay-danh-sach-thong-tin-tai-tro?p_id=-1&p_size=10&p_page=1',
        LayDanhSachKho: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/lay-danh-sach-kho?p_id=-1',
        LayDanhSachPhieuTuNgayDenNgay: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/tim-kiem-chi-tiet-thong-tin-phieu-nhap-kho-hang-hoa',
        ThemPhieu: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/them-chi-tiet-thong-tin-phieu-nhap-kho-hang-hoa',
        SuaPhieu: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/cap-nhat-chi-tiet-thong-tin-phieu-nhap-kho-hang-hoa',
        XoaPhieu: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/xoa-chi-tiet-thong-tin-phieu-nhap-kho-hang-hoa',
        InPhieu: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/in-phieu-nhap-kho-hang-hoa',
        LayDanhSachHangHoaTaiTro: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/lay-danh-sach-hang-hoa-tai-tro?p_id=-1',
        LayDanhSachHangHoaNhapKho: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/lay-danh-sach-thong-tin-hang-hoa-nhap-kho',
        LayDanhSachDonViTinh: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/lay-danh-sach-don-vi-tinh?p_id=-1',
        ThemHangHoa: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/them-chi-tiet-thong-tin-hang-hoa-nhap-kho',
        SuaHangHoa: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/cap-nhat-chi-tiet-thong-tin-hang-hoa-nhap-kho',
        XoaHangHoa: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/xoa-chi-tiet-thong-tin-hang-hoa-nhap-kho'
    },

    GNBV: {
        danhMuc: {
            loaiHinhHoatDong: rootUrl_Micro + 'matuy/danh-muc/loaiHinhDN',
            loaiHinhKinhTe: rootUrl_Micro + 'matuy/danh-muc/nhomNganhKT',
            chucVu: rootUrl_Micro + 'matuy/danh-muc/chucvu',
            trinhDoHocVan: rootUrl_Micro + 'matuy/danh-muc/trinhdohocvan',
            trinhDoCMKT: rootUrl_Micro + 'matuy/danh-muc/trinhdoCMKT',
            kyNangMem: rootUrl_Micro + 'matuy/danh-muc/kyNangMem',
            yeuCauKinhNghiem: rootUrl_Micro + 'matuy/danh-muc/ycKinhNghiem',
            yeuCauThem: rootUrl_Micro + 'matuy/danh-muc/yeuCauThem',
            loaiHopDong: rootUrl_Micro + 'matuy/danh-muc/loaiHopDongLD',
            hinhThucLamViec: rootUrl_Micro + 'matuy/danh-muc/hinhThucLamViec',
            mucDichLamViec: rootUrl_Micro + 'matuy/danh-muc/mucDichLamViec',
            mucLuong: rootUrl_Micro + 'matuy/danh-muc/mucLuong',
            cheDoPhucLoi: rootUrl_Micro + 'matuy/danh-muc/cheDoPhucLoi',
            noiLamViec: rootUrl_Micro + 'matuy/danh-muc/noiLamViec',
            trongLuongNang: rootUrl_Micro + 'matuy/danh-muc/trongLuongNang',
            diChuyen: rootUrl_Micro + 'matuy/danh-muc/diChuyen',
            ngheNoi: rootUrl_Micro + 'matuy/danh-muc/ngheNoi',
            thiLuc: rootUrl_Micro + 'matuy/danh-muc/thiLuc',
            thaoTacTay: rootUrl_Micro + 'matuy/danh-muc/thaoTacTay',
            dung2Tay: rootUrl_Micro + 'matuy/danh-muc/dung2Tay',
            doiTuongUuTien: rootUrl_Micro + 'matuy/danh-muc/doiTuongUuTien',
            hinhThucTuyenDung: rootUrl_Micro + 'matuy/danh-muc/hinhThucTuyenDung',
            maNghe: rootUrl_Micro + 'matuy/ldvl-thongtu11/getMaNghe',
            danhSachDoiTuongUuTien: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllDMDoiTuongUuTien",
            danhSachTrinhDoGDPT: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllDMTrinhDoHocVan",
            danhSachTrinhDoCMKT: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllDMTrinhDoKiThuat",
            danhSachTinhTrangHDKT: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllDMTinhTrangHoatDongKinhTe",
            danhSachViTheViecLam: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllDMViTheViecLam",
            danhSachLoaiHopDongLD: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllDMLoaiHopDong",
            danhSachLoaiHinhNoiLamViec: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllDMLoaiHinhNoiLamViec",
            danhSachLoaiHinhThatNghiep: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllDMNguoiThatNghiep",
            danhSachLoaiThoiGianThatNghiep: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllDMThoiGianThatNghiep",
            danhSachLyDoKhongThamGiaHDKT: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllLyDoKhongThamGiaHDKT"
        },
        thongTinDoanhNghiep_NCTDLaoDong: rootUrl_Micro + "matuy/danh-muc/DoanhNghiepByMST",
        danhSach_NCTDLaoDong: rootUrl_Micro + "matuy/v2/tuyen-dung-tt-11/danh-sach",
        thongTin_NCTDLaoDong: rootUrl_Micro + "matuy/tuyen-dung-tt-11/ChiTiet",
        xoa_NCTDLaoDong: rootUrl_Micro + "matuy/tuyen-dung-tt-11/delete",
        khoiPhuc_NCTDLaoDong: rootUrl_Micro + "matuy/tuyen-dung-tt-11/restore",
        insert_NCTDLaoDong: rootUrl_Micro + "matuy/v2/tuyen-dung-tt-11/insert",
        update_NCTDLaoDong: rootUrl_Micro + "matuy/v2/tuyen-dung-tt-11/update",

        danhSachDoiTuongUuTien: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllDMDoiTuongUuTien",
        danhSachTrinhDoGDPT: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllDMTrinhDoHocVan",
        danhSachTrinhDoCMKT: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllDMTrinhDoKiThuat",
        danhMucChuyenNganhDaoTao: rootUrl_Micro + "matuy/ldvl-thongtu11/getMaNganhCap3GiaoDucDaoTao",
        danhSachTinhTrangHDKT: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllDMTinhTrangHoatDongKinhTe",
        danhSachViTheViecLam: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllDMViTheViecLam",
        danhSachLoaiHopDongLD: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllDMLoaiHopDong",
        danhSachLoaiHinhNoiLamViec: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllDMLoaiHinhNoiLamViec",
        danhSachLoaiHinhThatNghiep: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllDMNguoiThatNghiep",
        danhSachLoaiThoiGianThatNghiep: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllDMThoiGianThatNghiep",
        danhSachLyDoKhongThamGiaHDKT: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllLyDoKhongThamGiaHDKT",
        danhSachKyNangMem: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllDMKyNangMem",
        danhSachLoaiHinhDN: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllDMLoaiHinhDoanhNghiep",
        danhSachChucVu: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllDMChucVu",
        danhSachKinhNghiemLamViec: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllDMKinhNghiem",
        danhSachKhaNangDapUng: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllDMKhaNangDapUng",
        danhSachHinhThucLamViec: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllDMHinhThucLamViec",
        danhSachMucDichLamViec: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllDMMucDichLamViec",
        danhSachMucLuong: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllDMMucLuong",
        danhSachPhucLoi: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllDMPhucLoi",
        danhSachNoiLamViec: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllDMNoiLamViec",
        danhSachTrongLuongNang: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllDMTrongLuong",
        danhSachDiLai: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllDMDiChuyen",
        danhSachNgheNoi: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllDMNgheNoi",
        danhSachThiLuc: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllDMThiLuc",
        danhSachThaoTacTay: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllDMThaoTacTay",
        danhSachDung2Tay: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllDMDung2Tay",
        danhSachSanSangLamViec: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllDMSanSang",
        danhSachHinhThucTuyenDung: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllDMHinhThucTuyenDung",
        danhSachThoiGianDaoTao: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllThoiGianDaoTao",
        danhSachNhuCauViecLamCanTim: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllNhuCauViecLamCanTim",
        danhSachNhuCauDaoTao: rootUrl_Micro + "matuy/ldvl-thongtu11/getAllNhuCauDaoTao",
        danhSachMaNghe: rootUrl_Micro + "matuy/ldvl-thongtu11/getMaNghe",
        timKiemThongTinNguoiLaoDong: rootUrl_Micro + "matuy/thongtu11/nguoi-lao-dong/danh-sach",
        addThongTinNguoiLaoDong: rootUrl_Micro + "matuy/thongtu11/nguoi-lao-dong/them-moi",
        layThongTinNguoiLaoDong: rootUrl_Micro + "matuy/thongtu11/nguoi-lao-dong/chi-tiet",
        updateThongTinNguoiLaoDong: rootUrl_Micro + "matuy/thongtu11/nguoi-lao-dong/cap-nhat",
        deleteThongTinNguoiLaoDong: rootUrl_Micro + "matuy/thongtu11/nguoi-lao-dong/xoa",
        kiemTraTrungCMND: rootUrl_Micro + "matuy/thongtu11/nguoi-lao-dong/check-trung",
        inThongTinNguoiLaoDong: rootUrl_Micro + "matuy/thongtu11/nguoi-lao-dong/in-danh-sach",
        inDanhSachTrichNgang: rootUrl_Micro + "matuy/thongtu11/nguoi-lao-dong/in-danh-sach-trich-ngang",
        DTP:{
          getDaTaCMND: rootUrl_Micro + "matuy/thongtu11/nguoi-lao-dong/get_tv_by_cmnd",
        },

        GET_DATA: {
            xuatBaoCaoMau2: rootUrl_Micro + "get-data/matuy/ldvl-thongtu11/mau02_TT11",
            xuatBaoCaoMau3: rootUrl_Micro + "get-data/matuy/ldvl-thongtu11/mau03_TT11",
            getBaoCaoMau8: rootUrl_Micro + "get-data/matuy/ldvl-thongtu11/bao-cao-mau-08",
            getBaoCaoMau7: rootUrl_Micro + "get-data/matuy/ldvl-thongtu11/bao-cao-mau-07",
            getBaoCaoMau3: rootUrl_Micro + "get-data/matuy/ldvl-thongtu11/bao-cao-mau-03",
            getFile_NCTDLDLaoDong: rootUrl_Micro + "get-data/matuy/ldvl-thongtu11/tuyen-dung-tt-11/print",
            getBaoCaoMau456: rootUrl_Micro + "get-data/matuy/ldvl-thongtu11/xuat-mau-4-5-6",
            xuatDanhSachNguoiLaoDong: rootUrl_Micro + "get-data/matuy/ldvl-thongtu11/xuat-danh-sach",
        },

        danhSach_NCTDLaoDong_STG: rootUrl_Micro + "matuy/tuyen-dung-tt-11/stg/danh-sach",
        insert_NCTDLaoDong_STG: rootUrl_Micro + "matuy/tuyen-dung-tt-11/stg/insert",
        update_NCTDLaoDong_STG: rootUrl_Micro + "matuy/tuyen-dung-tt-11/stg/update",
        danhSachQuyMoDoanhNghiep: rootUrl_Micro + "matuy/tuyen-dung-tt-11/stg/quy-mo-doanh-nghiep",
        danhSachCanBoThuThapTD: rootUrl_Micro + "matuy/tuyen-dung-tt-11/stg/can-bo-thu-thap",
        giaoNopTTTuyenDungSTG: rootUrl_Micro + "matuy/tuyen-dung-tt-11/stg/giao-nop",

        thongKeDoanhNgiepTheoLoaiHinh: rootUrl_Micro + "matuy/tuyen-dung-tt-11/stg/thong-ke-doanh-nghiep-theo-loai-hinh",
        thongKeTuyenDungTheoHinhThucLamViec: rootUrl_Micro + "matuy/tuyen-dung-tt-11/stg/thong-ke-tuyen-dung-theo-hinh-thuc",
        thongKeTuyenDungTheoLoaiHinh: rootUrl_Micro + "matuy/tuyen-dung-tt-11/stg/thong-ke-tuyen-dung-theo-loai-hinh",
        thongKeTuyenDungTheoMaCap2: rootUrl_Micro + "matuy/tuyen-dung-tt-11/stg/thong-ke-tuyen-dung-theo-ma-cap-2",
        thongKeTuyenDungTheoViTri: rootUrl_Micro + "matuy/tuyen-dung-tt-11/stg/thong-ke-tuyen-dung-theo-vi-tri",

        timKiemThongTinNguoiLaoDongStg: rootUrl_Micro + "matuy/thongtu11/nguoi-lao-dong/stg/danh-sach",
        timKiemThongTinNguoiLaoDongStgv2: rootUrl_Micro + "matuy/thongtu11/nguoi-lao-dong/stg/danh-sach-v2",
        timKiemThongTinNguoiLaoDongStgv2Count: rootUrl_Micro + "matuy/thongtu11/nguoi-lao-dong/stg/danh-sach-v2-count",

        danhSachChotDuLieu: rootUrl_Micro + "matuy/thongtu11/nguoi-lao-dong/stg/danh-sach-chot-du-lieu",
        capNhatChotDuLieu: rootUrl_Micro + "matuy/thongtu11/nguoi-lao-dong/stg/cap-nhat-chot-du-lieu",

        xuatBaoCaoMau2: rootUrl_Micro + "matuy/ldvl-thongtu11/mau02_TT11",
        xuatBaoCaoMau3: rootUrl_Micro + "matuy/ldvl-thongtu11/mau03_TT11",
        getBaoCaoMau8: rootUrl_Micro + "matuy/ldvl-thongtu11/bao-cao-mau-08",
        getBaoCaoMau7: rootUrl_Micro + "matuy/ldvl-thongtu11/bao-cao-mau-07",
        getBaoCaoMau3: rootUrl_Micro + "matuy/ldvl-thongtu11/bao-cao-mau-03",
        getBaoCaoMau456: rootUrl_Micro + "matuy/thongtu11/xuat-mau-4-5-6",

        getDsTinhTrangGiaoNopSTG: rootUrl_Micro + "matuy/thongtu11/nguoi-lao-dong/stg/danh-sach-tinh-trang-giao-nop",
        giaoNopTTNguoiTimViecSTG: rootUrl_Micro + "matuy/thongtu11/nguoi-lao-dong/stg/giao-nop",
        kiemTraTrungCMND_STG: rootUrl_Micro + "matuy/thongtu11/nguoi-lao-dong/stg/check-trung",
        layThongTinNguoiLaoDongTheoCCCD: rootUrl_Micro + "matuy/thongtu11/nguoi-lao-dong/stg/chi-tiet-cccd",
        addThongTinNguoiLaoDongSTG: rootUrl_Micro + "matuy/thongtu11/nguoi-lao-dong/stg/them-moi",
        updateThongTinNguoiLaoDongSTG: rootUrl_Micro + "matuy/thongtu11/nguoi-lao-dong/stg/cap-nhat",
        capNhatNguoiLaoDongKoConSTG: rootUrl_Micro + "matuy/thongtu11/nguoi-lao-dong/stg/cap-nhat-khong-con",
        getDsTinhTrangLaoDongSTG: rootUrl_Micro + "matuy/thongtu11/nguoi-lao-dong/stg/danh-sach-tinh-trang-nguoi-lao-dong",

        thongKeNguoiTu15TuoiTheoGioiTinh: rootUrl_Micro + "matuy/thongtu11/nguoi-lao-dong/stg/thong-ke-tren-15-theo-gioi-tinh",
        thongKeNguoiCoViecLamTheoTrinhDo: rootUrl_Micro + "matuy/thongtu11/nguoi-lao-dong/stg/thong-ke-co-viec-lam-theo-trinh-do",
        thongKeNguoiCoViecLamTheoViTheViecLam: rootUrl_Micro + "matuy/thongtu11/nguoi-lao-dong/stg/thong-ke-co-viec-lam-theo-vi-the",
        thongKeNguoiThatNghiepTheoTrinhDo: rootUrl_Micro + "matuy/thongtu11/nguoi-lao-dong/stg/thong-ke-that-nghiep-theo-trinh-do",
        thongKeNguoiThatNghiepTheoThoiGian: rootUrl_Micro + "matuy/thongtu11/nguoi-lao-dong/stg/thong-ke-that-nghiep-theo-thoi-gian",
        thongKeNguoiKhongHoatDongKTTheoDoiTuong: rootUrl_Micro + "matuy/thongtu11/nguoi-lao-dong/stg/thong-ke-ko-tham-gia-kt-theo-doi-tuong",
        thongKesoLuongBienDongHoSo: rootUrl_Micro + "matuy/thongtu11/nguoi-lao-dong/stg/thong-ke-bien-dong-ho-so",
    },

    //BTXH VLG -> Quản lý nhà tài trợ -> Thông tin tài trợ - LuongNC
    ThongTinTaiTro: {
        TimKiemThongTinTaiTro: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/tim-kiem-chi-tiet-thong-tin-tai-tro',
        LayDanhSachLoaiTaiTro: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/lay-danh-sach-loai-tai-tro?p_id=-1',
        LayDanhSachHinhThucTaiTro: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/lay-danh-sach-hinh-thuc-tai-tro?p_id=-1',
        ThemThongTinTaiTro: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/them-chi-tiet-thong-tin-tai-tro',
        ChinhSuaThongTinTaiTro: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/cap-nhat-chi-tiet-thong-tin-tai-tro',
        XoaThongTinTaiTro: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/xoa-thong-tin-tai-tro',
        InPhieuCamOn: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/in-thu-cam-on-nha-tai-tro',
        LayDanhSachHangHoa: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/lay-danh-sach-hang-hoa-tai-tro?p_id=-1',
        LayDanhSachHangHoaTaiTro: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/lay-danh-sach-thong-tin-hang-hoa-tai-tro',
        LayDanhSachDonViTinh: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/lay-danh-sach-don-vi-tinh?p_id=-1',
        ThemHangHoa: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/them-chi-tiet-thong-tin-hang-hoa-tai-tro',
        ChinhSuaHangHoa: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/cap-nhat-chi-tiet-thong-tin-hang-hoa-tai-tro',
        XoaHangHoa: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/xoa-chi-tiet-thong-tin-hang-hoa-tai-tro',
        XuatDSThongTinTaiTro: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/xuat-ds-thong-tin-tai-tro',
        LayDanhSachNhaTaiTro: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/lay-nha-tai-tro',
        SearchNhaTaiTro: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/tim-kiem-nha-tai-tro',
        ThemNhaTaiTro: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/them-nha-tai-tro',
        ChinhSuaNhaTaiTro: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/sua-nha-tai-tro',
        XoaNhaTaiTro: rootUrl_Micro + 'bao-tro-xa-hoi/v2/nha-tai-tro/xoa-nha-tai-tro'
    },

    GDNN_BAOCAO_SO: {
        DANH_MUC: {
            getAllTrinhDoTiengAnh: rootUrl_Micro + "gdnn/dm-trinh-do-tieng-anh",
            getAllTrinhDoTinHoc: rootUrl_Micro + "gdnn/dm-trinh-do-ung-dung-tin-hoc",
            getAllTrinhDoChuyenMon: rootUrl_Micro + "gdnn/dm-trinh-do-chuyen-mon",
            getAllChucDanh: rootUrl_Micro + "gdnn/dm-chuc-danh",
            getAllNghiepVuSuPham: rootUrl_Micro + "gdnn/dm-nghiep-vu-su-pham",
            getAllNghiepVuGiangDay: rootUrl_Micro + "gdnn/dm-nghiep-vu-giang-day",
            getAllPhongBan: rootUrl_Micro + "gdnn/dm-phong-ban",
            getAllNgheDaoTao: rootUrl_Micro + "gdnn/dm-nganh-nghe-dao-tao-get-all",
            getNgheDaoTaoByTuyenSinhId: rootUrl_Micro + "gdnn/dm-nganh-nghe-dao-tao",
            getAllCapBacCoQuan: rootUrl_Micro + "gdnn/dm-cap-bac-co-quan",
            getAllLoaiHinhCoSo: rootUrl_Micro + "gdnn/dm-loai-hinh-co-so",
            getAllCoCauChucDanh: rootUrl_Micro + "gdnn/dm-co-cau-chuc-danh",
            getAllChucDanhLanhDao: rootUrl_Micro + "gdnn/dm-chuc-danh-lanh-dao",
            getAllLoaiCoSoDaoTao: rootUrl_Micro + "gdnn/dm-loai-co-so-dao-tao",
            getAllDmCanBo: rootUrl_Micro + "gdnn/can-bo/dm-can-bo",
            getAllHocSinh: rootUrl_Micro + "gdnn/hoc-sinh-sinh-vien/dm-hssv",
            getAllTrinhDoDaoTao: rootUrl_Micro + "gdnn/dm-trinh-do-dao-tao",
            getNganhNghe: rootUrl_Micro + "gdnn/dm-nganh-nghe",
            getAllTuyenSinh: rootUrl_Micro + "gdnn/dm-tuyen-sinh",
            getAllHinhThucTuyenSinh: rootUrl_Micro + "gdnn/dm-hinh-thuc-tuyen-sinh",
            getAllChinhSach: rootUrl_Micro + "gdnn/chinh-sach/get-all",
            getCoSoDaoTaoIdMaTruong: rootUrl_Micro + "gdnn/pham-mem-so/co-so-dao-tao/get-id-theo-ma-truong",
            getAllDoiTuongTuyenSinh: rootUrl_Micro + "gdnn/dm-doi-tuong-tuyen-sinh",
            getAllDoiTuongChinhSach: rootUrl_Micro + "gdnn/dm-doi-tuong-chinh-sach",
            getDanhHieu: rootUrl_Micro + "gdnn/dm-danh-hieu-nha-giao",
            getAllTrangThai: rootUrl_Micro + "gdnn/dm-trang-thai-hssv",
            getDmLoaiCoSoVatChat: rootUrl_Micro + "gdnn/dm-loai-co-so-vat-chat",
            getDmTinhTrangCSVC: rootUrl_Micro + "gdnn/dm-tinh-trang-co-so-vat-chat",
            getAllHienTrang: rootUrl_Micro + "gdnn/dm-tinh-trang-trang-thiet-bi",
            getAllTruSo: rootUrl_Micro + "gdnn/pham-mem-so/tru-so-truong/gel-all",
            getAllDmDungChung: rootUrl_Micro + "gdnn/dm-dung-chung",
            getAllXepLoaiTotNghiep: rootUrl_Micro + "gdnn/dm-xep-loai-tot-nghiep-get-all",
            getKhoa: rootUrl_Micro + "gdnn/dm-khoa",
            getLop: rootUrl_Micro + "gdnn/dm-lop",
            getCapQuyetDinh: rootUrl_Micro + "gdnn/pham-mem-so/dm-cap-quyet-dinh/gel-all",
            getAllSinhVienDuDKTN: rootUrl_Micro + "gdnn/hoc-sinh-sinh-vien/dm-hssv-du-dktn",
            getDmCoSoVatChatByLoai: rootUrl_Micro + "gdnn/dm-co-so-vat-chat-by-loai",
            getAllDonViDienTich: rootUrl_Micro + "gdnn/dm-don-vi-dien-tich",
        },
        COSOVATCHAT: {
            THEM_MOI: rootUrl_Micro + "gdnn/trang-thiet-bi/them-moi",
            CHI_TIET: rootUrl_Micro + "gdnn/trang-thiet-bi/chi-tiet",
            CAP_NHAT: rootUrl_Micro + "gdnn/trang-thiet-bi/cap-nhat",
            XOA: rootUrl_Micro + "gdnn/trang-thiet-bi/xoa",
            DANH_SACH: rootUrl_Micro + "gdnn/trang-thiet-bi/danh-sach",
            TEAMPLATE_CSVC: rootUrl_Micro + "gdnn/trang-thiet-bi/xuat-template-import",
            IMPORT_FILE: rootUrl_Micro + "gdnn/trang-thiet-bi/import-trang-thiet-bi"
        },
        CAN_BO: {
            THEM_MOI: rootUrl_Micro + "gdnn/can-bo/them-moi",
            CHI_TIET: rootUrl_Micro + "gdnn/can-bo/chi-tiet",
            CAP_NHAT: rootUrl_Micro + "gdnn/can-bo/cap-nhat",
            XOA: rootUrl_Micro + "gdnn/can-bo/xoa",
            DANH_SACH: rootUrl_Micro + "gdnn/can-bo/danh-sach",
            TEMPLATE: rootUrl_Micro + "file/gdnn/download-file-admin/119c47e6-d73e-11ed-8989-0050568863c2",
            IMPORT: rootUrl_Micro + "gdnn/can-bo/import-can-bo"
        },
        CO_SO_DAO_TAO: {
            THEM_MOI: rootUrl_Micro + "gdnn/pham-mem-so/co-so-dao-tao/them-moi",
            CHI_TIET: rootUrl_Micro + "gdnn/pham-mem-so/co-so-dao-tao/chi-tiet",
            CAP_NHAT: rootUrl_Micro + "gdnn/pham-mem-so/co-so-dao-tao/cap-nhat",
            XOA: rootUrl_Micro + "gdnn/pham-mem-so/co-so-dao-tao/xoa",
            DANH_SACH: rootUrl_Micro + "gdnn/pham-mem-so/co-so-dao-tao/danh-sach",
            TEMPLATE_CSDT: rootUrl_Micro + "file/gdnn/download-file-admin/a2603686-d48b-11ed-8989-0050568863c2",
            IMPORT_CSDT: rootUrl_Micro + "gdnn/import-co-so-dao-tao",
            TEMPLATE_IMPORT_CSDT: rootUrl_Micro + "gdnn/pham-mem-so/template-import-excel",
            IMPORT_CSDT_FROM_TEMPLATE: rootUrl_Micro + "gdnn/pham-mem-so/import-co-so-dao-tao-from-template",
            UPLOAD_FILE_DINH_KEM: rootUrl_Micro + "file/gdnn/co-so-dao-tao/upload-file-dinh-kem",
            DOWNLOAD_FILE_DK: rootUrl_Micro + "file/gdnn/co-so-dao-tao/download-file"
        },

        CO_SO_DAO_TAO_GIAO_DUC: {
            DANH_SACH: rootUrl_Micro + "gdnn/agg/co-so-dao-tao-giao-duc/danh-sach-co-so-phan-trang",
            DANH_SACH_LOAI_TRUONG: rootUrl_Micro + "gdnn/agg/co-so-dao-tao-giao-duc/danh-sach-loai-truong",
            DANH_SACH_LEVEL_TRUONG: rootUrl_Micro + "gdnn/agg/co-so-dao-tao-giao-duc/danh-sach-level-truong",
            DANH_SACH_CHI_TIET: rootUrl_Micro + "gdnn/agg/co-so-dao-tao-giao-duc/chi-tiet",
            CAP_NHAT: rootUrl_Micro + "gdnn/agg/co-so-dao-tao-giao-duc/cap-nhat",
            XOA: rootUrl_Micro + "gdnn/agg/co-so-dao-tao-giao-duc/xoa",
            TEMPLATE_CSDTGD: rootUrl_Micro + "gdnn/agg/co-so-dao-tao-giao-duc/file-mau",
            IMPORT_CSDTGD: rootUrl_Micro + "gdnn/import-csdt-from-template",
            THEM:rootUrl_Micro+"gdnn/agg/co-so-dao-tao-giao-duc/them"
        },
        SINH_VIEN: {
            THEM_MOI: rootUrl_Micro + "gdnn/hoc-sinh-sinh-vien/them-moi",
            CHI_TIET: rootUrl_Micro + "gdnn/hoc-sinh-sinh-vien/chi-tiet",
            CAP_NHAT: rootUrl_Micro + "gdnn/hoc-sinh-sinh-vien/cap-nhat",
            XOA: rootUrl_Micro + "gdnn/hoc-sinh-sinh-vien/xoa",
            DANH_SACH: rootUrl_Micro + "gdnn/hoc-sinh-sinh-vien/danh-sach",
            TEMPLATE: rootUrl_Micro + "file/gdnn/download-file-admin/b879227d-d751-11ed-8989-0050568863c2",
            IMPORT: rootUrl_Micro + "gdnn/hoc-sinh-sinh-vien/import-hoc-sinh-sv",
            XUAT_LIST_SINH_VIEN: rootUrl_Micro + "gdnn/pham-mem-so/bao-cao/danh-sach-sinh-vien",
            TEMPLATE_HGI: rootUrl_Micro + "file/gdnn/download-file-admin",
            IMPORT_HGI: rootUrl_Micro + "gdnn/hoc-sinh-sinh-vien/import-hoc-sinh-sv-hgi",
            TEMPLATE_TN_HGI: rootUrl_Micro + "gdnn/hoc-sinh-sinh-vien/xuat-template-import-sv-tot-nghiep",
            IMPORT_TN_HGI: rootUrl_Micro + "gdnn/hoc-sinh-sinh-vien/import-hoc-sinh-sv-tot-nghiep",
            CHUYEN_VE_TM: rootUrl_Micro + "gdnn/hoc-sinh-sinh-vien/cap-nhat-tu-tot-nghiep-ve-tuyen-moi",
            checkFileImport: rootUrl_Micro + "gdnn/hoc-sinh-sinh-vien/check-file-import-hgi"
        },
        BAO_CAO: {
            CO_SO_DAO_TAO: rootUrl_Micro + "gdnn/pham-mem-so/bao-cao/201",
            GIAO_VIEN: rootUrl_Micro + "gdnn/pham-mem-so/bao-cao/202",
            HOC_SINH_TUYEN_SINH: rootUrl_Micro + "gdnn/pham-mem-so/bao-cao/203-1",
            HOC_SINH_TOT_NGHIEP: rootUrl_Micro + "gdnn/pham-mem-so/bao-cao/203-2",
        },
        CHINH_SACH: {
            THEM_MOI: rootUrl_Micro + "gdnn/chinh-sach/them-moi",
            CHI_TIET: rootUrl_Micro + "gdnn/chinh-sach/chi-tiet",
            CAP_NHAT: rootUrl_Micro + "gdnn/chinh-sach/cap-nhat",
            XOA: rootUrl_Micro + "gdnn/chinh-sach/xoa",
            DANH_SACH: rootUrl_Micro + "gdnn/chinh-sach/danh-sach"
        },
        VAN_BAN: {
            THEM_MOI: rootUrl_Micro + "file/gdnn/van-ban-quy-pham/them-moi",
            CHI_TIET: rootUrl_Micro + "gdnn/van-ban-quy-pham/chi-tiet",
            CAP_NHAT: rootUrl_Micro + "file/gdnn/van-ban-quy-pham/cap-nhat",
            XOA: rootUrl_Micro + "file/gdnn/van-ban-quy-pham/delete",
            DANH_SACH: rootUrl_Micro + "gdnn/van-ban-quy-pham/danh-sach",
            DOWNLOAD_FILE: rootUrl_Micro + "file/gdnn/van-ban-quy-pham/download-file"
        },
        TUYEN_DUONG_KHEN_THUONG: {
            THEM_MOI: rootUrl_Micro + "file/gdnn/van-ban-khen-thuong/them-moi",
            CHI_TIET: rootUrl_Micro + "gdnn/tuyen-duong-khen-thuong/chi-tiet",
            CAP_NHAT: rootUrl_Micro + "file/gdnn/van-ban-khen-thuong/cap-nhat",
            XOA: rootUrl_Micro + "file/gdnn/van-ban-khen-thuong/delete",
            DANH_SACH: rootUrl_Micro + "gdnn/tuyen-duong-khen-thuong/danh-sach"
        },
        CHUONG_TRINH_DAO_TAO: {
            THEM_MOI: rootUrl_Micro + "gdnn/chuong-trinh-dao-tao/them-moi",
            CHI_TIET: rootUrl_Micro + "gdnn/chuong-trinh-dao-tao/chi-tiet",
            CAP_NHAT: rootUrl_Micro + "gdnn/chuong-trinh-dao-tao/cap-nhat",
            XOA: rootUrl_Micro + "gdnn/chuong-trinh-dao-tao/xoa",
            DANH_SACH: rootUrl_Micro + "gdnn/chuong-trinh-dao-tao/danh-sach"
        },
        CHUONG_TRINH_MUC_TIEU_QUOC_GIA: {
          THEM_MOI: rootUrl_Micro + "gdnn/pham-mem-so/chuong-trinh-muc-tieu-qg/them-moi",
          CHI_TIET: rootUrl_Micro + "gdnn/pham-mem-so/chuong-trinh-muc-tieu-qg/chi-tiet",
          CAP_NHAT: rootUrl_Micro + "gdnn/pham-mem-so/chuong-trinh-muc-tieu-qg/cap-nhat",
          XOA: rootUrl_Micro + "gdnn/pham-mem-so/chuong-trinh-muc-tieu-qg/xoa",
          DANH_SACH: rootUrl_Micro + "gdnn/pham-mem-so/chuong-trinh-muc-tieu-qg/danh-sach",
          UPLOAD_FILE: rootUrl_Micro + "file/gdnn/chuong-trinh-mtqg/upload-file-dinh-kem",
          DOWNLOAD_FILE: rootUrl_Micro + "file/gdnn/chuong-trinh-mtqg/downloadFile",
          XUAT_DANH_SACH: rootUrl_Micro + "gdnn/pham-mem-so/chuong-trinh-muc-tieu-qg/xuat-danh-sach",
          EXPORT_TEMPLATE: rootUrl_Micro + "gdnn/pham-mem-so/chuong-trinh-muc-tieu-qg/xuat-template-import",
          IMPORT_FILE: rootUrl_Micro + "gdnn/pham-mem-so/chuong-trinh-muc-tieu-qg/import"
      },
        LIEN_KET: {
            THEM_MOI: rootUrl_Micro + "gdnn/lien-ket-truong/them-moi",
            CHI_TIET: rootUrl_Micro + "gdnn/lien-ket-truong/chi-tiet",
            CAP_NHAT: rootUrl_Micro + "gdnn/lien-ket-truong/cap-nhat",
            XOA: rootUrl_Micro + "gdnn/lien-ket-truong/xoa",
            DANH_SACH: rootUrl_Micro + "gdnn/lien-ket-truong/danh-sach",
            CHI_TIET_NGANH: rootUrl_Micro + "gdnn/lien-ket-truong/chi-tiet-nganh",
            GET_ALL_NGANH: rootUrl_Micro + "gdnn/lien-ket-truong/get-all-nganh-nghe",
            TEMPLATE_LKDT: rootUrl_Micro + "gdnn/lien-ket-truong/xuat-template-import-lien-ket-truong",
            EXPORT: rootUrl_Micro + "gdnn/lien-ket-truong/export-excel",
            UPLOAD_FILE: rootUrl_Micro + "file/gdnn/lien-ket-dao-tao/upload-file-dinh-kem",
            GET_FILE: rootUrl_Micro + "file/gdnn/lien-ket-dao-tao/download-file",
            IMPORT_LIEN_KET: rootUrl_Micro + "gdnn/lien-ket-truong/import"
        },
        TUYEN_SINH: {
            THEM_MOI: rootUrl_Micro + "gdnn/pham-mem-so/tuyen-sinh/them-moi",
            CHI_TIET: rootUrl_Micro + "gdnn/pham-mem-so/tuyen-sinh/chi-tiet",
            CAP_NHAT: rootUrl_Micro + "gdnn/pham-mem-so/tuyen-sinh/cap-nhat",
            XOA: rootUrl_Micro + "gdnn/pham-mem-so/tuyen-sinh/xoa",
            DANH_SACH: rootUrl_Micro + "gdnn/pham-mem-so/tuyen-sinh/danh-sach",
            TEMPLATE_TS: rootUrl_Micro + "gdnn/pham-mem-so/tuyen-sinh/xuat-template-import-tuyen-sinh",
            IMPORT_TS: rootUrl_Micro + "gdnn/pham-mem-so/tuyen-sinh/import-tuyen-sinh"
        },
        QUY_MO_TUYEN_SINH: {
            THEM_MOI: rootUrl_Micro + "gdnn/pham-mem-so/quy-mo-tuyen-sinh/them-moi",
            CHI_TIET: rootUrl_Micro + "gdnn/pham-mem-so/quy-mo-tuyen-sinh/chi-tiet",
            CAP_NHAT: rootUrl_Micro + "gdnn/pham-mem-so/quy-mo-tuyen-sinh/cap-nhat",
            XOA: rootUrl_Micro + "gdnn/pham-mem-so/quy-mo-tuyen-sinh/xoa",
            DANH_SACH: rootUrl_Micro + "gdnn/pham-mem-so/quy-mo-tuyen-sinh/danh-sach"
      },
      TAI_CHINH: {
        THEM_MOI: rootUrl_Micro + "gdnn/bao-cao-tai-chinh/them",
        CHI_TIET: rootUrl_Micro + "gdnn/bao-cao-tai-chinh",
        CAP_NHAT: rootUrl_Micro + "gdnn/bao-cao-tai-chinh/cap-nhat",
        XOA: rootUrl_Micro + "gdnn/bao-cao-tai-chinh/xoa",
        DANH_SACH: rootUrl_Micro + "gdnn/bao-cao-tai-chinh",
        DANH_MUC: rootUrl_Micro + "gdnn/bao-cao-tai-chinh/danh-muc-kinh-te/get-all"
      },
      QUAN_LY_BAO_CAO: {
        DANH_SACH: rootUrl_Micro + "gdnn/dm-bao-cao/get-danh-sach",
        DANH_MUC: rootUrl_Micro + "gdnn/bao-cao-tai-chinh/danh-muc-kinh-te/get-all",
        LOAI_BAO_CAO: rootUrl_Micro + "gdnn/dm-bao-cao/get-all",
      },
        BAO_CAO_GDNN: {
            BaoCaoCoSoDaoTao: rootUrl_Micro + "gdnn/pham-mem-so/bao-cao/so-so-dao-tao",
            BaoCaoCanBo: rootUrl_Micro + "gdnn/pham-mem-so/bao-cao/can-bo-tai-co-so-dao-tao",
            BcDoiNguCanBo: rootUrl_Micro + "gdnn/pham-mem-so/bao-cao/can-bo-quan-ly-gdnn",
            BCThucTrangCanBo: rootUrl_Micro + "gdnn/pham-mem-so/bao-cao/can-bo-quan-ly-gdnn-tai-co-so",
            BCHocSinhTheoChinhSach: rootUrl_Micro + "gdnn/pham-mem-so/bao-cao/tong-hop-sinh-vien-theo-doi-tuong-chinh-sach",
            BCHocSinhTheoNganhNghe: rootUrl_Micro + "gdnn/pham-mem-so/bao-cao/tong-hop-sinh-vien-theo-nganh-nghe",
            BCCoSoVatChat: rootUrl_Micro + "gdnn/pham-mem-so/bao-cao/trang-thiet-bi-dao-tao",
            BcCoSoVatChatReal: rootUrl_Micro + "gdnn/pham-mem-so/bao-cao/bao-cao-co-so-vat-chat",
            ThongKeTongHopCSDT: rootUrl_Micro + "gdnn/pham-mem-so/bao-cao/thong-ke-co-so-dao-tao-theo-loai-hinh",
            BaoCaoKQTS: rootUrl_Micro + "gdnn/pham-mem-so/bao-cao/ket-qua-tuyen-sinh",
            BaoCaoKQTNGQVL: rootUrl_Micro + "gdnn/pham-mem-so/bao-cao/ket-qua-tot-nghiep-gqvl",
            exportDanhSachTuyenSinh: rootUrl_Micro + "gdnn/pham-mem-so/tuyen-sinh/xuat-danh-sach",
            BCHocSinhTheoTrinhDo: rootUrl_Micro + "gdnn/pham-mem-so/bao-cao/sinh-vien-cao-dang-trung-cap",
            guiDuyet: rootUrl_Micro + "file/gdnn/baocao/upload-bao-cao-trinh-do-cd-tc-nghe",
            getListBaoCaoCanDuyet: rootUrl_Micro + "gdnn/pham-mem-so/bao-cao/sinh-vien-cao-dang-trung-cap/danh-sach",
            tuChoiPheDuyetBaoCao: rootUrl_Micro + "gdnn/pham-mem-so/bao-cao/duyet-bao-cao-sinh-vien-cao-dang-trung-cap",
            xemBaoCaoCanDuyet: rootUrl_Micro + "file/gdnn/baocao/download-file-bao-cao-trinh-do-cd-tc-nghe",
            BCHocSinhTheoTrinhDoSoCap: rootUrl_Micro + "gdnn/pham-mem-so/bao-cao/sinh-vien-so-cap-duoi-3-thang",
            BCQuyMoTuyenSinh: rootUrl_Micro + "gdnn/pham-mem-so/quy-mo-tuyen-sinh/xuat-bao-cao",
            BCTotNghiep: rootUrl_Micro + "gdnn/pham-mem-so/bao-cao/sinh-vien-tot-nghiep-theo-trinh-do",
            BCNguoiHocTheoTrinhDo: rootUrl_Micro + "gdnn/pham-mem-so/bao-cao/nguoi-hoc-gdnn-theo-hinh-thuc",
            BCNguoiHocTN_GQVL: rootUrl_Micro + "gdnn/pham-mem-so/hoc-sinh-sinh-vien/xuat-bao-cao-tn-co-vl",
            BCTotNghiepChinhSachCDTC: rootUrl_Micro + "gdnn/pham-mem-so/bao-cao/sinh-vien-tot-nghiep-tc-cd-theo-chinh-sach",
            BCTotNghiepChinhSachSC: rootUrl_Micro + "gdnn/pham-mem-so/bao-cao/sinh-vien-tot-nghiep-sc-duoi-3-thang-theo-chinh-sach",
            exportDanhSachThietBi: rootUrl_Micro + "gdnn/phan-mem-so/xuat-danh-sach-thiet-bi",
        },
        NGANH_NGHE: {
            THEM_MOI: rootUrl_Micro + "gdnn/nganh-nghe-dao-tao/them-moi",
            CHI_TIET: rootUrl_Micro + "gdnn/nganh-nghe-dao-tao/chi-tiet",
            CAP_NHAT: rootUrl_Micro + "gdnn/nganh-nghe-dao-tao/cap-nhat",
            XOA: rootUrl_Micro + "gdnn/nganh-nghe-dao-tao/xoa",
            DANH_SACH: rootUrl_Micro + "gdnn/nganh-nghe-dao-tao/danh-sach",
            TEAMPLATE_CSVC: rootUrl_Micro + "file/gdnn/download-file-admin/a7ab5013-e3e0-11ed-8989-0050568863c2",
            IMPORT_FILE: rootUrl_Micro + "gdnn/nganh-nghe-dao-tao/import-nganh-nghe"
        },
        CO_SO_VAT_CHAT_REAL: {
            THEM_MOI: rootUrl_Micro + "gdnn/co-so-vat-chat/them-moi",
            CHI_TIET: rootUrl_Micro + "gdnn/co-so-vat-chat/chi-tiet",
            CAP_NHAT: rootUrl_Micro + "gdnn/co-so-vat-chat/cap-nhat",
            XOA: rootUrl_Micro + "gdnn/co-so-vat-chat/xoa",
            DANH_SACH: rootUrl_Micro + "gdnn/co-so-vat-chat/danh-sach",
            TEAMPLATE_CSVC: rootUrl_Micro + "file/gdnn/download-file-admin/04698af7-e344-11ed-8989-0050568863c2",
            IMPORT_FILE: rootUrl_Micro + "gdnn/co-so-vat-chat/import-cs-vat-chat",
            EXPORT_FILE: rootUrl_Micro + "gdnn/co-so-vat-chat/export",
        },
        TRU_SO: {
          THEM_MOI: rootUrl_Micro + "gdnn/pham-mem-so/tru-so-truong/them-moi",
          CHI_TIET: rootUrl_Micro + "gdnn/pham-mem-so/tru-so-truong/chi-tiet",
          CAP_NHAT: rootUrl_Micro + "gdnn/pham-mem-so/tru-so-truong/cap-nhat",
          XOA: rootUrl_Micro + "gdnn/pham-mem-so/tru-so-truong/xoa",
          DANH_SACH: rootUrl_Micro + "gdnn/pham-mem-so/tru-so-truong/danh-sach"
        },
        DAO_TAO_NGHE:{
          SEARCH_DAO_TAO_NGHE: rootUrl_Micro + "gdnn/phan-mem-so/tim-kiem-nghe-dao-tao",
          ADD_DAO_TAO_NGHE: rootUrl_Micro + "gdnn/phan-mem-so/them-moi-nghe-dao-tao",
          UPDATE_DAO_TAO_NGHE: rootUrl_Micro + "gdnn/phan-mem-so/cap-nhat-nghe-dao-tao",
          DELETE_DAO_TAO_NGHE: rootUrl_Micro + "gdnn/phan-mem-so/xoa-nghe-dao-tao",
          IMPORT_DAO_TAO_NGHE: rootUrl_Micro + "gdnn/phan-mem-so/import-nghe-dao-tao",
          DM_TRUONG: rootUrl_Micro + "gdnn/phan-mem-so/get-danh-sach-truong",
          DM_NGHE: rootUrl_Micro + "gdnn/phan-mem-so/get-danh-sach-nghe",
          DM_NGHE_KQTS: rootUrl_Micro + "gdnn/phan-mem-so/get-danh-sach-nghe-kqts",
          TEMPLATE_IMPORT_DAO_TAO_NGHE: rootUrl_Micro + "gdnn/phan-mem-so/template-import-nghe-dao-tao",
        },
        TOT_NGHIEP_GQVL:{
          SEARCH_TN_GQVL: rootUrl_Micro + "gdnn/phan-mem-so/search-tot-nghiep-gqvl",
          ADD_TN_GQVL: rootUrl_Micro + "gdnn/phan-mem-so/them-moi-tot-nghiep-gqvl",
          UPDATE_TN_GQVL: rootUrl_Micro + "gdnn/phan-mem-so/cap-nhat-tot-nghiep-gqvl",
          DELETE_TN_GQVL: rootUrl_Micro + "gdnn/phan-mem-so/xoa-tot-nghiep-gqvl",
          IMPORT_TN_GQVL: rootUrl_Micro + "gdnn/phan-mem-so/import-tot-nghiep-gqvl",
          TEMPLATE_TN_GQVL: rootUrl_Micro + "gdnn/phan-mem-so/template-tot-nghiep-gqvl",
        },

        DASHBOARD:{
          getDmNganhNghe: rootUrl_Micro + "gdnn/agg/get-danh-muc-nganh-nghe",
          getDataCoSoDaoTao: rootUrl_Micro + "gdnn/agg/get-co-so-dao-tao",
          getDataCBGV: rootUrl_Micro + "gdnn/agg/get-can-bo-giao-vien",
          getDataKQTS: rootUrl_Micro + "gdnn/agg/get-ket-qua-tuyen-sinh",
          getDataKQTNGQVL: rootUrl_Micro + "gdnn/agg/get-kqtn-gqvl",
          getDataTotNghiep: rootUrl_Micro + "gdnn/dashboard/so-luong-tot-nghiep",
          getChiTieuTuyenSinh: rootUrl_Micro + "gdnn/dashboard/chi-tieu-tuyen-sinh",
          getKetQuaTuyenSinh: rootUrl_Micro + "gdnn/dashboard/ket-qua-tuyen-sinh",
          getSoNguoiHocGDNN: rootUrl_Micro + "gdnn/dashboard/so-nguoi-hoc-gdnn",
          getSoNguoiTotNghiep: rootUrl_Micro + "gdnn/dashboard/so-nguoi-tot-nghiep",
          getSoGiaoVien: rootUrl_Micro + "gdnn/dashboard/so-giao-vien",
          getTaiChinh: rootUrl_Micro + "gdnn/dashboard/bao-cao-tai-chinh"
        },
        DON_VI_PHAP_NHAN: rootUrl_Micro + "gdnn/don-vi-phap-nhan",
        KHOA: {
          THEM_MOI: rootUrl_Micro + "gdnn/pham-mem-so/khoa-phong/them-moi",
          CAP_NHAT: rootUrl_Micro + "gdnn/pham-mem-so/khoa-phong/cap-nhat",
          XOA: rootUrl_Micro + "gdnn/pham-mem-so/khoa-phong/xoa",
          DANH_SACH: rootUrl_Micro + "gdnn/pham-mem-so/khoa-phong/danh-sach"
      },
      LOP_HOC: {
        THEM_MOI: rootUrl_Micro + "gdnn/pham-mem-so/lop-hoc/them-moi",
        CAP_NHAT: rootUrl_Micro + "gdnn/pham-mem-so/lop-hoc/cap-nhat",
        XOA: rootUrl_Micro + "gdnn/pham-mem-so/lop-hoc/xoa",
        DANH_SACH: rootUrl_Micro + "gdnn/pham-mem-so/lop-hoc/danh-sach"
      },
      GIAY_CHUNG_NHAN: {
        THEM_MOI: rootUrl_Micro + "gdnn/pham-mem-so/giay-chung-nhan-hoat-dong-gdnn/them-moi",
        CHI_TIET: rootUrl_Micro + "gdnn/pham-mem-so/giay-chung-nhan-hoat-dong-gdnn/chi-tiet",
        CAP_NHAT: rootUrl_Micro + "gdnn/pham-mem-so/giay-chung-nhan-hoat-dong-gdnn/cap-nhat",
        XOA: rootUrl_Micro + "gdnn/pham-mem-so/giay-chung-nhan-hoat-dong-gdnn/xoa",
        DANH_SACH: rootUrl_Micro + "gdnn/pham-mem-so/giay-chung-nhan-hoat-dong-gdnn/danh-sach",
        GET_FILE: rootUrl_Micro + "file/gdnn/giay-chung-nhan/download-file",
        UPLOAD_FILE: rootUrl_Micro + "file/gdnn/giay-chung-nhan/upload-file-dinh-kem"
    },
    PHONG_UNG_DUNG: {
        THEM_MOI: rootUrl_Micro + "gdnn/pham-mem-so/phong-ung-dung/them-moi",
        CAP_NHAT: rootUrl_Micro + "gdnn/pham-mem-so/phong-ung-dung/cap-nhat",
        XOA: rootUrl_Micro + "gdnn/pham-mem-so/phong-ung-dung/xoa",
        DANH_SACH: rootUrl_Micro + "gdnn/pham-mem-so/phong-ung-dung/danh-sach"
    },
    HO_SO_XUAT_NGU: {
      THEM_MOI: rootUrl_Micro + "gdnn/pham-mem-so/ho-so-xuat-ngu/them-moi",
      CHI_TIET: rootUrl_Micro + "gdnn/pham-mem-so/ho-so-xuat-ngu/chi-tiet",
      CAP_NHAT: rootUrl_Micro + "gdnn/pham-mem-so/ho-so-xuat-ngu/cap-nhat",
      XOA: rootUrl_Micro + "gdnn/pham-mem-so/ho-so-xuat-ngu/xoa",
      DANH_SACH: rootUrl_Micro + "gdnn/pham-mem-so/ho-so-xuat-ngu/danh-sach",
      GET_FILE: rootUrl_Micro + "file/gdnn/ho-so-xuat-ngu/download-file",
      UPLOAD_FILE: rootUrl_Micro + "file/gdnn/ho-so-xuat-ngu/upload-file-dinh-kem"
    },
    BAO_CAO_KHAC: {
      THEM_MOI: rootUrl_Micro + "gdnn/pham-mem-so/bao-cao-dinh-ky/them-moi",
      CAP_NHAT: rootUrl_Micro + "gdnn/pham-mem-so/bao-cao-dinh-ky/cap-nhat",
      CHI_TIET: rootUrl_Micro + "gdnn/pham-mem-so/bao-cao-dinh-ky/chi-tiet",
      DANH_SACH: rootUrl_Micro + "gdnn/pham-mem-so/bao-cao-dinh-ky/danh-sach",
      XOA_BAO_CAO: rootUrl_Micro + "gdnn/pham-mem-so/bao-cao-dinh-ky/xoa",
      UPLOAD_MAU: rootUrl_Micro + "file/gdnn/mau-bao-cao-dinh-ky/upload-file-dinh-kem",
      DOWNLOAD_MAU: rootUrl_Micro + "file/gdnn/mau-bao-cao-dinh-ky/download-file",
      GET_ALL_BAO_CAO: rootUrl_Micro + "gdnn/pham-mem-so/bao-cao-dinh-ky/get-all",
      UPDATE_TRANG_THAI: rootUrl_Micro + "gdnn/pham-mem-so/bao-cao-dinh-ky/cap-nhat-trang-thai"
    },
    BANG_TOT_NGHIEP: {
      THEM_MOI_PHOI: rootUrl_Micro + "gdnn/pham-mem-so/bang-tot-nghiep/them-moi-phoi",
      CAP_NHAT_PHOI: rootUrl_Micro + "gdnn/pham-mem-so/bang-tot-nghiep/cap-nhat-phoi",
      CHI_TIET_PHOI: rootUrl_Micro + "gdnn/pham-mem-so/bang-tot-nghiep/chi-tiet-phoi",
      DANH_SACH_PHOI: rootUrl_Micro + "gdnn/pham-mem-so/bang-tot-nghiep/danh-sach-phoi",
      XOA_PHOI: rootUrl_Micro + "gdnn/pham-mem-so/bang-tot-nghiep/xoa-phoi",
      UPLOAD_MAU: rootUrl_Micro + "file/gdnn/bang-tot-nghiep/upload-file-dinh-kem",
      DOWNLOAD_MAU: rootUrl_Micro + "file/gdnn/bang-tot-nghiep/download-file",
      THEM_MOI: rootUrl_Micro + "gdnn/pham-mem-so/bang-tot-nghiep/them-moi",
      CAP_NHAT: rootUrl_Micro + "gdnn/pham-mem-so/bang-tot-nghiep/cap-nhat",
      CHI_TIET: rootUrl_Micro + "gdnn/pham-mem-so/bang-tot-nghiep/chi-tiet",
      DANH_SACH: rootUrl_Micro + "gdnn/pham-mem-so/bang-tot-nghiep/danh-sach",
      XOA: rootUrl_Micro + "gdnn/pham-mem-so/bang-tot-nghiep/xoa",
      TEMPLATE_INPORT: rootUrl_Micro + "gdnn/pham-mem-so/bang-tot-nghiep/xuat-template-import",
      IMPORT_BANG_TN: rootUrl_Micro + "gdnn/pham-mem-so/bang-tot-nghiep/import-bang-tot-nghiep",
      EXPORT_BANG_SO_CAP: rootUrl_Micro + "gdnn/pham-mem-so/bao-cao/bao-cao-thong-tin-bang-tot-nghiep-so-cap",
      EXPORT_BANG_CAO_DANG: rootUrl_Micro + "gdnn/pham-mem-so/bao-cao/bao-cao-thong-tin-bang-tot-nghiep-trung-cap-cao-dang",
    },
    XEP_LOAI_GV: {
      THEM_MOI: rootUrl_Micro + "gdnn/pham-mem-so/danh-gia-xep-loai-gv/them-moi",
      CAP_NHAT: rootUrl_Micro + "gdnn/pham-mem-so/danh-gia-xep-loai-gv/cap-nhat",
      XOA: rootUrl_Micro + "gdnn/pham-mem-so/danh-gia-xep-loai-gv/xoa-khoi-phuc",
      DANH_SACH: rootUrl_Micro + "gdnn/pham-mem-so/danh-gia-xep-loai-gv/danh-sach",
      CHI_TIET: rootUrl_Micro + "gdnn/pham-mem-so/danh-gia-xep-loai-gv/chi-tiet",
      IMPORT: rootUrl_Micro + "gdnn/pham-mem-so/danh-gia-xep-loai-gv/import",
      EXPORT_MAU: rootUrl_Micro + "gdnn/pham-mem-so/danh-gia-xep-loai-gv/xuat-mau-import",
      XUAT: rootUrl_Micro + "gdnn/pham-mem-so/danh-gia-xep-loai-gv/xuat"
    },
    QUA_TRINH_CONG_TAC: {
      THEM_MOI: rootUrl_Micro + "gdnn/them-moi-thong-tin-qua-trinh-cong-tac",
      CAP_NHAT: rootUrl_Micro + "gdnn/cap-nhat-thong-qua-trinh-cong-tac",
      XOA: rootUrl_Micro + "gdnn/xoa-thong-tin-qua-trinh-cong-tac",
      KHOI_PHUC: rootUrl_Micro + "gdnn/khoi-phuc-thong-tin-qua-trinh-cong-tac",
      DANH_SACH: rootUrl_Micro + "gdnn/search-qua-trinh-cong-tac",
      CHI_TIET: rootUrl_Micro + "gdnn/danh-sach-thong-tin-qua-trinh-cong-tac",
      IMPORT: rootUrl_Micro + "gdnn/import-qua-trinh-cong-tac",
      EXPORT_MAU: rootUrl_Micro + "gdnn/xuat-template-import-qua-trinh-cong-tac",
      XUAT: rootUrl_Micro + "gdnn/phan-mem-so/bao-cao-danh-sach-thong-tin-qua-trinh-cong-tac"
    },
    TRINH_DO_CHUYEN_MON: {
      DANH_SACH: rootUrl_Micro + "gdnn/search-nang-luc-chuyen-mon",
      XUAT: rootUrl_Micro + "gdnn/phan-mem-so/bao-cao-thong-tin-nang-luc-chuyen-mon",
      CHI_TIET_CHUYEN_MON: rootUrl_Micro + "gdnn/danh-sach-thong-tin-trinh-do-chuyen-mon",
      CHI_TIET_NGOAI_NGU: rootUrl_Micro + "gdnn/danh-sach-thong-tin-trinh-do-ngoai-ngu",
      CHI_TIET_TIN_HOC: rootUrl_Micro + "gdnn/danh-sach-thong-tin-trinh-do-tin-hoc",
      CHI_TIET_CHINH_TRI: rootUrl_Micro + "gdnn/danh-sach-thong-tin-ly-luan-chinh-tri",
    }

    },

    SmartCA: {
      token: rootUrl_Micro + "ncc/ky-so-smart-ca/token-smart-ca",
      list: rootUrl_Micro + "ncc/ky-so-smart-ca/list-credential-smart-ca",
      sign: rootUrl_Micro + "ncc/ky-so-smart-ca/sigh-hash-smart-ca",
      gettraninfo: rootUrl_Micro + "ncc/ky-so-smart-ca/credential-info-smart-ca",
      refershVanBan: rootUrl_Micro + "ncc/dungchung/cap-nhat-trang-thai-ky-so",
      hashSign: rootUrl_Micro + "ncc/ky-so-smart-ca/signature-smart-ca"
    },

        // Giáo dục nghề nghiệp STG
        GDNN_STG: {
          DANH_MUC: {
            DAN_TOC: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getDanToc',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertDanToc',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateDanToc',
              changeStatus: rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusDanToc',
            },
            CSGD: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getCSGD',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertCSGD',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateCSGD',
              changeStatus: rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusCSGD',
            },
            TrinhDoDaoTao: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getTrinhDoDaoTao',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertTrinhDoDaoTao',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateTrinhDoDaoTao',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusTrinhDoDaoTao',
            },
            NganhNghe: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getNganhNghe',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertNganhNghe',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateNganhNghe',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusNganhNghe',
            },
            NganhNghe_PhanTrang: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getNganhNghe_PhanTrang',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertNganhNghe',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateNganhNghe',
              changeStatus: rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusNganhNghe',
            },
            TrinhDoVanHoa: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getTrinhDoVanHoa',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertTrinhDoVanHoa',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateTrinhDoVanHoa',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusTrinhDoVanHoa',
            },
            NhomTrangThai: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getNhomTrangThai',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertNhomTrangThai',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateNhomTrangThai',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusNhomTrangThai',
            },
            TrangThai: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getTrangThai',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertTrangThai',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateTrangThai',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusTrangThai',
            },
            KhoaHoc: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getKhoaHoc',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertKhoaHoc',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateKhoaHoc',
              changeStatus: rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusKhoaHoc',
            },
            GioiTinh: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getGioiTinh',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertGioiTinh',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateGioiTinh',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusGioiTinh',
            },
            HinhThucKhenThuong: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getHinhThucKhenThuong',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertHinhThucKhenThuong',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateHinhThucKhenThuong',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusHinhThucKhenThuong',
            },
            HinhThucKyLuat: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getHinhThucKyLuat',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertHinhThucKyLuat',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateHinhThucKyLuat',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusHinhThucKyLuat',
            },
            LyDoHocVu: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getLyDoHocVu',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertLyDoHocVu',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateLyDoHocVu',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusLyDoHocVu',
            },
            HinhThucDaoTao: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getHinhThucDaoTao',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertHinhThucDaoTao',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateHinhThucDaoTao',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusHinhThucDaoTao',
            },
            XepLoai: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getXepLoai',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertXepLoai',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateXepLoai',
              changeStatus: rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusXepLoai',
            },
            PhanLoaiCanBo: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getPhanLoaiCanBo',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertPhanLoaiCanBo',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updatePhanLoaiCanBo',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusPhanLoaiCanBo',
            },
            HocHam: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getHocHam',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertHocHam',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateHocHam',
              changeStatus: rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusHocHam',
            },
            HocVi: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getHocVi',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertHocVi',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateHocVi',
              changeStatus: rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusHocVi',
            },
            TinhTrangCongTac: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getTinhTrangCongTac',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertTinhTrangCongTac',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateTinhTrangCongTac',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusTinhTrangCongTac',
            },
            ChucVu: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getChucVu',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertChucVu',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateChucVu',
              changeStatus: rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusChucVu',
            },
            LoaiHinhCoSo: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getLoaiHinhCoSo',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertLoaiHinhCoSo',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateLoaiHinhCoSo',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusLoaiHinhCoSo',
            },
            LoaiPhongHoc: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getLoaiPhongHoc',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertLoaiPhongHoc',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateLoaiPhongHoc',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusLoaiPhongHoc',
            },
            TinhTrangSuDung: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getTinhTrangSuDung',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertTinhTrangSuDung',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateTinhTrangSuDung',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusTinhTrangSuDung',
            },
            HinhThucPhongHoc: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getHinhThucPhongHoc',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertHinhThucPhongHoc',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateHinhThucPhongHoc',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusHinhThucPhongHoc',
            },
            BoPhanQuanLy: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getBoPhanQuanLy',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertBoPhanQuanLy',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateBoPhanQuanLy',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusBoPhanQuanLy',
            },
            ThuocSoHuu: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getThuocSoHuu',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertThuocSoHuu',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateThuocSoHuu',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusThuocSoHuu',
            },

            //
            ThanhPho: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getThanhPho',
            },
            QuanHuyen: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getQuanHuyen',
              getByIdTinh:
                rootUrl_Micro + 'gdnn/stg/danh-muc/getQuanHuyenByIdTinhThanh',
              getByMaTinh:
                rootUrl_Micro + 'gdnn/stg/danh-muc/getQuanHuyenByMaTinhThanh',
            },
            PhuongXa: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getPhuongXa',
              getByIdHuyen:
                rootUrl_Micro + 'gdnn/stg/danh-muc/getPhuongXaByIdQuanHuyen',
              getByMaHuyen:
                rootUrl_Micro + 'gdnn/stg/danh-muc/getPhuongXaByMaQuanHuyen',
            },
            TonGiao: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getTonGiao',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertTonGiao',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateTonGiao',
              changeStatus: rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusTonGiao',
            },
            DoiTuongUuTien: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getDoiTuongUuTien',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertDoiTuongUuTien',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateDoiTuongUuTien',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusDoiTuongUuTien',
            },
            DoiTuongChinhSach: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getDoiTuongChinhSach',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertDoiTuongChinhSach',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateDoiTuongChinhSach',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusDoiTuongChinhSach',
            },
            NienKhoa: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getNienKhoa',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertNienKhoa',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateNienKhoa',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusNienKhoa',
            },
            DoiTuongTuyenSinh: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getDoiTuongTuyenSinh',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertDoiTuongTuyenSinh',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateDoiTuongTuyenSinh',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusDoiTuongTuyenSinh',
            },
            LoaiHinhDaoTao: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getLoaiHinhDaoTao',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertLoaiHinhDaoTao',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateLoaiHinhDaoTao',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusLoaiHinhDaoTao',
            },
            LopKhoaHoc: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getLopKhoaHoc',
              getByIdNienKhoa:
                rootUrl_Micro + 'gdnn/stg/danh-muc/getDmLopHocByNienKhoa',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertLopKhoaHoc',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateLopKhoaHoc',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusLopKhoaHoc',
            },
            HinhThucTuyenSinh: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getHinhThucTuyenSinh',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertHinhThucTuyenSinh',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateHinhThucTuyenSinh',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusHinhThucTuyenSinh',
            },
            KetQuaTuyenSinh: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getKetQuaTuyenSinh',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertKetQuaTuyenSinh',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateKetQuaTuyenSinh',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusKetQuaTuyenSinh',
            },
            TrangThaiTuyenSinh: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getTrangThaiTuyenSinh',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertTrangThaiTuyenSinh',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateTrangThaiTuyenSinh',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusTrangThaiTuyenSinh',
            },
            QuocTich: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getQuocTich',
            },
            ThongTu: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getThongTu',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertThongTu',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateThongTu',
              changeStatus: rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusThongTu',
            },
            CapQuyetDinh: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getCapQuyetDinh',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertCapQuyetDinh',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateCapQuyetDinh',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusCapQuyetDinh',
            },
            CanBoThuoc: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getCanBoThuoc',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertCanBoThuoc',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateCanBoThuoc',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusCanBoThuoc',
            },
            //
            TrinhDoTinHoc: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getTrinhDoTinHoc',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertTrinhDoTinHoc',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateTrinhDoTinHoc',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusTrinhDoTinHoc',
            },
            NgoaiNgu: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getNgoaiNgu',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertNgoaiNgu',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateNgoaiNgu',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusNgoaiNgu',
            },
            TrinhDoNgoaiNgu: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getTrinhDoNgoaiNgu',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertTrinhDoNgoaiNgu',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateTrinhDoNgoaiNgu',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusTrinhDoNgoaiNgu',
            },
            KyNangNghe: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getKyNangNghe',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertKyNangNghe',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateKyNangNghe',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusKyNangNghe',
            },
            NghiepVuSuPham: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getNghiepVuSuPham',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertNghiepVuSuPham',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateNghiepVuSuPham',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusNghiepVuSuPham',
            },
            TrinhDoLyLuanChinhTri: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getTrinhDoLyLuanChinhTri',
              insert:
                rootUrl_Micro + 'gdnn/stg/danh-muc/insertTrinhDoLyLuanChinhTri',
              update:
                rootUrl_Micro + 'gdnn/stg/danh-muc/updateTrinhDoLyLuanChinhTri',
              changeStatus:
                rootUrl_Micro +
                'gdnn/stg/danh-muc/changeStatusTrinhDoLyLuanChinhTri',
            },
            TrinhDoQuanLyNhaNuoc: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getTrinhDoQuanLyNhaNuoc',
              insert:
                rootUrl_Micro + 'gdnn/stg/danh-muc/insertTrinhDoQuanLyNhaNuoc',
              update:
                rootUrl_Micro + 'gdnn/stg/danh-muc/updateTrinhDoQuanLyNhaNuoc',
              changeStatus:
                rootUrl_Micro +
                'gdnn/stg/danh-muc/changeStatusTrinhDoQuanLyNhaNuoc',
            },
            NhiemVuQuanLyGiaoDuc: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getNhiemVuQuanLyGiaoDuc',
              insert:
                rootUrl_Micro + 'gdnn/stg/danh-muc/insertNhiemVuQuanLyGiaoDuc',
              update:
                rootUrl_Micro + 'gdnn/stg/danh-muc/updateNhiemVuQuanLyGiaoDuc',
              changeStatus:
                rootUrl_Micro +
                'gdnn/stg/danh-muc/changeStatusNhiemVuQuanLyGiaoDuc',
            },
            DanhHieu: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getDanhHieu',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertDanhHieu',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateDanhHieu',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusDanhHieu',
            },
            NhiemVuGiangDay: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getNhiemVuGiangDay',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertNhiemVuGiangDay',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateNhiemVuGiangDay',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusNhiemVuGiangDay',
            },
            CapThi: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getCapThi',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertCapThi',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateCapThi',
              changeStatus: rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusCapThi',
            },
            GiaiThuong: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getGiaiThuong',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertGiaiThuong',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateGiaiThuong',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusGiaiThuong',
            },
            PhuongThucDaoTao: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getPhuongThucDaoTao',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertPhuongThucDaoTao',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updatePhuongThucDaoTao',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusPhuongThucDaoTao',
            },
            TrangThaiViecLam: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getTrangThaiViecLam',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertTrangThaiViecLam',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateTrangThaiViecLam',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusTrangThaiViecLam',
            },
            LoaiNoiLamViec: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getDmLoaiNoiViecLam'
            },
            CapQuyetDinhCSGDNN:{
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getCapQuyetDinhCSGDNN',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertCapQuyetDinhCSGDNN',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateCapQuyetDinhCSGDNN',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusCapQuyetDinhCSGDNN',
            },
            LoaiCoSoGDNN:{
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getLoaiCoSoGDNN',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertLoaiCoSoGDNN',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateLoaiCoSoGDNN',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusLoaiCoSoGDNN',
            },
            NguoiDung:{
              get: rootUrl_Micro + 'gdnn/stg/nguoidung/danh-sach',
              insert: rootUrl_Micro + 'gdnn/stg/nguoidung/them-moi',
              update: rootUrl_Micro + 'gdnn/stg/nguoidung/cap-nhat',
              changeStatus:
              rootUrl_Micro + 'gdnn/stg/nguoidung/xoa-khoi-phuc',
            },
            NhomNganhNghe:{
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getNhomNganhNghe',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertNhomNganhNghe',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateNhomNganhNghe',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusNhomNganhNghe',
            },
            ChuongTrinhDaoTao: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getChuongTrinhDaoTao',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertChuongTrinhDaoTao',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateChuongTrinhDaoTao',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusChuongTrinhDaoTao',
            },
            LoaiGiaoTrinhDaoTao: {
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getLoaiGiaoTrinh',
              insert: rootUrl_Micro + 'gdnn/stg/danh-muc/insertLoaiGiaoTrinh',
              update: rootUrl_Micro + 'gdnn/stg/danh-muc/updateLoaiGiaoTrinh',
              changeStatus: rootUrl_Micro + 'gdnn/stg/danh-muc/changeStatusLoaiGiaoTrinh',
            },
            KetQuaDanhGiaTrangThietBi:{
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getKqDanhGiaTrangThietBi',
            },
            LoaiHinhChoLam:{
              get: rootUrl_Micro + 'gdnn/stg/danh-muc/getLoaiHinhChoLam',
            }
          },
          THIET_LAP: {
            NganhNghe: {
              get: rootUrl_Micro + 'gdnn/stg/thiet-lap/getDsNganhNghe',
              getTheoKhoa: rootUrl_Micro + 'gdnn/stg/thiet-lap/getDsNganhNgheTheoKhoa',
              insert: rootUrl_Micro + 'gdnn/stg/thiet-lap/insertDsNganhNghe',
              update: rootUrl_Micro + 'gdnn/stg/thiet-lap/updateDsNganhNghe',
              changeStatus: rootUrl_Micro + 'gdnn/stg/thiet-lap/changeStatusDsNganhNghe',
            },
            KhoaHoc: {
              get: rootUrl_Micro + 'gdnn/stg/thietlap/khoahoc/danh-sach',
              insert: rootUrl_Micro + 'gdnn/stg/thietlap/khoahoc/them-moi',
              update: rootUrl_Micro + 'gdnn/stg/thietlap/khoahoc/cap-nhat',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/thietlap/khoahoc/xoa-khoi-phuc',
            },
            LopHoc: {
              get: rootUrl_Micro + 'gdnn/stg/thietlap/lophoc/danh-sach',
              insert: rootUrl_Micro + 'gdnn/stg/thietlap/lophoc/them-moi',
              update: rootUrl_Micro + 'gdnn/stg/thietlap/lophoc/cap-nhat',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/thietlap/lophoc/xoa-khoi-phuc',
            },
            KhoaPhongBan: {
              get: rootUrl_Micro + 'gdnn/stg/thietlap/khoaphong/danh-sach',
              getDetail: rootUrl_Micro + 'gdnn/stg/thietlap/khoaphong/chi-tiet',
              insert: rootUrl_Micro + 'gdnn/stg/thietlap/khoaphong/them-moi',
              update: rootUrl_Micro + 'gdnn/stg/thietlap/khoaphong/cap-nhat',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/thietlap/khoaphong/xoa-khoi-phuc',
            },
            LyDoHocVu: {
              get: rootUrl_Micro + 'gdnn/stg/thiet-lap/ly-do-hoc-vu/danh-sach',
              insert: rootUrl_Micro + 'gdnn/stg/thiet-lap/ly-do-hoc-vu/them-moi',
              update: rootUrl_Micro + 'gdnn/stg/thiet-lap/ly-do-hoc-vu/cap-nhat',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/thiet-lap/ly-do-hoc-vu/xoa-khoi-phuc',
            },
            DeTaiNghienCuuKhoaHoc: {
              get: rootUrl_Micro + 'gdnn/stg/thiet-lap/de-tai-nckh/danh-sach',
              insert: rootUrl_Micro + 'gdnn/stg/thiet-lap/de-tai-nckh/them-moi',
              update: rootUrl_Micro + 'gdnn/stg/thiet-lap/de-tai-nckh/cap-nhat',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/thiet-lap/de-tai-nckh/xoa-khoi-phuc',
            },
            HinhThucKhenThuong: {
              get: rootUrl_Micro + 'gdnn/stg/thiet-lap/khen-thuong/danh-sach',
              insert: rootUrl_Micro + 'gdnn/stg/thiet-lap/khen-thuong/them-moi',
              update: rootUrl_Micro + 'gdnn/stg/thiet-lap/khen-thuong/cap-nhat',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/thiet-lap/khen-thuong/xoa-khoi-phuc',
            },
            HinhThucKyLuat: {
              get: rootUrl_Micro + 'gdnn/stg/thiet-lap/ky-luat/danh-sach',
              insert: rootUrl_Micro + 'gdnn/stg/thiet-lap/ky-luat/them-moi',
              update: rootUrl_Micro + 'gdnn/stg/thiet-lap/ky-luat/cap-nhat',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/thiet-lap/ky-luat/xoa-khoi-phuc',
            },
            ThongTinKyThiKyNangNghe: {
              get: rootUrl_Micro + 'gdnn/stg/thiet-lap/ky-thi-nghe/danh-sach',
              insert: rootUrl_Micro + 'gdnn/stg/thiet-lap/ky-thi-nghe/them-moi',
              update: rootUrl_Micro + 'gdnn/stg/thiet-lap/ky-thi-nghe/cap-nhat',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/thiet-lap/ky-thi-nghe/xoa-khoi-phuc',
            },
            DonViTrucThuoc: {
              get: rootUrl_Micro + 'gdnn/stg/thiet-lap/don-vi-truc-thuoc/danh-sach',
              insert: rootUrl_Micro + 'gdnn/stg/thiet-lap/don-vi-truc-thuoc/them-moi',
              update: rootUrl_Micro + 'gdnn/stg/thiet-lap/don-vi-truc-thuoc/cap-nhat',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/thiet-lap/don-vi-truc-thuoc/xoa-khoi-phuc',
            },
            TieuChiCapMa: {
              get: rootUrl_Micro + 'gdnn/stg/thiet-lap/tieu-chi-cap-ma/danh-sach',
              chiTiet: rootUrl_Micro + 'gdnn/stg/thiet-lap/tieu-chi-cap-ma/chi-tiet',
              update: rootUrl_Micro + 'gdnn/stg/thiet-lap/tieu-chi-cap-ma/cap-nhat',
            },
            ThongTinCoSoGDNN:{
              getUuid: rootUrl_Micro + 'gdnn/stg/nguoidung/getUuidCoSoGDNN',
              chiTiet: rootUrl_Micro + 'gdnn/stg/thiet-lap/thong-tin-csgdnn/chi-tiet',
              capNhat: rootUrl_Micro + 'gdnn/stg/thiet-lap/thong-tin-csgdnn/cap-nhat',
            },
            ChuongTrinhDaoTao: {
              get: rootUrl_Micro + 'gdnn/stg/thiet-lap/ct-dao-tao/danh-sach',
              insert: rootUrl_Micro + 'gdnn/stg/thiet-lap/ct-dao-tao/them-moi',
              update: rootUrl_Micro + 'gdnn/stg/thiet-lap/ct-dao-tao/cap-nhat',
              changeStatus: rootUrl_Micro + 'gdnn/stg/thiet-lap/ct-dao-tao/xoa-khoi-phuc',
              detail: rootUrl_Micro + 'gdnn/stg/thiet-lap/ct-dao-tao/chi-tiet',
              log: rootUrl_Micro + 'gdnn/stg/thiet-lap/ct-dao-tao/lich-su',
              uploadReplaceAttachment: rootUrl_Micro + 'file/gdnn-stg/chuong-trinh-dao-tao/uploadReplaceFile',
              downloadAttachment: rootUrl_Micro + 'file/gdnn-stg/chuong-trinh-dao-tao/downloadFile',
              changeStatusAttachment: rootUrl_Micro + 'file/gdnn-stg/chuong-trinh-dao-tao/changeStatusFile',
            },
            GiaoTrinhDaoTao: {
              get: rootUrl_Micro + 'gdnn/stg/thiet-lap/giao-trinh-dao-tao/danh-sach',
              insert: rootUrl_Micro + 'gdnn/stg/thiet-lap/giao-trinh-dao-tao/them-moi',
              update: rootUrl_Micro + 'gdnn/stg/thiet-lap/giao-trinh-dao-tao/cap-nhat',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/thiet-lap/giao-trinh-dao-tao/xoa-khoi-phuc',
              detail: rootUrl_Micro + 'gdnn/stg/thiet-lap/giao-trinh-dao-tao/chi-tiet',
              log: rootUrl_Micro + 'gdnn/stg/thiet-lap/giao-trinh-dao-tao/lich-su',
              uploadReplaceAttachment: rootUrl_Micro + 'file/gdnn-stg/giao-trinh-dao-tao/uploadReplaceFile',
              downloadAttachment: rootUrl_Micro + 'file/gdnn-stg/giao-trinh-dao-tao/downloadFile',
              changeStatusAttachment: rootUrl_Micro + 'file/gdnn-stg/giao-trinh-dao-tao/changeStatusFile',
            },
          },

          QUAN_LY_TUYEN_SINH: {
            CHI_TIEU_HDTS: {
              getDanhSach:
                rootUrl_Micro + 'gdnn/stg/tuyensinh/dangkychitieu/danh-sach',
              insert: rootUrl_Micro + 'gdnn/stg/tuyensinh/dangkychitieu/them-moi',
              update: rootUrl_Micro + 'gdnn/stg/tuyensinh/dangkychitieu/cap-nhat',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/tuyensinh/dangkychitieu/xoa-khoi-phuc',
            },
            THONG_TIN_TS: {
              getDanhSach:
                rootUrl_Micro + 'gdnn/stg/tuyensinh/qlthongtintuyensinh/danh-sach',
              insert:
                rootUrl_Micro + 'gdnn/stg/tuyensinh/qlthongtintuyensinh/them-moi',
              update:
                rootUrl_Micro + 'gdnn/stg/tuyensinh/qlthongtintuyensinh/cap-nhat',
              changeStatus:
                rootUrl_Micro +
                'gdnn/stg/tuyensinh/qlthongtintuyensinh/xoa-khoi-phuc',
              xacNhanNhapHoc:
                rootUrl_Micro +
                'gdnn/stg/tuyensinh/qlthongtintuyensinh/xac-nhan-nhap-hoc',
            },
          },
          QUAN_LY_CAN_BO: {
            CAN_BO: {
              get: rootUrl_Micro + 'gdnn/stg/qlcanbo/canbo/danh-sach',
              getDetail: rootUrl_Micro + 'gdnn/stg/qlcanbo/canbo/chi-tiet',
              insert: rootUrl_Micro + 'gdnn/stg/qlcanbo/canbo/them-moi',
              update: rootUrl_Micro + 'gdnn/stg/qlcanbo/canbo/cap-nhat',
              changeStatus: rootUrl_Micro + 'gdnn/stg/qlcanbo/canbo/xoa-khoi-phuc',
            },
            NHA_GIAO: {
              get: rootUrl_Micro + 'gdnn/stg/qlcanbo/nhagiao/danh-sach',
              getDetail: rootUrl_Micro + 'gdnn/stg/qlcanbo/nhagiao/chi-tiet',
              insert: rootUrl_Micro + 'gdnn/stg/qlcanbo/nhagiao/them-moi',
              update: rootUrl_Micro + 'gdnn/stg/qlcanbo/nhagiao/cap-nhat',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/qlcanbo/nhagiao/xoa-khoi-phuc',
            },
          },
          QUAN_LY_CO_SO_VAT_CHAT: {
            PHONG_HOC: {
              get: rootUrl_Micro + 'gdnn/stg/ql-csvc/phong-hoc/danh-sach',
              insert: rootUrl_Micro + 'gdnn/stg/ql-csvc/phong-hoc/them-moi',
              update: rootUrl_Micro + 'gdnn/stg/ql-csvc/phong-hoc/cap-nhat',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/ql-csvc/phong-hoc/xoa-khoi-phuc',
            },
            TRANG_THIET_BI: {
              get: rootUrl_Micro + 'gdnn/stg/ql-csvc/trang-thiet-bi/danh-sach',
              insert: rootUrl_Micro + 'gdnn/stg/ql-csvc/trang-thiet-bi/them-moi',
              update: rootUrl_Micro + 'gdnn/stg/ql-csvc/trang-thiet-bi/cap-nhat',
              detail: rootUrl_Micro + 'gdnn/stg/ql-csvc/trang-thiet-bi/chi-tiet',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/ql-csvc/trang-thiet-bi/xoa-khoi-phuc',
            },
            DANH_GIA_TRANG_THIET_BI: {
              get: rootUrl_Micro + 'gdnn/stg/ql-csvc/trang-thiet-bi/danh-sach-danh-gia',
              update: rootUrl_Micro + 'gdnn/stg/ql-csvc/trang-thiet-bi/cap-nhat-danh-gia',
            }
          },
          QUAN_LY_HOC_SINH_SINH_VIEN: {
            DANH_SACH:
              rootUrl_Micro + 'gdnn/stg/hocsinhsinhvien/nhaptruong/danh-sach',
            CHI_TIET:
              rootUrl_Micro + 'gdnn/stg/hocsinhsinhvien/nhaptruong/chi-tiet',
            CHUYEN_NGANH:
              rootUrl_Micro + 'gdnn/stg/hocsinhsinhvien/nhaptruong/chuyen-nganh',
            PHAN_LOP_CHUYEN_LOP:
              rootUrl_Micro + 'gdnn/stg/hocsinhsinhvien/nhaptruong/phan-lop',
            CAP_NHAT:
              rootUrl_Micro + 'gdnn/stg/hocsinhsinhvien/nhaptruong/cap-nhat',
            HinhThucKhenThuong: {
              detail:
                rootUrl_Micro + 'gdnn/stg/hocsinhsinhvien/khen-thuong/chi-tiet',
              update: rootUrl_Micro + 'gdnn/stg/hocsinhsinhvien/khen-thuong/cap-nhat',
              insert: rootUrl_Micro + 'gdnn/stg/hocsinhsinhvien/khen-thuong/them-moi',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/hocsinhsinhvien/khen-thuong/xoa-khoi-phuc',
            },
            HinhThucKyLuat: {
              detail: rootUrl_Micro + 'gdnn/stg/hocsinhsinhvien/ky-luat/chi-tiet',
              update: rootUrl_Micro + 'gdnn/stg/hocsinhsinhvien/ky-luat/cap-nhat',
              insert: rootUrl_Micro + 'gdnn/stg/hocsinhsinhvien/ky-luat/them-moi',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/hocsinhsinhvien/ky-luat/xoa-khoi-phuc',
            },
            KyThiNghe: {
              detail: rootUrl_Micro + 'gdnn/stg/hocsinhsinhvien/ky-thi-nghe/chi-tiet',
              update: rootUrl_Micro + 'gdnn/stg/hocsinhsinhvien/ky-thi-nghe/cap-nhat',
              insert: rootUrl_Micro + 'gdnn/stg/hocsinhsinhvien/ky-thi-nghe/them-moi',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/hocsinhsinhvien/ky-thi-nghe/xoa-khoi-phuc',
            },
            DeTaiNghienCuuKhoaHoc: {
              detail: rootUrl_Micro + 'gdnn/stg/hocsinhsinhvien/de-tai-nckh/chi-tiet',
              update: rootUrl_Micro + 'gdnn/stg/hocsinhsinhvien/de-tai-nckh/cap-nhat',
              insert: rootUrl_Micro + 'gdnn/stg/hocsinhsinhvien/de-tai-nckh/them-moi',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/hocsinhsinhvien/de-tai-nckh/xoa-khoi-phuc',
            },
          },
          QUAN_LY_DAO_TAO: {
            QuanLyHocVu: {
              insert: rootUrl_Micro + 'gdnn/stg/ql-dao-tao/ql-hoc-vu/them-moi',
              delete: rootUrl_Micro + 'gdnn/stg/ql-dao-tao/ql-hoc-vu/huy',
            },
            QuanLyThongTinSauTotNghiep: {
              update: rootUrl_Micro + 'gdnn/stg/ql-dao-tao/ql-thong-tin-sau-tot-nghiep',
            },
            QuanLyThongTinTotNghiep: {
              update: rootUrl_Micro + 'gdnn/stg/ql-dao-tao/ql-thong-tin-tot-nghiep',
            },
          },
          QUAN_LY_BAO_CAO_TAI_CHINH: {
            BaoCaoTaiChinh: {
              get: rootUrl_Micro + 'gdnn/stg/qlbaocaotaichinh/bctaichinh/danh-sach',
              getChiTieu:
                rootUrl_Micro + 'gdnn/stg/qlbaocaotaichinh/bctaichinh/ds-chi-tieu',
              detail:
                rootUrl_Micro + 'gdnn/stg/qlbaocaotaichinh/bctaichinh/chi-tiet',
              insert:
                rootUrl_Micro + 'gdnn/stg/qlbaocaotaichinh/bctaichinh/them-moi',
              update:
                rootUrl_Micro + 'gdnn/stg/qlbaocaotaichinh/bctaichinh/cap-nhat',
              changeStatus:
                rootUrl_Micro + 'gdnn/stg/qlbaocaotaichinh/bctaichinh/xoa-khoi-phuc',
            },
          },
          CAC_MAU_BAO_CAO:{
            PHU_LUC_2:{
              getDanhSach: rootUrl_Micro + 'gdnn/stg/ql-baocao-pl2/danh-sach',
              getDmNguonVon: rootUrl_Micro + 'gdnn/stg/ql-baocao-pl2/get-dm-nguon-von',
              getDmNoiDungChi: rootUrl_Micro + 'gdnn/stg/ql-baocao-pl2/get-dm-noi-dung-chi',
              getChiTiet: rootUrl_Micro + 'gdnn/stg/ql-baocao-pl2/chi-tiet',
              insert: rootUrl_Micro + 'gdnn/stg/ql-baocao-pl2/them-moi',
              update: rootUrl_Micro + 'gdnn/stg/ql-baocao-pl2/cap-nhat',
              changeStatus: rootUrl_Micro + 'gdnn/stg/ql-baocao-pl2/xoa-khoi-phuc',
              inBaoCao: rootUrl_Micro + 'gdnn/stg/ql-baocao-pl2/in-bc-pl2',
              inBaoCaoTongHop: rootUrl_Micro + 'gdnn/stg/ql-baocao-pl2/in-bc-pl2-tong-hop',
            },
            PHU_LUC_1:{
              inBaoCao: rootUrl_Micro + 'gdnn/stg/ql-baocao-pl1/in-bc-pl1',
              inBaoCaoTongHop: rootUrl_Micro + 'gdnn/stg/ql-baocao-pl1/in-bc-pl1-tong-hop',
            },
            DanhSachCacBaoCaoThongKe: {
              getBaoCaoThongKeChuongTrinhDaoTao:
                rootUrl_Micro + 'gdnn/stg/ql-baocao-tk/get-tk-chuong-trinh-dao-tao',
              getBaoCaoThongKeSoLuongLopTheoKhoaHoc:
                rootUrl_Micro + 'gdnn/stg/ql-baocao-tk/get-tk-sl-lop-theo-khoa-hoc',
              getBaoCaoThongKeSoLuongHSSVTheoKhoaHoc:
                rootUrl_Micro +
                'gdnn/stg/ql-baocao-tk/get-tk-sl-hssv-theo-lop-khoa-hoc',
              getBaoCaoThongKeSoLuongLopTheoTruong:
                rootUrl_Micro + 'gdnn/stg/ql-baocao-tk/get-tk-sl-lop-theo-truong',
              getBaoCaoThongKeDoiTuongChinhSach:
                rootUrl_Micro + 'gdnn/stg/ql-baocao-tk/get-tk-doi-tuong-chinh-sach',
            },
            PHU_LUC_01H_02H:{
              inBaoCao01H: rootUrl_Micro + 'gdnn/stg/ql-baocao-pl01-02h/in-bc-01h',
              inBaoCao01HTongHop: rootUrl_Micro + 'gdnn/stg/ql-baocao-pl01-02h/in-bc-01h-tong-hop',
              inBaoCao02H: rootUrl_Micro + 'gdnn/stg/ql-baocao-pl01-02h/in-bc-02h',
              inBaoCao02HTongHop: rootUrl_Micro + 'gdnn/stg/ql-baocao-pl01-02h/in-bc-02h-tong-hop',
            }
          },
        },
    AGG: {
      getDanhSachViecTimNguoi: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/agg/get-list-ds-viec-tim-nguoi',
      getDanhSachChiTietViecTimNguoi: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/agg/get-detail-hs-viec-tim-nguoi',
      updateDanhSachViecTimNguoi: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/agg/update-hs-viec-tim-nguoi',
      importDataFromExcelDanhSachViecTimNguoi: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/agg/import-excel-ds-viec-tim-nguoi',
      deleteDanhSachViecTimNguoi: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/agg/delete-hs-viec-tim-nguoi',
      addDanhSachViecTimNguoi: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/agg/add-hs-viec-tim-nguoi',
      exportSampleFile: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/agg/export-sample-file-hs-viec-tim-nguoi',
      get_huyen_thi_thanh: rootUrl_Micro + 'ncc/agg/get-huyen-thi-thanh',
      // AGG NGƯỜI TÌM VIỆC
      AGG_NGUOITIMVIEC:
      {
        getDanhSachNguoiTimViec: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/agg/danh-sach-nguoi-tim-viec-phan-trang',
        getDanhSachChiTietNguoiTimViec: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/agg/chi-tiet-danh-sach-nguoi-tim-viec',
        capNhatDanhSachNguoiTimViec: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/agg/cap-nhat-danh-sach-nguoi-tim-viec',
        ImportDataFromExcelDanhSachNguoiTimViec: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/agg/import-dl-ntv-from-template',
        deleteDanhSachNguoiTimViec: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/agg/xoa-nguoi-tim-viec',
        themDanhSachNguoiTimViec: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/agg/them-nguoi-tim-viec',
        exportSampleFile: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/agg/export-sample-file-hs-nguoi-tim-viec',
      },
      NCC: {
        getDanhSachNhomLoaiDoiTuongChiTra: rootUrl_Micro + 'ncc/agg/get-danh-sach-nhom-loai-doi-tuong',
        getDanhSachLoaiDoiTuongChiTra: rootUrl_Micro + 'ncc/agg/get-danh-sach-loai-doi-tuong',
        timkiemLoaiDoiTuongChiTra: rootUrl_Micro + 'ncc/agg/tim-kiem-chi-tra-tro-cap',
        importDataChiTraTroCap: rootUrl_Micro + 'ncc/agg/import-chi-tra-tro-cap',
        themMoiChiTraTroCap: rootUrl_Micro + 'ncc/agg/them-moi-chi-tra-tro-cap',
        capNhatChiTraTroCap: rootUrl_Micro + 'ncc/agg/cap-nhat-chi-tra-tro-cap',
        xoaChiTraTroCap: rootUrl_Micro + 'ncc/agg/xoa-chi-tra-tro-cap',
        downloadTemplateChiTraTroCap: rootUrl_Micro + 'ncc/agg/download-template-chi-tra-tro-cap',
      },
      HS_LIET_SI:{
        GET_ALL: rootUrl_Micro + 'ncc/agg/lietsi/lay-danh-sach',
        DETAIL: rootUrl_Micro + 'ncc/agg/lietsi/chi-tiet',
        UPDATE: rootUrl_Micro + 'ncc/agg/lietsi/cap-nhat',
        IMPORT_EXCEL: rootUrl_Micro + 'ncc/agg/lietsi/import',
        DELETE: rootUrl_Micro + 'ncc/agg/lietsi/xoa',
        ADD: rootUrl_Micro + 'ncc/agg/lietsi/them',
        DOWNLOAD_TEMPLATE: rootUrl_Micro + 'ncc/agg/lietsi/template-liet-si',
      },
      HS_BENH_BINH: {
        GET_ALL: rootUrl_Micro + 'ncc/agg/benhbinh/lay-danh-sach',
        DETAIL: rootUrl_Micro + 'ncc/agg/benhbinh/chi-tiet',
        UPDATE: rootUrl_Micro + 'ncc/agg/benhbinh/cap-nhat',
        IMPORT_EXCEL: rootUrl_Micro + 'ncc/agg/benhbinh/import',
        DELETE: rootUrl_Micro + 'ncc/agg/benhbinh/xoa',
        ADD: rootUrl_Micro + 'ncc/agg/benhbinh/them',
        DOWNLOAD_TEMPLATE: rootUrl_Micro + 'ncc/agg/benhbinh/template-benhbinh',
      },
      HS_NGUOI_BI_TU_DAY:{
        GET_ALL: rootUrl_Micro + 'ncc/agg/nguoibituday/lay-danh-sach',
        DETAIL: rootUrl_Micro + 'ncc/agg/nguoibituday/chi-tiet',
        UPDATE: rootUrl_Micro + 'ncc/agg/nguoibituday/cap-nhat',
        IMPORT_EXCEL: rootUrl_Micro + 'ncc/agg/nguoibituday/import',
        DELETE: rootUrl_Micro + 'ncc/agg/nguoibituday/xoa',
        ADD: rootUrl_Micro + 'ncc/agg/nguoibituday/them',
        DOWNLOAD_TEMPLATE: rootUrl_Micro + 'ncc/agg/nguoibituday/template-nguoi-bi-tu-day',
      },
      HS_LAO_THANH_CACH_MANG:{
        GET_ALL: rootUrl_Micro + 'ncc/agg/laothanhcachmang/lay-danh-sach',
        DETAIL: rootUrl_Micro + 'ncc/agg/laothanhcachmang/chi-tiet',
        UPDATE: rootUrl_Micro + 'ncc/agg/laothanhcachmang/cap-nhat',
        IMPORT_EXCEL: rootUrl_Micro + 'ncc/agg/laothanhcachmang/import',
        DELETE: rootUrl_Micro + 'ncc/agg/laothanhcachmang/xoa',
        ADD: rootUrl_Micro + 'ncc/agg/laothanhcachmang/them',
        DOWNLOAD_TEMPLATE: rootUrl_Micro + 'ncc/agg/laothanhcachmang/template-lao-thanh-cach-mang',
      },
      ME_VIET_NAM_ANH_HUNG:
      {
        GET_DANH_SACH_ME_VIET_NAM_ANH_HUNG: rootUrl_Micro + "ncc/agg/mvnah/lay-danh-sach",
        THEM_HS_ME_VIET_NAM_ANH_HUNG: rootUrl_Micro + "ncc/agg/mvnah/them-moi",
        CAP_NHAT_HS_ME_VIET_NAM_ANH_HUNG: rootUrl_Micro + "ncc/agg/mvnah/cap-nhat",
        CHI_TIET_HS_ME_VIET_NAM_ANH_HUNG: rootUrl_Micro + "ncc/agg/mvnah/chi-tiet",
        XOA_HS_ME_VIET_NAM_ANH_HUNG: rootUrl_Micro + "ncc/agg/mvnah/xoa",
        IMPORT_DS_ME_VIET_NAM_ANH_HUNG: rootUrl_Micro + "ncc/agg/mvnah/import-excel",
        DOWNLOAD_TEMPLATE: rootUrl_Micro + "ncc/agg/mvnah/export-sample-file",
      },
      THANHNIEN_XUNGPHONG:
      {
          GET_DANH_SACH_THANH_NIEN_XUNG_PHONG: rootUrl_Micro + "ncc/agg/tnxp/lay-danh-sach",
          THEM_HS_THANH_NIEN_XUNG_PHONG: rootUrl_Micro + "ncc/agg/tnxp/them-moi",
          CAP_NHAT_HS_THANH_NIEN_XUNG_PHONG: rootUrl_Micro + "ncc/agg/tnxp/cap-nhat",
          CHI_TIET_HS_THANH_NIEN_XUNG_PHONG: rootUrl_Micro + "ncc/agg/tnxp/chi-tiet",
          XOA_HS_THANH_NIEN_XUNG_PHONG: rootUrl_Micro + "ncc/agg/tnxp/xoa",
          IMPORT_DS_THANH_NIEN_XUNG_PHONG: rootUrl_Micro + "ncc/agg/tnxp/import-excel",
          DOWNLOAD_TEMPLATE: rootUrl_Micro + "ncc/agg/tnxp/export-sample-file",
      },
      HOAT_DONG_KHANG_CHIEN:
      {
          GET_DANH_SACH_HOAT_DONG_KHANG_CHIEN: rootUrl_Micro + "ncc/agg/hdkc/lay-danh-sach",
          THEM_HS_HOAT_DONG_KHANG_CHIEN: rootUrl_Micro + "ncc/agg/hdkc/them-moi",
          CAP_NHAT_HS_HOAT_DONG_KHANG_CHIEN: rootUrl_Micro + "ncc/agg/hdkc/cap-nhat",
          CHI_TIET_HS_HOAT_DONG_KHANG_CHIEN: rootUrl_Micro + "ncc/agg/hdkc/chi-tiet",
          XOA_HS_HOAT_DONG_KHANG_CHIEN: rootUrl_Micro + "ncc/agg/hdkc/xoa",
          IMPORT_DS_HOAT_DONG_KHANG_CHIEN: rootUrl_Micro + "ncc/agg/hdkc/import-excel",
          DOWNLOAD_TEMPLATE: rootUrl_Micro + "ncc/agg/hdkc/export-sample-file",
      },
      GDCM:
      {
          GET_DANH_SACH_GDCM: rootUrl_Micro + "ncc/agg/gdcm/lay-danh-sach",
          THEM_HS_GDCM: rootUrl_Micro + "ncc/agg/gdcm/them-moi",
          CAP_NHAT_HS_GDCM: rootUrl_Micro + "ncc/agg/gdcm/cap-nhat",
          CHI_TIET_HS_GDCM: rootUrl_Micro + "ncc/agg/gdcm/chi-tiet",
          XOA_HS_GDCM: rootUrl_Micro + "ncc/agg/gdcm/xoa",
          IMPORT_DS_GDCM: rootUrl_Micro + "ncc/agg/gdcm/import-excel",
          DOWNLOAD_TEMPLATE: rootUrl_Micro + "ncc/agg/gdcm/export-sample-file",
      },
      KHTC:{
        importNganSachTrungUong: rootUrl_Micro + 'matuy/agg/import-ngan-sach-trung-uong',
        timKiemtNganSachTrungUong: rootUrl_Micro + 'matuy/agg/search-ngan-sach-trung-uong',
        themMoiNganSachTrungUong: rootUrl_Micro + 'matuy/agg/add-ngan-sach-trung-uong',
        capNhatNganSachTrungUong: rootUrl_Micro + 'matuy/agg/update-ngan-sach-trung-uong',
        xoaNganSachTrungUongTheoMaNganhKT: rootUrl_Micro + 'matuy/agg/delete-ngan-sach-trung-uong-theo-ma-nganh-kt',
        templateNganSachTrungUong: rootUrl_Micro + 'matuy/agg/template-ngan-sach-trung-uong',
        getChiTieNSTW: rootUrl_Micro + 'matuy/agg/get-ngan-sach-trung-uong-chi-tiet',
        xoaNganSachTrungUongTheoCTMTDA: rootUrl_Micro + 'matuy/agg/delete-ngan-sach-trung-uong-theo-ma-ctmt-da',

        importNganSachDiaPhuong: rootUrl_Micro + 'matuy/agg/import-ngan-sach-dia-phuong',
        timKiemtNganSachDiaPhuong: rootUrl_Micro + 'matuy/agg/search-ngan-sach-dia-phuong',
        themMoiNganSachDiaPhuong: rootUrl_Micro + 'matuy/agg/add-ngan-sach-dia-phuong',
        capNhatNganSachDiaPhuong: rootUrl_Micro + 'matuy/agg/update-ngan-sach-dia-phuong',
        xoaNganSachDiaPhuongTheoMaNganhKT: rootUrl_Micro + 'matuy/agg/delete-ngan-sach-dia-phuong-theo-ma-nganh-kt',
        templateNganSachDiaPhuong: rootUrl_Micro + 'matuy/agg/template-ngan-sach-dia-phuong',
        getChiTieNSDP: rootUrl_Micro + 'matuy/agg/get-ngan-sach-dia-phuong-chi-tiet',
        getDMMaNDKT: rootUrl_Micro + 'matuy/agg/get-dm-ma-ndkt',
        xoaNganSachDiaPhuongTheoNDKT: rootUrl_Micro + 'matuy/agg/delete-ngan-sach-dia-phuong-theo-ma-ndkt',

      },

      DASHBOARD_NCC:{
        getDataNghiaTrang: rootUrl_Micro + "ncc/agg/dashboard-ncc-label-tong-so-nghia-trang",
        getDataNCCTheoHuyen: rootUrl_Micro + "ncc/agg/dashboard-ncc-theo-huyen",
        getDataNCCTheoTyLe: rootUrl_Micro + "ncc/agg/dashboard-ncc-theo-ty-le",
        getDataNCCMoLietSiTheoHuyen: rootUrl_Micro + "ncc/agg/dashboard-ncc-mo-liet-si-theo-huyen",
        getDataLabelSLDtNhanTroCap: rootUrl_Micro + "ncc/agg/dashboard-ncc-label-dt-nhan-tro-cap",
        getDMNhomDoiTuongNhanTroCap: rootUrl_Micro + "ncc/agg/dashboard-ncc-nhom-dt-nhan-tro-cap",
        getDataChiTraTheoThang: rootUrl_Micro + "ncc/agg/dashboard-ncc-chi-tra-tro-cap-theo-thang",
        getDataChiTraTheoHuyen: rootUrl_Micro + "ncc/agg/dashboard-ncc-chi-tra-tro-cap-theo-huyen",
        getDataChiTraTheoNhomDt: rootUrl_Micro + "ncc/agg/dashboard-ncc-chi-tra-tro-cap-theo-nhom-dt",
      },

      BTXH: {
        GET_SO_LIEU_DT_BTXH_TAI_CONG_DONG_PAGEABLE: rootUrl_Micro + 'bao-tro-xa-hoi/an-giang/get-sl-dt-btxh-tai-cong-dong-pageable',
        DOWNLOAD_SO_LIEU_DT_BTXH_TAI_CONG_DONG_TEMPLATE: rootUrl_Micro + 'bao-tro-xa-hoi/an-giang/download-sl-dt-btxh-tai-cong-dong-template',
        IMPORT_SO_LIEU_DT_BTXH_TAI_CONG_DONG: rootUrl_Micro + 'bao-tro-xa-hoi/an-giang/import-sl-dt-btxh-tai-cong-dong',
        DELETE_DT_BTXH_TAI_CONG_DONG: rootUrl_Micro + 'bao-tro-xa-hoi/an-giang/delete-dt-btxh-tai-cong-dong',
        DELETE_DT_BTXH_TAI_CONG_DONG_THEO_HUYEN: rootUrl_Micro + 'bao-tro-xa-hoi/an-giang/delete-dt-btxh-tai-cong-dong-theo-huyen',

        IMPORT_DT_BTXH_TAI_TRUNG_TAM: rootUrl_Micro + 'bao-tro-xa-hoi/an-giang/import-dt-btxh-tai-trung-tam',
        GET_DT_BTXH_TAI_TRUNG_TAM_PAGEABLE: rootUrl_Micro + 'bao-tro-xa-hoi/an-giang/get-dt-btxh-tai-trung-tam-pageable',
        DOWNLOAD_DT_BTXH_TAI_TRUNG_TAM_TEMPLATE: rootUrl_Micro + 'bao-tro-xa-hoi/an-giang/download-dt-btxh-tai-trung-tam-template',
        ADD_DT_BTXH_TAI_TRUNG_TAM: rootUrl_Micro + 'bao-tro-xa-hoi/an-giang/add-dt-btxh-tai-trung-tam',
        UPDATE_DT_BTXH_TAI_TRUNG_TAM: rootUrl_Micro + 'bao-tro-xa-hoi/an-giang/update-dt-btxh-tai-trung-tam',
        DELETE_DT_BTXH_TAI_TRUNG_TAM: rootUrl_Micro + 'bao-tro-xa-hoi/an-giang/delete-dt-btxh-tai-trung-tam',

        GET_SO_LIEU_HO_NGHEO_HO_CAN_NGHEO: rootUrl_Micro + 'bao-tro-xa-hoi/an-giang/get-sl-ho-ngheo-ho-can-ngheo',
        GET_CHI_SO_THIEU_HUT_HO_NGHEO: rootUrl_Micro + 'bao-tro-xa-hoi/an-giang/get-chi-so-thieu-hut-ho-ngheo',
        GET_CHI_SO_THIEU_HUT_HO_CAN_NGHEO: rootUrl_Micro + 'bao-tro-xa-hoi/an-giang/get-chi-so-thieu-hut-ho-can-ngheo',
        DOWNLOAD_SO_LIEU_HO_NGHEO_HO_CAN_NGHEO_TEMPLATE: rootUrl_Micro + 'bao-tro-xa-hoi/an-giang/download-sl-ho-ngheo-ho-can-ngheo-template',
        IMPORT_SO_LIEU_HO_NGHEO_HO_CAN_NGHEO: rootUrl_Micro + 'bao-tro-xa-hoi/an-giang/import-sl-ho-ngheo-ho-can-ngheo',
        DELETE_HO_NGHEO_HO_CAN_NGHEO: rootUrl_Micro + 'bao-tro-xa-hoi/an-giang/delete-ho-ngheo-ho-can-ngheo',
        DELETE_CHI_SO_THIEU_HUT: rootUrl_Micro + 'bao-tro-xa-hoi/an-giang/delete-chi-so-thieu-hut',

        DASHBOARD:{
          /* ĐỐI TƯỢNG BTXH TẠI CỘNG ĐỒNG */
          GET_DASHBOARD_BTXH_LABEL_TAI_CONG_DONG: rootUrl_Micro + "bao-tro-xa-hoi/an-giang/agg-dashboard-btxh-label-tai-cong-dong",
          GET_DASHBOARD_BTXH_TAI_CONG_DONG_THEO_HUYEN: rootUrl_Micro + "bao-tro-xa-hoi/an-giang/agg-dashboard-btxh-tai-cong-dong-theo-huyen",

          /* ĐỐI TƯỢNG BTXH TẠI TRUNG TÂM */
          GET_DASHBOARD_BTXH_LABEL_TAI_TRUNG_TAM: rootUrl_Micro + "bao-tro-xa-hoi/an-giang/agg-dashboard-btxh-label-tai-trung-tam",
          GET_DASHBOARD_BTXH_LABEL_TAI_TRUNG_TAM_VAO_RA: rootUrl_Micro + "bao-tro-xa-hoi/an-giang/agg-dashboard-btxh-label-tai-trung-tam-vao-ra",
          GET_DASHBOARD_BTXH_TAI_TRUNG_TAM_THEO_GIOI_TINH: rootUrl_Micro + "bao-tro-xa-hoi/an-giang/agg-dashboard-btxh-tai-trung-tam-theo-gioi-tinh",
          GET_DASHBOARD_BTXH_TAI_TRUNG_TAM_THEO_NHOM_TUOI: rootUrl_Micro + "bao-tro-xa-hoi/an-giang/agg-dashboard-btxh-tai-trung-tam-theo-nhom-tuoi",
          GET_DASHBOARD_BTXH_TAI_TRUNG_TAM_THEO_THANG: rootUrl_Micro + "bao-tro-xa-hoi/an-giang/agg-dashboard-btxh-tai-trung-tam-theo-thang",

          /* HỘ NGHÈO, HỘ CẬN NGHÈO */
          GET_DASHBOARD_BTXH_LABEL_HO_NGHEO_CAN_NGHEO: rootUrl_Micro + "bao-tro-xa-hoi/an-giang/agg-dashboard-btxh-label-ho-ngheo-can-ngheo",
          GET_DASHBOARD_BTXH_HO_NGHEO_CAN_NGHEO_THEO_HUYEN: rootUrl_Micro + "bao-tro-xa-hoi/an-giang/agg-dashboard-btxh-ho-ngheo-can-ngheo-theo-huyen",
          GET_DASHBOARD_BTXH_HO_NGHEO_CAN_NGHEO_THEO_NAM: rootUrl_Micro + "bao-tro-xa-hoi/an-giang/agg-dashboard-btxh-ho-ngheo-can-ngheo-theo-nam",
          GET_DASHBOARD_BTXH_HO_NGHEO_CAN_NGHEO_THEO_CSTH: rootUrl_Micro + "bao-tro-xa-hoi/an-giang/agg-dashboard-btxh-ho-ngheo-can-ngheo-theo-csth",
        }

      },

      HS_CAXN: {
        GET_ALL: rootUrl_Micro + 'ncc/agg/caxn/lay-danh-sach',
        DETAIL: rootUrl_Micro + 'ncc/agg/caxn/chi-tiet',
        UPDATE: rootUrl_Micro + 'ncc/agg/caxn/cap-nhat',
        IMPORT_EXCEL: rootUrl_Micro + 'ncc/agg/caxn/import',
        DELETE: rootUrl_Micro + 'ncc/agg/caxn/xoa',
        ADD: rootUrl_Micro + 'ncc/agg/caxn/them',
        DOWNLOAD_TEMPLATE: rootUrl_Micro + 'ncc/agg/caxn/template-caxn',
      },

      HS_QNXN: {
        GET_ALL: rootUrl_Micro + 'ncc/agg/qnxn/lay-danh-sach',
        DETAIL: rootUrl_Micro + 'ncc/agg/qnxn/chi-tiet',
        UPDATE: rootUrl_Micro + 'ncc/agg/qnxn/cap-nhat',
        IMPORT_EXCEL: rootUrl_Micro + 'ncc/agg/qnxn/import',
        DELETE: rootUrl_Micro + 'ncc/agg/qnxn/xoa',
        ADD: rootUrl_Micro + 'ncc/agg/qnxn/them',
        DOWNLOAD_TEMPLATE: rootUrl_Micro + 'ncc/agg/qnxn/template-qnxn',
      },
      HS_QD_290_2005_QD_TTG:{
        GET_ALL: rootUrl_Micro + 'ncc/agg/qd-290-2005-qd-ttg/lay-danh-sach',
        DETAIL: rootUrl_Micro + 'ncc/agg/qd-290-2005-qd-ttg/chi-tiet',
        UPDATE: rootUrl_Micro + 'ncc/agg/qd-290-2005-qd-ttg/cap-nhat',
        IMPORT_EXCEL: rootUrl_Micro + 'ncc/agg/qd-290-2005-qd-ttg/import',
        DELETE: rootUrl_Micro + 'ncc/agg/qd-290-2005-qd-ttg/xoa',
        ADD: rootUrl_Micro + 'ncc/agg/qd-290-2005-qd-ttg/them',
        DOWNLOAD_TEMPLATE: rootUrl_Micro + 'ncc/agg/qd-290-2005-qd-ttg/template_agg_quyet-dinh-290-2005-QĐ-TTG',
      },
      HS_QD_53_2010_QD_TTG:{
        GET_ALL: rootUrl_Micro + 'ncc/agg/qd-53-2010-qd-ttg/lay-danh-sach',
        DETAIL: rootUrl_Micro + 'ncc/agg/qd-53-2010-qd-ttg/chi-tiet',
        UPDATE: rootUrl_Micro + 'ncc/agg/qd-53-2010-qd-ttg/cap-nhat',
        IMPORT_EXCEL: rootUrl_Micro + 'ncc/agg/qd-53-2010-qd-ttg/import',
        DELETE: rootUrl_Micro + 'ncc/agg/qd-53-2010-qd-ttg/xoa',
        ADD: rootUrl_Micro + 'ncc/agg/qd-53-2010-qd-ttg/them',
        DOWNLOAD_TEMPLATE: rootUrl_Micro + 'ncc/agg/qd-53-2010-qd-ttg/template_agg_quyet-dinh-53-2010-QĐ-TTG',
      },

      GET_TEN_HUYEN_THI_THANH: rootUrl_Micro + 'ncc/agg/benhbinh/get-huyen-thi-thanh',
      HS_TAI_NAN_LAO_DONG:{
        GET_ALL: rootUrl_Micro + 'ncc/agg/tai-nan-lao-dong/lay-danh-sach',
        DETAIL: rootUrl_Micro + 'ncc/agg/tai-nan-lao-dong/chi-tiet',
        UPDATE: rootUrl_Micro + 'ncc/agg/tai-nan-lao-dong/cap-nhat',
        IMPORT_EXCEL: rootUrl_Micro + 'ncc/agg/tai-nan-lao-dong/import',
        DELETE: rootUrl_Micro + 'ncc/agg/tai-nan-lao-dong/xoa',
        ADD: rootUrl_Micro + 'ncc/agg/tai-nan-lao-dong/them',
        DOWNLOAD_TEMPLATE: rootUrl_Micro + 'ncc/agg/tai-nan-lao-dong/template_agg_tai_nan_lao_dong',
      },

    },
    // Bảo hiểm thất nghiệp AGG
    BHTN_AGG:{
      tuVanViecLam: {
        getInfoCongDan2: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/tu-van-viec-lam/tim-kiem-hs-tvvl",
        getCongDanByUuid: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/cong-dan/thong-tin-cong-dan-theo-uuid",
      },

      troCapThatNghiep:{
        timKiem: rootUrl_Micro + "quan-ly-san-viec-lam/v2/bhtn/tim-kiem-dt-huong-bhtn",
      },

      danhMuc: {
        tonGiao: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/ton-giao/lay-ds-ton-giao",
        ngheTruocKhiThatNghiep: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/dm-nghe-truoc-khi-mat-viec/lay-ds-dm-nghe-truoc-khi-mat-viec",
        nganhNgheDaoTao: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/dm-nganh-nghe-kt/lay-ds-dm-nganh-nghe-kt",
        chuyenMonKt: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/dm-chuyen-mon-kt/lay-ds-dm-chuyen-mon-kt",
        veTinh: rootUrl_Micro + "quan-ly-san-viec-lam/v2/ql-bhtn/dm-ve-tinh/lay-ds-dm-ve-tinh",
        getDmNganhNgheDaoTaoAgg: rootUrl_Micro + "quan-ly-san-viec-lam/v2/bhtn/dm-nganh-nghe-dao-tao-agg"
      },

      bhtn:{
        importDTHuongBHTN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/bhtn/import-bhtn-from-template",
        addDTHuongBHTN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/bhtn/them-moi-dt-huong-bhtn",
        updateDTHuongBHTN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/bhtn/cap-nhat-dt-huong-bhtn",
        deleteDTHuongBHTN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/bhtn/xoa-dt-huong-bhtn",
        getSampleFileDTHuongBHTN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/bhtn/template-import-dt-huong-bhtn-2",
        getDmVeTinhAgg: rootUrl_Micro + "quan-ly-san-viec-lam/v2/bhtn/dm-ve-tinh-agg",

      }
    },

  // Số liệu doanh nghiệp toàn tỉnh AGG
  SLDN_AGG:{

    sldn:{
      danhMucLoaiHinhDoanhNghiep: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/danh-muc-loai-hinh-doanh-nghiep",
      importSoLieuDN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/import-sldn-from-template",
      timKiem: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/get-list-sldn",
      themMoiSoLieuDN_LH: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/them-moi-sldn-lh",
      capNhatSoLieuDN_LH: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/cap-nhat-sldn-lh",
      xoaSoLieuDN_LH: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/xoa-sldn-lh",
      templateSoLieuDN_LH: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/download-template-sldn-lh",

      importSoLieuDNKV: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/import-sldnkv-from-template",
      timKiemKV: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/get-list-sldnkv",
      themMoiSoLieuDN_KV: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/them-moi-sldn-kv",
      capNhatSoLieuDN_KV: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/cap-nhat-sldn-kv",
      xoaSoLieuDN_KV: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/xoa-sldn-kv",
      templateSoLieuDN_KV: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/download-template-sldn-kv",

    }
  },
  // AGG NGƯỜI TÌM VIỆC
  AGG_NGUOITIMVIEC:
  {
    getDanhSachNguoiTimViec: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/agg/danh-sach-nguoi-tim-viec-phan-trang',
    getDanhSachChiTietNguoiTimViec: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/agg/chi-tiet-danh-sach-nguoi-tim-viec',
    capNhatDanhSachNguoiTimViec: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/agg/cap-nhat-danh-sach-nguoi-tim-viec',
    ImportDataFromExcelDanhSachNguoiTimViec: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/agg/import-dl-ntv-from-template',
    deleteDanhSachNguoiTimViec: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/agg/xoa-nguoi-tim-viec',
    themDanhSachNguoiTimViec: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/agg/them-nguoi-tim-viec',
    exportSampleFile: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/agg/export-sample-file-hs-nguoi-tim-viec',
  },
  AN_GIANG: {
    lay_ten_quan_huyen_tinh_an_giang: rootUrl_Micro + 'ncc/an-giang/lay-ten-quan-huyen-kv-ag',
    AHLLVT:
      {
        GET_DANH_SACH_AHLLVT: rootUrl_Micro + "ncc/an-giang/lay-danh-sach-ahllvt",
        THEM_HS_AHLLVT: rootUrl_Micro + "ncc/an-giang/them-ahllvt",
        CAP_NHAT_HS_AHLLVT: rootUrl_Micro + "ncc/an-giang/cap-nhat-ahllvt",
        CHI_TIET_HS_AHLLVT: rootUrl_Micro + "ncc/an-giang/chi-tiet-ahllvt",
        XOA_HS_AHLLVT: rootUrl_Micro + "ncc/an-giang/xoa-ahllvt",
        IMPORT_DS_AHLLVT: rootUrl_Micro + "ncc/an-giang/import-ds-ahllvt",
      },
  },
  //Lao động việc làm HGI
  LDVL_HGI:{
    thongKeTinhHinhLaoDong:{
      timKiemThongKeTinhHinhLaoDong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-tinh-hinh-lao-dong/get-thong-ke-tinh-hinh-lao-dong",
      chiTietThongKeTinhHinhLaoDong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-tinh-hinh-lao-dong/get-thong-ke-tinh-hinh-lao-dong-chi-tiet",
      chiTietThongKeTinhHinhLaoDongThangNam: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-tinh-hinh-lao-dong/get-tk-chi-tiet-thang-nam",
      themMoiThongKeTinhHinhLaoDong:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-tinh-hinh-lao-dong/add-thong-ke-tinh-hinh-lao-dong",
      capNhatThongKeTinhHinhLaoDong:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-tinh-hinh-lao-dong/update-thong-ke-tinh-hinh-lao-dong",
      xoaThongKeTinhHinhLaoDong:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-tinh-hinh-lao-dong/delete-thong-ke-tinh-hinh-lao-dong",
      xuatBaoCaoThongKeTinhHinhLaoDong:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-tinh-hinh-lao-dong/export-thong-ke-tinh-hinh-lao-dong",
    },

    BAO_CAO_CONG_TAC_AN_TOAN_VE_SINH_LAO_DONG: {
      layThongTinBaoCao: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/xuat-bao-cao",
    },

    dangKyTaiKhoanDoanhNghiep: {
      layDanhSachDonVi: 'quan-ly-san-viec-lam/v2/dm-don-vi',
      layDanhMucDungChung: 'quan-ly-san-viec-lam/v2/dm-dung-chung',
      dangKyDoanhNghiep: 'quan-ly-san-viec-lam/v2/dang-ky',
      xacThucTaiKhoan: 'quan-ly-san-viec-lam/v2/xac-nhan-ma',
      guiLaiMa: 'quan-ly-san-viec-lam/v2/gui-lai-ma',
    },

    GET_KIEM_TRA_SAN_PHAM_HANG_HOA_PAGEABLE: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi/get-kiem-tra-san-pham-hang-hoa-pageable",
    ADD_KIEM_TRA_SAN_PHAM_HANG_HOA: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi/add-kiem-tra-san-pham-hang-hoa",
    UPDATE_KIEM_TRA_SAN_PHAM_HANG_HOA: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi/update-kiem-tra-san-pham-hang-hoa",
    DELETE_KIEM_TRA_SAN_PHAM_HANG_HOA: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi/delete-kiem-tra-san-pham-hang-hoa",

    GET_HUAN_LUYEN_AN_TOAN_VSLD_PAGEABLE: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi/get-huan-luyen-an-toan-vsld-pageable",
    ADD_HUAN_LUYEN_AN_TOAN_VSLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi/add-huan-luyen-an-toan-vsld",
    UPDATE_HUAN_LUYEN_AN_TOAN_VSLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi/update-huan-luyen-an-toan-vsld",
    DELETE_HUAN_LUYEN_AN_TOAN_VSLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi/delete-huan-luyen-an-toan-vsld",

    GET_HO_SO_VSMT_LAO_DONG_DETAIL: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi/get-ho-so-vsmt-lao-dong-detail",
    GET_HO_SO_VSMT_LAO_DONG_PAGEABLE: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi/get-ho-so-vsmt-lao-dong-pageable",
    GET_YEU_TO_CO_HAI_HO_SO_VSMT_LAO_DONG: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi/get-yeu-to-co-hai-ho-so-vsmt-lao-dong",
    DELETE_YEU_TO_CO_HAI_HO_SO_VSMT_LAO_DONG: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi/delete-yeu-to-co-hai-ho-so-vsmt-lao-dong",
    GET_PHAN_XUONG_HO_SO_VSMT_LAO_DONG: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi/get-phan-xuong-ho-so-vsmt-lao-dong",
    DELETE_PHAN_XUONG_HO_SO_VSMT_LAO_DONG: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi/delete-phan-xuong-ho-so-vsmt-lao-dong",
    GET_YEU_TO_PHAN_XUONG_HO_SO_VSMT_LAO_DONG: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi/get-yeu-to-phan-xuong-ho-so-vsmt-lao-dong",
    DELETE_YEU_TO_PHAN_XUONG_HO_SO_VSMT_LAO_DONG: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi/delete-yeu-to-phan-xuong-ho-so-vsmt-lao-dong",
    GET_THIET_BI_PHAN_XUONG_HO_SO_VSMT_LAO_DONG: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi/get-thiet-bi-phan-xuong-ho-so-vsmt-lao-dong",
    DELETE_THIET_BI_PHAN_XUONG_HO_SO_VSMT_LAO_DONG: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi/delete-thiet-bi-phan-xuong-ho-so-vsmt-lao-dong",
    ADD_HO_SO_VSMT_LAO_DONG: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi/add-ho-so-vsmt-lao-dong",
    UPDATE_HO_SO_VSMT_LAO_DONG: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi/update-ho-so-vsmt-lao-dong",
    DELETE_HO_SO_VSMT_LAO_DONG: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi/delete-ho-so-vsmt-lao-dong",
    EXPORT_HO_SO_VSMT_LAO_DONG: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi/export-ho-so-vsmt-lao-dong",

    GET_BAO_CAO_KET_QUA_GQVL_XKLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi/get-bao-cao-ket-qua-gqvl-xkld",
    GET_BAO_CAO_KET_QUA_GQVL_XKLD_TOAN_TINH: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi/get-bao-cao-ket-qua-gqvl-xkld-toan-tinh",

    GET_PHIEN_GIAO_DICH_VL_PAGEABLE: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi/get-phien-giao-dich-viec-lam-pageable",
    GET_BAO_CAO_PHIEN_GIAO_DICH_VL: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi/get-bao-cao",

    GET_GIAI_QUYET_VIEC_LAM_PAGEABLE: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi/get-giai-quyet-viec-lam-pageable",
    ADD_GIAI_QUYET_VIEC_LAM: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi/add-giai-quyet-viec-lam",
    UPDATE_GIAI_QUYET_VIEC_LAM: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi/update-giai-quyet-viec-lam",
    DELETE_GIAI_QUYET_VIEC_LAM: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi/delete-giai-quyet-viec-lam",

    GET_THU_HOI_GIAY_PHEP_CHO_THUE_LD_PAGEABLE: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi/get-thu-hoi-giay-phep-cho-thue-lao-dong-pageable",
    DOWNLOAD_THU_HOI_GIAY_PHEP_CHO_THUE_LD_TEMPLATE: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi/download-thu-hoi-giay-phep-cho-thue-lao-dong-template",
    IMPORT_THU_HOI_GIAY_PHEP_CHO_THUE_LD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi/import-thu-hoi-giay-phep-cho-thue-lao-dong",
    UPDATE_THU_HOI_GIAY_PHEP_CHO_THUE_LD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi/update-thu-hoi-giay-phep-cho-thue-lao-dong",
    THU_HOI_GIAY_PHEP_CHO_THUE_LD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi/thu-hoi-giay-phep-cho-thue-lao-dong",
    DELETE_THU_HOI_GIAY_PHEP_CHO_THUE_LD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi/delete-thu-hoi-giay-phep-cho-thue-lao-dong",

    khaiBaoTaiNanLaoDong:{
      timKiemKhaiBaoTaiNanLaoDong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/tim-kiem-khai-bao-tai-nan-lao-dong",
      danhSachNanNhanTaiNanLaoDong:rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/danh-sach-nan-nhan-tai-nan-lao-dong",
      danhSachDanhMucDungChung: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/danh-sach-danh-muc-dung-chung",
      getThongTinCoSo: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/get-thong-tin-co-so",
      themMoiKhaiBaoTaiNanLaoDong:rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/them-moi-khai-bao-tai-nan-lao-dong",
      capNhatKhaiBaoTaiNanLaoDong:rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/cap-nhat-khai-bao-tai-nan-lao-dong",
      xoaKhaiBaoTaiNanLaoDong:rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/xoa-khai-bao-tai-nan-lao-dong"
    },

    baoCaoKhaiBaoTaiNanLaoDong:{
      timKiemBaoCaoKhaiBaoTaiNanLaoDong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/tim-kiem-bao-cao-khai-bao-tai-nan-lao-dong",
      danhSachNanNhanTaiNanLaoDongOfBaoCao: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/bao-cao-danh-sach-nan-nhan-tai-nan-lao-dong",
      xuatBaoCaoKhaiBaoTNLDByIdCoSoAndIdTaiNan: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/xuat-bao-cao-khai-bao-tai-nan-lao-dong",
      danhSachNguyenNhanXayRa: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/danh-sach-nguyen-nhan-xay-ra",
      getThongTinCoSoOfBaoCao: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/get-thong-tin-co-so-by-id",
    },

    baoCaoNhanhTnldChetNguoi:{
      timkiemQuanLyNhanhTnldChetNguoi: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/tim-kiem-bao-cao-nhanh-tnld-chet-nguoi",
      danhMucGioiTinh: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/danh-muc-gioi-tinh-bao-cao",
      getThongTinCoSoChetNguoi: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/get-thong-tin-co-so-chet-nguoi-bao-cao",
      danhSachNanNhanTaiNanByIdTaiNan: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/danh-sach-nan-nhan-by-idtainan-bao-cao",
      xuatBaoCaoNhanhTNLDChetNguoiByIdCoSoAndIdTaiNan: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/xuat-bao-cao-nhanh-tai-nan-lao-dong-bao-cao"
    },
    qlNhanhTnldChetNguoi:{
      timkiemQuanLyNhanhTnldChetNguoi: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/tim-kiem-quan-ly-nhanh-tnld-chet-nguoi",
      danhMucGioiTinh: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/danh-muc-gioi-tinh",
      getThongTinCoSoChetNguoi: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/get-thong-tin-co-so-chet-nguoi",
      danhSachThongTinCoSo: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/danh-sach-thong-tin-co-so",
      danhSachNanNhanTaiNanByIdTaiNan: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/danh-sach-nan-nhan-by-idtainan",
      themMoiQuanLyNhanhTnldChetNguoi: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/them-moi-quan-ly-nhanh-tnld-chet-nguoi",
      capNhatQuanLyNhanhTnldChetNguoi: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/cap-nhat-quan-ly-nhanh-tnld-chet-nguoi",
      xoaQuanLyNhanhTnldChetNguoi: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/xoa-quan-ly-nhanh-tnld-chet-nguoi",
      xuatBaoCaoNhanhTNLDChetNguoiByIdCoSoAndIdTaiNan: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/xuat-bao-cao-nhanh-tai-nan-lao-dong"
    },
    TNLD_TONG_HOPV2: {
        insertTNLDNguoiLDKhongHopDongTongHop: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong-tong-hop/them-tnld-nguoi-khong-hdld-tong-hop',
        upsertTNLDNguoiLDKhongHopDongTongHop: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong-tong-hop/cap-nhat-tnld-nguoi-khong-hdld-tong-hop',
    },
    TNLD_TONG_HOP: {
      getDMNgheNghiep: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong-tong-hop/lay-danh-sach-nganh-nghe',
      getDSTrangThai3Cap: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong-tong-hop/lay-danh-sach-trang-thai-3-cap',
      getTNLDNguoiLDKhongHopDongChiTiet: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong-tong-hop/lay-tnld-nguoi-lao-dong-khong-hdld-chi-tiet',
      getTNLDNguoiLDKhongHopDongTongHop: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong-tong-hop/tai-nan-lao-dong-khong-hdld-tong-hop',
      getTNLDNguoiLDKhongHopDongTongHopChiTiet: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong-tong-hop/lay-tnld-nguoi-lao-dong-khong-hdld-tong-hop-chi-tiet',
      insertTNLDNguoiLDKhongHopDongTongHop: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong-tong-hop/them-tnld-nguoi-khong-hdld-tong-hop',
      upsertTNLDNguoiLDKhongHopDongTongHop: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong-tong-hop/cap-nhat-tnld-nguoi-khong-hdld-tong-hop',
      deleteTNLDNguoiLDKhongHopDongTongHop: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tai-nan-lao-dong-tong-hop/xoa-tnld-nguoi-khong-hdld-tong-hop',
      inbaocaoTNLDNguoiLDKhongHDLDTongHop: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao/tai-nan-ld-nguoi-ld-khong-hdld-tong-hop'},

      thongKeLaoDongTaiDiaPhuong:{
        xuatBaoCaoThongKeLaoDongTaiDiaPhuong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-lao-dong-tai-dia-phuong/export-thong-ke-lao-dong-tai-dia-phuong",
      },
      thongKeLaoDongTaiDiaPhuongV2:{
        xuatBaoCaoThongKeLaoDongTaiDiaPhuong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-lao-dong-tai-dia-phuong/export-thong-ke-lao-dong-tai-dia-phuong",
      },

    danhMucNguoiLaoDong:{
      timKiem: rootUrl_Micro + "quan-ly-san-viec-lam/v2/danh-sach-nguoi-lao-dong/tim-kiem-danh-sach-nguoi-lao-dong",
      themMoi: rootUrl_Micro + "quan-ly-san-viec-lam/v2/danh-sach-nguoi-lao-dong/them-moi-danh-sach-nguoi-lao-dong",
      capNhat: rootUrl_Micro + "quan-ly-san-viec-lam/v2/danh-sach-nguoi-lao-dong/cap-nhat-danh-sach-nguoi-lao-dong",
      xoa: rootUrl_Micro + "quan-ly-san-viec-lam/v2/danh-sach-nguoi-lao-dong/xoa-danh-sach-nguoi-lao-dong",
      getSampleFileDanhSachNguoiLaoDong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/danh-sach-nguoi-lao-dong/xuat-mau-danh-sach-nguoi-lao-dong",
      importDanhSachNguoiLaoDong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/danh-sach-nguoi-lao-dong/import-danh-sach-nguoi-lao-dong",
      danhMucViTriCongViec: rootUrl_Micro + "quan-ly-san-viec-lam/v2/danh-sach-nguoi-lao-dong/dm-vi-tri-cong-viec",
      danhMucHopDongLaoDong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/danh-sach-nguoi-lao-dong/dm-hop-dong-lao-dong",
      danhMucQuocTich: rootUrl_Micro + "quan-ly-san-viec-lam/v2/danh-sach-nguoi-lao-dong/dm-quoc-tich",
      danhMucDanToc: rootUrl_Micro + "quan-ly-san-viec-lam/v2/danh-sach-nguoi-lao-dong/dm-dan-toc",
      danhMucGioiTinh: rootUrl_Micro + "quan-ly-san-viec-lam/v2/danh-sach-nguoi-lao-dong/dm-gioi-tinh",
      danhMucTrinhDoChuyenMon: rootUrl_Micro + "quan-ly-san-viec-lam/v2/danh-sach-nguoi-lao-dong/dm-trinh-do-chuyen-mon",
      danhMucLyDoNghi: rootUrl_Micro + "quan-ly-san-viec-lam/v2/danh-sach-nguoi-lao-dong/dm-ly-do-nghi",
      chiTiet: rootUrl_Micro + "quan-ly-san-viec-lam/v2/danh-sach-nguoi-lao-dong/get-chi-tiet-nguoi-lao-dong",
    },
    quanLySoTKTNLD:{
      timkiemQLSoTnld: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/tim-kiem-ql-so-tk-tnld",
      danhSachCoSo: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/danh-sach-co-so",
      danhSachNganh: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/danh-sach-nganh",
      danhSachNgheNghiep: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/danh-sach-nghe-nghiep",
      danhSachLoaiChanThuong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/danh-sach-loai-chan-thuong",
      insertQLSoThongKeTNLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/them-moi-ql-so-tk-tnld",
      updateQLSoThongKeTNLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/cap-nhat-ql-so-tk-tnld",
      deleteQLSoThongKeTNLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/xoa-ql-so-tk-tnld",
      xuatBaoCaoQLTKTNLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/xuat-bao-cao-ql-so-tk-tnld",
    },
    thongKeToChucGTVLDuocCapPhep:{
      timKiemThongKeToChucGTVLDuocCapPhep: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-to-chuc-gtvl-duoc-cap-phep/get-thong-ke-to-chuc-gtvl-duoc-cap-phep",
      chiTietThongKeToChucGTVLDuocCapPhep: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-to-chuc-gtvl-duoc-cap-phep/get-thong-ke-to-chuc-gtvl-duoc-cap-phep-chi-tiet",
      themMoiThongKeToChucGTVLDuocCapPhep:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-to-chuc-gtvl-duoc-cap-phep/add-thong-ke-to-chuc-gtvl-duoc-cap-phep",
      capNhatThongKeToChucGTVLDuocCapPhep:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-to-chuc-gtvl-duoc-cap-phep/update-thong-ke-to-chuc-gtvl-duoc-cap-phep",
      xoaThongKeToChucGTVLDuocCapPhep:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-to-chuc-gtvl-duoc-cap-phep/delete-thong-ke-to-chuc-gtvl-duoc-cap-phep",
      xuatBaoCaoThongKeToChucGTVLDuocCapPhep:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-to-chuc-gtvl-duoc-cap-phep/export-thong-ke-to-chuc-gtvl-duoc-cap-phep",
      GuiThongKeToChucGTVLDuocCapPhep:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-to-chuc-gtvl-duoc-cap-phep/send-thong-ke-to-chuc-gtvl-duoc-cap-phep",
    },
    QUAN_LY_TINH_HINH_SU_DUNG_LAO_DONG: {
      getDuLieu: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/quan-ly-tinh-hinh-su-dung-ld-va-danh-sach-tham-gia-bhxh/get-du-lieu',
      deletetDuLieu: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/quan-ly-tinh-hinh-su-dung-ld-va-danh-sach-tham-gia-bhxh/delete-du-lieu',
      getDuLieuChiTiet: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/quan-ly-tinh-hinh-su-dung-ld-va-danh-sach-tham-gia-bhxh/get-du-lieu-chi-tiet',
      getDuLieuDoanhnghiep: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/quan-ly-tinh-hinh-su-dung-ld-va-danh-sach-tham-gia-bhxh/get-du-lieu-doanh-nghiep',
      themMoiDuLieu: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/quan-ly-tinh-hinh-su-dung-ld-va-danh-sach-tham-gia-bhxh/them-moi-du-lieu-doanh-nghiep',
      getDuLieuDoanhnghiepChiTietUpdate: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/quan-ly-tinh-hinh-su-dung-ld-va-danh-sach-tham-gia-bhxh/get-du-lieu-doanh-nghiep-chi-tiet-update',
      updateDuLieu: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/quan-ly-tinh-hinh-su-dung-ld-va-danh-sach-tham-gia-bhxh/update-du-lieu-doanh-nghiep',
      capNhatMoiDuLieu: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/quan-ly-tinh-hinh-su-dung-ld-va-danh-sach-tham-gia-bhxh/cap-nhat-du-lieu-doanh-nghiep',
      xuatBaoCao: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/quan-ly-tinh-hinh-su-dung-ld-va-danh-sach-tham-gia-bhxh/xuat-bao-cao',
      xuatBaoCaoSo: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/quan-ly-tinh-hinh-su-dung-ld-va-danh-sach-tham-gia-bhxh/xuat-bao-cao-so',
      chotSoLieu: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/quan-ly-tinh-hinh-su-dung-ld-va-danh-sach-tham-gia-bhxh/chot-so-lieu',
    },
    baocaothongKeToChucGTVLDuocCapPhep:{
      xuatBaoCaoThongKeToChucGTVLDuocCapPhepHoatDong:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-to-chuc-gtvl-duoc-cap-phep/xbc-thong-ke-to-chuc-gtvl-duoc-cap-phep"
    },
    thongKeSoNguoiHuongTroCapThatNghiep:{
      timKiemThongKeSoNguoiHuongTroCapThatNghiep: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-so-nguoi-huong-tro-cap-that-nghiep/get",
      chiTietThongKeSoNguoiHuongTroCapThatNghiep: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-so-nguoi-huong-tro-cap-that-nghiep/get-chi-tiet",
      themMoiThongKeSoNguoiHuongTroCapThatNghiep:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-so-nguoi-huong-tro-cap-that-nghiep/add",
      capNhatThongKeSoNguoiHuongTroCapThatNghiep:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-so-nguoi-huong-tro-cap-that-nghiep/update",
      xoaThongKeSoNguoiHuongTroCapThatNghiep:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-so-nguoi-huong-tro-cap-that-nghiep/delete",
      xuatBaoCaoThongKeSoNguoiHuongTroCapThatNghiep:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-so-nguoi-huong-tro-cap-that-nghiep/export",
      guiThongKeSoNguoiHuongTroCapThatNghiep:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-so-nguoi-huong-tro-cap-that-nghiep/gui",
      duyetThongKeSoNguoiHuongTroCapThatNghiep:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-so-nguoi-huong-tro-cap-that-nghiep/duyet",
      tuChoiThongKeSoNguoiHuongTroCapThatNghiep:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-so-nguoi-huong-tro-cap-that-nghiep/tu-choi"
    },
    baocaoThongKeSoNguoiHuongTroCapThatNghiep:{
      xuatBaoCaoThongKeSoNguoiHuongTroCapThatNghiep:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-so-nguoi-huong-tro-cap-that-nghiep/xbc"
    },
    congTacAnToanVeSinhLaoDong: {
      layDanhSachBaoCaoDN: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/co-so',
      layDanhSachBaoCaoSo:rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/so/search',
      chinhSuaBaoCaoDN:rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/co-so',
      xoaBaoCao:rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/co-so',
      guiDuyeBaoCao:rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/cong-tac',
      taoBaoCaoDN:rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/co-so',
      layChiTietBaoCaoCongTac:rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/cong-tac',
      layYeuToDanhGia:rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/yeu-to',
      layDanhMucDanhGia:rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/danh-muc-dung-chung',
      layThongTinCoSo:rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/co-so',
    },
     // SRS 48
     bienBanKiemTraATVSLD: {
      searchBienBanCoSo: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bien-ban-kiem-tra-atvsld/search-dn",
      layThongTinCoSo: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bien-ban-kiem-tra-atvsld/thong-tin-co-so",
      layThongTinNguoiLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bien-ban-kiem-tra-atvsld/thong-tin-nguoi-ld",
      layChucVu: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bien-ban-kiem-tra-atvsld/chuc-vu",
      layBienBanKiemTra: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bien-ban-kiem-tra-atvsld",
      themMoiBienBan: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bien-ban-kiem-tra-atvsld",
      chinhSuaBienBan: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bien-ban-kiem-tra-atvsld",
      xoaBienBan: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bien-ban-kiem-tra-atvsld",
      xuatFile: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bien-ban-kiem-tra-atvsld/xuat-bao-cao",
    },
    //srs56
    baoCaoKetQuaHoatDongDichVuViecLam: {
      xuatBaoCaoKetQuaHoatDongDichVuViecLam: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao-kqhddvvl-08/xuat-bao-cao"
    },
    //

    ketQuaTrienKhaiThangHanhDongVeATVSLD:{
      apiLayDanhSachBaoCaoDN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/ket-qua-trien-khai-thang-hanh-dong-ve-atvsld/doanh-nghiep",
      apiLayDanhSachBaoCaoSo: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/ket-qua-trien-khai-thang-hanh-dong-ve-atvsld/so",
      apiCapNhatBaoCaoDN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/ket-qua-trien-khai-thang-hanh-dong-ve-atvsld",
      apiCapNhatTrangThaiBaoCao: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/ket-qua-trien-khai-thang-hanh-dong-ve-atvsld/cap-nhat-trang-thai",
      apiXoaBaoCaoDN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/ket-qua-trien-khai-thang-hanh-dong-ve-atvsld",
      apiXuatBaoCao: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/ket-qua-trien-khai-thang-hanh-dong-ve-atvsld/xuat-bao-cao",
      apiXemChiTietBaoCao: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/ket-qua-trien-khai-thang-hanh-dong-ve-atvsld/chi-tiet",
      apiThemBaoCaoMoi: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/ket-qua-trien-khai-thang-hanh-dong-ve-atvsld",
      apiLayThongTinDoanhNghiep: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/ket-qua-trien-khai-thang-hanh-dong-ve-atvsld/thong-tin-doanh-nghiep",
    },

    KhaiBaoMayMoc: {
      timKiemKhaiBaoMayMoc: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/khai-bao-may-moc/danh-sach-khai-bao-may-moc",
      getChiTietKhaiBaoMayMoc: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/khai-bao-may-moc/chi-tiet-khai-bao-may-moc",
      themMoiKhaiBaoMayMoc: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/khai-bao-may-moc/them-moi-khai-bao-may-moc",
      capNhatKhaiBaoMayMoc: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/khai-bao-may-moc/cap-nhat-khai-bao-may-moc",
      duyetKhaiBaoMayMoc: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/khai-bao-may-moc/chuyen-khai-bao-may-moc",
      xoaKhaiBaoMayMoc: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/khai-bao-may-moc/xoa-khai-bao-may-moc",
      getChiTietThongTinCoSo: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-tin-co-so/getById",
      xuatBaoCao: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/khai-bao-may-moc/xuat-bao-cao",
      xuatDanhSachKhaiBao: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/khai-bao-may-moc/xuat-danh-sach-khai-bao",
      uploadFile: rootUrl_Micro + "file/khai-bao-may-moc/upload-file-dinh-kem",
      uploadMultipleFiles: rootUrl_Micro + "file/khai-bao-may-moc/upload-nhieu-file-dinh-kem",
      downloadFile: rootUrl_Micro + "file/khai-bao-may-moc/download-file",
      getFileName: rootUrl_Micro + "file/khai-bao-may-moc/get-file-name",
      getDmTrangThaiMayMoc: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/khai-bao-may-moc/dm-trang-thai-may-moc",
      getDsFileDinhKem: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/khai-bao-may-moc/danh-sach-file-dinh-kem",
      deleteFileDinhKem: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/khai-bao-may-moc/xoa-file-dinh-kem",
      getPdfFile: rootUrl_Micro + "file/khai-bao-may-moc/download-pdf",
      downloadTemplateKhaiBaoMayMoc: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/khai-bao-may-moc/download-template-import-khai-bao-may-moc",
      importKhaiBaoMayMoc: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/khai-bao-may-moc/import-khai-bao-may-moc",
      dmDoanhNgiep: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/khai-bao-may-moc/dm-doanh-nghiep",
      dmThietBiVatTuAtvsld: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/khai-bao-may-moc/dm-thietbi-vattu-atvsld",
      tongHopTinhTrangThietBiVatTuATVSLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/khai-bao-may-moc/tong-hop-tinh-trang-thiet-bi-vat-tu-atvsld",
    },
    thongKeDinhCong:{
      dmNganhNgheKinhTe: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-dinh-cong/get-dm-nganh-nghe-kinh-te",
      timKiemThongKeDinhCong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-dinh-cong/get",
      chiTietThongKeDinhCong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-dinh-cong/get-chi-tiet",
      themMoiThongKeDinhCong:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-dinh-cong/add",
      capNhatThongKeDinhCong:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-dinh-cong/update",
      xoaThongKeDinhCong:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-dinh-cong/delete",
      xuatBaoCaoThongKeDinhCong:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-dinh-cong/export",
    },

    tongHopBaoCaoATVSLD: {
      layDanhsachCongtacATVSLD: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/search',
      xoaCongtacATVSLD: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/cong-tac-dia-ban',
      layChitietBaocaoSRS38: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/cong-tac-dia-ban',
      layChitietQuanTracSRS38: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/cong-tac-dia-ban-thqt',
      layChitietBaocaoSRS39: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/cong-tac-dia-ban-39',
      layChitietQuanTracSRS39: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/cong-tac-dia-ban-thqt-39',
      themBaocao: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/cong-tac-dia-ban',
      capNhatBaoCao: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/cong-tac-dia-ban',
    },

    quanLyTinhHinhSdNguoiLdNuocNgoai:{
      searchQuanLyTinhHinhSDNguoiLDNN : rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/tim-kiem-ql-th-sd-nguoi-ld-nn",
      getThongTinDn: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/thong-tin-dn",
      getThongTinBaoCaoChiTiet: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/thong-tin-bao-cao-chi-tiet",
      createQuanLyTinhHinhSDNguoiLDNN: rootUrl_Micro +  "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/them-moi-ql-th-sd-nguoi-ld-nn",
      updateQuanLyTinhHinhSDNguoiLDNN: rootUrl_Micro +  "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/cap-nhat-ql-th-sd-nguoi-ld-nn",
      deleteQuanLyTinhHinhSDNguoiLDNN: rootUrl_Micro +  "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/xoa-ql-th-sd-nguoi-ld-nn",
      setTrangThaiXacNhan: rootUrl_Micro +  "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/cap-nhat-trang-thai-xac-nhan",
      exportFile: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/xuat-bc-ql-th-sd-nguoi-ld-nn",
      uploadFile: rootUrl_Micro + 'file/cung-cau-lao-dong/thong-tin-co-so/upload-gpkd',
      downloadFile: rootUrl_Micro + 'file/cung-cau-lao-dong/thong-tin-co-so/download'
    },

    quanLyTinhHinhNguoiLdNuocNgoai:{
      searchQuanLyTinhHinhNguoiLDNN : rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/tim-kiem-ql-th-nguoi-ld-nn",
      listQuocTich: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/danh-sach-quoc-tich",
      getSoLieuTongHopQuanLyTinhHinhSdNguoiLDNN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/so-lieu-th-ql-th-sd-nguoi-ld-nn",
      getChiTietQuanLyTinhHinhNguoiLDNN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/chi-tiet-ql-th-nguoi-ld-nn",
      createQuanLyTinhHinhNguoiLDNN: rootUrl_Micro +  "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/them-moi-ql-th-nguoi-ld-nn",
      updateQuanLyTinhHinhNguoiLDNN: rootUrl_Micro +  "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/cap-nhat-ql-th-nguoi-ld-nn",
      deleteQuanLyTinhHinhNguoiLDNN: rootUrl_Micro +  "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/xoa-ql-th-nguoi-ld-nn",
      exportFileQuanLyTinhHinhSDNguoiLDNN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/xuat-bc-ql-th-nguoi-ld-nn"
    },

    baoCaoQuanLyThSdNldNuocNgoai:{
      searchBcQuanLyTinhHinhSDNguoiLDNN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/tim-kiem-bc-th-sd-nld-nuoc-ngoai"
    },

    baoCaoQuanLyThNldNuocNgoai:{
      searchBcQuanLyTinhHinhNguoiLDNN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/tim-kiem-bc-ql-th-nuoc-ngoai"
    },

    TKLDLamViecNuocNgoaiTheoHopDong: {
      getList: rootUrl_Micro +  "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/ld-nuoc-ngoai-trong-nam-theo-hd/getList",
      getTongHopTheoNam: rootUrl_Micro +  "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/ld-nuoc-ngoai-trong-nam-theo-hd/getTongHopTheoNam",
      themMoi: rootUrl_Micro +  "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/ld-nuoc-ngoai-trong-nam-theo-hd/themMoi",
      capNhat: rootUrl_Micro +  "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/ld-nuoc-ngoai-trong-nam-theo-hd/capNhat",
      getChiTiet: rootUrl_Micro +  "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/ld-nuoc-ngoai-trong-nam-theo-hd/getChiTiet",
      xoa: rootUrl_Micro +  "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/ld-nuoc-ngoai-trong-nam-theo-hd/xoa",
      chuyenDuyet: rootUrl_Micro +  "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/ld-nuoc-ngoai-trong-nam-theo-hd/chuyenDuyet",
      xuatBaoCao: rootUrl_Micro +  "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/ld-nuoc-ngoai-trong-nam-theo-hd/xuatBaoCao",
    },
    TKLDLamViecNuocNgoaiTheoHopDongSo: {
      getList: rootUrl_Micro +  "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/ld-nuoc-ngoai-trong-nam-theo-hd-so/getList",
      getTongHopTheoNam: rootUrl_Micro +  "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/ld-nuoc-ngoai-trong-nam-theo-hd-so/getTongHopTheoNam",
      themMoi: rootUrl_Micro +  "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/ld-nuoc-ngoai-trong-nam-theo-hd-so/themMoi",
      capNhat: rootUrl_Micro +  "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/ld-nuoc-ngoai-trong-nam-theo-hd-so/capNhat",
      getChiTiet: rootUrl_Micro +  "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/ld-nuoc-ngoai-trong-nam-theo-hd-so/getChiTiet",
      xoa: rootUrl_Micro +  "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/ld-nuoc-ngoai-trong-nam-theo-hd-so/xoa",
      xuatBaoCao: rootUrl_Micro +  "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/ld-nuoc-ngoai-trong-nam-theo-hd-so/xuatBaoCao",
    },
    dmChauLucKhuVuc: {
      getListChauLuc: rootUrl_Micro  + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dm-chau-luc-khu-vuc/getAllChauLuc",
      getListByChauLuc: rootUrl_Micro  + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dm-chau-luc-khu-vuc/getByChauLuc"
    },

    thongBaoTinhHinhBienDongLaodong:{
      xuatBaoCao: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/thong-bao-tinh-hinh-bien-dong-lao-dong/xuat-bao-cao',
    },
    baoCaoThongkeTNLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao/bao-cao-thong-ke-tai-nan-lao-dong",
    baoCaoThongKeNguoiLDNuocNgoaiTaiVietNam: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao/thong-ke-lao-dong-nguoi-nuoc-ngoai-tai-viet-nam-duoc-cap-giay-phep',
    thongBaoTinhHinhBienDongLaoDongMau29:{
      xuatBaoCaoMau29: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/thong-bao-tinh-hinh-bien-dong-lao-dong-mau29/xuat-bao-cao-mau29',
    },
    thongKeLaoDongCoViecLamTangThem:{
      timKiem: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-lao-dong-co-viec-lam-tang-them/get",
      chiTiet: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-lao-dong-co-viec-lam-tang-them/get-chi-tiet",
      themMoi:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-lao-dong-co-viec-lam-tang-them/add",
      capNhat:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-lao-dong-co-viec-lam-tang-them/update",
      xoa:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-lao-dong-co-viec-lam-tang-them/delete",
      xuatBaoCao:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-lao-dong-co-viec-lam-tang-them/export",
      chotSoLieuTheoNam:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-lao-dong-co-viec-lam-tang-them/chot-so-lieu-theo-nam",
      chotSoLieuTheoId:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-lao-dong-co-viec-lam-tang-them/chot-so-lieu-theo-id",
    },
    TKLDLamViecNuocNgoaiTheoKetThucHopDongSo: {
      xuatBaoCao: rootUrl_Micro +  "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/ldnntn-ket-thuc-hd-so/xuatBaoCao",
      checkReport: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/ldnntn-ket-thuc-hd-so/check-report"
    },
        //SRS71
    baoCaoCongTacATVSLĐTrenDiaBan: {
        xuatBaoCaoCongTacATVSLĐTrenDiaBan: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/bao-cao-cong-tac-atvsld/xuat-bao-cao"
    },
        //END SRS71

    baoCaoThongKeViecLamQuyQuocGia:{
      layDanhSachBaoCaoThongKe: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/bao-cao-thong-ke-lao-dong",
      xoaBaoCaoThongKe: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/bao-cao-thong-ke-lao-dong",
      themBaoCaoThongKe: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/bao-cao-thong-ke-lao-dong",
      capNhatBaoCaoThongKe: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/bao-cao-thong-ke-lao-dong",
      layChiTietBaoCaoThongKe: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/bao-cao-thong-ke-lao-dong/chi-tiet",
      xuatBaoCaoExcel: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/bao-cao-thong-ke-lao-dong/xuat-bao-cao",
      xuatBaoCaoPDF: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/bao-cao-thong-ke-lao-dong/xuat-bao-cao",
    },
    tinhTrangViecLam:{
      timKiemTinhTrangViecLam: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tinh-trang-viec-lam/get",
      chiTietTinhTrangViecLam: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tinh-trang-viec-lam/get-chi-tiet",
      themMoiTinhTrangViecLam:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tinh-trang-viec-lam/add",
      capNhatTinhTrangViecLam:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tinh-trang-viec-lam/update",
      xoaTinhTrangViecLam:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tinh-trang-viec-lam/delete",
      xuatBaoCaoTinhTrangViecLam:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tinh-trang-viec-lam/export",
      guiTinhTrangViecLam:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tinh-trang-viec-lam/gui",
      duyetTinhTrangViecLam:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tinh-trang-viec-lam/duyet",
      tuChoiTinhTrangViecLam:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tinh-trang-viec-lam/tu-choi",
      dmLoaiHDLD:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tinh-trang-viec-lam/get-dm-loai-hdld",
    },
    dashboardTheHienSoNguoiCoViecLamThatNghiepTrongTinh: {
      layThongTinBieuDoNguoiCoViecLam: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/dashboard_the_hien_so_nguoi_co_viec_lam_va_that_nghiep_trong_tinh/tinh_tong_so_nguoi_co_viec_lam",
      layThongTinBieuDoTyLeLaoDongTheoHopDong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/dashboard_the_hien_so_nguoi_co_viec_lam_va_that_nghiep_trong_tinh/tinh_ty_le_lao_dong_theo_hop_dong",
      layThongTinBieuDoTyLeLaoDongTheoLoaiHinhNoiLamViec: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/dashboard_the_hien_so_nguoi_co_viec_lam_va_that_nghiep_trong_tinh/tinh_ty_le_lao_dong_theo_loai_hinh_noi_lam_viec",
      layThongTinBieuDoNguoiThatNghiep: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/dashboard_the_hien_so_nguoi_co_viec_lam_va_that_nghiep_trong_tinh/tinh_tong_so_nguoi_that_nghiep",
      layThongTinBieuDoTyLeChuaVaDaLamViec: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/dashboard_the_hien_so_nguoi_co_viec_lam_va_that_nghiep_trong_tinh/tinh_ty_le_chua_va_da_lam_viec",
      layThongTinBieuDoTyLeThoiGianThatNghiep: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/quan-ly-cong-tac-an-toan-ve-sinh-lao-dong/dashboard_the_hien_so_nguoi_co_viec_lam_va_that_nghiep_trong_tinh/tinh_ty_le_thoi_gian_that_nghiep"
    },
    dashboardTheHienSoLieuCungCauLaoDongTrongTinh: {
      layThongTinTinhTongSoLaoDongNamNu: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dashboard-bieu-do-the-hien-so-lieu-cung-cau-lao-dong/tinh-tong-so-lao-long-nam-nu",
      layThongTinTinhLucLuongLaoDongTheoDiaBan: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dashboard-bieu-do-the-hien-so-lieu-cung-cau-lao-dong/tinh-luc-luong-lao-dong-theo-hop-dong",
      layThongTinTinhTyLeTrinhDoGiaoDuc: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dashboard-bieu-do-the-hien-so-lieu-cung-cau-lao-dong/tinh-ty-le-trinh-do-giao-duc",
      layThongTinTinhTyLeTrinhDoChuyenMonKyThuat: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dashboard-bieu-do-the-hien-so-lieu-cung-cau-lao-dong/tinh-ty-le-trinh-do-theo-chuyen-mon-ky-thuat",
    },
    dashboardTheHienThongTinDoanhNghiepTrongTinh: {
      layThongTinSoDoanhNghiepChuaDungHoatDong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dashboard-the-hien-so-doanh-nghiep-trong-tinh/tinh-tong-so-doanh-nghiep-chua-dung-hoat-dong",
      layThongTinSoDoanhNghiepDaThanhLapCongDoan: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dashboard-the-hien-so-doanh-nghiep-trong-tinh/tinh-tong-so-doanh-nghiep-da-thanh-lap-cong-doan",
      layThongTinSoDoanhNghiepCoTongSoNguoiLaoDongTren1000: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dashboard-the-hien-so-doanh-nghiep-trong-tinh/tinh-tong-so-doanh-nghiep-da-co-tong-so-lao-dong-tren-1000",
      layThongTinSoDoanhNghiepTheoDiaBan: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dashboard-the-hien-so-doanh-nghiep-trong-tinh/tinh-tong-so-doanh-nghiep-theo-dia-ban",
      layThongTinSoDoanhNghiepTheoDieuKien: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dashboard-the-hien-so-doanh-nghiep-trong-tinh/tinh-tong-so-doanh-nghiep-theo-dieu-kien",
      layThongTinSoDoanhNghiepTheoLoaiHinhCoSo: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dashboard-the-hien-so-doanh-nghiep-trong-tinh/tinh-tong-so-doanh-nghiep-theo-loai-hinh-co-so",
    },
    dashboardThongKeSoTaiNanLaoDong: {
      tinhTongSoTNLD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dashboard-thong-ke-so-tai-nan-lao-dong/tinh-tong-so-tai-nan-lao-dong",
      tinhTongSoTNLDKhongTheoHD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dashboard-thong-ke-so-tai-nan-lao-dong/tinh-tong-so-tai-nan-lao-dong-khong-theo-hd",
      tinhTongSoTNLDChart: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dashboard-thong-ke-so-tai-nan-lao-dong/tinh-to-so-tai-nan-lao-dong-chart",
      tinhTongSoTNLDKhongTheoHDChart: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dashboard-thong-ke-so-tai-nan-lao-dong/tinh-to-so-tai-nan-lao-dong-khong-theo-hd-chart",
      tongHopSoTaiNanLaoDong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dashboard-thong-ke-so-tai-nan-lao-dong/tong-hop-so-tai-nan-lao-dong-chart",
    },
    TKLDLamViecNuocNgoaiTheoKetThucHopDong: {
      getList: rootUrl_Micro +  "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/ld-nuoc-ngoai-trong-nam-theo-ket-thuc-hd/getList",
      getTongHopTheoNam: rootUrl_Micro +  "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/ld-nuoc-ngoai-trong-nam-theo-ket-thuc-hd/getTongHopTheoNam",
      themMoi: rootUrl_Micro +  "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/ld-nuoc-ngoai-trong-nam-theo-ket-thuc-hd/themMoi",
      capNhat: rootUrl_Micro +  "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/ld-nuoc-ngoai-trong-nam-theo-ket-thuc-hd/capNhat",
      getChiTiet: rootUrl_Micro +  "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/ld-nuoc-ngoai-trong-nam-theo-ket-thuc-hd/getChiTiet",
      xoa: rootUrl_Micro +  "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/ld-nuoc-ngoai-trong-nam-theo-ket-thuc-hd/xoa",
      chuyenDuyet: rootUrl_Micro +  "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/ld-nuoc-ngoai-trong-nam-theo-ket-thuc-hd/chuyenDuyet",
      xuatBaoCao: rootUrl_Micro +  "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/ld-nuoc-ngoai-trong-nam-theo-ket-thuc-hd/xuatBaoCao",
    },
    dashboardThongKeSoNguoiNNLamViecTaiVietNam: {
      tinhTongSoGiayPhepDuocCapMoi: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dashboard-the-hien-so-luong-nguoi-nuoc-ngoai-lam-viec-tai-viet-nam/tinh-tong-so-giay-phep-cap-moi",
      tinhTongSoGiayPhepDuocCap2_3: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dashboard-the-hien-so-luong-nguoi-nuoc-ngoai-lam-viec-tai-viet-nam/tinh-tong-so-giay-phep-duoc-cap-2-3",
      tinhTongSoGiayPhepDuocCap5: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dashboard-the-hien-so-luong-nguoi-nuoc-ngoai-lam-viec-tai-viet-nam/tinh-tong-so-giay-phep-duoc-cap-5",
      tinhTongSoGiayPhepThuHoi: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dashboard-the-hien-so-luong-nguoi-nuoc-ngoai-lam-viec-tai-viet-nam/tinh-tong-so-giay-phep-thu-hoi",
      tinhTongHopGiayPhepChart: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dashboard-the-hien-so-luong-nguoi-nuoc-ngoai-lam-viec-tai-viet-nam/tinh-tong-hop-giay-phep",
      tinhTyLeQuocTich: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dashboard-the-hien-so-luong-nguoi-nuoc-ngoai-lam-viec-tai-viet-nam/tinh-ty-le-quoc-tich",
      tinhTyLeLoaiHinhDoanhNghiep: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dashboard-the-hien-so-luong-nguoi-nuoc-ngoai-lam-viec-tai-viet-nam/tinh-ty-le-loai-hinh-doanh-nghiep",
    },
    dashboardTheHienSoNguoiVietNamLamViecTaiNuocNgoai: {
      tinhTongSoNguoiVietLamViecTaiNN: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dashboard-the-hien-so-lao-dong-viet-nam-lam-viec-tai-nuoc-ngoai/tong-so-lao-dong-viet-nam-lam-viec-tai-nguoc-ngoai",
      tinhTongSoNguoiVietLamViecTaiNNTheoDiaBan: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dashboard-the-hien-so-lao-dong-viet-nam-lam-viec-tai-nuoc-ngoai/tong-so-lao-dong-viet-nam-lam-viec-tai-nguoc-ngoai-theo-dia-ban",
      tinhTongSoNguoiVietLamViecTaiNNTheoQuocGia: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dashboard-the-hien-so-lao-dong-viet-nam-lam-viec-tai-nuoc-ngoai/tong-so-lao-dong-viet-nam-lam-viec-tai-nguoc-ngoai-theo-quoc-gia",
      tinhTongSoNguoiVietLamViecTaiNNTheoTrinhDoChuyenMon: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/dashboard-the-hien-so-lao-dong-viet-nam-lam-viec-tai-nuoc-ngoai/tong-so-lao-dong-viet-nam-lam-viec-tai-nguoc-ngoai-theo-trinh-do-chuyen-mon",
    },
    traCuuNguoiLDONuocNgoai: {
      searchTraCuu: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tra-cuu-thong-tin-nld-o-nuoc-ngoai/tra-cuu",
      getThanhVien: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tra-cuu-thong-tin-nld-o-nuoc-ngoai/tra-cuu-thanh-vien",
      getQuocGia: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tra-cuu-thong-tin-nld-o-nuoc-ngoai/quoc-gia"
    },
    traCuuThongTinNguoiCoViecLamTrongDiaBan: {
      traCuuThongTinNguoiCoViecLam: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tra-cuu-thong-tin-nguoi-co-viec-lam/danh-sach-nguoi-co-viec-lam",
      danhSachDoanhNghiepTrongDiaBan: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/tra-cuu-thong-tin-nguoi-co-viec-lam/danh-sach-doanh-nghiep-trong-dia-ban",
    },

    tinhHinhTuyenDungSuDungNldVn:{
      timKiem: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/tim-kiem-tinh-hinh-td-sd-nld-vn",
      themMoi: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/them-moi-tinh-hinh-td-sd-nld-vn",
      capNhat: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/cap-nhat-tinh-hinh-td-sd-nld-vn",
      xoa: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/xoa-tinh-hinh-td-sd-nld-vn",
      capNhatTrangThai: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/cap-nhat-tt-tinh-hinh-td-sd-nld-vn",
      xuatBaoCao: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/xuat-bao-cao-tinh-hinh-td-sd-nld-vn",
      dsChiTiet: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/danh-sach-chi-tiet",
      checkReport: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/check-report",
    },
    baoCaoThongKeLDVLCoThoiHanNNTheoHD: {
      xuatBaoCaoThongKeLDVLCoThoiHanNNTheoHD: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-ldlv-nuoc-ngoai-theo-hdcth/thong-ke",
      checkReport: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-ldlv-nuoc-ngoai-theo-hdcth/check-report"
    },
    thongTinNguoiVietNamLamViecTaiNN: {
      taiFileMau: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-tin-nguoi-viet-nam-lam-viec-tai-nuoc-ngoai/tai-file-mau",
      importFile: rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-tin-nguoi-viet-nam-lam-viec-tai-nuoc-ngoai/import-file"
    },
    quanLyTongHopTinhHinhHdThueLaiLd:{
      searchList : rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/tim-kiem-tong-hop-tinh-hinh-hoat-dong-thue-lai-ld",
      listDetails: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/danh-sach-chi-tiet-tong-hop-tinh-hinh-hoat-dong-thue-lai-ld",
      create: rootUrl_Micro +  "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/them-moi-tong-hop-tinh-hinh-hoat-dong-thue-lai-ld",
      update: rootUrl_Micro +  "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/cap-nhat-tong-hop-tinh-hinh-hoat-dong-thue-lai-ld",
      delete: rootUrl_Micro +  "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/xoa-tong-hop-tinh-hinh-hoat-dong-thue-lai-ld",
      exportFile: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/xuat-bao-cao-tong-hop-tinh-hinh-hoat-dong-thue-lai-ld"
    }
  },

  QLLĐ:{
    quanLySoLaoDong:{
      timKiemQuanLySoLaoDong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/quan-ly-so-lao-dong/tim-kiem-quan-ly-so-lao-dong",
      getDataFormThemMoi: rootUrl_Micro + "quan-ly-san-viec-lam/v2/quan-ly-so-lao-dong/get-data-them-moi",
      getDmGioiTinh: rootUrl_Micro + "quan-ly-san-viec-lam/v2/quan-ly-so-lao-dong/get-dm-gioi-tinh",
      getDmDantoc: rootUrl_Micro + "quan-ly-san-viec-lam/v2/quan-ly-so-lao-dong/get-dm-dan-toc",
      getDmchuyenmon: rootUrl_Micro + "quan-ly-san-viec-lam/v2/quan-ly-so-lao-dong/get-dm-chuyen-mon",
      getDmLoaiHdld: rootUrl_Micro + "quan-ly-san-viec-lam/v2/quan-ly-so-lao-dong/get-dm-loai-hdld",
      getDmViTriCV: rootUrl_Micro + "quan-ly-san-viec-lam/v2/quan-ly-so-lao-dong/get-dm-viTriCV",
      themMoiDuLieu: rootUrl_Micro + "quan-ly-san-viec-lam/v2/quan-ly-so-lao-dong/them-moi-du-lieu",
      capNhatDuLieu: rootUrl_Micro + "quan-ly-san-viec-lam/v2/quan-ly-so-lao-dong/cap-nhat-du-lieu",
      getDataCapNhat: rootUrl_Micro + "quan-ly-san-viec-lam/v2/quan-ly-so-lao-dong/get-data-cap-nhat",
      delete: rootUrl_Micro + "quan-ly-san-viec-lam/v2/quan-ly-so-lao-dong/delete-du-lieu",
      guiDuyet: rootUrl_Micro + "quan-ly-san-viec-lam/v2/quan-ly-so-lao-dong/gui-duyet",
      tuChoi: rootUrl_Micro + "quan-ly-san-viec-lam/v2/quan-ly-so-lao-dong/tu-choi",
      checkTonTaiDuLieuNam: rootUrl_Micro + 'quan-ly-san-viec-lam/v2/quan-ly-so-lao-dong/check-ton-tai-du-lieu-nam'
    
    },
    thongKeTienLuongLaodong:{
      getDmNgheNghiep: rootUrl_Micro + "quan-ly-san-viec-lam/v2/thong-ke-tien-luong-lao-dong-trong-doanh-nghiep-hgi/get-dm-nghe-nghiep",
      getDmNgheNghiepHgi: rootUrl_Micro + "quan-ly-san-viec-lam/v2/thong-ke-tien-luong-lao-dong-trong-doanh-nghiep-hgi/get-dm-nghe-nghiep-hgi",
      getDmTinhThanhHgi: rootUrl_Micro + "quan-ly-san-viec-lam/v2/thong-ke-tien-luong-lao-dong-trong-doanh-nghiep-hgi/get-dm-tinh-thanh",
      getTenDoanhNghiep: rootUrl_Micro + "quan-ly-san-viec-lam/v2/thong-ke-tien-luong-lao-dong-trong-doanh-nghiep-hgi/get-ten-doanh-nghiep",
      themMoiDuLieu: rootUrl_Micro + "quan-ly-san-viec-lam/v2/thong-ke-tien-luong-lao-dong-trong-doanh-nghiep-hgi/them-moi-du-lieu",
      timKiemDulieu: rootUrl_Micro + "quan-ly-san-viec-lam/v2/thong-ke-tien-luong-lao-dong-trong-doanh-nghiep-hgi/tim-kiem",
      getDataCapNhat: rootUrl_Micro + "quan-ly-san-viec-lam/v2/thong-ke-tien-luong-lao-dong-trong-doanh-nghiep-hgi/get-data-cap-nhat",
      capNhatDuLieu: rootUrl_Micro + "quan-ly-san-viec-lam/v2/thong-ke-tien-luong-lao-dong-trong-doanh-nghiep-hgi/cap-nhat-du-lieu",
      delete: rootUrl_Micro + "quan-ly-san-viec-lam/v2/thong-ke-tien-luong-lao-dong-trong-doanh-nghiep-hgi/delete-du-lieu",
      xuatBaoCao: rootUrl_Micro + "quan-ly-san-viec-lam/v2/thong-ke-tien-luong-lao-dong-trong-doanh-nghiep-hgi/xuat-bao-cao",
    },

    baocaothongKeToChucGTVLDuocCapPhep:{
      xuatBaoCaoThongKeToChucGTVLDuocCapPhepHoatDong:rootUrl_Micro + "quan-ly-san-viec-lam/v2/cung-cau-lao-dong/thong-ke-to-chuc-gtvl-duoc-cap-phep/xbc-thong-ke-to-chuc-gtvl-duoc-cap-phep"
    },

    quanLyTinhHinhSdNguoiLdNuocNgoai:{
      searchQuanLyTinhHinhSDNguoiLDNN : rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/tim-kiem-ql-th-sd-nguoi-ld-nn",
      listQuocTich: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/danh-sach-quoc-tich",
      getThongTinDn: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/thong-tin-dn",
      getThongTinBaoCaoChiTiet: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/thong-tin-bao-cao-chi-tiet",
      createQuanLyTinhHinhSDNguoiLDNN: rootUrl_Micro +  "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/them-moi-ql-th-sd-nguoi-ld-nn",
      updateQuanLyTinhHinhSDNguoiLDNN: rootUrl_Micro +  "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/cap-nhat-ql-th-sd-nguoi-ld-nn",
      deleteQuanLyTinhHinhSDNguoiLDNN: rootUrl_Micro +  "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/xoa-ql-th-sd-nguoi-ld-nn",
      setTrangThaiXacNhan: rootUrl_Micro +  "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/cap-nhat-trang-thai-xac-nhan",
      exportFile: rootUrl_Micro + "quan-ly-san-viec-lam/v2/hgi-lao-dong-viec-lam/xuat-bc-ql-th-sd-nguoi-ld-nn",
      uploadFile: rootUrl_Micro + 'file/cung-cau-lao-dong/thong-tin-co-so/upload-gpkd',
      downloadFile: rootUrl_Micro + 'file/cung-cau-lao-dong/thong-tin-co-so/download'
    },
    thongKeLaoDongTimDuocVieclam:{
      getDmQuanHuyen: rootUrl_Micro + "quan-ly-san-viec-lam/v2/thong-ke-lao-dong-tim-duoc-viec-lam/get-dm-quan-huyen",
      themMoiDuLieu: rootUrl_Micro + "quan-ly-san-viec-lam/v2/thong-ke-lao-dong-tim-duoc-viec-lam/them-moi-du-lieu",
      timKiemDulieu: rootUrl_Micro + "quan-ly-san-viec-lam/v2/thong-ke-lao-dong-tim-duoc-viec-lam/tim-kiem",
      getDataCapNhat: rootUrl_Micro + "quan-ly-san-viec-lam/v2/thong-ke-lao-dong-tim-duoc-viec-lam/get-data-cap-nhat",
      capNhatDuLieu: rootUrl_Micro + "quan-ly-san-viec-lam/v2/thong-ke-lao-dong-tim-duoc-viec-lam/cap-nhat-du-lieu",
      delete: rootUrl_Micro + "quan-ly-san-viec-lam/v2/thong-ke-lao-dong-tim-duoc-viec-lam/delete-du-lieu",
      xuatBaoCao: rootUrl_Micro + "quan-ly-san-viec-lam/v2/thong-ke-lao-dong-tim-duoc-viec-lam/xuat-bao-cao",
    },
    quanLyBienDongLaoDong:{
      timKiemQuanLyBienDongLaoDong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/quan-ly-tinh-hinh-bien-dong-lao-dong/tim-kiem-quan-ly-tinh-hinh-bien-dong-lao-dong",
      getDataFormThemMoiSo2: rootUrl_Micro + "quan-ly-san-viec-lam/v2/quan-ly-tinh-hinh-bien-dong-lao-dong/get-data-them-moi-giam",
      getDataFormThemMoiSo3: rootUrl_Micro + "quan-ly-san-viec-lam/v2/quan-ly-tinh-hinh-bien-dong-lao-dong/get-data-them-moi-tang",
      getDataFormThemMoiSo1: rootUrl_Micro + "quan-ly-san-viec-lam/v2/quan-ly-tinh-hinh-bien-dong-lao-dong/get-data-them-moi-so1",
      getDmGioiTinh: rootUrl_Micro + "quan-ly-san-viec-lam/v2/quan-ly-tinh-hinh-bien-dong-lao-dong/get-dm-gioi-tinh",
      getDmDantoc: rootUrl_Micro + "quan-ly-san-viec-lam/v2/quan-ly-tinh-hinh-bien-dong-lao-dong/get-dm-dan-toc",
      getDmchuyenmon: rootUrl_Micro + "quan-ly-san-viec-lam/v2/quan-ly-tinh-hinh-bien-dong-lao-dong/get-dm-chuyen-mon",
      getDmLoaiHdld: rootUrl_Micro + "quan-ly-san-viec-lam/v2/quan-ly-tinh-hinh-bien-dong-lao-dong/get-dm-loai-hdld",
      getDmLyDo: rootUrl_Micro + "quan-ly-san-viec-lam/v2/quan-ly-tinh-hinh-bien-dong-lao-dong/get-dm-ly-do",
      getDmViTriCV: rootUrl_Micro + "quan-ly-san-viec-lam/v2/quan-ly-tinh-hinh-bien-dong-lao-dong/get-dm-viTriCV",
      themMoiDuLieu: rootUrl_Micro + "quan-ly-san-viec-lam/v2/quan-ly-tinh-hinh-bien-dong-lao-dong/them-moi-du-lieu",
      capNhatDuLieu: rootUrl_Micro + "quan-ly-san-viec-lam/v2/quan-ly-tinh-hinh-bien-dong-lao-dong/cap-nhat-du-lieu",
      getDataCapNhat: rootUrl_Micro + "quan-ly-san-viec-lam/v2/quan-ly-tinh-hinh-bien-dong-lao-dong/get-data-cap-nhat",
      delete: rootUrl_Micro + "quan-ly-san-viec-lam/v2/quan-ly-tinh-hinh-bien-dong-lao-dong/delete-du-lieu",
      guiDuyet: rootUrl_Micro + "quan-ly-san-viec-lam/v2/quan-ly-tinh-hinh-bien-dong-lao-dong/gui-duyet",
      tuChoi: rootUrl_Micro + "quan-ly-san-viec-lam/v2/quan-ly-tinh-hinh-bien-dong-lao-dong/tu-choi",
      getTenDoanhNghiep: rootUrl_Micro + "quan-ly-san-viec-lam/v2/quan-ly-tinh-hinh-bien-dong-lao-dong/get-ten-doanh-nghiep",
      getDmCoSo: rootUrl_Micro + "quan-ly-san-viec-lam/v2/quan-ly-tinh-hinh-bien-dong-lao-dong/get-dm-co-so",
      checkQuyenQuanLyLaoDong: rootUrl_Micro + "quan-ly-san-viec-lam/v2/quan-ly-tinh-hinh-bien-dong-lao-dong/check-quyen-quan-ly-lao-dong"
    },
  },
  BAO_CAO_TONG_HOP: {
    getBaoCaoTongHop: rootUrl_Micro + "get-data/thong-ke/bao-cao-thong-ke-so-luong-nhap",
    thongKeTongHop: rootUrl_Micro + "get-data/thong-ke/thong-ke-so-luong-nhap",
  }

};

